import React, { createContext, useMemo, useState, useCallback, useEffect, useRef, useContext } from 'react';
import _extends from '@babel/runtime/helpers/extends';
import { jsx, css, Global } from '@emotion/react';
import { Flex, Text, Div, Grid, GridItem, Span, Icon as Icon$1, Image as Image$1, Button, VStack, Tabs, Tab, InfiniteScroller, LoadingSpinner, Spacer, IconLink, Accordion, HStack, IncrementSetting, AnimatedCheckMark, CloseButton, ImageUploader, SettingInput, QuantumColorPicker, Input, List, ListItem, Pill, Banner, Stoplight, ColorOption, Tooltip, Zoom, Section, ButtonWithMenu, Sidebar, Drawer, ImageUploadWidget, QuantumThemeWrapper, useColorSwatch } from '@sendoutcards/quantum-design-ui';
import { useDispatch, useSelector, connect as connect$1, Provider } from 'react-redux';
import { bindActionCreators, combineReducers, createStore } from 'redux';
import { ActionCreator } from '@sendoutcards/core';
import useResizeObserver from 'use-resize-observer';
import isNumber from 'lodash/isNumber';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AnimatePresence, useAnimation, useMotionValue, useDragControls, animate } from 'framer-motion';
import Color from 'color';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import equal from 'fast-deep-equal';
import ReactResizeDetector from 'react-resize-detector';
import AvatarEditor from 'react-avatar-editor';
import Moveable from 'react-moveable';
import { useMergeRefs } from 'use-callback-ref';
import LogRocket from 'logrocket';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var EditorChromeContext = /*#__PURE__*/createContext({
  layouts: [],
  images: {
    hasMore: false,
    loadMore: function () {},
    isLoadingMore: false,
    results: []
  },
  stickers: {
    hasMore: false,
    loadMore: function () {},
    isLoadingMore: false,
    results: []
  },
  fonts: [],
  signatures: [],
  placeholders: [],
  defaultBackPanels: {
    hasMore: false,
    isLoadingMore: false,
    loadMore: function () {},
    results: []
  },
  customBackPanels: {
    hasMore: false,
    isLoadingMore: false,
    loadMore: function () {},
    results: []
  },
  colorPalettes: {
    isLoading: false,
    palette: []
  }
});
var EditorChromeProvider = EditorChromeContext.Provider;
EditorChromeContext.Consumer;

var selectImageScale = ActionCreator('SELECT_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var removeImage = ActionCreator('REMOVE_IMAGE');
var selectElement = ActionCreator('SELECT_ELEMENT', function (activeElement, panelLocation, textStart, textEnd) {
  return {
    activeElement: activeElement,
    panelLocation: panelLocation,
    textStart: textStart,
    textEnd: textEnd
  };
});
var deselectElement = ActionCreator('DESELECT_ELEMENT');
var toggleElementDraggable = ActionCreator('TOGGLE_ELEMENT_DRAGGABLE');
var setCard = ActionCreator('SET_CARD', function (card) {
  return {
    card: card
  };
});
var openFacebookImageDrawer = ActionCreator('OPEN_FACEBOOK_IMAGE_DRAWER');
var clearCard = ActionCreator('CLEAR_CARD');
var setToolbarAction = ActionCreator('SET_TOOLBAR_ACTION', function (toolbarAction) {
  return {
    toolbarAction: toolbarAction
  };
});
var selectBackPanel = ActionCreator('SELECT_BACK_PANEL', function (layout) {
  return {
    layout: layout
  };
});
var updateCard$1 = ActionCreator('UPDATE_CARD', function (card) {
  return {
    card: card
  };
});
var setPanelBackground = ActionCreator('SET_PANEL_BACKGROUND', function (color) {
  return {
    color: color
  };
});
var openFilterDrawer = ActionCreator('OPEN_FILTER_DRAWER');
var selectFilter = ActionCreator('SELECT_FILTER', function (filterName, url) {
  return {
    filterName: filterName,
    url: url
  };
});
var removeSpan = ActionCreator('REMOVE_SPAN');
var openBackgroundDrawer = ActionCreator('OPEN_BACKGROUND_DRAWER');
var addTextElement = ActionCreator('ADD_TEXT_ELEMENT', function (isFullPanel) {
  return {
    isFullPanel: isFullPanel
  };
});
var addImageElement = ActionCreator('ADD_IMAGE_ELEMENT', function (image, isFullPanel) {
  return {
    image: image,
    isFullPanel: isFullPanel
  };
});
var disableSelectingElements = ActionCreator('DISABLE_SELECTING_ELEMENTS');
var enableSelectingElements = ActionCreator('ENABLE_SELECTING_ELEMENTS');
var updateElementSize = ActionCreator('UPDATE_ELEMENT_SIZE', function (elementLocation, width, height) {
  return {
    elementLocation: elementLocation,
    width: width,
    height: height
  };
});
var selectImagePosition = ActionCreator('SELECT_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateElementPosition = ActionCreator('UPDATE_ELEMENT_POSITION', function (elementLocation, x, y) {
  return {
    elementLocation: elementLocation,
    x: x,
    y: y
  };
});
var updateElementRotation = ActionCreator('UPDATE_ELEMENT_ROTATION', function (elementLocation, rotation) {
  return {
    elementLocation: elementLocation,
    rotation: rotation
  };
});
var selectImage = ActionCreator('SELECT_IMAGE', function (photo) {
  return {
    photo: photo
  };
});
var removeElement = ActionCreator('REMOVE_ELEMENT');
var clearPanel = ActionCreator('CLEAR_PANEL');
var selectLayoutToLoad = ActionCreator('SELECT_LAYOUT_TO_LOAD', function (layoutId) {
  return {
    layoutId: layoutId
  };
});
var selectFullBleed = ActionCreator('SELECT_FULL_BLEED', function (fullBleedLocation) {
  return {
    fullBleedLocation: fullBleedLocation
  };
});
var selectSinglePanel = ActionCreator('SELECT_SINGLE_PANEL', function (fullBleedLocation, panelLocation) {
  return {
    fullBleedLocation: fullBleedLocation,
    panelLocation: panelLocation
  };
});
var selectLayout = ActionCreator('SELECT_LAYOUT', function (layout) {
  return {
    layout: layout
  };
});
var loadedCard = ActionCreator('LOADED_CARD', function (card) {
  return {
    card: card
  };
});
var selectPanel = ActionCreator('SELECT_PANEL', function (panelLocation, fullBleedLocation) {
  return {
    panelLocation: panelLocation,
    fullBleedLocation: fullBleedLocation
  };
});
var closeEditorDrawer = ActionCreator('CLOSE_EDITOR_DRAWER');
var resetState = ActionCreator('RESET_STATE');
var editorUndo = ActionCreator('UNDO_EDITOR_CHANGE');
var editorRedo = ActionCreator('REDO_EDITOR_CHANGE');
var duplicateElement = ActionCreator('DUPLICATE_ELEMENT');
var layerUp = ActionCreator('LAYER_UP', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var layerDown = ActionCreator('LAYER_DOWN', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var setEditing = ActionCreator('SET_EDITING', function (editing) {
  return {
    editing: editing
  };
});
var setFullBleedBackgroundImage = ActionCreator('SET_FULLBLEED_BACKGROUND_IMAGE', function (image) {
  return {
    image: image
  };
});
var deleteFullBleedBackgroundImage = ActionCreator('DELETE_FULL_BLEED_BACKGROUND_IMAGE');
var updateFullBleedBackgroundImagePosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundImageScale = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var updateFullBleedBackgroundElementPosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundElementSize = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_SIZE', function (width, height) {
  return {
    width: width,
    height: height
  };
});
var updateFullBleedBackgroundElementRotation = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_ROTATION', function (rotation) {
  return {
    rotation: rotation
  };
});
var selectVariation = ActionCreator('SELECT_VARIATION', function (variationID) {
  return {
    variationID: variationID
  };
});
var enablePreviewMode = ActionCreator('ENABLE_PREVIEW_MODE');
var updateClientAsset = ActionCreator('UPDATE_CLIENT_ASSET', function (image) {
  return {
    image: image
  };
});

var openElementInsertDrawer = ActionCreator('OPEN_ELEMENT_INSERT_DRAWER', function (insertType) {
  return {
    insertType: insertType
  };
});
var closeElementInsertDrawer = ActionCreator('CLOSE_ELEMENT_INSERT_DRAWER');
var openElementSettingsDrawer = ActionCreator('OPEN_ELEMENT_SETTINGS_DRAWER', function (settingType) {
  return {
    settingType: settingType
  };
});
var closeElementSettingsDrawer = ActionCreator('CLOSE_ELEMENT_SETTINGS_DRAWER');
var setActiveImageSetting = ActionCreator('SET_ACTIVE_IMAGE_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setActiveTextSetting = ActionCreator('SET_ACTIVE_TEXT_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setShouldReplaceSelectedImage = ActionCreator('SET_SHOULD_REPLACE_SELECTED_IMAGE', function (shouldReplaceSelectedImage) {
  return {
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  };
});
var setIsTextCursorActive = ActionCreator('SET_IS_TEXT_CURSOR_ACTIVE', function (isTextCursorActive) {
  return {
    isTextCursorActive: isTextCursorActive
  };
});
var toggleInteractionMode = ActionCreator('TOGGLE_INTERACTION_MODE');
var closeBetaBanner = ActionCreator('CLOSED_BETA_BANNER');
var toggleImageUploaderWidget = ActionCreator('TOGGLED_IMAGE_UPLOADER_WIDGET');
var setHasUploadedImage = ActionCreator('SET_HAS_UPLOADED_IMAGE', function (hasUploadedImage) {
  return {
    hasUploadedImage: hasUploadedImage
  };
});
var saveAndSend = ActionCreator('SAVED_AND_SENT');

var uploadedImage = ActionCreator('UPLOADED_IMAGE', function (image) {
  return {
    image: image
  };
});
var showImages = ActionCreator('SHOW_IMAGES');

var insertText = ActionCreator('INSERT_TEXT', function (text) {
  return {
    text: text
  };
});
var selectFontFamily = ActionCreator('SELECT_FONT_FAMILY', function (fontFamily) {
  return {
    fontFamily: fontFamily
  };
});
var insertNewLine = ActionCreator('INSERT_NEW_LINE');
var selectColor = ActionCreator('SELECT_COLOR', function (color) {
  return {
    color: color
  };
});
var insertCharacter = ActionCreator('INSERT_CHARACTER', function (character) {
  return {
    character: character
  };
});
var insertSignature = ActionCreator('INSERT_SIGNATURE', function (signature) {
  return {
    signature: signature
  };
});
var insertFragments = ActionCreator('INSERT_FRAGMENTS', function (fragments) {
  return {
    fragments: fragments
  };
});
var selectTextAlign = ActionCreator('SELECT_TEXT_ALIGN', function (textAlign) {
  return {
    textAlign: textAlign
  };
});
var deleteForwardFragments = ActionCreator('DELETE_FORWARD_FRAGMENTS');
var deleteFragments = ActionCreator('DELETE_FRAGMENTS');
var selectFontSize = ActionCreator('SELECT_FONT_SIZE', function (fontSize) {
  return {
    fontSize: fontSize
  };
});
var insertPlaceholder = ActionCreator('INSERT_PLACEHOLDER', function (placeholder) {
  return {
    placeholder: placeholder
  };
});
var updateTextCasing = ActionCreator('UPDATE_TEXT_CASING', function (casing) {
  return {
    casing: casing
  };
});
var clearText = ActionCreator('CLEAR_TEXT');

var toggleMobileNavigation = ActionCreator('TOGGLE_MOBILE_NAVIGATION', function (isVisible) {
  return {
    isVisible: isVisible
  };
});
var toggleDrawerState = ActionCreator('TOGGLE_DRAWER_STATE', function (drawerState) {
  return {
    drawerState: drawerState
  };
});

var actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addImageElement: addImageElement,
    addTextElement: addTextElement,
    clearCard: clearCard,
    clearPanel: clearPanel,
    clearText: clearText,
    closeBetaBanner: closeBetaBanner,
    closeEditorDrawer: closeEditorDrawer,
    closeElementInsertDrawer: closeElementInsertDrawer,
    closeElementSettingsDrawer: closeElementSettingsDrawer,
    deleteForwardFragments: deleteForwardFragments,
    deleteFragments: deleteFragments,
    deleteFullBleedBackgroundImage: deleteFullBleedBackgroundImage,
    deselectElement: deselectElement,
    disableSelectingElements: disableSelectingElements,
    duplicateElement: duplicateElement,
    editorRedo: editorRedo,
    editorUndo: editorUndo,
    enablePreviewMode: enablePreviewMode,
    enableSelectingElements: enableSelectingElements,
    insertCharacter: insertCharacter,
    insertFragments: insertFragments,
    insertNewLine: insertNewLine,
    insertPlaceholder: insertPlaceholder,
    insertSignature: insertSignature,
    insertText: insertText,
    layerDown: layerDown,
    layerUp: layerUp,
    loadedCard: loadedCard,
    openBackgroundDrawer: openBackgroundDrawer,
    openElementInsertDrawer: openElementInsertDrawer,
    openElementSettingsDrawer: openElementSettingsDrawer,
    openFacebookImageDrawer: openFacebookImageDrawer,
    openFilterDrawer: openFilterDrawer,
    removeElement: removeElement,
    removeImage: removeImage,
    removeSpan: removeSpan,
    resetState: resetState,
    saveAndSend: saveAndSend,
    selectBackPanel: selectBackPanel,
    selectColor: selectColor,
    selectElement: selectElement,
    selectFilter: selectFilter,
    selectFontFamily: selectFontFamily,
    selectFontSize: selectFontSize,
    selectFullBleed: selectFullBleed,
    selectImage: selectImage,
    selectImagePosition: selectImagePosition,
    selectImageScale: selectImageScale,
    selectLayout: selectLayout,
    selectLayoutToLoad: selectLayoutToLoad,
    selectPanel: selectPanel,
    selectSinglePanel: selectSinglePanel,
    selectTextAlign: selectTextAlign,
    selectVariation: selectVariation,
    setActiveImageSetting: setActiveImageSetting,
    setActiveTextSetting: setActiveTextSetting,
    setCard: setCard,
    setEditing: setEditing,
    setFullBleedBackgroundImage: setFullBleedBackgroundImage,
    setHasUploadedImage: setHasUploadedImage,
    setIsTextCursorActive: setIsTextCursorActive,
    setPanelBackground: setPanelBackground,
    setShouldReplaceSelectedImage: setShouldReplaceSelectedImage,
    setToolbarAction: setToolbarAction,
    showImages: showImages,
    toggleDrawerState: toggleDrawerState,
    toggleElementDraggable: toggleElementDraggable,
    toggleImageUploaderWidget: toggleImageUploaderWidget,
    toggleInteractionMode: toggleInteractionMode,
    toggleMobileNavigation: toggleMobileNavigation,
    updateCard: updateCard$1,
    updateClientAsset: updateClientAsset,
    updateElementPosition: updateElementPosition,
    updateElementRotation: updateElementRotation,
    updateElementSize: updateElementSize,
    updateFullBleedBackgroundElementPosition: updateFullBleedBackgroundElementPosition,
    updateFullBleedBackgroundElementRotation: updateFullBleedBackgroundElementRotation,
    updateFullBleedBackgroundElementSize: updateFullBleedBackgroundElementSize,
    updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
    updateFullBleedBackgroundImageScale: updateFullBleedBackgroundImageScale,
    updateTextCasing: updateTextCasing,
    uploadedImage: uploadedImage
});

var useReduxActions = function () {
  var dispatch = useDispatch();
  return useMemo(function () {
    return bindActionCreators(actions, dispatch);
  }, [dispatch]);
};

function useReduxState(selector, equalityFn) {
  return useSelector(typeof selector === 'string' ? function (state) {
    return state[selector];
  } : selector, equalityFn);
}

var DEFAULT_BACK_PANEL_ID = '66495';

var defaultBackPanelLabelStyles = {
  color: 'white',
  backgroundColor: '#14f243',
  position: 'absolute',
  zIndex: 2,
  top: 0,
  width: '70%',
  borderRadius: '2px',
  borderTopLeftRadius: '0px',
  borderTopRightRadius: '0px',
  boxShadow: '0 1px 18px -1px #a8a8a8'
};
var defaultBackPanelBorderStyles = {
  borderColor: '#14f243',
  borderWidth: 'bold',
  borderStyle: 'solid'
};

var Layouts = function (_a) {
  var layouts = _a.layouts,
      title = _a.title,
      subtitle = _a.subtitle,
      canDelete = _a.canDelete,
      onDelete = _a.onDelete,
      isOnBackPanel = _a.isOnBackPanel,
      onSetDefaultBackPanel = _a.onSetDefaultBackPanel,
      defaultBackPanelId = _a.defaultBackPanelId,
      onSelectBackLayout = _a.onSelectBackLayout;
  var card = useReduxState('editor').card;
  var actions = useReduxActions();

  var _b = __read(useState(), 2),
      isHoveringId = _b[0],
      setIsHoveringId = _b[1];

  var orientation = card === null || card === void 0 ? void 0 : card.orientation;

  var handleLayout = function (layout) {
    if (isOnBackPanel) {
      onSelectBackLayout === null || onSelectBackLayout === void 0 ? void 0 : onSelectBackLayout(layout.id.toString());
      actions.selectBackPanel(layout);
    } else {
      actions.selectLayout(layout);
    }
  }; // AspectRatio is defined by layout image sizes stored in our servers


  var getAspectRatio = function () {
    if ((card === null || card === void 0 ? void 0 : card.type) === 'POSTCARD') {
      return '735/850';
    } else if (orientation === 'LANDSCAPE') {
      return '14/10';
    } else {
      return '10/14';
    }
  };

  return jsx(Flex, {
    inset: 'x1',
    flexDirection: 'column',
    height: '100%'
  }, title && jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title), subtitle && jsx(Text, {
    type: "caption",
    weight: "thin"
  }, subtitle), jsx(Div, {
    width: '100%',
    outset: {
      vertical: 'x4'
    }
  }, jsx(Grid, {
    height: '100%',
    columnSize: 42,
    rowSize: 25,
    gap: 16
  }, layouts.map(function (layout) {
    var id = typeof layout.id === 'number' ? layout.id.toString() : layout.id;
    var isHorizontal = orientation === 'LANDSCAPE';
    var isDefaultBackPanel = id === defaultBackPanelId;
    var isDefaultSocBackPanel = layout.id.toString() === DEFAULT_BACK_PANEL_ID;
    return jsx(GridItem, {
      key: id,
      gridColSpan: 2,
      gridRowSpan: isHorizontal ? 2 : 4,
      borderRadius: 'medium',
      aspectRatio: getAspectRatio()
    }, jsx(Div, _extends({}, isDefaultBackPanel ? defaultBackPanelBorderStyles : {}, {
      position: "relative",
      width: "100%",
      height: "100%",
      onHoverStart: function () {
        return setIsHoveringId(id);
      },
      onHoverEnd: function () {
        return setIsHoveringId(undefined);
      }
    }), canDelete && !isDefaultSocBackPanel && jsx(Div, {
      width: "100%",
      height: "100%",
      alignItems: "center",
      position: "absolute",
      zIndex: 1,
      backgroundColor: "#343434b8",
      display: "flex",
      justifyContent: "center",
      borderRadius: "small"
    }, jsx(Span, {
      cursor: "pointer"
    }, jsx(Icon$1, {
      size: "medium",
      name: "delete",
      primaryColor: "danger",
      onClick: function () {
        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(id);
      }
    }))), isDefaultBackPanel && jsx(Div, {
      display: "flex",
      justifyContent: "center",
      onClick: function () {
        handleLayout(layout);
      }
    }, jsx(Div, isDefaultBackPanel ? defaultBackPanelLabelStyles : {}, jsx(Text, {
      alignment: "center",
      type: "caption",
      color: "inverseBody"
    }, "Default"))), jsx(Image$1, {
      image: layout.thumbnail,
      onClick: function () {
        if (canDelete) {
          return;
        }

        handleLayout(layout);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    }), id === isHoveringId && isOnBackPanel && onSetDefaultBackPanel && id !== defaultBackPanelId && !canDelete && jsx(Div, {
      bottom: "30px",
      zIndex: 2,
      position: "relative",
      display: "flex",
      justifyContent: "center"
    }, jsx(Button, {
      size: "xSmall",
      title: "set as default",
      onClick: function () {
        return onSetDefaultBackPanel(layout.id.toString());
      }
    }))));
  }))));
};

var useWindowSize = function () {
  var isClient = typeof window === 'object';
  var getSize = useCallback(function () {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0
    };
  }, [isClient]);

  var _a = __read(useState(getSize), 2),
      windowSize = _a[0],
      setWindowSize = _a[1];

  useEffect(function () {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [getSize, isClient]);
  var width = windowSize.width,
      height = windowSize.height;
  return {
    width: width,
    height: height
  };
};

var TabWrapper = function (props) {
  return jsx(Div, {
    height: "calc(100vh - " + (props.heightOffset - 2) + "px)",
    overflow: "auto",
    position: "relative"
  }, props.children);
};

var BackPanels = function (_a) {
  var defaultBackPanels = _a.defaultBackPanels,
      customBackPanels = _a.customBackPanels,
      onDelete = _a.onDelete,
      onSelectBackLayout = _a.onSelectBackLayout,
      onSetDefaultBackPanel = _a.onSetDefaultBackPanel,
      defaultBackPanelId = _a.defaultBackPanelId;

  var _b = useResizeObserver(),
      ref = _b.ref,
      height = _b.height;

  var _c = useResizeObserver(),
      defaultBackPanelWrapperRef = _c.ref,
      defaultBackPanelWrapperHeight = _c.height;

  var _d = useResizeObserver(),
      customBackPanelWrapperRef = _d.ref,
      customBackPanelWrapperHeight = _d.height;

  var windowHeight = useWindowSize().height;

  var _e = __read(useState(false), 2),
      canDelete = _e[0],
      setCanDelete = _e[1];

  var heightOffset = height ? height + 96 : 0;
  /* Passing true to the InfiniteScroller initialLoad prop causes infinite re render issues. The InfiniteScroller also does not re fetch unless
     an overflow exists on the parent and user scrolls to the bottom. This can cause issues on larger monitors if client only
     fetches a handful of backpanels that do not fill up the whole drawer. The below fix measures the layout grid container and continues
     to loadMore until an overflow exists on the drawer and InfiniteScroller can handle the remaining fetches.
  */

  var shouldFetchMore = useCallback(function (defaultHeight, backpanel) {
    if (typeof heightOffset === 'number' && typeof windowHeight === 'number' && typeof defaultHeight === 'number') {
      var shouldFetchMore_1 = defaultHeight < windowHeight - heightOffset;

      if (backpanel.hasMore && shouldFetchMore_1) {
        backpanel.loadMore();
      }
    }
  }, [heightOffset, windowHeight]); // Watch for height changes in defaultBackPanels drawer

  useEffect(function () {
    shouldFetchMore(defaultBackPanelWrapperHeight, defaultBackPanels);
  }, [defaultBackPanelWrapperHeight, shouldFetchMore]); //eslint-disable-line
  // Watch for height changes in customBackPanels drawer

  useEffect(function () {
    shouldFetchMore(customBackPanelWrapperHeight, customBackPanels);
  }, [customBackPanelWrapperHeight, shouldFetchMore]); //eslint-disable-line

  return jsx(React.Fragment, null, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, {
    ref: ref
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Add a back Panel"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Select from an existing back panel or create a new one")), jsx(Tabs, {
    height: "100%",
    defaultActiveKey: "new"
  }, jsx(Tab, {
    tabKey: "new",
    title: "Create New"
  }, jsx(TabWrapper, {
    heightOffset: heightOffset
  }, jsx(InfiniteScroller, {
    hasMore: defaultBackPanels.hasMore,
    isLoadingMore: defaultBackPanels.isLoadingMore,
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    loadMore: defaultBackPanels.loadMore,
    isScrollingOnWindow: false
  }, jsx(Div, {
    ref: defaultBackPanelWrapperRef
  }, jsx(Layouts, {
    isOnBackPanel: true,
    layouts: defaultBackPanels.results,
    onSelectBackLayout: onSelectBackLayout
  }))))), jsx(Tab, {
    tabKey: "custom",
    title: "View Saved"
  }, jsx(TabWrapper, {
    heightOffset: heightOffset
  }, jsx(Div, {
    position: "absolute",
    top: '0px',
    left: "0px",
    inset: {
      left: 'x1'
    },
    display: "flex"
  }, jsx(Button, {
    size: "xSmall",
    type: "primary",
    onClick: function () {
      return setCanDelete(!canDelete);
    },
    outlined: !canDelete ? false : true
  }, !canDelete ? 'Delete' : 'Finished Deleting'), jsx(Spacer, {
    space: "x2",
    orientation: "horizontal"
  })), jsx(InfiniteScroller, {
    hasMore: customBackPanels.hasMore,
    isLoadingMore: customBackPanels.isLoadingMore,
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    loadMore: customBackPanels.loadMore,
    isScrollingOnWindow: false
  }, jsx(Div, {
    ref: customBackPanelWrapperRef
  }, jsx(Layouts, {
    onSetDefaultBackPanel: onSetDefaultBackPanel,
    defaultBackPanelId: defaultBackPanelId,
    isOnBackPanel: true,
    layouts: customBackPanels.results,
    canDelete: canDelete,
    onDelete: onDelete,
    onSelectBackLayout: onSelectBackLayout
  }))))))));
};

var ClientNavigation = function (_a) {
  var clientNav = _a.clientNav;
  return jsx(React.Fragment, null, jsx(Div, {
    inset: "x1"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Navigation"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Navigate around your sendoutcards account")), jsx(Div, {
    width: "100%",
    inset: "x4"
  }, jsx(VStack, {
    gap: "x2"
  }, clientNav.map(function (navSection) {
    return jsx(React.Fragment, null, jsx(Text, {
      type: "body",
      weight: "bold"
    }, navSection.section.title), jsx(VStack, {
      gap: "x1"
    }, navSection.section.links.map(function (link) {
      return jsx(Div, {
        inset: {
          left: 'x2'
        }
      }, jsx(IconLink, {
        icon: link.icon,
        title: link.title,
        onClick: link.onClick,
        size: "small"
      }));
    })), jsx(Spacer, {
      space: "x2"
    }));
  }))));
};

var Settings = function (_a) {
  var _b;

  var sections = _a.sections,
      startingActiveKey = _a.startingActiveKey;
  var initialActiveKey = (_b = sections.find(function (section) {
    return section.key === startingActiveKey;
  })) === null || _b === void 0 ? void 0 : _b.key;

  var _c = __read(useState([initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : 'NONE']), 2),
      activeKey = _c[0],
      setActiveKey = _c[1];

  var activeImageSetting = useReduxState('editorChrome').activeImageSetting;
  useEffect(function () {
    var _a;

    setActiveKey([(_a = initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : activeImageSetting) !== null && _a !== void 0 ? _a : 'NONE']);
  }, [activeImageSetting, initialActiveKey]);

  var onSettingSectionChange = function (section) {
    section.onClick();
    setActiveKey(activeKey[0] === section.key ? ['NONE'] : section.key ? [section.key] : ['NONE']);
  };

  return jsx(Accordion, {
    stateOverride: {
      activeIndexes: activeKey[0] ? activeKey : [-1],
      setActiveIndexes: setActiveKey
    },
    isExclusive: true,
    isHeadingBackgroundInverse: true,
    insetBody: "x_5",
    sections: sections.map(function (section) {
      return {
        heading: jsx(React.Fragment, null, jsx(Flex, null, jsx(HStack, {
          gap: "x1_5",
          justify: "flex-start"
        }, jsx(Flex, {
          alignItems: "center"
        }, jsx(Icon$1, {
          name: section.icon,
          size: "small",
          primaryColor: section.key === activeKey[0] ? 'primaryBrand' : 'default'
        })), jsx(Flex, {
          alignItems: "center"
        }, jsx(Text, {
          type: "footnote",
          weight: section.key === activeKey[0] ? 'semiBold' : 'regular'
        }, section.title))))),
        key: section.key,
        body: jsx(Div, {
          width: "100%"
        }, section.settings),
        onHeadingClick: function () {
          return onSettingSectionChange(section);
        }
      };
    })
  });
};

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

var ElementIncrementSetting = function (_a) {
  var title = _a.title,
      min = _a.min,
      max = _a.max,
      callback = _a.callback,
      initial = _a.initial,
      resetDependency = _a.resetDependency,
      _b = _a.sliderOrigin,
      sliderOrigin = _b === void 0 ? 'left' : _b;

  var _c = __read(useState(initial * 100), 2),
      value = _c[0],
      setValue = _c[1];

  var _d = __read(useState(false), 2),
      isDisabled = _d[0],
      setIsDisabled = _d[1];

  var previousValue = usePrevious(value);

  var _e = useReduxState('editor'),
      activeElement = _e.activeElement,
      panelLocation = _e.panelLocation;

  var handleNoRange = function () {
    setIsDisabled(true);
    setValue(min);
  };

  useEffect(function () {
    if (min === max) {
      handleNoRange();
      return;
    }

    setIsDisabled(false);

    if (previousValue === value) {
      return;
    }

    callback(value / 100);
  }, [value, min, max]); // eslint-disable-line

  useEffect(function () {
    var desiredValue = Math.floor(Math.round(initial * 100));

    if (desiredValue >= min && desiredValue <= max) {
      setValue(desiredValue);
    }
  }, [activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, panelLocation, resetDependency]); // eslint-disable-line

  return jsx(IncrementSetting, {
    sliderOrigin: sliderOrigin,
    isDisabled: isDisabled,
    title: {
      content: title,
      type: 'footnote',
      weight: 'bold'
    },
    min: min,
    max: max,
    value: value,
    setValue: function (value) {
      return setValue(value);
    },
    layout: "inlineBlock"
  });
};

var CropSettings = function (_a) {
  var scale = _a.scale,
      x = _a.x,
      y = _a.y,
      onSelectImagePosition = _a.onSelectImagePosition,
      onSelectImageScale = _a.onSelectImageScale;
  return jsx(Flex, {
    flexDirection: "column",
    inset: {
      bottom: 'x3'
    }
  }, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Horizontal: X',
    initial: x,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(value, undefined);
    },
    resetDependency: x
  })), jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Vertical: Y',
    initial: y,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(undefined, value);
    },
    resetDependency: y
  })), jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Scale',
    initial: scale !== null && scale !== void 0 ? scale : 1,
    min: 50,
    max: 500,
    callback: function (value) {
      return onSelectImageScale(value);
    },
    resetDependency: scale
  }))));
};

var ImageSettings = function (props) {
  var title = props.title,
      subtitle = props.subtitle,
      imageScale = props.imageScale,
      imageX = props.imageX,
      imageY = props.imageY,
      onSelectImagePosition = props.onSelectImagePosition,
      onSelectImageScale = props.onSelectImageScale,
      isLayoutElement = props.isLayoutElement;
  var activeImageSetting = useReduxState('editorChrome').activeImageSetting;
  var actions = useReduxActions();
  var nonLayoutElementSections = [// {
    //   title: 'Layout',
    //   onClick: () => setActiveImageSetting(null),
    //   icon: 'sliderHorizontal',
    //   settings: (
    //     <LayoutSettings
    //       width={elementWidth}
    //       height={elementHeight}
    //       x={elementX}
    //       y={elementY}
    //       location={location}
    //       onUpdatePosition={onUpdatePosition}
    //       onUpdateSize={onUpdateSize}
    //     />
    //   ),
    // },
    // {
    //   title: 'Rotate',
    //   icon: 'cropRotate',
    //   onClick: () => setActiveImageSetting(null),
    //   settings: (
    //     <RotateSettings
    //       location={location}
    //       rotation={elementRotation}
    //       onUpdateRotation={onUpdateRotation}
    //     />
    //   ),
    // },
  ];
  var layoutElementSections = [{
    title: 'Crop',
    key: 'crop',
    onClick: activeImageSetting === 'crop' ? function () {
      return actions.setActiveImageSetting(null);
    } : function () {
      return actions.setActiveImageSetting('crop');
    },
    icon: 'crop',
    settings: jsx(CropSettings, {
      onSelectImagePosition: onSelectImagePosition,
      onSelectImageScale: onSelectImageScale,
      x: imageX,
      y: imageY,
      scale: imageScale
    })
  }];
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, subtitle), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: !isLayoutElement ? __spread(nonLayoutElementSections, layoutElementSections) : __spread(layoutElementSections)
  })));
};

var black = {
  r: 0,
  g: 0,
  b: 0
};
var rgbString = function (color) {
  return "rgb(" + color.r + ", " + color.g + ", " + color.b + ")";
};

var defaultFragment = {
  fontFamily: 'HelveticaV2',
  fontSize: 16,
  color: black,
  textAlign: 'CENTER'
};
var signatureCharacter = 'æ'; // type IncompleteFragment = {

var textState = function (editor) {
  var element = selectedElement(editor);
  var textSelection = editor.textSelection;
  return element && element.text && textSelection ? __assign(__assign({}, textSelection), {
    fragments: element.text.fragments
  }) : {
    fragments: [defaultFragment],
    start: 1,
    end: 1,
    overrideProperties: {}
  };
};
var paragraphStart = function (textState) {
  return textState.fragments.slice(0, textState.start).reduce(function (acc, fragment, index) {
    return fragment.textAlign ? index : acc;
  }, 0);
};
var insertionTextAlign = function (textState) {
  return textState.fragments[paragraphStart(textState)].textAlign;
};
var insertionProperties = function (textState) {
  var insertionProperties = __assign(__assign({}, textState.fragments[textState.start === textState.end ? textState.start - 1 : textState.start]), textState.overrideProperties);

  insertionProperties.textAlign;
      insertionProperties.signatureFontFamily;
      insertionProperties.text;
      var remainingProperties = __rest(insertionProperties, ["textAlign", "signatureFontFamily", "text"]);

  return remainingProperties;
};
var paragraphs = function (fragments) {
  return fragments.reduce(function (paragraphs, fragment, index) {
    var lastIndex = paragraphs.length - 1;
    var lastParagraph = paragraphs[lastIndex];
    return fragment.textAlign ? __spread(paragraphs, [{
      index: index,
      fontFamily: fragment.fontFamily,
      fontSize: fragment.fontSize,
      color: fragment.color,
      textAlign: fragment.textAlign,
      fragments: []
    }]) : __spread(paragraphs.slice(0, lastIndex), [__assign(__assign({}, lastParagraph), {
      fragments: __spread(lastParagraph.fragments, [__assign(__assign({}, fragment), {
        index: index
      })])
    })]);
  }, []);
};

var selectedFragments = function (textState) {
  // todo look into alignment and why first element is being pulled, is it a line break?
  return textState.fragments.slice(1, textState.end);
};

var selectedText = function (textState) {
  return textState.fragments.map(function (fragment) {
    return fragment.text ? fragment.text : fragment.signatureFontFamily ? '' : '\n';
  }).join('');
};

var selectedProperty = function (textState, key) {
  return textState.start === textState.end ? insertionProperties(textState)[key] : textState.fragments.slice(textState.start, textState.end).map(function (fragment) {
    return fragment[key];
  }).reduce(function (acc, value) {
    return acc === value ? acc : undefined;
  });
}; // TODO change any types
var selectedFontSize = function (textState) {
  return selectedProperty(textState, 'fontSize');
};
var selectedColor = function (textState) {
  return selectedProperty(textState, 'color');
};

var selectionPaths = function (textState) {
  return textState.fragments.reduce(function (_a, fragment) {
    var paragraph = _a.paragraph,
        offset = _a.offset,
        selectionPaths = _a.selectionPaths;
    var newParagraph = fragment.textAlign ? paragraph + 1 : paragraph;
    var newOffset = fragment.textAlign ? 0 : offset + 1;
    return {
      paragraph: newParagraph,
      offset: newOffset,
      selectionPaths: __spread(selectionPaths, [{
        paragraph: newParagraph,
        offset: newOffset
      }])
    };
  }, {
    paragraph: -1,
    offset: -1,
    selectionPaths: Array()
  }).selectionPaths;
};

var paragraphSelection = function (textState) {
  var paths = selectionPaths(textState);
  return {
    start: __assign(__assign({}, paths[textState.start - 1]), {
      index: textState.start
    }),
    end: __assign(__assign({}, paths[textState.end - 1]), {
      index: textState.end
    }),
    fragments: selectedFragments(textState),
    text: selectedText(textState)
  };
};
var computedElementText = function (textState, isSelected) {
  return {
    paragraphs: paragraphs(textState.fragments),
    selectionUpperBound: textState.fragments.length,
    selection: isSelected ? paragraphSelection(textState) : undefined
  };
};

var selectedFullBleed = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation;
  return card && isNumber(fullBleedLocation) ? card.fullBleeds[fullBleedLocation] : undefined;
};
var selectedPanel = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation,
      panelLocation = _a.panelLocation;
  return card && isNumber(panelLocation) ? card.fullBleeds[fullBleedLocation].panels[panelLocation !== null && panelLocation !== void 0 ? panelLocation : 0] : undefined;
};
var selectedElement = function (editor) {
  var _a;

  var card = editor.card,
      fullBleedLocation = editor.fullBleedLocation,
      panelLocation = editor.panelLocation,
      activeElement = editor.activeElement;

  if (!card || !isNumber(activeElement.location)) {
    return undefined;
  }

  if (isNumber(panelLocation)) {
    var panel = selectedPanel(editor);
    return panel ? panel.elements[(_a = activeElement.location) !== null && _a !== void 0 ? _a : 0] : undefined;
  } else {
    return card.fullBleeds[fullBleedLocation].backgroundElement;
  }
}; // TODO: Type this

var computedElements = function (elements, panel, fullBleed, selection) {
  return elements.map(function (element, location) {
    var points = {
      x: element.x * panel.width,
      y: element.y * panel.height,
      width: element.width * panel.width,
      height: element.height * panel.height
    };
    var isSelected = fullBleed.location === selection.fullBleed && panel.location === selection.panel && location === selection.element;

    var textState = __assign({
      fragments: element.text ? element.text.fragments : []
    }, selection.textSelection || {
      start: 0,
      end: 0,
      overrideProperties: {}
    });

    var computedElement = __assign(__assign({}, element), {
      text: element.text ? computedElementText(textState, isSelected) : null,
      location: location,
      isSelected: isSelected,
      points: points
    });

    return computedElement;
  });
};

var computedPanels = function (panels, fullBleed, selection) {
  return panels.map(function (panel, location) {
    var points = {
      x: panel.x * fullBleed.width,
      y: panel.y * fullBleed.height,
      width: panel.width * fullBleed.width,
      height: panel.height * fullBleed.height
    };
    return __assign(__assign({}, panel), {
      location: location,
      isSelected: fullBleed.location === selection.fullBleed && location === selection.panel,
      points: points,
      elements: computedElements(panel.elements, {
        location: location,
        width: points.width,
        height: points.height
      }, fullBleed, selection)
    });
  });
}; // TODO - was ComputedFullBleed[] (causing errors with flatMap)


var computedFullBleeds = function (editor) {
  return editor.card ? editor.card.fullBleeds.map(function (fullBleed, location) {
    return __assign(__assign({}, fullBleed), {
      location: location,
      backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
        location: 0,
        isSelected: !isNumber(editor.panelLocation),
        points: {
          x: fullBleed.backgroundElement.x * fullBleed.width,
          y: fullBleed.backgroundElement.y * fullBleed.height,
          width: fullBleed.backgroundElement.width * fullBleed.width,
          height: fullBleed.backgroundElement.height * fullBleed.height
        }
      }) : null,
      panels: computedPanels(fullBleed.panels, {
        location: location,
        width: fullBleed.width,
        height: fullBleed.height
      }, {
        fullBleed: editor.fullBleedLocation,
        panel: editor.panelLocation,
        element: editor.activeElement.location,
        textSelection: editor.textSelection
      })
    });
  }) : [];
};
var computedSingleFullBleeds = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed) {
    return fullbleed.panels.map(function (panel) {
      return __assign(__assign({}, fullbleed), {
        panels: [panel]
      });
    });
  });
};
var getPanelLocations = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed, fullbleedLocation) {
    return fullbleed.panels.map(function (_, panelLocation) {
      return {
        fullbleed: fullbleedLocation,
        panel: panelLocation
      };
    });
  });
};
var isHorizontalFullBleed = function (view, index, numFullBleeds, numPanels, isHorizontal) {
  // All back panels (for now) are portrait
  if (index === numFullBleeds - 1) {
    return false;
  }

  if (view === 'panel') {
    return isHorizontal;
  } else {
    if (index !== 1) {
      return isHorizontal;
    }

    if (numPanels > 1) {
      return !isHorizontal;
    }
  }

  return isHorizontal;
};

var FullBleedSettings = function () {
  var _a;

  var editor = useReduxState('editor');
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var backgroundElement = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.backgroundElement;
  var fullBleedLocation = editor.fullBleedLocation;
  var actions = useReduxActions();
  return jsx(VStack, {
    gap: "x3"
  }, ((_a = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _a === void 0 ? void 0 : _a.image) ? jsx(ImageSettings, {
    title: "Background Image Settings:",
    subtitle: "Apply the following settings to your background image",
    location: fullBleedLocation !== null && fullBleedLocation !== void 0 ? fullBleedLocation : 0,
    elementY: backgroundElement.y,
    elementX: backgroundElement.x,
    elementHeight: backgroundElement.height,
    elementWidth: backgroundElement.width,
    elementRotation: backgroundElement.rotation,
    imageY: backgroundElement.image.position.y,
    imageX: backgroundElement.image.position.x,
    imageScale: backgroundElement.image.scale,
    onUpdateSize: function (_location, width, height) {
      return actions.updateFullBleedBackgroundElementSize(width, height);
    },
    onUpdateRotation: function (_location, rotation) {
      return actions.updateFullBleedBackgroundElementRotation(rotation);
    },
    onUpdatePosition: function (_location, x, y) {
      return actions.updateFullBleedBackgroundElementPosition(x, y);
    },
    onSelectImageScale: actions.updateFullBleedBackgroundImageScale,
    onSelectImagePosition: actions.updateFullBleedBackgroundImagePosition,
    isLayoutElement: false
  }) : jsx(Text, {
    type: "body"
  }, "There is no background image"));
};

var ImageElementSettings = function () {
  var _a, _b, _c, _d, _e, _f, _g;

  var editor = useReduxState('editor');
  var activeElement = editor.activeElement;
  var selectedElement$1 = selectedElement(editor);
  var actions = useReduxActions();
  var scale = selectedElement$1 ? (_b = (_a = selectedElement$1.image) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1 : 0;
  var x = selectedElement$1 ? (_d = (_c = selectedElement$1.image) === null || _c === void 0 ? void 0 : _c.position.x) !== null && _d !== void 0 ? _d : 0.5 : 0;
  var y = selectedElement$1 ? (_f = (_e = selectedElement$1.image) === null || _e === void 0 ? void 0 : _e.position.y) !== null && _f !== void 0 ? _f : 0.5 : 0;
  var rotation = selectedElement$1 ? selectedElement$1.rotation : 0;
  var location = (_g = activeElement.location) !== null && _g !== void 0 ? _g : 0;
  return selectedElement$1 ? jsx(ImageSettings, {
    title: 'Image Settings',
    subtitle: 'Apply the following setting to your selected image',
    location: location,
    imageScale: scale,
    imageX: x,
    imageY: y,
    elementRotation: rotation,
    elementHeight: selectedElement$1.height,
    elementWidth: selectedElement$1.width,
    elementX: selectedElement$1.x,
    elementY: selectedElement$1.y,
    isLayoutElement: !selectedElement$1.draggable || false,
    onSelectImagePosition: actions.selectImagePosition,
    onSelectImageScale: actions.selectImageScale,
    onUpdatePosition: actions.updateElementPosition,
    onUpdateRotation: actions.updateElementRotation,
    onUpdateSize: actions.updateElementSize
  }) : jsx("div", null, "You don't have an image selected");
};

var DrawerSummary = function (_a) {
  var title = _a.title,
      elementCount = _a.elementCount,
      outset = _a.outset,
      _b = _a.color,
      color = _b === void 0 ? 'primaryHeading' : _b;
  return jsx(Flex, {
    outset: outset,
    flexDirection: "row",
    justifyContent: "space-between"
  }, jsx(Text, {
    inset: "x0",
    outset: "x0",
    lineHeight: 1.2,
    type: "footnote",
    weight: "semiBold",
    content: title,
    color: color
  }), jsx(Text, {
    inset: "x0",
    outset: "x0",
    lineHeight: 1.2,
    type: "footnote",
    content: "(" + elementCount + ")",
    color: color
  }));
};

var styles$6 = {
  stickersContainer: /*#__PURE__*/css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    ::-webkit-scrollbar {\n      width: 0; /* Remove scrollbar space */\n      background: transparent; /* Optional: just make scrollbar invisible */\n    }\n    scrollbar-width: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:stickersContainer;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHdUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzdGlja2Vyc0NvbnRhaW5lcjogY3NzKHRlbXBsYXRlT2JqZWN0XzEgfHwgKHRlbXBsYXRlT2JqZWN0XzEgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdLCBbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdKSkpLFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    ::-webkit-scrollbar {\n      width: 0; /* Remove scrollbar space */\n      background: transparent; /* Optional: just make scrollbar invisible */\n    }\n    scrollbar-width: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:stickersContainer;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHdUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzdGlja2Vyc0NvbnRhaW5lcjogY3NzKHRlbXBsYXRlT2JqZWN0XzEgfHwgKHRlbXBsYXRlT2JqZWN0XzEgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdLCBbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdKSkpLFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])))
};
var templateObject_1$a;

var InsertDrawerContent = function (_a) {
  var heading = _a.heading,
      description = _a.description,
      dataLength = _a.dataLength,
      hasMore = _a.hasMore,
      loadMore = _a.loadMore,
      grid = _a.grid,
      endMessage = _a.endMessage,
      drawerSummaryTitle = _a.drawerSummaryTitle,
      children = _a.children,
      actionElement = _a.actionElement,
      totalDataCount = _a.totalDataCount;

  var _b = useResizeObserver(),
      height = _b.height,
      ref = _b.ref;

  useEffect(function () {
    if (height && window.innerHeight > height && hasMore) {
      loadMore();
    }
  }, [height]); //eslint-disable-line

  return jsx(Flex, {
    inset: 'x1',
    height: '100%',
    width: "100%",
    flexDirection: "column"
  }, jsx(Div, null, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, heading), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, description)), actionElement && jsx(Div, {
    inset: {
      vertical: 'x2'
    }
  }, actionElement), typeof totalDataCount === 'number' && jsx(DrawerSummary, {
    outset: {
      vertical: 'x2'
    },
    elementCount: totalDataCount,
    title: drawerSummaryTitle
  }), jsx(Div, {
    overflowY: "auto",
    css: styles$6.stickersContainer,
    id: "scrollAble",
    ref: ref,
    height: "100%"
  }, jsx(InfiniteScroll, {
    css: styles$6.stickersContainer,
    hasMore: hasMore,
    dataLength: dataLength,
    height: height + "px",
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    endMessage: jsx(Flex, {
      position: "relative",
      width: "100%",
      flexDirection: "column",
      alignItems: "center",
      outset: {
        top: 'x4'
      }
    }, jsx(AnimatedCheckMark, {
      size: "small"
    }), jsx(Spacer, {
      space: "x1"
    }), jsx(Text, {
      type: "body"
    }, endMessage)),
    next: loadMore,
    scrollableTarget: "scrollAble"
  }, jsx(Grid, {
    columnSize: grid === null || grid === void 0 ? void 0 : grid.columnSize,
    rowSize: grid === null || grid === void 0 ? void 0 : grid.rowSize,
    gap: 16
  }, children))));
};

var UploadImagesOverlay = function (_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      onFinished = _a.onFinished,
      onUpload = _a.onUpload,
      _b = _a.hasMultiUpload,
      hasMultiUpload = _b === void 0 ? false : _b;
  return jsx(Flex, {
    animate: {
      opacity: 1
    },
    initial: {
      opacity: 0
    },
    exit: {
      opacity: 0
    },
    flexDirection: "column",
    height: "100%",
    width: "100%",
    backgroundColor: "background",
    position: "absolute",
    top: "0",
    inset: {
      left: 'x3',
      right: 'x1_5',
      vertical: 'x1'
    }
  }, jsx(CloseButton, {
    fill: "danger",
    top: "12px",
    right: "12px",
    onClose: function () {
      return onFinished();
    }
  }), jsx(Text, {
    weight: "extraBold",
    type: "largeBody",
    content: title
  }), jsx(Flex, {
    width: "80%"
  }, jsx(Text, {
    alignment: "left",
    lineHeight: 1.4,
    type: "caption",
    content: subtitle
  })), jsx(Spacer, {
    space: "x2"
  }), jsx(Div, {
    height: "100%",
    inset: {
      bottom: 'x4'
    }
  }, jsx(ImageUploader, {
    onUpload: function (files, fileList) {
      onUpload(files, fileList);
      onFinished();
    },
    acceptedFiles: ['gif', 'jpeg', 'jpg', 'png'],
    hasMultiupload: hasMultiUpload,
    backgroundColor: "foreground"
  })));
};

var Images = function (props) {
  var _a, _b;

  var images = props.images,
      onUploadImages = props.onUploadImages,
      onDelete = props.onDelete,
      isFullPanel = props.isFullPanel;
  var editor = useReduxState('editor');
  var activeElement = editor.activeElement;
  var editing = editor.editing;
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var selectedPanel$1 = selectedPanel(editor);
  var selectedElement$1 = selectedElement(editor);
  var shouldReplaceSelectedImage = useReduxState('editorChrome').shouldReplaceSelectedImage;
  var actions = useReduxActions();
  var selectImage = actions.selectImage;

  var _c = __read(useState(false), 2),
      isUploadOverlayOpen = _c[0],
      setIsUploadOverlayOpen = _c[1];

  var _d = __read(useState(false), 2),
      isEditable = _d[0],
      setIsEditable = _d[1];

  var _e = __read(useState(images.results.length), 2),
      imageQty = _e[0],
      setImageQty = _e[1];

  var hasFullBleedImage = ((_b = (_a = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.backgroundElement) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.image) ? true : false;

  var isImageElementIsSelected = function (location, elementType) {
    if (typeof location === 'number' && elementType === 'image') {
      return true;
    }

    return false;
  };

  var handleAddImage = function (image) {
    var _a;

    if (editing === 'fullbleed') {
      actions.setFullBleedBackgroundImage(image);
    } else if (shouldReplaceSelectedImage && isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type)) {
      actions.selectImage(image);
      actions.setActiveImageSetting('crop');
    } else if (isFullPanel) {
      var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
        var _a;

        return (element === null || element === void 0 ? void 0 : element.isFullPanel) && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
      });

      if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
        actions.selectImage(backgroundImage.image.image);
        actions.removeElement();
      }

      actions.addImageElement(image, true);
      actions.setActiveImageSetting('crop');
      actions.setShouldReplaceSelectedImage(false);
    } else {
      actions.openElementSettingsDrawer('image');
      actions.addImageElement(image);
      actions.setShouldReplaceSelectedImage(false);
      actions.setActiveImageSetting(null);
    }
  };

  useEffect(function () {
    var _a, _b;

    var isElementSticker = (_b = (_a = selectedElement$1 === null || selectedElement$1 === void 0 ? void 0 : selectedElement$1.image) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.isSticker;

    if (images.results.length - 1 === imageQty && selectedElement$1 && !isElementSticker) {
      var uploadedImage = images.results[0];
      uploadedImage && selectImage(uploadedImage);
    }

    setImageQty(images.results.length);
  }, [images, selectImage, selectedElement$1, imageQty, setImageQty]);
  return jsx(AnimatePresence, null, isUploadOverlayOpen ? jsx(UploadImagesOverlay, {
    onUpload: function (_files, fileList) {
      if (_files.rejected.length > 0) {
        return;
      }

      if (fileList && fileList.length > 0 && _files.accepted.length > 0) {
        onUploadImages === null || onUploadImages === void 0 ? void 0 : onUploadImages(fileList);
      }
    },
    onFinished: function () {
      return setIsUploadOverlayOpen(false);
    },
    title: "Upload Images",
    subtitle: "Personalize your card by adding an image"
  }) : jsx(InsertDrawerContent, {
    dataLength: images.results.length,
    heading: editing === 'fullbleed' ? hasFullBleedImage ? 'Change background image' : 'Add background image' : isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Change your image' : 'Add an image',
    description: isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Choose an image below to replace your current selection' : 'Choose an image below to add it to your selected panel',
    drawerSummaryTitle: "All Images",
    hasMore: images.hasMore,
    loadMore: images.loadMore,
    grid: {
      columnSize: 42,
      rowSize: 35
    },
    endMessage: "All Images Loaded",
    actionElement: jsx(Flex, {
      justifyContent: "space-between",
      alignItems: "center"
    }, jsx(Button, {
      size: "xSmall",
      type: "smoke",
      onClick: function () {
        return setIsUploadOverlayOpen(true);
      },
      title: "Upload Photo"
    }), jsx(Button, {
      size: "xSmall",
      type: "primary",
      onClick: function () {
        return setIsEditable(!isEditable);
      },
      outlined: true
    }, isEditable ? 'Select' : 'Delete'))
  }, images.results.map(function (image) {
    return jsx(GridItem, {
      gridColSpan: 2,
      gridRowSpan: image.width > image.height ? 2 : 4,
      borderRadius: 'medium',
      key: image.id
    }, jsx(Div, {
      position: "relative",
      width: "100%",
      height: "100%"
    }, isEditable && jsx(CloseButton, {
      onClose: function () {
        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(image.id);
      }
    }), jsx(Image$1, {
      image: {
        url: image.thumbnailUrl
      },
      onClick: function () {
        if (isEditable) {
          return;
        }

        handleAddImage(image);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    })));
  })));
};

var useOutsideClick = function (ref, shouldIgnoreClick, handleClick) {
  useEffect(function () {
    if (!ref || shouldIgnoreClick) {
      return;
    }

    var handleClickOutside = function (event) {
      if ((event === null || event === void 0 ? void 0 : event.target) instanceof Node && ref.current && !ref.current.contains(event.target)) {
        handleClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
};

var ColorPicker = function (_a) {
  var _b;

  var defaultColor = _a.defaultColor,
      onColorChange = _a.onColorChange,
      canRemoveColor = _a.canRemoveColor,
      isChangingBackground = _a.isChangingBackground;

  var _c = __read(useState(!isChangingBackground), 2),
      showColorPicker = _c[0],
      setShowColorPicker = _c[1];

  var strDefaultColor = defaultColor ? Color(defaultColor).hex() : '';
  var colorPalettes = useContext(EditorChromeContext).colorPalettes;

  var rgbToHex = function (r, g, b) {
    return '#' + [r, g, b].map(function (x) {
      return x.toString(16).padStart(2, '0');
    }).join('');
  };

  var convertedDefaultColor = defaultColor ? rgbToHex(defaultColor.r, defaultColor.g, defaultColor.b) : '#fff';

  var _d = __read(useState(convertedDefaultColor), 2),
      color = _d[0],
      setColor = _d[1];

  var editor = useReduxState('editor');
  var selectedPanel$1 = selectedPanel(editor);
  var colorPickerRef = useRef(null);
  useOutsideClick(colorPickerRef, !showColorPicker || !isChangingBackground, function () {
    return setShowColorPicker(false);
  });

  var handleRemoveColor = function () {
    onColorChange(null);
    setColor('#FFFFFF');
    setShowColorPicker(false);
  };

  useEffect(function () {
    try {
      if (convertedDefaultColor !== Color(color).hex().toLowerCase()) {
        setColor(strDefaultColor);
      }
    } catch (_a) {}
  }, [convertedDefaultColor]); //eslint-disable-line

  return jsx(Div, {
    ref: colorPickerRef
  }, jsx(VStack, {
    gap: "x2",
    inset: {
      horizontal: 'x1'
    }
  }, isChangingBackground && jsx(SettingInput, {
    inactiveTitle: "Add...",
    onRemove: function () {
      return handleRemoveColor();
    },
    settingsType: 'color',
    value: (selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor) ? Color(selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor).hex() : '#FFFFFF',
    onClick: function () {
      return setShowColorPicker(!showColorPicker);
    }
  }), showColorPicker && jsx(QuantumColorPicker, {
    color: color,
    onChange: function (color) {
      return setColor(color);
    },
    convertedColorType: "rgb",
    convertedColorCallback: function (color) {
      return onColorChange(color);
    },
    palette: {
      title: 'Card Colors',
      isLoading: colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.isLoading,
      colors: (_b = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.palette) === null || _b === void 0 ? void 0 : _b.map(function (palette) {
        return Color(palette).hex();
      })
    }
  }), canRemoveColor && jsx(Button, {
    onClick: handleRemoveColor,
    title: "Remove Color",
    outlined: true,
    size: "xSmall",
    hover: true
  })));
};

var BackgroundImageUploader = function (_a) {
  var _b, _c, _d;

  var images = _a.images;
  var actions = useReduxActions();
  var editor = useReduxState('editor');

  var _e = useReduxState('editorChrome'),
      activeImageSetting = _e.activeImageSetting,
      hasUploadedImage = _e.hasUploadedImage;

  var selectedPanel$1 = selectedPanel(editor);
  var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
    var _a;

    return element.isFullPanel && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
  });

  var _f = __read(useState(false), 2),
      showUploader = _f[0],
      setShowUploader = _f[1];

  var _g = __read(useState((_d = (_c = (_b = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null), 2),
      backgroundUrl = _g[0],
      setBackgroundUrl = _g[1];

  var handleRemoveBackgroundImage = useCallback(function () {
    var _a;

    if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
      actions.selectImage(backgroundImage.image.image);
      actions.removeElement();
      setBackgroundUrl('');
      setShowUploader(false);
    }
  }, [actions, backgroundImage]);
  useEffect(function () {
    var _a, _b, _c, _d;

    setBackgroundUrl((_c = (_b = (_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '');

    if ((_d = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _d === void 0 ? void 0 : _d.image) {
      actions.setActiveImageSetting('crop');
    }
  }, [backgroundImage, actions]);
  useEffect(function () {
    actions.setShouldReplaceSelectedImage(showUploader);
  }, [showUploader, actions]);
  useEffect(function () {
    if (hasUploadedImage) {
      var uploadedImage = images.results[0];

      if (uploadedImage) {
        setBackgroundUrl(uploadedImage.url);
        handleRemoveBackgroundImage();
        actions.addImageElement(uploadedImage, true);
        actions.setHasUploadedImage(false);
        actions.toggleImageUploaderWidget();
        actions.setActiveImageSetting('crop');
      }
    }
  }, [images, actions, hasUploadedImage, actions.setHasUploadedImage, handleRemoveBackgroundImage]);
  return jsx(VStack, {
    gap: "x2",
    inset: {
      horizontal: 'x1'
    }
  }, jsx(SettingInput, {
    inactiveTitle: "Add...",
    onRemove: function () {
      return handleRemoveBackgroundImage();
    },
    settingsType: "image",
    value: backgroundUrl,
    onClick: function () {
      return actions.toggleImageUploaderWidget();
    }
  }), jsx(React.Fragment, null, (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) && activeImageSetting === 'crop' && jsx(Div, null, jsx(Text, {
    type: "caption",
    outset: {
      top: 'x3',
      bottom: 'x1'
    }
  }, "Crop Background Settings"), jsx(CropSettings, {
    onSelectImagePosition: actions.selectImagePosition,
    onSelectImageScale: actions.selectImageScale,
    x: backgroundImage.image.position.x,
    y: backgroundImage.image.position.y,
    scale: backgroundImage.image.scale
  }))));
};

var PanelSettings = function (_a) {
  var _b;

  var images = _a.images,
      onUploadImages = _a.onUploadImages;
  var editor = useReduxState('editor');
  var isPanelBackgroundImage = editor.activeElement.type === 'image' && editor.editing === 'element';
  var selectedPanel$1 = selectedPanel(editor);
  var actions = useReduxActions();
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Panel Settings"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Adjust the background of your panel"), jsx(Div, {
    position: "relative"
  }, jsx(Settings, {
    startingActiveKey: "background_settings",
    sections: [{
      title: 'Background Settings',
      onClick: function () {},
      icon: 'colorPalette',
      key: 'background_settings',
      settings: jsx(Div, null, jsx(ColorPicker, {
        defaultColor: (_b = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor) !== null && _b !== void 0 ? _b : undefined,
        onColorChange: function (color) {
          return actions.setPanelBackground(color);
        },
        isChangingBackground: true
      }), jsx(Spacer, {
        space: "x4"
      }), jsx(BackgroundImageUploader, {
        images: images,
        onUploadImages: onUploadImages
      }))
    }]
  }), isPanelBackgroundImage && jsx(React.Fragment, null)));
};

var StickerThumbnail = function (_a) {
  var _b = _a.backgrounColor,
      backgrounColor = _b === void 0 ? 'background' : _b,
      url = _a.url,
      _c = _a.width,
      width = _c === void 0 ? '110px' : _c,
      _d = _a.height,
      height = _d === void 0 ? '110px' : _d,
      onClick = _a.onClick;
  return jsx(Flex, {
    width: width,
    height: height,
    backgroundColor: backgrounColor,
    borderRadius: "default",
    justifyContent: "center",
    alignItems: "center",
    inset: "x3",
    onClick: onClick,
    cursor: "pointer"
  }, jsx(Image$1, {
    width: '100%',
    height: '100%',
    isActive: true,
    image: {
      url: url
    },
    borderRadius: "none"
  }));
};

var Stickers = function (_a) {
  var _b, _c;

  var stickers = _a.stickers;
  var actions = useReduxActions();
  return jsx(InsertDrawerContent, {
    loadMore: stickers.loadMore,
    hasMore: !!(stickers === null || stickers === void 0 ? void 0 : stickers.hasMore),
    dataLength: (_c = (_b = stickers === null || stickers === void 0 ? void 0 : stickers.results) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0,
    endMessage: "All Stickers Loaded",
    description: "Insert fun Stickers onto your card",
    heading: "Add a Sticker",
    grid: {
      columnSize: 110,
      rowSize: 110
    },
    drawerSummaryTitle: "All Stickers",
    totalDataCount: stickers.results.length
  }, stickers.results.map(function (sticker) {
    var thumbnail = sticker.thumbnailUrl;
    return jsx(GridItem, {
      gridColSpan: 1,
      gridRowSpan: 1,
      key: sticker.id
    }, sticker.url && jsx(StickerThumbnail, {
      onClick: function () {
        actions.addImageElement({
          id: sticker.id,
          width: 700,
          height: 500,
          url: sticker.url,
          thumbnailUrl: sticker.thumbnailUrl
        }, undefined);
        actions.closeElementSettingsDrawer();
        actions.setShouldReplaceSelectedImage(false);
      },
      url: thumbnail
    }));
  }));
};

var FontTile = function (_a) {
  var font = _a.font,
      setFont = _a.setFont,
      active = _a.active;
  return jsx(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    outset: {
      left: 'x_5'
    },
    onClick: function () {
      return setFont(font.fontName);
    },
    cursor: "pointer"
  }, jsx(Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'default',
    position: "relative"
  }, jsx("p", {
    css: /*#__PURE__*/css({
      fontFamily: font.fontName,
      textAlign: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:FontTile;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvbnRUaWxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNVyIsImZpbGUiOiJGb250VGlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBGbGV4LCBJY29uIH0gZnJvbSAnQHNlbmRvdXRjYXJkcy9xdWFudHVtLWRlc2lnbi11aSc7XHJcbmV4cG9ydCB2YXIgRm9udFRpbGUgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBmb250ID0gX2EuZm9udCwgc2V0Rm9udCA9IF9hLnNldEZvbnQsIGFjdGl2ZSA9IF9hLmFjdGl2ZTtcclxuICAgIHJldHVybiAoPEZsZXggZmxleERpcmVjdGlvbj1cInJvd1wiIGp1c3RpZnlDb250ZW50PVwic3BhY2UtYmV0d2VlblwiIG91dHNldD17eyBsZWZ0OiAneF81JyB9fSBvbkNsaWNrPXtmdW5jdGlvbiAoKSB7IHJldHVybiBzZXRGb250KGZvbnQuZm9udE5hbWUpOyB9fSBjdXJzb3I9XCJwb2ludGVyXCI+XG4gICAgICA8RmxleCBqdXN0aWZ5Q29udGVudD17J2NlbnRlcid9IGFsaWduSXRlbXM9eydjZW50ZXInfSBib3JkZXJSYWRpdXM9eydkZWZhdWx0J30gcG9zaXRpb249XCJyZWxhdGl2ZVwiPlxuICAgICAgICA8cCBjc3M9e3sgZm9udEZhbWlseTogZm9udC5mb250TmFtZSwgdGV4dEFsaWduOiAnY2VudGVyJyB9fT5cbiAgICAgICAgICB7Zm9udC5kaXNwbGF5TmFtZX1cbiAgICAgICAgPC9wPlxuICAgICAgPC9GbGV4PlxuICAgICAge2FjdGl2ZSAmJiAoPEZsZXggaW5zZXQ9e3sgaG9yaXpvbnRhbDogJ3hfMjUnLCB0b3A6ICd4XzI1JywgYm90dG9tOiAneDEnIH19IG91dHNldD17eyByaWdodDogJ3hfNScgfX0gYWxpZ25JdGVtcz1cImNlbnRlclwiPlxuICAgICAgICAgIDxJY29uIG5hbWU9XCJjaGVja1wiIHByaW1hcnlDb2xvcj1cInByaW1hcnlIZWFkaW5nVGV4dFwiIHNpemU9XCJ4U21hbGxcIi8+XG4gICAgICAgIDwvRmxleD4pfVxuICAgIDwvRmxleD4pO1xyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1Gb250VGlsZS5qc3gubWFwIl19 */")
  }, font.displayName)), active && jsx(Flex, {
    inset: {
      horizontal: 'x_25',
      top: 'x_25',
      bottom: 'x1'
    },
    outset: {
      right: 'x_5'
    },
    alignItems: "center"
  }, jsx(Icon$1, {
    name: "check",
    primaryColor: "primaryHeadingText",
    size: "xSmall"
  })));
};

var FontFamilyGrid = function (_a) {
  var fonts = _a.fonts,
      onFontChange = _a.onFontChange;

  var _b = __read(useState(''), 2),
      fontSearch = _b[0],
      setFontSearch = _b[1];

  var _c = __read(useState({
    index: -1,
    fontName: ''
  }), 2),
      activeFontIndex = _c[0],
      setActiveFontIndex = _c[1];

  var handleFontChange = function (font, i) {
    onFontChange(font);
    setActiveFontIndex({
      index: i,
      fontName: font
    });
  };

  var mapFontsToTiles = function (font, i) {
    var isMatch = font.displayName.toLowerCase().includes(fontSearch.toLowerCase());
    return isMatch && jsx(ListItem, {
      key: font.fontName,
      orientation: "horizontal"
    }, jsx(FontTile, {
      font: font,
      setFont: function () {
        return handleFontChange(font.fontName, i);
      },
      active: i === activeFontIndex.index
    }));
  };

  var customFonts = fonts.filter(function (font) {
    return font.isCustomFont;
  }).map(mapFontsToTiles);
  return jsx(React.Fragment, null, jsx(Input, {
    isFullWidth: true,
    type: "text",
    value: fontSearch,
    onChange: setFontSearch,
    icon: "search",
    placeholder: "Search Fonts"
  }), jsx(Spacer, {
    space: "x2"
  }), jsx(Tabs, {
    defaultActiveKey: "system",
    height: "400px"
  }, jsx(Tab, {
    title: "System",
    tabKey: "system"
  }, jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, fonts.filter(function (font) {
    return !font.isCustomFont;
  }).map(mapFontsToTiles))), customFonts.length > 0 && jsx(Tab, {
    title: "Custom",
    tabKey: "custom"
  }, jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, customFonts))));
};

var FontFamilySettings = function () {
  var actions = useReduxActions();
  var fonts = useContext(EditorChromeContext).fonts;
  var activeTextSetting = useReduxState('editorChrome').activeTextSetting;
  return jsx(React.Fragment, null, activeTextSetting === 'family' && jsx(FontFamilyGrid, {
    fonts: fonts,
    onFontChange: actions.selectFontFamily
  }));
};

var alignmentOptions = [{
  icon: 'alignLeft',
  alignment: 'LEFT'
}, {
  icon: 'alignCenter',
  alignment: 'CENTER'
}, {
  icon: 'alignRight',
  alignment: 'RIGHT'
}];

var AlignmentSettings = function () {
  var actions = useReduxActions();

  var _a = __read(useState(-1), 2),
      selectedAlignmentIndex = _a[0],
      setSelectedAlignmentIndex = _a[1];

  var onAlignmentChange = function (alignment, index) {
    actions.selectTextAlign(alignment);
    setSelectedAlignmentIndex(index);
  };

  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Alignment:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, alignmentOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.alignment + " " + index,
      icon: option.icon,
      onClick: function () {
        return onAlignmentChange(option.alignment, index);
      },
      activeColor: "primaryBrand",
      isActive: index === selectedAlignmentIndex
    });
  })));
};

var InsertSettings = function (_a) {
  var onInsertSignature = _a.onInsertSignature,
      onInsertPlaceholder = _a.onInsertPlaceholder;

  var _b = useContext(EditorChromeContext),
      placeholders = _b.placeholders,
      signatures = _b.signatures;

  return jsx(Flex, null, jsx(Tabs, {
    defaultActiveKey: "signatures",
    height: '400px'
  }, signatures && jsx(Tab, {
    tabKey: "signatures",
    title: "Signatures"
  }, jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, signatures.map(function (signature) {
    return jsx(ListItem, {
      inset: "x1",
      orientation: "vertical",
      onClick: function () {
        return onInsertSignature(signature.fontName);
      }
    }, jsx("span", {
      key: signature.fontName,
      css: /*#__PURE__*/css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName)
    }, "\xE6"));
  }))), jsx(Tab, {
    tabKey: "placeholder",
    title: "Placeholders"
  }, jsx(List, {
    alignment: "left",
    orientation: "vertical"
  }, placeholders === null || placeholders === void 0 ? void 0 : placeholders.map(function (placeholder) {
    return jsx(ListItem, {
      onClick: function () {
        return onInsertPlaceholder(placeholder);
      },
      inset: "x1",
      orientation: "vertical",
      key: placeholder,
      cursor: "pointer"
    }, jsx(Text, {
      color: "primaryHeading",
      type: "body"
    }, placeholder));
  })))));
};
var templateObject_1$9;

var casingOptions = [{
  icon: 'uppercaseText',
  casing: 'uppercase'
}, {
  icon: 'lowercaseText',
  casing: 'lowercase'
}, {
  icon: 'capitalizedText',
  casing: 'capitalize'
}];
var CasingSettings = function (_a) {
  var onTextCasingUpdate = _a.onTextCasingUpdate,
      originalText = _a.originalText;

  var _b = __read(useState(null), 2),
      activeCasing = _b[0],
      setActiveCasing = _b[1];

  var isUpperCase = function (words) {
    return words === words.toUpperCase();
  };

  var isLowerCase = function (words) {
    return words === words.toLowerCase();
  };

  var isCapitalized = function (words) {
    var capitalizedWords = words.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return words === capitalizedWords;
  };

  useEffect(function () {
    if (isUpperCase(originalText)) {
      setActiveCasing('uppercase');
    } else if (isLowerCase(originalText)) {
      setActiveCasing('lowercase');
    } else if (isCapitalized(originalText)) {
      setActiveCasing('capitalize');
    } else {
      setActiveCasing(null);
    }
  }, [originalText]);
  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Casing:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, casingOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.casing + " " + index,
      icon: option.icon,
      onClick: function () {
        return onTextCasingUpdate(option.casing);
      },
      activeColor: "primaryBrand",
      isActive: activeCasing === option.casing
    });
  })));
};

var DEFAULT_FONT_SIZE = 16;

var TextSettings = function () {
  var actions = useReduxActions();
  var editor = useReduxState('editor'); // const activeElement = editor.activeElement

  var selectedElement$1 = selectedElement(editor);
  var textState$1 = textState(editor);
  var color = selectedColor(textState$1);
  var fontSize = selectedFontSize(textState$1);
  var text = selectedText(textState$1);
  return selectedElement$1 ? jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Text Settings:"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Apply the following setting to your selected text"), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: [{
      title: 'Font Family',
      onClick: function () {
        return actions.setActiveTextSetting('alignment');
      },
      icon: 'aText',
      settings: jsx(FontFamilySettings, null),
      key: 'alignment'
    }, {
      title: 'Settings',
      onClick: function () {
        return actions.setActiveTextSetting('alignment');
      },
      icon: 'fontSize',
      key: 'font_size',
      settings: jsx(VStack, {
        gap: "x2"
      }, jsx(Div, null, jsx(ElementIncrementSetting, {
        initial: fontSize ? fontSize / 100 : DEFAULT_FONT_SIZE / 100,
        title: "Size:",
        min: 8,
        max: 80,
        callback: function (value) {
          actions.selectFontSize(value * 100);
        },
        resetDependency: fontSize
      })), jsx(AlignmentSettings, null), jsx(CasingSettings, {
        originalText: text !== null && text !== void 0 ? text : '',
        onTextCasingUpdate: actions.updateTextCasing
      }))
    }, {
      title: 'Color',
      onClick: function () {
        return actions.setActiveTextSetting('casing');
      },
      icon: 'colorPalette',
      key: 'color',
      settings: jsx(Div, {
        outset: {
          vertical: 'x3'
        }
      }, jsx(ColorPicker, {
        defaultColor: color || {
          r: 51,
          b: 51,
          g: 51
        },
        onColorChange: function (color) {
          return actions.selectColor(color);
        }
      }))
    }, // TODO Discuss whether we want keep slider for rotate in layout/text settings
    // As of now is fairly problematic with moveable
    // {
    //   title: 'Rotate',
    //   onClick: () => actions.setActiveTextSetting('rotate'),
    //   icon: 'rotateRight',
    //   key: 'rotate',
    //   settings: (
    //     <Div inset={{ bottom: 'x3' }}>
    //       <ElementIncrementSetting
    //         title={'Rotation Degrees'}
    //         initial={selectedElement.rotation / 100}
    //         callback={value =>
    //           actions.updateElementRotation(
    //             activeElement?.location,
    //             value * 100,
    //           )
    //         }
    //         min={-360}
    //         max={360}
    //         sliderOrigin="center"
    //       />
    //     </Div>
    //   ),
    // },
    {
      title: 'Insert',
      onClick: function () {
        return actions.setActiveTextSetting('casing');
      },
      icon: 'signature',
      key: 'insert',
      settings: jsx(InsertSettings, {
        onInsertPlaceholder: actions.insertPlaceholder,
        onInsertSignature: actions.insertSignature
      })
    }]
  }))) : jsx("div", null, "There is no current text element selected");
};

var ChromePill = function () {
  var editor = useReduxState('editor');
  var editing = editor.editing,
      activeElement = editor.activeElement;
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var selectedPanel$1 = selectedPanel(editor);
  var selectedElement$1 = selectedElement(editor);
  var actions = useReduxActions();
  var isLayoutElement = !(selectedElement$1 === null || selectedElement$1 === void 0 ? void 0 : selectedElement$1.draggable);
  var clearPanel = {
    title: 'Clear Panel',
    icon: 'clearPanel',
    onClick: function () {
      return actions.clearPanel();
    },
    isActive: false
  };
  var view = editing !== 'fullbleed' ? {
    title: 'Edit Full Bleed',
    icon: 'fullBleed',
    onClick: function () {
      actions.setEditing('fullbleed');
      actions.openElementSettingsDrawer('fullbleed');
    },
    isActive: false
  } : {
    title: 'Edit Panel',
    icon: 'panelMode',
    onClick: function () {
      actions.setEditing('panel');
      actions.openElementSettingsDrawer('panel');
    },
    isActive: false
  };
  var elementSettings = isLayoutElement ? [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      if (activeElement.type === 'image') {
        actions.removeImage();
        actions.openElementSettingsDrawer('image');
      } else {
        actions.clearText();
        actions.openElementSettingsDrawer('text');
      }
    }
  }] : [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      actions.removeElement();
      actions.openElementSettingsDrawer('panel');
    }
  }, {
    title: 'Duplicate',
    icon: 'copy',
    onClick: function () {
      actions.duplicateElement();
      (activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) === 'image' ? actions.setActiveImageSetting(null) : actions.setActiveTextSetting(null);
    }
  }, {
    title: 'Layer Up',
    icon: 'layerUp',
    onClick: function () {
      return actions.layerUp(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }, {
    title: 'Layer Down',
    icon: 'layerDown',
    onClick: function () {
      return actions.layerDown(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }];
  var panelSettings = [{
    title: 'Add Panel Layout',
    icon: 'template',
    onClick: function () {
      return actions.openElementInsertDrawer('layouts');
    },
    isActive: false
  }, {
    title: 'Add Panel Image',
    icon: 'image',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(true);
      actions.openElementInsertDrawer('images');
      actions.addImageElement(undefined, true);
      actions.openElementSettingsDrawer('panel');
    },
    isActive: false
  }, {
    title: 'Add Panel Text',
    icon: 'fullBleedText',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(false);
      actions.openElementSettingsDrawer('text');
      actions.addTextElement(true);
    },
    isActive: false
  }];
  var fullBleedSettings = [{
    title: 'Add Full Bleed Image',
    icon: 'fullBleedImage',
    onClick: function () {
      return actions.openElementInsertDrawer('images');
    },
    isActive: false
  }, {
    title: 'Delete Full Bleed Image',
    icon: 'delete',
    onClick: function () {
      return actions.deleteFullBleedBackgroundImage();
    },
    isActive: false
  }];

  var getPillSettings = function (editing) {
    var _a, _b;

    var isOnInsidePanel = ((_a = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'inside';

    var shouldClearContent = function (element) {
      var _a, _b;

      return (selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.isLocked) && (!!((_a = element.image) === null || _a === void 0 ? void 0 : _a.image) || ((_b = element === null || element === void 0 ? void 0 : element.text) === null || _b === void 0 ? void 0 : _b.fragments.some(function (fragment) {
        return fragment.text;
      })));
    };

    var hasElementsToClear = (_b = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements) === null || _b === void 0 ? void 0 : _b.some(function (element) {
      return !element.locked && (element.draggable || !selectedPanel$1.isLocked || shouldClearContent(element));
    });
    var settings = isOnInsidePanel ? [view] : [];
    var clearPanelSettings = hasElementsToClear ? [clearPanel] : [];

    switch (editing) {
      case 'element':
        return __spread(elementSettings, settings, clearPanelSettings);

      case 'panel':
        return __spread(panelSettings, settings, clearPanelSettings);

      case 'fullbleed':
        return __spread(fullBleedSettings, settings, clearPanelSettings);
    }
  };

  return jsx(Pill, {
    items: __spread(getPillSettings(editing)),
    boxShadow: "light"
  });
};

var BetaBanner = function (_a) {
  var button = _a.button,
      banner = _a.banner,
      _b = _a.zIndex,
      zIndex = _b === void 0 ? 0 : _b,
      timeout = _a.timeout;
  var actions = useReduxActions();
  useEffect(function () {
    var timer = null;

    if (typeof timeout === 'number') {
      timer = setTimeout(function () {
        actions.closeBetaBanner();
      }, timeout);
    }

    return function () {
      return timer ? clearTimeout(timer) : undefined;
    };
  }, [actions, timeout]);
  return jsx(Div, {
    position: "absolute",
    top: "0px",
    width: "100%",
    minWidth: "816px",
    maxWidth: "1200px",
    zIndex: zIndex,
    initial: {
      y: '-110%',
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: '-100%',
      opacity: 0,
      transition: {
        delay: 0,
        duration: 0.3
      }
    },
    left: "0px",
    right: "0px",
    outset: {
      horizontal: 'auto',
      top: 'x1'
    },
    transition: {
      duration: 0.3,
      delay: 2,
      damping: 15,
      stiffness: 100,
      type: 'spring'
    }
  }, jsx(Banner, {
    status: banner.status,
    isOutlined: banner.isOutlined,
    onClose: banner.onClose
  }, jsx(Button, {
    type: "accent",
    textColorOverride: "primaryBody",
    title: button.title,
    size: "xSmall",
    onClick: function () {
      return button.onClick();
    }
  })));
};

var PREVIEW_ZOOM_VALUES = [{
  value: '4',
  label: '210%'
}, {
  value: '3.804',
  label: '200%'
}, {
  value: '3.279',
  label: '190%'
}, {
  value: '2.827',
  label: '180%'
}, {
  value: '2.437',
  label: '170%'
}, {
  value: '2.101',
  label: '160%'
}, {
  value: '1.811',
  label: '150%'
}, {
  value: '1.561',
  label: '140%'
}, {
  value: '1.346',
  label: '130%'
}, {
  value: '1.16',
  label: '120%'
}, {
  value: '1',
  label: '100%'
}];
var EDIT_ZOOM_VALUES = [{
  value: '1.35',
  label: '3x'
}, {
  value: '1.25',
  label: '2x'
}, {
  value: '1',
  label: '1x'
}];

var EditorWrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a = props.scale,
      scale = _a === void 0 ? 1 : _a;
  var controls = useAnimation();
  useEffect(function () {
    controls.start({
      scale: scale,
      transition: {
        duration: 0.3,
        damping: 15,
        stiffness: 100,
        type: 'spring'
      }
    });
  }, [scale, controls]);
  return jsx(Div, {
    ref: ref,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: props.width,
    height: props.height,
    animate: controls,
    inset: props.isPreviewMode ? 'x7' : 'x0'
  }, props.children);
});

var CircleIconButton = function (_a) {
  var icon = _a.icon,
      onClick = _a.onClick,
      size = _a.size,
      iconSize = _a.iconSize,
      outset = _a.outset,
      offsetIcon = _a.offsetIcon;
  return jsx(Flex, {
    onClick: onClick,
    width: size || '50px',
    height: size || '50px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: {
      swatch: 'grayScale',
      shade: '_600'
    },
    borderRadius: 'circle',
    boxShadow: 'mediumLight',
    outset: outset,
    cursor: 'pointer',
    inset: (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetLeft) ? {
      left: offsetIcon.insetLeft
    } : (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetRight) ? {
      right: offsetIcon.insetRight
    } : 'x0'
  }, jsx(Icon$1, {
    name: icon,
    size: iconSize || 'medium',
    primaryColor: 'inverseBodyText'
  }));
};

var Variations = function (_a) {
  var variationState = _a.variationState,
      onSelectVariation = _a.onSelectVariation,
      selectedVariation = _a.selectedVariation;

  var _b = __read(useState(false), 2),
      isExpanded = _b[0],
      setIsExpanded = _b[1];

  var _c = __read(useState(selectedVariation !== null && selectedVariation !== void 0 ? selectedVariation : 0), 2),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  return jsx(Stoplight, {
    isCollapsible: true,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    type: "colors",
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    orientation: 'horizontal'
  }, variationState.variations.map(function (v, i) {
    return jsx(ColorOption, {
      onClick: function () {
        if (activeIndex !== i) onSelectVariation(variationState.variations[i]);
      },
      hexColor: v.color
    });
  }));
};

var ViewModes = function (_a) {
  var onChangeView = _a.onChangeView;

  var _b = __read(useState(false), 2),
      isExpanded = _b[0],
      setIsExpanded = _b[1];

  var _c = __read(useState(0), 2),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  var _d = __read(useState(-1), 2),
      activeIndicatorTooltip = _d[0],
      setActiveIndicatorTooltip = _d[1];

  useEffect(function () {
    setActiveIndicatorTooltip(-1);
  }, []);
  return jsx(Flex, {
    position: "relative"
  }, jsx(Stoplight, {
    isCollapsible: true,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    type: "icons",
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    orientation: 'horizontal'
  }, jsx(Flex, {
    onClick: function () {
      return onChangeView('fullbleed');
    },
    justifyContent: "center",
    alignItems: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(1);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    },
    cursor: "pointer"
  }, jsx(Icon$1, {
    name: "fullBleed",
    size: "small",
    primaryColor: !activeIndex ? 'primaryBrand' : 'default'
  })), jsx(Flex, {
    onClick: function () {
      return onChangeView('panel');
    },
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    },
    cursor: "pointer"
  }, jsx(Icon$1, {
    name: "viewSinglePanel",
    size: "small",
    primaryColor: activeIndex ? 'primaryBrand' : 'default'
  }))), activeIndicatorTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    bottom: "46px",
    left: activeIndicatorTooltip === 1 ? '-32px' : activeIndicatorTooltip === 2 ? '-6.5px' : undefined,
    animate: activeIndicatorTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "bottom",
    title: activeIndicatorTooltip === 1 ? 'Fullbleed View' : 'Single Panel View'
  })));
};

var ChromeControls = function (_a) {
  var _b, _c;

  var onNextPanel = _a.onNextPanel,
      onPreviousPanel = _a.onPreviousPanel,
      onSelectVariation = _a.onSelectVariation,
      onChangeView = _a.onChangeView,
      zoomItems = _a.zoomItems,
      setActiveZoomIndex = _a.setActiveZoomIndex,
      activeZoomIndex = _a.activeZoomIndex,
      isPreviewMode = _a.isPreviewMode;

  var _d = useReduxState('editor'),
      editing = _d.editing,
      card = _d.card,
      fullBleedLocation = _d.fullBleedLocation,
      panelLocation = _d.panelLocation;

  var getPanelName = function () {
    var _a, _b;

    if (typeof fullBleedLocation === 'number' && typeof panelLocation === 'number') {
      var fullBleed = (_a = card === null || card === void 0 ? void 0 : card.fullBleeds) === null || _a === void 0 ? void 0 : _a[fullBleedLocation];
      var panel = (_b = fullBleed === null || fullBleed === void 0 ? void 0 : fullBleed.panels) === null || _b === void 0 ? void 0 : _b[panelLocation];
      return (panel === null || panel === void 0 ? void 0 : panel.name) || '';
    }

    return '';
  };

  var shouldShowVariation = getPanelName() === 'Front';
  var shouldHideView = ['Front', 'Back'].includes(getPanelName()); // TODO remove this and logical render after preview chrome gets designed

  var shouldHidePreviewToggle = true;
  useReduxActions();
  var hasColorVariations = ((_b = card === null || card === void 0 ? void 0 : card.variationState) === null || _b === void 0 ? void 0 : _b.variations) && card.variationState.variations.length > 1;

  var selectedVariation = (_c = card === null || card === void 0 ? void 0 : card.variationState) === null || _c === void 0 ? void 0 : _c.variations.findIndex(function (v) {
    var _a;

    return v.id === ((_a = card.variationState) === null || _a === void 0 ? void 0 : _a.selectedVariationID);
  });
  return jsx(Flex, {
    justifyContent: "space-between"
  }, editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'leftChevron',
    onClick: onPreviousPanel,
    outset: {
      right: 'x8'
    },
    offsetIcon: {
      insetRight: 'x_5'
    }
  }), jsx(HStack, {
    justify: "center",
    gap: "x1"
  }, !shouldHidePreviewToggle , !shouldHideView && jsx(ViewModes, {
    onChangeView: onChangeView
  }), jsx(Zoom, {
    items: zoomItems,
    onChange: setActiveZoomIndex,
    selectedOptionIndex: activeZoomIndex,
    background: "foreground"
  }), shouldShowVariation && hasColorVariations && (card === null || card === void 0 ? void 0 : card.variationState) && !isPreviewMode && jsx(Div, null, jsx(Variations, {
    selectedVariation: selectedVariation,
    variationState: card.variationState,
    onSelectVariation: function (id) {
      return onSelectVariation === null || onSelectVariation === void 0 ? void 0 : onSelectVariation(id);
    }
  }))), editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'rightChevron',
    onClick: onNextPanel,
    outset: {
      left: 'x8'
    },
    offsetIcon: {
      insetLeft: 'x_5'
    }
  }));
};

var PreviewMode = function (props) {
  var _a = __read(useState(PREVIEW_ZOOM_VALUES.length - 1), 2),
      activeZoomIndex = _a[0],
      setActiveZoomIndex = _a[1];

  var activeElement = useReduxState('editor').activeElement;

  var findZoomValueIndex = function (scale) {
    var exactIndex = PREVIEW_ZOOM_VALUES.findIndex(function (zoomVal) {
      return parseFloat(zoomVal.value) === scale;
    });
    var index = PREVIEW_ZOOM_VALUES.findIndex(function (zoomVal) {
      return parseFloat(zoomVal.value) > scale - 0.5 && parseFloat(zoomVal.value) < scale + 0.5;
    });
    return exactIndex === -1 ? index : exactIndex;
  };

  var memoizedReset = React.useCallback(function (cb) {
    if (activeZoomIndex === PREVIEW_ZOOM_VALUES.length - 1) {
      cb();
    }
  }, [activeZoomIndex]);
  var editorWrapperRef = useRef(null);
  var zoomPanPinchRef = useRef(null);
  return jsx(ChromeContentGrid$1, null, jsx(ChromeContentZone$1, null, jsx(Text, {
    type: "title",
    content: "Preview Mode"
  })), jsx(ChromeContentZone$1, null, jsx(TransformWrapper, {
    disabled: typeof (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) === 'number',
    wheel: {
      disabled: false
    },
    onZoom: function (_a) {
      var state = _a.state;
      return setActiveZoomIndex(findZoomValueIndex(state.scale));
    },
    initialPositionX: 0,
    initialPositionY: 0,
    maxScale: 4,
    minScale: 1,
    ref: zoomPanPinchRef
  }, function (_a) {
    var resetTransform = _a.resetTransform;
    memoizedReset(resetTransform);
    return jsx(TransformComponent, null, jsx(EditorWrapper, {
      width: "50vw",
      height: "50vh",
      ref: editorWrapperRef,
      isPreviewMode: true
    }, props.children));
  })), jsx(ChromeContentZone$1, null, jsx(ChromeControls, {
    isPreviewMode: true,
    onNextPanel: props.handleNextPanel,
    onPreviousPanel: props.handlePreviousPanel,
    onChangeView: props.onChangeView,
    zoomItems: PREVIEW_ZOOM_VALUES,
    setActiveZoomIndex: function (index) {
      var _a;

      if (zoomPanPinchRef.current) {
        setActiveZoomIndex(index);
        (_a = zoomPanPinchRef.current) === null || _a === void 0 ? void 0 : _a.centerView(parseFloat("" + PREVIEW_ZOOM_VALUES[index].value), 300, 'easeInOutQuad');
      }
    },
    activeZoomIndex: activeZoomIndex
  })));
};

var LocationTip = function (_a) {
  var location = _a.location;
  return jsx(Div, {
    backgroundColor: {
      swatch: 'primaryBrand',
      shade: '_100'
    },
    borderRadius: "default",
    inset: {
      horizontal: 'x2',
      vertical: 'x1'
    },
    display: "inline-flex"
  }, jsx(Span, {
    display: "inline-flex"
  }, jsx(Text, {
    type: "caption",
    content: "Location:",
    weight: "bold",
    color: "inverseBody"
  }), jsx(Spacer, {
    space: "x_5",
    orientation: "horizontal"
  }), jsx(Text, {
    type: "caption",
    content: location,
    color: "inverseBody"
  })));
};

var ChromeContentGrid$1 = function (_a) {
  var children = _a.children;
  return jsx("div", {
    css: /*#__PURE__*/css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: hidden;\n        #chromeContentZone {\n          overflow-y: auto;\n\n          /* hide scrollbar for IE, Edge and Firefox */\n          -ms-overflow-style: none;\n          scrollbar-width: none;\n        }\n\n        /* hide scrollbar for chrome, safari and opera */\n        #chromeContentZone::-webkit-scrollbar {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: hidden;\n        #chromeContentZone {\n          overflow-y: auto;\n\n          /* hide scrollbar for IE, Edge and Firefox */\n          -ms-overflow-style: none;\n          scrollbar-width: none;\n        }\n\n        /* hide scrollbar for chrome, safari and opera */\n        #chromeContentZone::-webkit-scrollbar {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])))
  }, children);
};
var ChromeContentZone$1 = function (props) {
  var _a = props.align,
      align = _a === void 0 ? 'center' : _a,
      _b = props.justify,
      justify = _b === void 0 ? 'center' : _b,
      _c = props.rowSpan,
      rowSpan = _c === void 0 ? 1 : _c,
      _d = props.columnSpan,
      columnSpan = _d === void 0 ? 1 : _d,
      zIndex = props.zIndex;
  return jsx("div", {
    id: "chromeContentZone",
    css: /*#__PURE__*/css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n        overflow-y: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n        overflow-y: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), typeof columnSpan === 'number' ? "span " + columnSpan : columnSpan, typeof rowSpan === 'number' ? "span " + rowSpan : rowSpan, justify, align, zIndex)
  }, props.children);
};
var ChromeContent = function (_a) {
  var _b, _c;

  var children = _a.children,
      height = _a.height,
      _d = _a.xOffset,
      xOffset = _d === void 0 ? 0 : _d,
      onPreviousPanel = _a.onPreviousPanel,
      onNextPanel = _a.onNextPanel,
      onChangeView = _a.onChangeView;

  var _e = __read(useState(EDIT_ZOOM_VALUES.length - 1), 2),
      activeZoomIndex = _e[0],
      setActiveZoomIndex = _e[1];

  var _f = useReduxState('editorChrome'),
      showBetaBanner = _f.showBetaBanner,
      interactionMode = _f.interactionMode;

  var _g = useReduxState('editor'),
      card = _g.card,
      fullBleedLocation = _g.fullBleedLocation,
      panelLocation = _g.panelLocation;

  var panelName = typeof fullBleedLocation === 'number' && typeof panelLocation === 'number' && ((_c = (_b = card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation]) === null || _b === void 0 ? void 0 : _b.panels[panelLocation]) === null || _c === void 0 ? void 0 : _c.name);
  var actions = useReduxActions();

  var handleSelectVariation = function (variation) {
    actions.selectVariation(variation.id);
  };

  return jsx(Section, {
    backgroundColor: "background",
    width: "calc(100vw - " + xOffset + "px)",
    height: height,
    outset: {
      left: xOffset + "px"
    },
    minWidth: "880px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflowY: "hidden"
  }, jsx(AnimatePresence, null, showBetaBanner && jsx(BetaBanner, {
    timeout: 30000,
    zIndex: 6,
    button: {
      title: 'Dismiss',
      onClick: actions.closeBetaBanner
    },
    banner: {
      status: 'danger',
      bannerTitle: {
        icon: 'exclamation',
        message: 'Warning: For the best experience, please deactive browser plugins or OS settings that automatically alter text inputs, as the beta release of the new editor does not currently support them.'
      }
    }
  })), interactionMode === 'edit' ? jsx(ChromeContentGrid$1, null, jsx(ChromeContentZone$1, {
    columnSpan: 1
  }, jsx(Div, {
    outset: {
      top: 'x2'
    }
  }, jsx(ChromePill, null))), jsx(ChromeContentZone$1, null, jsx(EditorWrapper, {
    width: "50vw",
    height: "50vh",
    scale: parseFloat(EDIT_ZOOM_VALUES[activeZoomIndex].value)
  }, children)), jsx(ChromeContentZone$1, {
    columnSpan: 1,
    justify: "center",
    align: "center",
    zIndex: 6
  }, typeof panelName === 'string' && interactionMode === 'edit' && jsx(LocationTip, {
    location: panelName
  }), jsx(ChromeControls, {
    activeZoomIndex: activeZoomIndex,
    setActiveZoomIndex: setActiveZoomIndex,
    onNextPanel: onNextPanel,
    onPreviousPanel: onPreviousPanel,
    onChangeView: onChangeView,
    onSelectVariation: handleSelectVariation,
    zoomItems: EDIT_ZOOM_VALUES,
    isPreviewMode: false
  }))) : jsx(PreviewMode, {
    handleNextPanel: onNextPanel,
    handlePreviousPanel: onPreviousPanel,
    onChangeView: onChangeView
  }, children));
};
var templateObject_1$8, templateObject_2$3;

var ChromeUndoRedo = function () {
  var actions = useReduxActions();

  var _a = __read(useState(-1), 2),
      undoRedoTooltip = _a[0],
      setUndoRedoTooltip = _a[1];

  var handleKeyDown = function (event) {
    var isMetaOrCtrl = event.metaKey || event.ctrlKey;
    var isShift = event.shiftKey;

    if (event.key === 'z' && isMetaOrCtrl && isShift || event.key === 'y' && isMetaOrCtrl) {
      actions.editorRedo();
    }

    if (event.key === 'z' && isMetaOrCtrl) {
      actions.editorUndo();
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
  return jsx(Flex, {
    position: "absolute"
  }, jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(1);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return actions.editorUndo();
    },
    icon: 'undo',
    size: "small",
    fill: "primaryHeadingText"
  })), jsx(Spacer, {
    orientation: "horizontal",
    space: "x2"
  }), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(2);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return actions.editorRedo();
    },
    icon: 'redo',
    size: "small",
    fill: "primaryHeadingText"
  })), undoRedoTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    top: "-60px",
    left: undoRedoTooltip === 1 ? '-12px' : undefined,
    right: undoRedoTooltip === 2 ? '-12px' : undefined,
    animate: undoRedoTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "bottom",
    title: undoRedoTooltip === 1 ? 'Undo' : 'Redo'
  })));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "nfd03i",
  styles: "margin-right:1rem"
} : {
  name: "f16xme-ChromeBottomBar",
  styles: "margin-right:1rem;label:ChromeBottomBar;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};

var ChromeBottomBar = function (_a) {
  var _b, _c;

  var contextZones = _a.contextZones,
      saveActions = _a.saveActions,
      height = _a.height,
      zIndex = _a.zIndex,
      xOffset = _a.xOffset,
      isPreviewMode = _a.isPreviewMode;

  var _d = __read(useState(false), 2),
      isSaveContextExpanded = _d[0],
      setIsSaveContextExpanded = _d[1];

  var actions = useReduxActions();
  return jsx(Flex, {
    width: "100%",
    height: height,
    backgroundColor: "foreground",
    position: "fixed",
    bottom: "0px",
    justifyContent: "center",
    alignItems: "center",
    zIndex: zIndex,
    inset: {
      left: xOffset + "px"
    }
  }, jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center"
  }, contextZones.secondary), jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    width: "calc(100% / 3)"
  }, jsx(AnimatePresence, null, !isPreviewMode && jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    exit: {
      opacity: 0,
      y: 70
    },
    initial: {
      opacity: 0,
      y: 70
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3
    }
  }, jsx(ChromeUndoRedo, null)))), jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center",
    inset: {
      right: 'x2'
    }
  }, jsx(Div, {
    css: _ref$2
  }, jsx(ButtonWithMenu, {
    menuLocation: "top",
    menuOptions: contextZones.save ? __spread(contextZones.save.options, saveActions) : __spread(saveActions),
    isExpanded: isSaveContextExpanded,
    isLoading: (_b = contextZones === null || contextZones === void 0 ? void 0 : contextZones.save) === null || _b === void 0 ? void 0 : _b.isLoading,
    loadingMessage: (_c = contextZones === null || contextZones === void 0 ? void 0 : contextZones.save) === null || _c === void 0 ? void 0 : _c.loadingMessage,
    onClick: function () {
      return setIsSaveContextExpanded(!isSaveContextExpanded);
    },
    title: 'Save',
    size: "xSmall",
    fullWidth: true,
    type: "shadow",
    outlined: true
  })), jsx("div", {
    onClick: function () {
      return actions.saveAndSend();
    }
  }, contextZones === null || contextZones === void 0 ? void 0 : contextZones.primary), contextZones.externalActions));
};

var PanelElementSidebar = function (_a) {
  var helpIcon = _a.helpIcon,
      isPreviewMode = _a.isPreviewMode,
      panelOptions = _a.panelOptions;

  var _b = __read(useState(-1), 2),
      sidebarHoverIndex = _b[0],
      setSidebarHoverIndex = _b[1];

  var _c = useReduxState('editorChrome'),
      isElementInsertOpen = _c.isElementInsertOpen,
      elementInsertDrawerType = _c.elementInsertDrawerType;

  var actions = useReduxActions();
  var editor = useReduxState('editor');
  var selectedPanel$1 = selectedPanel(editor);
  var activeElement = editor.activeElement;

  var getLockedOptions = function () {
    var allLocked = ['image', 'sticker', 'template', 'text'];
    var activeElementType = typeof activeElement.location === 'number' && activeElement.type ? activeElement.type : null;
    var isLockedPanel = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.isLocked;
    if (!isLockedPanel) return [];

    if (activeElementType === null) {
      return allLocked;
    }

    var modes = {
      sticker: allLocked,
      text: allLocked,
      image: ['text', 'sticker', 'template']
    };
    return modes[activeElementType];
  };

  var lockedOptions = getLockedOptions();
  var tooltipVariants = {
    hoverOn: {
      opacity: 1
    },
    hoverOff: {
      opacity: 0
    }
  };
  return jsx(Sidebar, {
    position: "left",
    zIndex: 6,
    width: "70px"
  }, jsx(Div, {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Section, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Span, {
    inset: {
      vertical: 'x2'
    }
  }, jsx(Icon$1, {
    name: 'socLogo',
    size: "medium",
    primaryColor: "primaryBrand"
  })), jsx(Span, null, jsx(IconLink, {
    icon: "hamburger",
    fill: 'primaryBodyText',
    size: "small",
    onClick: function () {
      return isElementInsertOpen && elementInsertDrawerType === 'clientNav' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('clientNav');
    }
  }))), jsx(AnimatePresence, null, !isPreviewMode && jsx(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, panelOptions.map(function (option, index) {
    var isLocked = lockedOptions.includes(option.key);
    return jsx(Div, {
      exit: {
        opacity: 0,
        x: -70
      },
      initial: {
        opacity: 0,
        x: -70
      },
      animate: {
        opacity: 1,
        x: 0
      },
      transition: {
        duration: 0.3
      },
      "data-feature": option.dataFeature
    }, jsx(Flex, {
      key: index,
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      onHoverStart: function () {
        setSidebarHoverIndex(index + 1);
      },
      onHoverEnd: function () {
        return setSidebarHoverIndex(-1);
      }
    }, jsx(IconLink, {
      isDisabled: isLocked,
      hasBackgroundColor: option.isActive,
      onClick: function () {
        return option.onClick();
      },
      icon: option.icon,
      title: option.title,
      size: "small",
      isStacked: true,
      isActive: option.isActive
    }), sidebarHoverIndex === index + 1 && jsx(Flex, {
      position: "absolute",
      left: "75px",
      variants: tooltipVariants,
      animate: sidebarHoverIndex ? 'hoverOn' : 'hoverOff',
      initial: 'hoverOff',
      transition: {
        ease: 'easeIn',
        duration: 0.2
      }
    }, jsx(Tooltip, {
      direction: "left",
      title: isLocked ? 'Locked Panel' : "Add " + option.title,
      background: "dark"
    }))), jsx(Spacer, {
      space: 'x4'
    }));
  }))), jsx(Section, null, helpIcon)));
};

var ChromeSidebar = function (_a) {
  var helpIcon = _a.helpIcon,
      isPreviewMode = _a.isPreviewMode;

  var _b = useReduxState('editorChrome'),
      isElementInsertOpen = _b.isElementInsertOpen,
      elementInsertDrawerType = _b.elementInsertDrawerType;

  var actions = useReduxActions();
  var panelOptions = [{
    title: 'Image',
    icon: 'image',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'images' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('images');
    },
    isActive: elementInsertDrawerType === 'images' && isElementInsertOpen,
    key: 'image'
  }, {
    title: 'Text',
    icon: 'textBox',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(false);
      actions.addTextElement();
      actions.closeElementInsertDrawer();
      actions.openElementSettingsDrawer('text');
    },
    key: 'text'
  }, {
    title: 'Stickers',
    icon: 'stickers',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'stickers' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('stickers');
    },
    isActive: elementInsertDrawerType === 'stickers' && isElementInsertOpen,
    dataFeature: 'stickers',
    key: 'sticker'
  }, {
    title: 'Template',
    icon: 'template',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'layouts' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('layouts');
    },
    key: 'template',
    isActive: elementInsertDrawerType === 'layouts' && isElementInsertOpen
  }];
  return jsx(PanelElementSidebar, {
    helpIcon: helpIcon,
    panelOptions: panelOptions,
    isPreviewMode: isPreviewMode
  });
};

var DesktopChrome = function (props) {
  var children = props.children,
      layouts = props.layouts,
      images = props.images,
      stickers = props.stickers,
      onUploadImages = props.onUploadImages,
      helpIcon = props.helpIcon,
      contextZones = props.contextZones,
      handleNextPanel = props.handleNextPanel,
      handlePreviousPanel = props.handlePreviousPanel,
      handleChangeView = props.handleChangeView,
      customBackPanels = props.customBackPanels,
      onSaveBackPanel = props.onSaveBackPanel,
      onCreateBackPanel = props.onCreateBackPanel,
      defaultBackPanels = props.defaultBackPanels,
      onDeleteBackPanel = props.onDeleteBackPanel,
      onSelectBackLayout = props.onSelectBackLayout,
      onDeleteImage = props.onDeleteImage,
      onSetDefaultBackPanel = props.onSetDefaultBackPanel,
      defaultBackPanelId = props.defaultBackPanelId;

  var _a = useReduxState('editor'),
      editing = _a.editing,
      card = _a.card,
      fullBleedLocation = _a.fullBleedLocation,
      layoutToLoad = _a.layoutToLoad,
      activeFullBleedLocation = _a.fullBleedLocation;

  var _b = useReduxState('editorChrome'),
      isElementInsertOpen = _b.isElementInsertOpen,
      isElementSettingsOpen = _b.isElementSettingsOpen,
      elementInsertDrawerType = _b.elementInsertDrawerType,
      elementSettingsDrawerType = _b.elementSettingsDrawerType,
      interactionMode = _b.interactionMode,
      isImageUploaderWidgetActive = _b.isImageUploaderWidgetActive;

  var canShowWidget = isElementSettingsOpen && elementSettingsDrawerType === 'panel';
  var isPreviewMode = interactionMode === 'preview';
  var actions = useReduxActions();
  var isOnBackPanel = (card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation].name.toLowerCase()) === 'back';
  var bottomBarHeight = 60;
  var sideBarWidth = 70;
  var isFrontPanelLocked = (card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked) !== undefined && (card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked);

  var renderElementInsertDrawerContent = function (insertType) {
    switch (insertType) {
      case 'images':
        return jsx(Images, {
          images: images,
          onUploadImages: onUploadImages,
          loaderComponent: jsx(LoadingSpinner, {
            size: "medium"
          }),
          onDelete: onDeleteImage
        });

      case 'layouts':
        return isOnBackPanel ? jsx(BackPanels, {
          onSetDefaultBackPanel: onSetDefaultBackPanel,
          defaultBackPanelId: defaultBackPanelId,
          defaultBackPanels: defaultBackPanels,
          customBackPanels: customBackPanels,
          onDelete: onDeleteBackPanel,
          onSelectBackLayout: onSelectBackLayout
        }) : jsx(Layouts, {
          title: "Add a Design Layout",
          subtitle: "Choose pre-designed layout below to add a nice design to your card",
          layouts: layouts
        });

      case 'clientNav':
        return (contextZones === null || contextZones === void 0 ? void 0 : contextZones.clientNavigation) && jsx(ClientNavigation, {
          clientNav: contextZones.clientNavigation
        });

      case 'stickers':
        return jsx(Stickers, {
          stickers: stickers
        });

      default:
        return jsx(React.Fragment, null);
    }
  };

  var renderSettingsDrawerContent = function (settingType) {
    switch (settingType) {
      case 'image':
        return jsx(ImageElementSettings, null);

      case 'text':
        return jsx(TextSettings, null);

      case 'panel':
        return jsx(PanelSettings, {
          images: images,
          onUploadImages: onUploadImages
        });

      case 'fullbleed':
        return jsx(FullBleedSettings, null);

      default:
        return jsx(React.Fragment, null);
    }
  };

  React.useEffect(function () {
    if (editing === 'panel') {
      if (activeFullBleedLocation !== 0 || activeFullBleedLocation === 0 && !isFrontPanelLocked) actions.openElementSettingsDrawer('panel');else if (activeFullBleedLocation === 0 && isFrontPanelLocked) actions.closeElementSettingsDrawer();
    }
  }, [editing, card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked]); // eslint-disable-line

  var currentPanel = card === null || card === void 0 ? void 0 : card.fullBleeds.filter(function (fullBleed) {
    return fullBleed.name.toLowerCase() === 'back';
  }).filter(function (fullBleed) {
    return fullBleed.panels.filter(function (panel) {
      return panel.name.toLowerCase() === 'back';
    });
  })[0].panels[0];
  var backPanelSaveActions = [{
    title: 'Save new back panel',
    onClick: function () {
      return currentPanel && layoutToLoad && onCreateBackPanel(currentPanel, layoutToLoad);
    }
  }, {
    title: 'Save existing back panel',
    onClick: function () {
      return currentPanel && layoutToLoad && onSaveBackPanel(currentPanel, layoutToLoad);
    }
  }];
  var saveActions = isOnBackPanel ? __spread(backPanelSaveActions) : [];
  var editor = useReduxState('editor');
  var selectedPanel$1 = selectedPanel(editor);

  var handleAddImage = function (image) {
    var _a;

    var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
      var _a;

      return (element === null || element === void 0 ? void 0 : element.isFullPanel) && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
    });

    if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
      actions.selectImage(backgroundImage.image.image);
      actions.removeElement();
    }

    actions.addImageElement(image, true);
    actions.setActiveImageSetting('crop');
    actions.setShouldReplaceSelectedImage(false);
  };

  var userImages = images.results.map(function (image) {
    return {
      url: image.url,
      isHorizontal: image.width > image.height,
      onClick: function () {
        handleAddImage(image);
        actions.toggleImageUploaderWidget();
      }
    };
  });
  var rightDrawerOpenValue = 315;
  var windowWidth = useWindowSize().width;
  var widgetWidth = 264;
  var widgetOffsetPadding = 50;
  var imageUploadWidgetOffset = windowWidth - rightDrawerOpenValue - widgetWidth - widgetOffsetPadding;
  return jsx(React.Fragment, null, jsx(Flex, {
    position: "absolute",
    left: 0,
    overflow: "hidden",
    zIndex: 0
  }, jsx(Drawer, {
    isTabHidden: true,
    zIndex: 5,
    location: "left",
    offset: 60,
    openValue: 298,
    isOpen: isElementInsertOpen,
    onClick: function () {
      return actions.closeElementInsertDrawer();
    },
    overflow: "hidden",
    tabMode: "dark"
  }, jsx(Flex, {
    width: "100%",
    height: "100%",
    alignItems: "center",
    flexDirection: "column",
    inset: "x1",
    overflowY: "auto"
  }, renderElementInsertDrawerContent(elementInsertDrawerType))), jsx(ChromeContent, {
    onNextPanel: handleNextPanel,
    onPreviousPanel: handlePreviousPanel,
    onChangeView: handleChangeView,
    height: "calc(100vh - " + bottomBarHeight + "px)",
    xOffset: sideBarWidth
  }, children), jsx(Drawer, {
    tabMode: "dark",
    isTabHidden: isPreviewMode,
    zIndex: 8,
    location: "right",
    openValue: rightDrawerOpenValue,
    isOpen: isElementSettingsOpen,
    onClick: function () {
      return isElementSettingsOpen ? actions.closeElementSettingsDrawer() : typeof elementSettingsDrawerType === 'string' && actions.openElementSettingsDrawer(elementSettingsDrawerType);
    },
    overflow: "auto",
    shoudHideScroll: true
  }, renderSettingsDrawerContent(elementSettingsDrawerType))), jsx(ChromeBottomBar, {
    saveActions: saveActions,
    contextZones: contextZones,
    height: bottomBarHeight + "px",
    zIndex: 5,
    xOffset: sideBarWidth,
    isPreviewMode: isPreviewMode
  }), jsx(ChromeSidebar, {
    helpIcon: helpIcon,
    isPreviewMode: isPreviewMode
  }), jsx(ImageUploadWidget, {
    title: "Background Image",
    onClose: function () {
      return actions.toggleImageUploaderWidget();
    },
    onFinished: function () {
      return actions.toggleImageUploaderWidget();
    },
    isOpen: isImageUploaderWidgetActive && canShowWidget,
    onUpload: function (files, fileList) {
      if (files.rejected.length > 0) {
        // TODO: Show user error if upload error?
        return;
      }

      if (fileList && fileList.length > 0 && files.accepted.length > 0) {
        actions.setShouldReplaceSelectedImage(true);
        onUploadImages(fileList);
        actions.setHasUploadedImage(true);
      }
    },
    userImages: userImages,
    x: imageUploadWidgetOffset,
    y: 267,
    hasMore: images.hasMore,
    loadMore: images.loadMore,
    dataLength: images.results.length,
    endMessage: "All Images Loaded",
    width: widgetWidth
  }));
};

var Duvet = function (_a) {
  var onClose = _a.onClose,
      children = _a.children,
      isOpen = _a.isOpen,
      openValue = _a.openValue,
      directionArrow = _a.directionArrow,
      headerOffset = _a.headerOffset;
  var y = useMotionValue(0);
  var safeOpenValue = openValue > window.innerHeight ? window.innerHeight : openValue;
  var openOffset = window.innerHeight - safeOpenValue;
  var dragControls = useDragControls();

  var startDrag = function (event) {
    dragControls.start(event);
  };

  var handleDrag = useCallback(function (_, _a) {
    var delta = _a.delta;
    y.set(Math.max(y.get() + delta.y, openOffset));
  }, [y, openOffset]);
  var handleDragEnd = useCallback(function (_, _a) {
    var velocity = _a.velocity;

    if (velocity.y > 500) {
      onClose();
    } else {
      var yOffset = window.innerHeight - y.get();
      var snapTo = yOffset / safeOpenValue > 0.4 ? openOffset : window.innerHeight;
      animate(y, snapTo, {
        type: 'spring',
        stiffness: 300,
        damping: 30,
        mass: 0.2
      });
    }
  }, [y, safeOpenValue, openOffset]);
  return jsx(AnimatePresence, null, isOpen && jsx(Div, {
    boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 10%);",
    borderRadius: {
      top: 'large'
    },
    key: "duvet",
    width: '100%',
    drag: "y",
    transition: {
      stiffness: 300,
      damping: 30,
      mass: 0.2
    },
    maxHeight: "calc(100% - 125px)",
    height: "100%",
    backgroundColor: 'foreground',
    dragConstraints: {
      top: 0,
      bottom: window.innerHeight
    },
    dragMomentum: false,
    dragElastic: 0,
    style: {
      y: y
    },
    initial: {
      y: window.innerHeight
    },
    animate: {
      y: openOffset
    },
    dragControls: dragControls,
    onDrag: handleDrag,
    onDragEnd: handleDragEnd,
    position: "fixed",
    bottom: "66px",
    overflow: "hidden",
    "data-should-drag": "true",
    dragListener: false
  }, jsx(Flex, {
    position: "fixed",
    top: "x2",
    right: "x2",
    onClick: onClose,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F5F5F5",
    borderRadius: "circle",
    inset: ".5rem",
    zIndex: 2
  }, jsx(Icon$1, {
    name: "close",
    size: 14,
    primaryColor: "primaryBodyText"
  })), jsx(Div, {
    position: "absolute",
    top: "16px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
    "data-should-drag": "true",
    onTapStart: startDrag
  }, jsx(Div, {
    width: "50px",
    height: "4px",
    borderRadius: "large",
    backgroundColor: {
      swatch: 'grayScale',
      shade: '_1000'
    },
    "data-should-drag": "true",
    style: {
      cursor: 'grab'
    }
  }), directionArrow && jsx(Span, {
    cursor: "pointer",
    onClick: directionArrow.onClick,
    inset: {
      top: 'x_5'
    },
    transform: "rotate(" + (directionArrow.direction === 'up' ? '0deg' : '180deg') + ")"
  }, jsx(Icon$1, {
    name: "chevron",
    size: "small",
    primaryColor: "default",
    orientation: 'up'
  }))), jsx(Div, {
    position: "absolute",
    top: headerOffset,
    left: "0px",
    inset: {
      horizontal: 'x2'
    },
    width: "100%",
    height: openValue + "px",
    overflow: "hidden",
    "data-should-drag": "true"
  }, children)));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "i5syz",
  styles: "background-color:#bada55"
} : {
  name: "fxz4jj-MobileChromeControls",
  styles: "background-color:#bada55;label:MobileChromeControls;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};

var MobileChromeControls = function (props) {
  var children = props.children,
      onNextPanel = props.onNextPanel,
      onPreviousPanel = props.onPreviousPanel;
      // onSelectVariation,
  // onChangeView,
  props.isPreviewMode;
  var editing = useReduxState('editor').editing; // const getPanelName = () => {
  //   if (
  //     typeof fullBleedLocation === 'number' &&
  //     typeof panelLocation === 'number'
  //   ) {
  //     const fullBleed = card?.fullBleeds?.[fullBleedLocation]
  //     const panel = fullBleed?.panels?.[panelLocation]
  //     return panel?.name || ''
  //   }
  //   return ''
  // }
  // const shouldShowVariation = getPanelName() === 'Front'
  // const shouldHideView = ['Front', 'Back'].includes(getPanelName())
  // TODO remove this and logical render after preview chrome gets designed

  var shouldHidePreviewToggle = true;
  useReduxActions(); // const hasColorVariations =
  //   v => v.id === card.variationState?.selectedVariationID,
  // )


  return jsx(Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'leftChevron',
    onClick: onPreviousPanel,
    outset: {
      right: 'x8'
    },
    offsetIcon: {
      insetRight: 'x_5'
    }
  }), children, jsx(HStack, {
    justify: "center",
    gap: "x1",
    css: _ref$1
  }, !shouldHidePreviewToggle ), editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'rightChevron',
    onClick: onNextPanel,
    outset: {
      left: 'x8'
    },
    offsetIcon: {
      insetLeft: 'x_5'
    }
  }));
};

var ChromeContentGrid = function (_a) {
  var children = _a.children;
  return jsx("div", {
    css: /*#__PURE__*/css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: hidden;\n        #chromeContentZone {\n          overflow-y: auto;\n\n          /* hide scrollbar for IE, Edge and Firefox */\n          -ms-overflow-style: none;\n          scrollbar-width: none;\n        }\n\n        /* hide scrollbar for chrome, safari and opera */\n        #chromeContentZone::-webkit-scrollbar {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: hidden;\n        #chromeContentZone {\n          overflow-y: auto;\n\n          /* hide scrollbar for IE, Edge and Firefox */\n          -ms-overflow-style: none;\n          scrollbar-width: none;\n        }\n\n        /* hide scrollbar for chrome, safari and opera */\n        #chromeContentZone::-webkit-scrollbar {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])))
  }, children);
};
var ChromeContentZone = function (props) {
  var _a = props.align,
      align = _a === void 0 ? 'center' : _a,
      _b = props.justify,
      justify = _b === void 0 ? 'center' : _b,
      _c = props.rowSpan,
      rowSpan = _c === void 0 ? 1 : _c,
      _d = props.columnSpan,
      columnSpan = _d === void 0 ? 1 : _d,
      zIndex = props.zIndex;
  return jsx("div", {
    id: "chromeContentZone",
    css: /*#__PURE__*/css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n        overflow-y: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n        overflow-y: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), typeof columnSpan === 'number' ? "span " + columnSpan : columnSpan, typeof rowSpan === 'number' ? "span " + rowSpan : rowSpan, justify, align, zIndex)
  }, props.children);
};
var MobileChromeContent = function (props) {
  var _a, _b;

  var height = props.height,
      onPreviousPanel = props.onPreviousPanel,
      onNextPanel = props.onNextPanel,
      onChangeView = props.onChangeView,
      children = props.children;

  var _c = useReduxState('editorChrome'),
      showBetaBanner = _c.showBetaBanner,
      interactionMode = _c.interactionMode,
      isElementInsertOpen = _c.isElementInsertOpen,
      isElementSettingsOpen = _c.isElementSettingsOpen,
      activeTextSetting = _c.activeTextSetting;

  var _d = useReduxState('editor'),
      card = _d.card,
      fullBleedLocation = _d.fullBleedLocation,
      panelLocation = _d.panelLocation;

  var panelName = typeof fullBleedLocation === 'number' && typeof panelLocation === 'number' && ((_b = (_a = card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation]) === null || _a === void 0 ? void 0 : _a.panels[panelLocation]) === null || _b === void 0 ? void 0 : _b.name);
  var actions = useReduxActions();

  var handleSelectVariation = function (variation) {
    actions.selectVariation(variation.id);
  };

  var handleBack = function () {
    if (isElementInsertOpen) {
      actions.closeElementInsertDrawer();
      actions.toggleDrawerState('minified');
      actions.toggleMobileNavigation(true);
    }

    if (isElementSettingsOpen) {
      if (activeTextSetting !== null) {
        actions.setActiveTextSetting(null);
      }

      actions.closeElementSettingsDrawer();
      actions.toggleDrawerState('minified');
      actions.toggleMobileNavigation(true);
    }
  };

  return jsx(Section, {
    backgroundColor: "background",
    height: height,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflowY: "hidden"
  }, jsx(AnimatePresence, null, showBetaBanner && jsx(BetaBanner, {
    timeout: 30000,
    zIndex: 6,
    button: {
      title: 'Dismiss',
      onClick: actions.closeBetaBanner
    },
    banner: {
      status: 'danger',
      bannerTitle: {
        icon: 'exclamation',
        message: 'Warning: For the best experience, please deactive browser plugins or OS settings that automatically alter text inputs, as the beta release of the new editor does not currently support them.'
      }
    }
  })), interactionMode === 'edit' ? jsx(ChromeContentGrid, null, jsx(ChromeContentZone, {
    columnSpan: 2
  }, jsx(Flex, {
    outset: {
      top: 'x2'
    }
  }, jsx(Flex, {
    inset: 'x1_5',
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    style: {
      fontSize: '1rem'
    },
    cursor: "pointer",
    onClick: handleBack
  }, "\u2190 back"), jsx(ChromePill, null), typeof panelName === 'string' && interactionMode === 'edit' && jsx(LocationTip, {
    location: panelName
  }))), jsx(ChromeContentZone, {
    zIndex: 0
  }, jsx(MobileChromeControls, {
    onNextPanel: onNextPanel,
    onPreviousPanel: onPreviousPanel,
    onChangeView: onChangeView,
    onSelectVariation: handleSelectVariation,
    isPreviewMode: false
  }, jsx(EditorWrapper, {
    width: "70vw",
    height: "70vh"
  }, children)))) : jsx(PreviewMode, {
    handleNextPanel: onNextPanel,
    handlePreviousPanel: onPreviousPanel,
    onChangeView: onChangeView
  }, children));
};
var templateObject_1$7, templateObject_2$2;

var SVGs = {
  layout: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("rect", {
    x: 4,
    y: 4,
    width: 10.9714,
    height: 24,
    rx: 2,
    fill: "#6B7280"
  }), jsx("rect", {
    x: 17.0287,
    y: 4,
    width: 10.9714,
    height: 6.96774,
    rx: 2,
    fill: "#1C75BC"
  }), jsx("rect", {
    x: 17.0287,
    y: 13.2904,
    width: 10.9714,
    height: 14.7097,
    rx: 2,
    fill: "#8DBADD"
  })),
  images: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M29.9995 7.34177V21.2758C29.8215 21.3032 29.7493 21.1318 29.6529 21.022C26.9352 17.9321 24.2191 14.8409 21.5069 11.7447C21.2134 11.4099 20.8784 11.1892 20.4727 11.0976C19.7714 10.9392 19.1751 11.1805 18.678 11.7373C17.7314 12.7984 16.7969 13.8745 15.8574 14.9444C15.0531 15.8603 14.2494 16.7768 13.4435 17.6914C13.3483 17.7999 13.2645 17.9302 13.1211 17.9664C12.9628 17.977 12.8769 17.8442 12.7816 17.7369C12.3874 17.2924 11.9806 16.861 11.6073 16.394C10.9141 15.5274 9.6199 15.4089 8.7494 16.3865C7.87506 17.3678 7.01168 18.3623 6.14337 19.3505C4.88909 20.7782 3.63535 22.2066 2.38106 23.6344C2.30386 23.7217 2.23324 23.8195 2.13414 23.8763C2.04052 23.9299 1.99782 23.8912 2.00384 23.774C2.00549 18.4072 2.01096 13.0397 2.00001 7.67221C1.99782 6.60919 2.32303 5.73196 2.99479 5.01621C3.6348 4.33413 4.40401 4.00494 5.27889 4.00307C6.9531 3.99933 8.62731 4.00182 10.3015 4.00182C15.7698 4.00182 21.2386 3.99559 26.7069 4.00619C28.1194 4.0093 29.1519 4.75124 29.7909 6.19707C29.9518 6.56118 29.9376 6.95833 30 7.34115L29.9995 7.34177Z",
    fill: "#F9FAFB"
  }), jsx("path", {
    d: "M29.9992 24.9463C29.9067 25.0212 29.9204 25.1471 29.8974 25.2494C29.535 26.8517 28.2801 27.9864 26.8293 27.992C25.1743 27.9982 23.5187 27.987 21.8631 27.9833C21.7382 27.9359 21.6479 27.8349 21.557 27.732C18.8081 24.6003 16.0575 21.4699 13.3108 18.3357C13.2177 18.2297 13.0557 18.1492 13.1219 17.9379C14.9177 15.8941 16.7134 13.8498 18.5092 11.806C19.4996 10.6788 20.6854 10.6757 21.6769 11.8035C24.4516 14.9602 27.2251 18.1187 29.9992 21.2766V24.947V24.9463Z",
    fill: "#398F43"
  }), jsx("path", {
    d: "M13.1219 17.9372C13.1438 18.085 13.2539 18.1561 13.3354 18.2483C16.103 21.4031 18.8727 24.5566 21.6413 27.7102C21.718 27.7974 21.7891 27.8916 21.863 27.9826C21.7541 27.9864 21.6451 27.9932 21.5362 27.9932C16.1128 27.9932 10.69 27.9832 5.2666 28.0001C3.72215 28.0051 2.05287 26.601 2.03207 24.3683C2.03042 24.2131 2.03535 24.0579 2.03754 23.902C2.11091 23.8253 2.18701 23.7523 2.25708 23.6725C4.37366 21.2634 6.48914 18.8537 8.60516 16.4446C9.59283 15.3205 10.7776 15.3267 11.7756 16.4477C12.2207 16.9478 12.6325 17.4889 13.1219 17.9372Z",
    fill: "#4FAF4F"
  }), jsx("path", {
    d: "M11.5283 10.2375C11.5262 11.9038 10.2084 13.2252 8.54278 13.2308C6.86448 13.2365 5.52691 11.9038 5.52832 10.2284C5.52973 8.56065 6.87647 7.22591 8.55336 7.23085C10.2077 7.23579 11.5304 8.57264 11.5283 10.2375Z",
    fill: "#FFC112"
  })),
  text: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.00103 21.6241C3.30283 18.735 4.60463 15.8448 5.90643 12.9556C6.19229 12.3222 6.47609 11.6889 6.77018 11.0585C7.22262 10.0884 8.08638 9.68556 9.14653 9.94712C9.76556 10.1005 10.1296 10.5254 10.3764 11.0685C10.8967 12.212 11.417 13.3544 11.9363 14.4979C12.9347 16.6956 13.928 18.8953 14.9337 21.09C15.1866 21.6412 15.1938 22.1563 14.7856 22.6333C14.1779 23.3448 12.9841 23.2667 12.5327 22.4509C12.1717 21.7975 11.8848 21.102 11.5908 20.4156C11.492 20.1861 11.3758 20.1039 11.1157 20.1059C9.39229 20.1189 7.6689 20.1189 5.9455 20.1059C5.68124 20.1039 5.56607 20.1901 5.47249 20.4206C5.21748 21.0469 4.95219 21.6702 4.65707 22.2796C4.27044 23.0783 3.33676 23.3478 2.61285 22.9019C2.2838 22.6994 2.13573 22.3808 2 22.0501C2 21.9078 2 21.7654 2 21.6231L2.00103 21.6241ZM10.362 17.5795C9.74808 16.1544 9.1527 14.7725 8.53368 13.3354C7.9126 14.7765 7.31517 16.1654 6.70643 17.5795H10.363H10.362Z",
    fill: "#F15A29"
  }), jsx("path", {
    d: "M23.053 17.3452C23.1898 16.3069 22.4494 15.4992 21.3142 15.426C20.4587 15.3709 19.6278 15.4792 18.8021 15.6986C17.9198 15.9331 17.1558 15.2286 17.3327 14.3578C17.418 13.9379 17.6988 13.6562 18.0967 13.52C19.7049 12.9698 21.3512 12.8164 23.017 13.2063C24.6129 13.5801 25.4869 14.6283 25.744 16.1817C25.8078 16.5665 25.8355 16.9593 25.8386 17.3492C25.8499 18.7712 25.8458 20.1933 25.8417 21.6153C25.8396 22.3278 25.5209 22.8129 24.9327 23.0223C24.0803 23.326 23.2628 22.885 23.0396 21.9951C22.7754 22.1955 22.5327 22.43 22.2468 22.5884C20.7836 23.3961 19.2895 23.4232 17.8304 22.6084C16.8196 22.0432 16.3281 20.8276 16.5337 19.6511C16.7826 18.23 17.6515 17.3923 19.2237 17.0996C20.4052 16.8802 21.5815 16.9363 22.7384 17.273C22.8258 17.2981 22.9121 17.3261 22.9995 17.3502C23.016 17.3542 23.0355 17.3472 23.053 17.3452ZM20.9913 18.6479C20.7929 18.693 20.4556 18.7371 20.143 18.8464C19.5384 19.0568 19.234 19.5659 19.2977 20.1832C19.3502 20.6983 19.7584 21.1092 20.3702 21.1934C20.7075 21.2395 21.0643 21.2475 21.3995 21.1954C22.4186 21.0361 23.1877 20.4508 23.1085 19.2101C23.1034 19.122 23.0211 18.9957 22.9409 18.9616C22.3651 18.7151 21.7512 18.654 20.9923 18.6489L20.9913 18.6479Z",
    fill: "#6B7280"
  }), jsx("path", {
    d: "M28.5194 23.9281H30.0001V24.8H26.105V23.9402H27.5816V8.87287H26.104V8H29.995V8.85583H28.5194V23.9281Z",
    fill: "black"
  })),
  stickers: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    opacity: 0.78,
    d: "M20.1621 20.0726C17.3345 18.7484 16.0608 15.2587 17.3171 12.2781C18.5734 9.29763 21.884 7.95496 24.7115 9.27922C27.539 10.6035 28.8128 14.0932 27.5565 17.0737C26.3002 20.0542 22.9896 21.3969 20.1621 20.0726Z",
    fill: "#FFFFFE"
  }), jsx("path", {
    d: "M20.4736 19.3341C18.0331 18.1911 16.9337 15.179 18.018 12.6064C19.1024 10.0338 21.9599 8.8749 24.4004 10.0179C26.841 11.1609 27.9404 14.173 26.856 16.7456C25.7717 19.3182 22.9142 20.4771 20.4736 19.3341Z",
    fill: "#FFCB2B"
  }), jsx("path", {
    d: "M20.9127 18.1516C22.4291 18.861 24.1498 18.4462 25.1926 17.1563C25.3359 16.979 25.3015 16.7614 25.1107 16.6435C25.0864 16.6284 25.0601 16.6168 25.0343 16.6047C23.1359 15.7156 21.2375 14.8265 19.3391 13.9374C19.1475 13.8477 19.0086 13.8726 18.906 14.0095C18.8667 14.0619 18.8525 14.1222 18.8463 14.1845C18.7016 15.6166 19.1619 16.7895 20.2144 17.7028C20.4401 17.8985 20.6923 18.0556 20.9126 18.1518L20.9127 18.1516Z",
    fill: "#FFFFFE"
  }), jsx("path", {
    d: "M25.0994 13.1583C24.577 12.8654 23.841 13.0963 23.5453 13.6467C23.5159 13.7012 23.4846 13.7563 23.4666 13.8152C23.4151 13.9836 23.485 14.1395 23.6359 14.2065C23.7796 14.2703 23.9345 14.2145 24.0123 14.0617C24.1484 13.7949 24.3479 13.6429 24.6438 13.6755C25.0317 13.7183 25.2711 14.1273 25.1411 14.5147C25.0665 14.7368 25.1166 14.9002 25.2828 14.978C25.4332 15.0485 25.5997 14.9837 25.6719 14.8265C25.9326 14.2601 25.7112 13.5179 25.1902 13.2113C25.1601 13.1935 25.1298 13.176 25.0997 13.1582L25.0994 13.1583Z",
    fill: "#6F4E42"
  }), jsx("path", {
    d: "M21.8017 11.6154C21.2794 11.3138 20.5369 11.541 20.2383 12.0944C20.2073 12.1517 20.1716 12.2064 20.1547 12.2717C20.1117 12.438 20.1777 12.5895 20.3242 12.6559C20.468 12.7211 20.6213 12.6642 20.703 12.5155C20.8687 12.2137 21.0768 12.0888 21.3509 12.1271C21.7262 12.1793 21.9607 12.5852 21.8336 12.9623C21.7569 13.1898 21.8082 13.3542 21.9798 13.4313C22.1268 13.4973 22.2908 13.4324 22.362 13.2802C22.6248 12.7172 22.4042 11.9706 21.8844 11.6637C21.8568 11.6475 21.8294 11.6316 21.8018 11.6156L21.8017 11.6154Z",
    fill: "#6F4E42"
  }), jsx("g", {
    opacity: 0.78,
    filter: "url(#filter0_b_610_33579)"
  }, jsx("path", {
    d: "M15.9673 25.4635C11.0085 26.8633 5.91208 23.7606 4.58417 18.5336C3.25626 13.3065 6.19968 7.93435 11.1585 6.53455C16.1173 5.13476 21.2137 8.23738 22.5416 13.4645C23.8695 18.6915 20.9261 24.0637 15.9673 25.4635Z",
    fill: "#FFFFFE"
  })), jsx("path", {
    d: "M15.6411 24.1689C11.3612 25.3777 6.96192 22.7004 5.81511 18.1889C4.6683 13.6774 7.20821 9.04014 11.4882 7.83128C15.7681 6.62243 20.1674 9.29975 21.3142 13.8113C22.461 18.3228 19.9211 22.96 15.6411 24.1689Z",
    fill: "#FFCB2B"
  }), jsx("path", {
    d: "M15.038 22.1599C17.6966 21.4076 19.5061 18.9805 19.575 16.1695C19.5845 15.7832 19.3248 15.5404 18.9619 15.598C18.9157 15.6053 18.8702 15.6192 18.825 15.6319C15.4958 16.5722 12.1666 17.5126 8.83733 18.4529C8.5014 18.5478 8.34682 18.7328 8.34991 19.0221C8.35115 19.133 8.39243 19.2264 8.44608 19.3135C9.67663 21.3204 11.4312 22.3275 13.6929 22.3485C14.1778 22.3529 14.6588 22.2783 15.0381 22.1602L15.038 22.1599Z",
    fill: "#FFFFFE"
  }), jsx("path", {
    d: "M15.4984 11.114C14.5344 11.3106 13.8133 12.4178 13.9765 13.4531C13.9925 13.5557 14.0067 13.6612 14.0418 13.757C14.1419 14.0309 14.3865 14.1552 14.6474 14.0757C14.896 14 15.0405 13.7576 14.9898 13.4749C14.9013 12.9811 15.0083 12.5655 15.4223 12.2823C15.9652 11.9109 16.6788 12.1755 16.8945 12.8182C17.018 13.1867 17.2443 13.3425 17.5357 13.2602C17.7995 13.1857 17.9502 12.919 17.8879 12.6368C17.6637 11.6194 16.6436 10.9052 15.6679 11.0825C15.6114 11.0927 15.5551 11.1035 15.4986 11.1136L15.4984 11.114Z",
    fill: "#6F4E42"
  }), jsx("path", {
    d: "M9.71633 12.7493C8.74402 12.9346 8.01086 14.0441 8.17324 15.0865C8.18995 15.1944 8.19809 15.3043 8.24081 15.4072C8.34989 15.669 8.585 15.7919 8.83984 15.7165C9.08983 15.6424 9.23126 15.4006 9.18949 15.1188C9.10461 14.5473 9.24961 14.1573 9.64106 13.9054C10.1769 13.56 10.8811 13.8258 11.0904 14.4522C11.2166 14.8299 11.4454 14.9857 11.7432 14.8964C11.9981 14.82 12.1456 14.5559 12.0868 14.2813C11.8686 13.2659 10.8452 12.5451 9.87075 12.7207C9.81925 12.7302 9.76813 12.7398 9.71671 12.7495L9.71633 12.7493Z",
    fill: "#6F4E42"
  }), jsx("defs", null, jsx("filter", {
    id: "filter0_b_610_33579",
    x: -257.734,
    y: -255.801,
    width: 542.595,
    height: 543.601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, jsx("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), jsx("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 131
  }), jsx("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_610_33579"
  }), jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_610_33579",
    result: "shape"
  })))),
  color: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6.44246 23.2596C5.64741 22.3022 4.94291 21.2873 4.45755 20.1362C4.18408 19.4872 3.97219 18.822 4.00298 18.1048C4.0229 17.6476 4.17503 17.2478 4.50826 16.9178C6.75034 14.6999 8.9906 12.482 11.2309 10.2623C11.3033 10.1906 11.3739 10.1135 11.4446 10.04C12.7847 11.7361 14.2173 13.3534 15.7205 14.9079C15.8128 15.0029 15.7675 15.0675 15.7349 15.1553C15.5774 15.5803 15.7277 16.0357 16.0972 16.2795C16.472 16.5252 16.9592 16.4822 17.2852 16.1756C17.6076 15.8707 17.671 15.3866 17.4409 15.0047C17.2109 14.6264 16.7564 14.4507 16.3253 14.6031C16.1768 14.6551 16.0953 14.6264 15.9994 14.5206C15.485 13.9594 14.9598 13.4108 14.4509 12.846C13.5291 11.8222 12.6199 10.7894 11.7995 9.68317C11.8629 9.62401 11.9299 9.56842 11.9915 9.50746C12.9025 8.60739 13.8134 7.70552 14.7226 6.80186C14.8638 6.662 15.0123 6.53291 15.1808 6.42712C15.3492 6.36616 15.5176 6.3052 15.6842 6.24603C16.4829 6.14025 17.2309 6.33389 17.9589 6.62794C19.118 7.09591 20.1485 7.77186 21.1101 8.55539C21.8183 9.13094 22.4847 9.74593 23.0932 10.4255C23.785 11.1982 24.4153 12.0158 24.9423 12.9087C24.9658 12.9482 24.9785 12.9948 24.9966 13.0396C24.667 13.0056 24.3356 12.9733 24.006 12.9392C23.9915 12.9105 23.9788 12.8818 23.9607 12.8567C22.4883 10.7697 20.6954 9.01798 18.466 7.72703C17.8665 7.3792 17.2345 7.10666 16.5409 6.99729C15.6136 6.85385 15.0775 7.3792 15.2134 8.2972C15.293 8.84227 15.4868 9.34789 15.7422 9.8302C16.7165 11.6823 18.102 13.1992 19.683 14.5565C20.105 14.9438 20.5578 15.2898 21.0449 15.5928C21.0486 15.6054 21.0504 15.6161 21.0504 15.6287C21.0431 15.643 21.0304 15.6574 21.0304 15.6717C20.9997 16.7654 20.9815 17.8592 21.3202 18.9188C21.3709 19.0766 21.3673 19.1949 21.2423 19.324C20.6592 19.9354 20.0941 20.5648 19.5074 21.1744C18.5511 22.1659 17.6221 23.1807 16.6278 24.1364C16.4829 24.2744 16.3199 24.3766 16.1334 24.4555C15.2568 24.8321 14.3187 24.8338 13.3969 24.8446C12.8083 24.8518 12.2106 24.8087 11.6184 24.7352C10.5137 24.5972 9.43069 24.3748 8.37122 24.0431C7.71925 23.8387 7.09806 23.559 6.48592 23.2596L6.48955 23.2614C6.47687 23.2363 6.46057 23.2327 6.44246 23.2578V23.2596Z",
    fill: "#FFE3A9"
  }), jsx("path", {
    d: "M6.48401 23.2613C7.09614 23.5607 7.71733 23.8404 8.36931 24.0448C9.42877 24.3783 10.5118 24.5989 11.6165 24.7369C12.2087 24.8104 12.8064 24.8535 13.395 24.8463C14.3168 24.8355 15.2549 24.8337 16.1315 24.4572C16.318 24.3765 16.481 24.2761 16.6259 24.1381C17.6201 23.1824 18.551 22.1676 19.5054 21.1761C20.0922 20.5664 20.6573 19.9389 21.2404 19.3257C21.3636 19.1966 21.369 19.0783 21.3183 18.9205C20.9796 17.859 20.9977 16.7671 21.0285 15.6734C21.0285 15.6591 21.0412 15.6447 21.0484 15.6304C21.5537 15.9388 22.0481 16.2615 22.5951 16.4964C22.6947 16.5394 22.711 16.6111 22.7146 16.7026C22.7291 17.0002 22.7418 17.2978 22.7671 17.5955C22.8233 18.2696 22.9935 18.9187 23.2163 19.5552C23.1475 19.6197 23.075 19.6807 23.008 19.7488C20.4345 22.2967 17.8538 24.8355 15.2948 27.3959C14.746 27.9445 14.1085 28.0736 13.395 27.9643C12.0475 27.7599 10.8957 27.1072 9.80003 26.3524C8.59931 25.524 7.5326 24.5433 6.58905 23.4352C6.54558 23.3832 6.47495 23.3456 6.48401 23.2595V23.2613Z",
    fill: "#FFCB5F"
  }), jsx("path", {
    d: "M21.045 15.5945C20.5579 15.2915 20.1051 14.9437 19.6831 14.5582C20.6394 14.5367 21.525 14.2892 22.3182 13.746C22.838 13.3892 23.3523 13.018 24.0079 12.9409C24.3375 12.975 24.6671 13.0073 24.9986 13.0413C25.4839 13.1704 25.9566 13.3282 26.3677 13.6276C27.2352 14.2588 27.6481 15.1499 27.8528 16.1593C28.0466 17.1186 28.0085 18.0868 27.9687 19.055C27.9288 19.9837 27.8582 20.9089 27.7133 21.8287C27.6427 22.2788 27.5648 22.7306 27.4199 23.1645C27.1121 22.935 26.9726 22.5961 26.8458 22.2572C26.6484 21.7265 26.4764 21.185 26.279 20.6543C26.1938 20.4248 26.0816 20.1899 25.7918 20.1595C25.3807 20.1182 25.1398 19.8439 24.9334 19.5463C24.3864 18.7538 24.1999 17.8483 24.1818 16.9088C24.1691 16.2167 23.7942 15.8653 23.2255 15.738C22.5084 15.5766 21.7767 15.5874 21.045 15.5945Z",
    fill: "#4994CD"
  }), jsx("path", {
    d: "M21.0447 15.5946C21.7745 15.5875 22.5062 15.5767 23.2252 15.7381C23.7938 15.8654 24.1687 16.2186 24.1814 16.9089C24.1995 17.8484 24.3861 18.7539 24.933 19.5464C25.1395 19.844 25.3803 20.1183 25.7914 20.1596C26.0812 20.1883 26.1935 20.4249 26.2786 20.6544C26.476 21.1852 26.6462 21.7266 26.8455 22.2574C26.9722 22.5962 27.1117 22.9351 27.4196 23.1646C27.3417 23.5286 27.2041 23.8728 26.9831 24.1741C26.6915 24.5739 26.3021 24.5577 26.0504 24.131C25.7588 23.6362 25.6592 23.0732 25.5143 22.5281C25.4129 22.1498 25.326 21.7661 25.1576 21.4075C25.0417 21.1601 24.8823 20.9843 24.5672 20.9736C24.3335 20.9664 24.1416 20.8158 23.9677 20.6598C23.6236 20.3532 23.4298 19.9462 23.2179 19.5518C22.997 18.9152 22.8249 18.2662 22.7688 17.592C22.7453 17.2944 22.7308 16.9968 22.7163 16.6991C22.7108 16.6077 22.6945 16.536 22.5967 16.4929C22.0498 16.2598 21.5554 15.9353 21.0501 15.6269C21.0501 15.6144 21.0483 15.6018 21.0447 15.5911V15.5946Z",
    fill: "#347AAF"
  }), jsx("path", {
    d: "M11.7993 9.68302C12.6197 10.7893 13.5288 11.8238 14.4506 12.8458C14.9595 13.4106 15.4847 13.9593 15.9991 14.5205C16.0969 14.6263 16.1766 14.6567 16.3251 14.603C16.7579 14.4506 17.2125 14.6263 17.4407 15.0046C17.6707 15.3847 17.6055 15.8706 17.2849 16.1754C16.9589 16.4838 16.4718 16.5268 16.0969 16.2794C15.7274 16.0355 15.5771 15.5801 15.7347 15.1552C15.7673 15.0673 15.8125 15.0028 15.7202 14.9078C14.2152 13.3533 12.7845 11.7342 11.4443 10.0398C10.7633 9.1272 10.0824 8.21278 9.5608 7.19795C9.26017 6.61524 8.97945 6.01997 8.9704 5.34581C8.95953 4.62144 9.36159 4.16423 10.086 4.0459C10.8068 3.92756 11.4968 4.04948 12.1741 4.28078C13.4654 4.72364 14.6299 5.38884 15.684 6.24767C15.5155 6.30864 15.3471 6.3696 15.1805 6.42877C15.108 6.38036 15.0356 6.33194 14.965 6.28174C14.0884 5.67571 13.1775 5.13244 12.1669 4.77743C11.5185 4.54972 10.8557 4.38656 10.1584 4.51745C9.65316 4.61248 9.43222 4.88143 9.45576 5.39063C9.47206 5.74923 9.58797 6.08451 9.73104 6.41084C10.2544 7.60496 11.006 8.65744 11.8029 9.68302H11.7993Z",
    fill: "#2A5F88"
  }), jsx("path", {
    d: "M6.4426 23.2596C6.46053 23.2345 6.47487 23.238 6.48921 23.2631C6.47308 23.2631 6.45873 23.2596 6.4426 23.2596Z",
    fill: "#FFCB5F"
  }), jsx("path", {
    d: "M24.0079 12.9409C23.3523 13.018 22.838 13.3891 22.3182 13.7459C21.525 14.291 20.6394 14.5366 19.6831 14.5582C18.1021 13.2009 16.7166 11.684 15.7423 9.83186C15.4887 9.34776 15.295 8.84393 15.2135 8.29886C15.0776 7.38265 15.6155 6.85552 16.541 6.99895C17.2364 7.10653 17.8667 7.38086 18.4661 7.7287C20.6955 9.01964 22.4884 10.7714 23.9608 12.8584C23.9789 12.8835 23.9916 12.914 24.0061 12.9409H24.0079Z",
    fill: "#2A5F88"
  })),
  covers: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6.14423 4.09315C10.2242 3.28515 14.3122 2.47715 18.3922 1.66916C19.4482 1.45908 20.5122 1.249 21.5682 1.01468C21.8322 0.958118 21.8722 1.06316 21.8722 1.36212C21.8642 2.17011 21.8642 4.00427 21.8722 4.81227C21.8722 5.0789 21.8322 5.18394 21.6002 5.18394C16.4802 5.17586 11.3682 5.5233 6.24823 5.5233C6.13623 5.46674 6.16823 4.14163 6.13623 4.13355L6.15223 4.08507L6.14423 4.09315Z",
    fill: "#CFCFCE"
  }), jsx("path", {
    d: "M26 30.652C26 30.9268 25.952 31.0076 25.688 30.9995C19.232 30.9914 12.776 30.9914 6.312 30.9995C6.056 30.9995 6 30.9348 6 30.652C6 21.9095 6 13.1751 6 4.43252C6 4.14972 6.056 4.08508 6.312 4.08508C12.768 4.09316 19.224 4.09316 25.688 4.08508C25.944 4.08508 26 4.1578 26 4.43252C25.992 7.80187 25.992 27.2827 26 30.644V30.652Z",
    fill: "#7DC9A7"
  }), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.8
  }, jsx("path", {
    d: "M15.714 10.6517H16.2148C16.5655 10.6821 16.9161 10.7023 17.2667 10.7832C19.8211 11.3397 21.5641 12.8472 22.4657 15.326C22.5759 15.6296 22.636 15.9432 22.616 16.267C22.5759 16.9752 22.2954 17.5721 21.7645 18.0375C21.6743 18.1185 21.6743 18.1589 21.7645 18.2399C22.2153 18.6648 22.6661 19.0796 23.1068 19.5147C23.5877 19.9902 23.6377 20.7288 23.2471 21.265C22.7362 21.953 21.7945 22.0137 21.1935 21.3763C20.3821 20.5265 19.5907 19.6665 18.7893 18.8065C18.6791 18.6952 18.589 18.6851 18.4587 18.7559C18.0981 18.9481 17.9178 19.3427 18.008 19.7676C18.0881 20.1521 18.3986 20.4455 18.7893 20.4759C18.9296 20.486 19.0698 20.4961 19.2 20.5163C19.8311 20.6377 20.2819 21.093 20.4121 21.7406C20.5323 22.3577 20.2919 22.9547 19.751 23.3189C18.589 24.098 17.3067 24.4622 15.9143 24.4521C15.2331 24.4521 14.562 24.3509 13.9108 24.1182C11.707 23.3594 10.2344 21.862 9.48314 19.6361C9.32286 19.1505 9.24272 18.6446 9.18262 18.1387C9.18262 17.7441 9.18262 17.3495 9.18262 16.955C9.18262 16.9246 9.19263 16.9044 9.20265 16.874C9.26276 16.2164 9.403 15.579 9.66345 14.982C10.6251 12.7258 12.288 11.3094 14.6722 10.7731C15.0128 10.6922 15.3734 10.672 15.724 10.6416L15.714 10.6517ZM10.0541 17.6834C10.0541 17.8251 10.0541 18.0881 10.0942 18.3512C10.2845 19.6968 10.8255 20.8705 11.7972 21.8215C13.3398 23.329 15.183 23.8551 17.2867 23.4302C17.9879 23.2885 18.6391 23.0053 19.2401 22.6006C19.4805 22.4387 19.5907 22.1756 19.5406 21.9227C19.4705 21.6192 19.2902 21.4472 18.9796 21.3864C18.8294 21.3561 18.6791 21.3662 18.5389 21.346C17.6974 21.174 17.0663 20.4253 17.0763 19.5754C17.0763 18.9481 17.3468 18.4321 17.8677 18.0679C17.9579 18.0072 17.9779 17.9667 17.8978 17.8757C17.6373 17.6025 17.3869 17.3293 17.1264 17.0561C17.0663 16.9853 16.9962 16.955 16.906 16.9752C16.2649 17.0663 15.6939 16.8841 15.2031 16.4491C14.8825 16.1658 14.7222 15.7712 14.592 15.3766C14.3015 14.5369 14.1613 13.6566 14.0611 12.7764C14.031 12.5032 14.2314 12.2908 14.5019 12.2908C14.7423 12.2908 14.9727 12.3414 15.2031 12.3717C15.9344 12.483 16.6456 12.6348 17.3368 12.9079C17.6173 13.0192 17.8878 13.1406 18.0981 13.3632C18.589 13.8691 18.7793 14.4762 18.6891 15.1743C18.6791 15.2653 18.6992 15.326 18.7693 15.3766C19.4805 16.0444 20.1817 16.7223 20.893 17.4001C20.9731 17.4811 21.0332 17.4811 21.1134 17.4001C21.6543 16.9752 21.8546 16.2568 21.6242 15.579C20.6526 12.7157 17.8076 11.1171 14.9927 11.6028C12.1478 12.0884 10.0241 14.638 10.0441 17.6632L10.0541 17.6834ZM16.4953 16.1152C17.3769 16.1152 17.9479 15.4474 17.8276 14.6886C17.7575 14.2333 17.5071 13.9298 17.0763 13.7578C16.5053 13.5352 15.9043 13.4037 15.2932 13.3025C15.0128 13.2519 15.0027 13.2519 15.0528 13.5352C15.163 14.1625 15.2832 14.7898 15.5236 15.3867C15.724 15.8825 16.1047 16.095 16.4853 16.1152H16.4953ZM22.606 20.4455C22.606 20.314 22.5459 20.2027 22.4357 20.1015C21.1334 18.8672 19.8411 17.6227 18.5389 16.3884C18.4688 16.3176 18.3986 16.1961 18.3085 16.1961C18.2183 16.1961 18.1682 16.3277 18.0881 16.3985C17.8978 16.5806 17.8978 16.5907 18.0881 16.783C19.0398 17.7947 19.9814 18.8166 20.933 19.8283C21.2236 20.142 21.5141 20.4556 21.8146 20.7693C21.9648 20.921 22.1552 20.9615 22.3355 20.8907C22.5058 20.8199 22.606 20.658 22.606 20.4455Z",
    fill: "black",
    fillOpacity: 0.4
  })), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.6
  }, jsx("path", {
    d: "M14.8424 22.5398C15.628 22.5398 16.2649 21.8965 16.2649 21.1031C16.2649 20.3096 15.628 19.6664 14.8424 19.6664C14.0568 19.6664 13.4199 20.3096 13.4199 21.1031C13.4199 21.8965 14.0568 22.5398 14.8424 22.5398Z",
    fill: "black",
    fillOpacity: 0.4
  })), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.6
  }, jsx("path", {
    d: "M12.3683 18.8469C13.1539 18.8469 13.7907 18.2037 13.7907 17.4102C13.7907 16.6167 13.1539 15.9735 12.3683 15.9735C11.5827 15.9735 10.9458 16.6167 10.9458 17.4102C10.9458 18.2037 11.5827 18.8469 12.3683 18.8469Z",
    fill: "black",
    fillOpacity: 0.4
  }))),
  folds: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M5.00818 5.20266C5.00818 4.85265 5.00818 4.67003 5.08481 4.54068C5.12312 4.47981 5.1691 4.43416 5.22274 4.3885C5.34535 4.2972 5.5216 4.27437 5.88176 4.24393L18.541 2.02295C18.6253 2.01534 18.6636 2.00773 18.6942 2.02295C18.7095 2.03056 18.7172 2.03816 18.7249 2.05338C18.7479 2.08382 18.7479 2.12186 18.7479 2.20556V24.9478C18.7479 25.0011 18.7479 25.0315 18.7325 25.0543C18.7325 25.0619 18.7172 25.0771 18.7095 25.0848C18.6942 25.1 18.6636 25.1152 18.6099 25.1304L6.52544 29.2925C6.03502 29.4599 5.7898 29.5436 5.59823 29.4675C5.51393 29.4371 5.44497 29.3838 5.38366 29.3229C5.24573 29.1707 5.24573 28.912 5.23807 28.4022L5.00818 5.20266Z",
    fill: "url(#paint0_linear_610_33350)"
  }), jsx("path", {
    d: "M26.7243 4.0612L18.7472 2V27.1246L27.0002 29.4522L26.7243 4.05359V4.0612Z",
    fill: "url(#paint1_linear_610_33350)"
  }), jsx("path", {
    d: "M23.4294 4.32764H5.27587C5.12351 4.32764 5 4.45028 5 4.60156V29.7262C5 29.8775 5.12351 30.0001 5.27587 30.0001H23.4294C23.5818 30.0001 23.7053 29.8775 23.7053 29.7262V4.60156C23.7053 4.45028 23.5818 4.32764 23.4294 4.32764Z",
    fill: "#E175A5"
  }), jsx("path", {
    d: "M23.4294 4.32764H5.27587C5.12351 4.32764 5 4.45028 5 4.60156V29.7262C5 29.8775 5.12351 30.0001 5.27587 30.0001H23.4294C23.5818 30.0001 23.7053 29.8775 23.7053 29.7262V4.60156C23.7053 4.45028 23.5818 4.32764 23.4294 4.32764Z",
    fill: "#E175A5"
  }), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M12.8852 12.9482H16.2723L19.4907 22.117H16.8776L16.4332 20.8311H12.7396L12.2952 22.117H9.68213L12.9006 12.9482H12.8852ZM15.6133 18.5104L14.5788 15.5733L13.5443 18.5104H15.6056H15.6133Z",
    fill: "#B2507F"
  })), jsx("defs", null, jsx("linearGradient", {
    id: "paint0_linear_610_33350",
    x1: 24.7709,
    y1: 13.3366,
    x2: 20.3669,
    y2: 14.1697,
    gradientUnits: "userSpaceOnUse"
  }, jsx("stop", {
    stopColor: "#DDDDDD"
  }), jsx("stop", {
    offset: 1,
    stopColor: "#C0BFBF"
  })), jsx("linearGradient", {
    id: "paint1_linear_610_33350",
    x1: 25.0078,
    y1: 16.3192,
    x2: 14.5559,
    y2: 15.7713,
    gradientUnits: "userSpaceOnUse"
  }, jsx("stop", {
    stopColor: "#DDDDDD"
  }), jsx("stop", {
    offset: 1,
    stopColor: "#C0BFBF"
  })))),
  freeForm: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M15.6455 14.7646C14.682 14.5412 13.7185 14.3046 12.8338 13.8446C12.5447 13.6956 12.2776 13.5072 12.0586 13.2619C11.6206 12.7756 11.5462 12.2323 11.8177 11.6409C12.0673 11.0976 12.4834 10.6902 12.9258 10.3046C13.5082 9.79205 14.1783 9.39775 14.8046 8.94211C15.2032 8.65296 15.5842 8.3419 15.8776 7.93883C16.2937 7.37367 16.2324 6.96622 15.6674 6.55878C15.0805 6.14257 14.4061 5.93228 13.7185 5.75265C12.2644 5.3715 10.7797 5.17873 9.29063 5.04291C7.6833 4.89833 6.0672 4.81509 4.45111 4.80195C4.24088 4.80195 4.11387 4.6968 4 4.54784V4.24993C4.12263 4.06154 4.28906 3.99582 4.52118 4.0002C7.00445 4.03963 9.47896 4.17983 11.9316 4.56537C13.009 4.73623 14.0732 4.95529 15.0893 5.36273C15.5798 5.55988 16.0441 5.79646 16.4251 6.16886C17.0076 6.73841 17.104 7.43939 16.6923 8.14475C16.2674 8.86763 15.6192 9.36708 14.9448 9.8271C14.3404 10.2433 13.7272 10.642 13.1929 11.1502C12.9652 11.3693 12.7462 11.5971 12.5929 11.8775C12.3695 12.2893 12.4309 12.5872 12.8119 12.8764C13.3243 13.2663 13.9243 13.4678 14.5287 13.6518C15.1243 13.8314 15.7331 13.9673 16.3419 14.1075C16.3813 14.1556 16.3682 14.2038 16.3375 14.2433C16.1886 14.4317 16.0178 14.5981 15.8339 14.7515C15.7769 14.7997 15.7112 14.7953 15.6455 14.7646Z",
    fill: "#366387"
  }), jsx("path", {
    d: "M6.84684 28C6.80743 27.9518 6.77239 27.9036 6.73297 27.8554C6.75487 27.759 6.8337 27.7064 6.8994 27.6407C7.30233 27.2377 7.70526 26.8346 8.10819 26.4315C8.18702 26.3527 8.26147 26.2519 8.39724 26.2607C8.54615 26.3001 8.62499 26.4228 8.72572 26.5192C8.94908 26.7382 9.17244 26.9616 9.39143 27.1895C9.45712 27.2596 9.54909 27.3209 9.51844 27.4392C8.77389 27.6101 8.02497 27.7809 7.28043 27.9518C7.24977 27.9605 7.22349 27.9824 7.19722 28H6.84684Z",
    fill: "#2C5270"
  }), jsx("path", {
    d: "M17.993 20.7931C17.9273 20.8544 17.8528 20.9114 17.7915 20.9771C16.0134 22.7558 14.2352 24.5346 12.4527 26.3133C12.3695 26.3966 12.2819 26.471 12.1943 26.5499C11.9009 26.6594 11.6906 26.563 11.603 26.2607C11.5242 25.9804 11.4848 25.6912 11.4235 25.4064C11.2877 24.7449 11.3578 24.8281 10.7183 24.8194C10.5782 24.8194 10.438 24.8194 10.2935 24.8194C10.184 24.8194 10.0789 24.8062 9.99132 24.723C9.92563 24.6353 9.97818 24.5653 10.0307 24.4995C10.0877 24.4294 10.1577 24.3681 10.2234 24.3024C13.8454 20.6792 17.4718 17.0516 21.0938 13.4284C21.1901 13.3321 21.2646 13.2006 21.4266 13.1787C21.466 13.1919 21.5011 13.2138 21.5317 13.2444C22.1624 13.8665 22.7887 14.4974 23.415 15.1283C23.45 15.1634 23.4807 15.2028 23.4851 15.2554C23.3712 15.3824 23.2529 15.5095 23.1391 15.6365C22.9989 15.9125 22.7142 16.0659 22.5434 16.3156C22.4383 16.3988 22.342 16.4908 22.25 16.5828C21.1989 17.6343 20.1478 18.6858 19.0966 19.7373C19.0222 19.8117 18.9521 19.8994 18.8601 19.9519C18.9302 19.9651 19.0397 19.9125 19.0397 20.0527C18.7156 20.0834 18.5185 20.3068 18.3171 20.5215C18.2207 20.6222 18.1287 20.7318 17.993 20.7843V20.7931Z",
    fill: "#3887C8"
  }), jsx("path", {
    d: "M21.4264 13.2004C21.3607 13.2617 21.2906 13.3231 21.2249 13.3888C17.546 17.0689 13.8671 20.7447 10.1926 24.4248C10.1225 24.4949 10.0612 24.5738 9.99549 24.6483C9.96483 24.6614 9.93855 24.6614 9.91665 24.6395C9.82468 24.5388 9.82468 24.4117 9.82468 24.289C9.82468 24.0568 9.81592 23.8246 9.82468 23.5924C9.83344 23.3865 9.74147 23.2945 9.54438 23.2595C9.15459 23.185 8.76042 23.1237 8.37501 23.0141C8.07281 22.9309 7.9896 22.7469 8.09033 22.4446C8.62027 21.8487 9.21591 21.3142 9.76774 20.7403C9.83344 20.6702 9.92979 20.6176 9.94731 20.5081C10.1926 20.2146 10.486 19.9692 10.7488 19.6932C10.8408 19.6538 10.9196 19.5925 10.9897 19.5224C12.505 18.0021 14.0248 16.4862 15.5401 14.966C15.5927 14.9134 15.6978 14.8784 15.6496 14.7688C15.9562 14.6287 16.1577 14.3745 16.346 14.1117C16.4511 14.0898 16.508 13.9978 16.5781 13.9321C17.511 13.0033 18.4482 12.0701 19.3811 11.1413C19.4687 11.1194 19.5213 11.1807 19.5738 11.2333C20.187 11.8423 20.7957 12.4512 21.4045 13.0646C21.4264 13.0865 21.4439 13.1172 21.4571 13.1478C21.4571 13.1741 21.4527 13.1916 21.4308 13.2092L21.4264 13.2004Z",
    fill: "#539AD3"
  }), jsx("path", {
    d: "M26.7348 7.94756C27.1114 8.31996 27.5406 8.63978 27.7815 9.13484C28.145 9.8884 28.053 10.6113 27.5187 11.2203C26.9669 11.8468 26.3362 12.4075 25.7406 12.999C25.6486 13.034 25.6004 12.9639 25.5479 12.9158C24.9216 12.2936 24.2953 11.6715 23.6777 11.0406C23.6558 11.0187 23.6383 10.9881 23.6252 10.9574C23.6208 10.9311 23.6252 10.9092 23.634 10.8873C24.58 9.96726 25.4997 9.02532 26.4369 8.09652C26.5158 8.01766 26.5815 7.87746 26.7391 7.94318L26.7348 7.94756Z",
    fill: "#D0D1D1"
  }), jsx("path", {
    d: "M26.7351 7.94751C26.6213 7.95189 26.5687 8.04828 26.4986 8.11399C25.6227 8.98584 24.7511 9.86206 23.8752 10.7339C23.8051 10.804 23.7526 10.896 23.6387 10.9004C23.5511 10.9311 23.4986 10.8653 23.4504 10.8128C22.8635 10.2301 22.281 9.64301 21.6941 9.06032C21.646 9.01213 21.6109 8.95955 21.589 8.89383C22.1759 8.31553 22.7671 7.75036 23.3409 7.16329C23.9278 6.5587 25.0446 6.45793 25.7366 6.97928C26.1088 7.25968 26.4242 7.6014 26.7351 7.94313V7.94751Z",
    fill: "#EEEDEE"
  }), jsx("path", {
    d: "M23.6427 10.9489C23.958 11.1898 24.2165 11.5009 24.5011 11.7769C24.9172 12.1799 25.3289 12.5962 25.7406 13.0036C25.3683 13.4417 24.9435 13.8229 24.5405 14.2303C24.1989 14.5808 23.8442 14.9182 23.4938 15.2599C22.8062 14.5764 22.1142 13.8886 21.4266 13.2051C21.4266 13.192 21.4266 13.1745 21.4266 13.1613C21.4441 13.0956 21.4923 13.0474 21.5405 12.9992C22.1843 12.3552 22.8237 11.7155 23.4675 11.0715C23.5201 11.019 23.5683 10.9576 23.6515 10.9489H23.6427Z",
    fill: "#ECB320"
  }), jsx("path", {
    d: "M23.6429 10.9486C22.9203 11.7021 22.1932 12.4513 21.4224 13.161C20.7392 12.4863 20.0603 11.8117 19.3771 11.137C19.8151 10.6463 20.3012 10.2038 20.7611 9.735C21.037 9.45899 21.3129 9.1786 21.5888 8.90259C22.0268 9.27498 22.4078 9.70871 22.8195 10.103C23.0954 10.3703 23.367 10.6375 23.6385 10.9048C23.6385 10.9179 23.6385 10.931 23.6429 10.9486Z",
    fill: "#FFCB2A"
  }), jsx("path", {
    d: "M22.5347 16.2761C22.7012 16.0264 22.9289 15.838 23.1479 15.6409C23.7742 15.8512 24.3698 16.114 24.8822 16.5478C25.6049 17.1567 25.7669 17.9629 25.3377 18.8084C24.9611 19.5576 24.326 20.0001 23.5683 20.298C22.7887 20.6047 21.9654 20.723 21.1332 20.7843C20.0865 20.8632 19.0398 20.8632 17.993 20.7931C18.2076 20.574 18.4266 20.3593 18.6324 20.1315C18.7507 20.0045 18.8996 20.0746 19.031 20.0395C19.0835 19.9869 19.1536 19.9826 19.2149 19.9869C19.7493 20.0088 20.2792 19.9607 20.8091 19.93C21.7245 19.8818 22.6311 19.7766 23.4807 19.3911C23.9406 19.1852 24.3216 18.8873 24.5494 18.4229C24.8121 17.8884 24.7114 17.4941 24.2253 17.1436C23.8574 16.8807 23.4545 16.688 23.034 16.5259C22.8632 16.4601 22.6574 16.4426 22.5347 16.2805V16.2761Z",
    fill: "#366387"
  }), jsx("path", {
    d: "M9.95235 24.6396C9.95235 24.6396 9.98301 24.644 9.99615 24.6484C10.075 24.7667 10.1976 24.7536 10.3115 24.7536C10.6093 24.7536 10.9115 24.7536 11.2093 24.7536C11.3276 24.7536 11.3801 24.7842 11.402 24.9157C11.4677 25.3056 11.5641 25.6955 11.6385 26.0854C11.7217 26.4972 11.7874 26.5586 12.1947 26.5498C12.0196 26.8214 11.7568 26.9354 11.4502 26.9967C10.802 27.1325 10.1582 27.2902 9.51001 27.4392C9.17277 27.023 8.7786 26.6637 8.39757 26.2957C8.37567 26.2826 8.36691 26.2607 8.36691 26.2344C8.37567 26.1643 8.42385 26.1161 8.46765 26.0679C8.91875 25.6166 9.36986 25.161 9.82096 24.7141C9.856 24.6791 9.89542 24.644 9.94797 24.6396H9.95235Z",
    fill: "#FAB280"
  }), jsx("path", {
    d: "M10.7446 19.6932C10.5388 20.0262 10.2541 20.2803 9.94317 20.5081C8.79569 20.5914 7.6526 20.7053 6.59272 21.2003C5.62482 21.656 4.98101 22.3701 4.87151 23.4698C4.79268 24.2715 5.12992 24.9418 5.58978 25.5639C5.76497 25.8005 5.97519 26.002 6.17665 26.208C6.33432 26.3657 6.33432 26.5847 6.18979 26.7468C6.04089 26.9133 5.83504 26.9527 5.65547 26.8038C4.52552 25.8312 3.60141 24.1444 4.28464 22.4621C4.75764 21.3055 5.66423 20.6395 6.80295 20.2452C8.07743 19.8028 9.40009 19.6976 10.7359 19.6888L10.7446 19.6932Z",
    fill: "#366387"
  }), jsx("path", {
    d: "M9.95155 24.6396C9.55738 25.0996 9.1019 25.5027 8.68145 25.9408C8.5851 26.0416 8.48875 26.1467 8.39239 26.2475C8.3267 26.2694 8.27852 26.2344 8.23911 26.1905C7.91501 25.8751 7.59092 25.5553 7.27996 25.2267C7.24492 25.1917 7.23178 25.1435 7.20551 25.0996C7.36755 24.4118 7.54712 23.724 7.68289 23.0318C7.73544 22.7557 7.90625 22.6024 8.0902 22.4403C8.08144 22.8127 8.13837 22.8916 8.49751 22.9704C8.86102 23.0493 9.22453 23.1369 9.59242 23.1851C9.8333 23.2201 9.89462 23.3165 9.89024 23.5531C9.89024 23.9124 9.81578 24.2804 9.95155 24.6353V24.6396Z",
    fill: "#FCCCAC"
  }), jsx("path", {
    d: "M7.20152 25.1042C7.55628 25.4022 7.85409 25.7526 8.18695 26.0725C8.25264 26.1338 8.32272 26.1908 8.38841 26.2521C8.38841 26.2652 8.39717 26.2828 8.39717 26.2959C8.2833 26.3003 8.22636 26.3923 8.16067 26.458C7.75336 26.8654 7.34605 27.2729 6.93436 27.6803C6.87305 27.7417 6.81611 27.8205 6.72852 27.8512C6.58399 27.7241 6.63217 27.5664 6.6672 27.4131C6.84239 26.642 7.02196 25.8709 7.20152 25.0999V25.1042Z",
    fill: "#366387"
  })),
  paperTypes: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6.01554 4.09315C10.0955 3.28515 14.1835 2.47715 18.2635 1.66916C19.3195 1.45908 20.3835 1.249 21.4395 1.01468C21.7035 0.958118 21.7435 1.06316 21.7435 1.36212C21.7355 2.17011 21.7355 4.00427 21.7435 4.81227C21.7435 5.0789 21.7035 5.18394 21.4715 5.18394C16.3515 5.17586 11.2395 5.5233 6.11954 5.5233C6.00754 5.46674 6.03954 4.14163 6.00754 4.13355L6.02354 4.08507L6.01554 4.09315Z",
    fill: "#CFCFCE"
  }), jsx("path", {
    d: "M26 30.6522C26 30.9269 25.952 31.0077 25.688 30.9996C19.232 30.9915 12.776 30.9915 6.312 30.9996C6.056 30.9996 6 30.935 6 30.6522C6 21.9096 6 13.1752 6 4.43264C6 4.14984 6.056 4.08521 6.312 4.08521C12.768 4.09329 19.224 4.09329 25.688 4.08521C25.944 4.08521 26 4.15792 26 4.43264C25.992 7.80199 25.992 27.2828 26 30.6441V30.6522Z",
    fill: "#FEC145"
  }), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M13.736 10.1935C13.824 10.4116 13.792 10.654 13.824 10.8803C14.04 12.3428 15.136 13.5628 16.56 13.9345C16.848 14.0072 17.136 14.0315 17.432 14.0557C17.52 14.0557 17.592 14.0799 17.592 14.1931C17.592 14.2981 17.512 14.3223 17.424 14.3223C16.824 14.3466 16.248 14.4759 15.72 14.7748C14.56 15.4374 13.912 16.4393 13.792 17.7806C13.792 17.8695 13.776 17.9503 13.768 18.0391C13.768 18.1199 13.736 18.1765 13.648 18.1846C13.552 18.1846 13.52 18.128 13.512 18.0391C13.488 17.7563 13.464 17.4655 13.4 17.1907C13.064 15.7444 11.832 14.589 10.376 14.3789C10.208 14.3547 10.04 14.3385 9.87199 14.3304C9.78399 14.3304 9.69599 14.3223 9.68799 14.2011C9.68799 14.0799 9.77599 14.0719 9.86399 14.0638C10.336 14.0395 10.808 13.9668 11.24 13.7648C12.584 13.1427 13.344 12.0923 13.488 10.5975C13.504 10.4682 13.488 10.3389 13.552 10.2096H13.728L13.736 10.1935Z",
    fill: "#AE7A2B"
  })), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M23.0961 17.6592C22.8961 17.74 22.6721 17.7077 22.4641 17.7481C21.1841 17.9905 20.2161 18.9924 20.0321 20.2852C20.0161 20.4226 20.0081 20.5519 20.0001 20.6892C20.0001 20.77 19.9601 20.8266 19.8801 20.8266C19.7841 20.8266 19.7521 20.77 19.7441 20.6811C19.7201 20.3822 19.6961 20.0913 19.6001 19.8085C19.2001 18.6369 18.3841 17.9501 17.1841 17.7319C17.0561 17.7077 16.9281 17.7077 16.8001 17.6996C16.7121 17.6996 16.6401 17.6673 16.6401 17.5623C16.6401 17.4653 16.7121 17.4411 16.8001 17.4411C17.2321 17.4168 17.6561 17.3441 18.0401 17.1421C19.0321 16.6331 19.6081 15.817 19.7201 14.6939C19.7201 14.6212 19.7361 14.5404 19.7441 14.4676C19.7441 14.3788 19.7761 14.306 19.8801 14.306C19.9841 14.306 20.0001 14.3949 20.0081 14.4757C20.0321 14.7585 20.0561 15.0494 20.1521 15.3241C20.5521 16.4957 21.3601 17.1825 22.5681 17.4087C22.7441 17.4411 22.9361 17.4087 23.1121 17.4815V17.6592H23.0961Z",
    fill: "#AE7A2B"
  })), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M15.3201 18.645C15.4161 18.645 15.4481 18.7016 15.4561 18.7905C15.4801 19.0086 15.4961 19.2187 15.5601 19.4288C15.8241 20.3095 16.5921 20.9478 17.4961 21.0367C17.5521 21.0367 17.6161 21.0529 17.6721 21.0609C17.7601 21.0609 17.8401 21.0852 17.8401 21.1902C17.8401 21.2953 17.7681 21.3195 17.6801 21.3276C17.4081 21.3518 17.1441 21.3841 16.8961 21.4892C16.0721 21.8528 15.5841 22.4749 15.4801 23.388C15.4721 23.4607 15.4641 23.5415 15.4561 23.6142C15.4481 23.6869 15.4081 23.7354 15.3281 23.7354C15.2481 23.7354 15.2081 23.6869 15.2001 23.6142C15.1841 23.4526 15.1681 23.291 15.1361 23.1375C14.9441 22.176 14.1201 21.4326 13.1601 21.3518C13.1041 21.3518 13.0401 21.3356 12.9841 21.3276C12.8961 21.3276 12.8081 21.3114 12.8081 21.1902C12.8081 21.0852 12.8881 21.069 12.9761 21.0609C13.2161 21.0367 13.4641 21.0125 13.6881 20.9236C14.5521 20.5761 15.0481 19.9459 15.1681 19.0086C15.1761 18.9278 15.1841 18.847 15.1921 18.7662C15.2001 18.7016 15.2401 18.6612 15.3121 18.6531L15.3201 18.645Z",
    fill: "#AE7A2B"
  }))),
  preview: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6.14285 4.09166C10.2266 3.28425 14.3103 2.47684 18.3941 1.66944C19.4546 1.46159 20.5151 1.25374 21.5677 1.01392C21.8289 0.957958 21.8764 1.06988 21.8684 1.36566C21.8605 2.17307 21.8605 4.01172 21.8684 4.81913C21.8684 5.08293 21.8289 5.19485 21.5915 5.19485C16.4709 5.18686 11.3583 5.5386 6.23782 5.53061C6.11911 5.47465 6.15868 4.14762 6.11911 4.13963L6.13494 4.09166H6.14285Z",
    fill: "#CFCFCE"
  }), jsx("path", {
    d: "M25.9993 30.6484C25.9993 30.9282 25.9518 31.0002 25.6906 31.0002C19.2326 30.9922 12.7746 30.9922 6.31657 31.0002C6.06331 31.0002 6 30.9362 6 30.6564C6 21.9109 6 13.1733 6 4.42767C6 4.14788 6.06331 4.07593 6.31657 4.07593C12.7746 4.08392 19.2326 4.08392 25.6906 4.07593C25.9518 4.07593 26.0072 4.14788 25.9993 4.42767C25.9914 7.7932 25.9914 27.2749 25.9993 30.6484Z",
    fill: "#B97EB6"
  }), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M21.0687 18.0655C20.8471 17.1862 20.4039 16.4747 19.7629 15.9311C18.2592 14.66 16.5576 14.3882 14.6978 15.1157C13.3682 15.6353 12.4897 16.6106 12.094 18.0096C12.0623 18.1295 12.0544 18.2254 12.0861 18.3293C12.276 19.0648 12.6401 19.7043 13.1624 20.232C14.0646 21.1433 15.2122 21.6149 16.5734 21.6309C16.6051 21.6309 16.6368 21.6309 16.6684 21.6309C17.2066 21.6309 17.7289 21.535 18.2275 21.3511C19.6917 20.8075 20.6414 19.8003 21.0608 18.3613C21.0846 18.2734 21.1083 18.1775 21.0766 18.0655H21.0687ZM20.2536 18.3214C19.8499 19.4805 19.0506 20.2479 17.816 20.6556C17.4124 20.7915 16.9929 20.8555 16.5655 20.8395C15.4575 20.8235 14.5157 20.4558 13.7718 19.7363C13.3523 19.3366 13.0516 18.841 12.8775 18.2814C12.8538 18.2094 12.8617 18.1375 12.8933 18.0416C13.2574 16.9863 13.9617 16.2429 14.9906 15.8432C15.5525 15.6273 16.0986 15.5154 16.6288 15.5154C17.5073 15.5154 18.3383 15.8112 19.1139 16.4108C19.6442 16.8185 20.0241 17.3701 20.2536 18.0496C20.2852 18.1455 20.2852 18.2334 20.2536 18.3293V18.3214Z",
    fill: "black"
  })), jsx("g", {
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.4
  }, jsx("path", {
    d: "M16.5893 16.3948H16.5735C16.1144 16.3948 15.6792 16.5786 15.3388 16.9224C15.0064 17.2581 14.8086 17.7058 14.8086 18.1615C14.8086 18.6171 14.9906 19.0808 15.3309 19.4246C15.6633 19.7683 16.1224 19.9602 16.5735 19.9682C17.0404 19.9682 17.5074 19.7683 17.8477 19.4086C18.1721 19.0648 18.3463 18.6331 18.3304 18.1855C18.3463 17.7458 18.1801 17.3061 17.8556 16.9704C17.5153 16.6106 17.0562 16.4028 16.5972 16.4028L16.5893 16.3948ZM17.5469 18.1855C17.5469 18.7371 17.1116 19.1687 16.5656 19.1687C16.0195 19.1687 15.5921 18.7291 15.5921 18.1775C15.5921 17.6259 16.0274 17.1942 16.5735 17.1942C17.1196 17.1942 17.5469 17.6339 17.5469 18.1855Z",
    fill: "black"
  }))),
  smartArt: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("rect", {
    x: 16.4139,
    y: 14.2858,
    width: 11.5862,
    height: 13.7143,
    rx: 1,
    fill: "#F3F4F6"
  }), jsx("path", {
    d: "M28.0001 5.19271V10.1698C27.928 10.1795 27.8952 10.1183 27.8559 10.0796C26.7314 8.97714 25.6069 7.87147 24.4857 6.76579C24.3644 6.64652 24.2267 6.56593 24.0562 6.5337C23.7644 6.47568 23.5186 6.56271 23.3153 6.76257C22.9252 7.14295 22.5383 7.52655 22.1482 7.90693C21.8138 8.2325 21.4827 8.5613 21.1483 8.88688C21.109 8.92556 21.0729 8.97069 21.0139 8.98681C20.9483 8.99003 20.9123 8.94168 20.8729 8.90622C20.709 8.74827 20.5418 8.59354 20.3877 8.42592C20.1025 8.11646 19.5648 8.07455 19.2042 8.42592C18.8436 8.77728 18.4863 9.13187 18.1256 9.48324C17.6076 9.99255 17.0897 10.5051 16.5684 11.0144C16.5356 11.0467 16.5061 11.0789 16.4668 11.1015C16.4274 11.1208 16.411 11.1079 16.4143 11.066C16.4143 9.14799 16.4143 7.22998 16.4143 5.31198C16.4143 4.9316 16.5487 4.61892 16.8274 4.36426C17.0929 4.11927 17.4109 4 17.7748 4C18.4666 4 19.1616 4 19.8533 4C22.1154 4 24.3775 4 26.6396 4C27.2231 4 27.6526 4.26755 27.9149 4.78332C27.9804 4.91226 27.9772 5.0541 28.0001 5.19271Z",
    fill: "#ECEEF0"
  }), jsx("path", {
    d: "M27.9998 11.4817C27.9605 11.5075 27.967 11.5526 27.9572 11.5913C27.8064 12.1651 27.2884 12.568 26.6884 12.5713C26.0033 12.5713 25.3181 12.5713 24.6329 12.5713C24.5804 12.5551 24.5444 12.5197 24.505 12.481C23.3674 11.3624 22.2298 10.2439 21.0922 9.1253C21.0529 9.08662 20.9873 9.05761 21.0136 8.98347C21.7578 8.25173 22.4987 7.52321 23.2429 6.79146C23.6527 6.38852 24.1444 6.38852 24.5542 6.79146C25.7016 7.9197 26.8491 9.04794 27.9965 10.1762V11.4882L27.9998 11.4817Z",
    fill: "#398F43"
  }), jsx("path", {
    d: "M21.0203 8.97717C21.0302 9.02875 21.0761 9.05453 21.1088 9.08999C22.253 10.2182 23.4004 11.3432 24.5446 12.4715C24.5774 12.5037 24.6069 12.536 24.6364 12.5682C24.5905 12.5682 24.5479 12.5714 24.502 12.5714C22.2596 12.5714 20.0139 12.5682 17.7714 12.5714C17.1322 12.5714 16.4404 12.0718 16.4339 11.2756C16.4339 11.2208 16.4339 11.166 16.4339 11.1079C16.4634 11.0821 16.4962 11.0531 16.5257 11.0273C17.401 10.1667 18.2763 9.30597 19.1516 8.44529C19.5614 8.04234 20.0499 8.04557 20.463 8.44529C20.6466 8.62258 20.8171 8.81599 21.0203 8.97717Z",
    fill: "#4FAF4F"
  }), jsx("path", {
    d: "M19.8043 6.41103C19.8043 6.93646 19.3814 7.35552 18.847 7.35552C18.3093 7.35552 17.8799 6.93646 17.8799 6.4078C17.8799 5.88237 18.3126 5.46008 18.8503 5.46008C19.3814 5.46008 19.8076 5.88237 19.8043 6.4078V6.41103Z",
    fill: "#FFC112"
  }), jsx("path", {
    d: "M4.0121 15.8778C4.0121 12.2433 4.01513 8.60888 4.00303 4.97441C4.00303 4.65796 4.09983 4.40731 4.26621 4.16606C4.32066 4.0846 4.39327 4.0658 4.47797 4.05326C4.69578 4.0188 4.90754 4 5.12534 4C7.97803 4 10.8307 4.00313 13.6834 4C14.0252 4 14.3641 4.02193 14.7029 4.047C14.8844 4.05953 15.0871 4.33525 15.1264 4.62663C15.1415 4.73629 15.1355 4.84909 15.1355 4.96188C15.1355 7.12376 15.1113 9.28564 15.1445 11.4475C15.2232 16.5358 15.1597 21.6272 15.1869 26.7154C15.1869 27.2355 15.0356 27.6616 14.5546 27.9091C14.4155 27.9812 14.2703 28 14.119 28C11.1 28 8.08089 28 5.06182 28C4.41444 28 4.00303 27.5551 4 26.8689C4.00303 23.2 4.00303 19.5405 4.00303 15.8778H4.0121ZM8.25937 5.39426C7.55149 5.39426 6.84664 5.39426 6.13876 5.39426C5.89675 5.39426 5.69407 5.48512 5.63054 5.72637C5.49441 6.23081 5.50348 6.75091 5.62146 7.25535C5.68197 7.51854 5.94818 7.65013 6.19019 7.61253C6.44127 7.5718 6.62883 7.37128 6.65303 7.11123C6.69135 6.72898 6.89907 6.53786 7.2762 6.53786C7.31856 6.53786 7.36091 6.54099 7.40023 6.53786C7.63014 6.50966 7.70275 6.61932 7.69972 6.85117C7.69065 7.64386 7.69972 8.43655 7.69972 9.22611C7.69972 9.57285 7.53132 9.76188 7.19453 9.79321C7.17032 9.79321 7.14612 9.79634 7.1189 9.80261C6.83454 9.85587 6.65303 10.0689 6.65 10.3509C6.64698 10.6454 6.83151 10.9023 7.12797 10.9117C7.8661 10.9337 8.60726 10.9337 9.34539 10.9149C9.65395 10.9055 9.85058 10.6423 9.84453 10.3446C9.83848 10.0439 9.6358 9.82768 9.32118 9.79634C9.22136 9.78694 9.12153 9.78694 9.0217 9.79008C8.86439 9.79634 8.79784 9.71802 8.79784 9.55509C8.79784 8.62454 8.79784 7.69399 8.79784 6.76658C8.79784 6.62245 8.84927 6.53473 9.00052 6.53786C9.21531 6.53786 9.43311 6.53786 9.6479 6.53786C9.7689 6.53786 9.83545 6.59739 9.83545 6.72585C9.83545 6.81044 9.83545 6.89817 9.83848 6.98277C9.84453 7.34935 10.0502 7.59687 10.3588 7.61253C10.6583 7.6282 10.9094 7.38381 10.9305 7.02036C10.9487 6.67572 10.9517 6.33107 10.9305 5.98956C10.9063 5.57911 10.6946 5.39426 10.2983 5.39112C9.61765 5.39112 8.93397 5.39112 8.25332 5.39112L8.25937 5.39426ZM9.57832 17.5446C10.6583 17.5446 11.7413 17.5446 12.8212 17.5446C12.9453 17.5446 13.0723 17.5446 13.1903 17.5008C13.4232 17.4099 13.5685 17.2345 13.5715 16.9807C13.5745 16.7238 13.4384 16.5452 13.1994 16.4574C13.0875 16.4167 12.9725 16.4104 12.8545 16.4104C10.6674 16.4104 8.4802 16.4104 6.29304 16.4104C6.20229 16.4104 6.10851 16.4136 6.02078 16.4355C5.76364 16.495 5.60331 16.705 5.60331 16.9744C5.60331 17.2439 5.75457 17.4569 6.0117 17.5164C6.11456 17.5415 6.22649 17.5446 6.33237 17.5446C7.41233 17.5446 8.49533 17.5446 9.57529 17.5446H9.57832ZM9.56017 24.1587C10.6159 24.1587 11.6717 24.1587 12.7275 24.1587C12.8273 24.1587 12.9271 24.1587 13.027 24.1462C13.3748 24.0992 13.5866 23.8674 13.5715 23.5603C13.5594 23.2752 13.3174 23.0559 12.9876 23.0339C12.9453 23.0339 12.906 23.0339 12.8636 23.0339C10.6855 23.0339 8.50743 23.0339 6.32934 23.0339C6.23859 23.0339 6.14481 23.0402 6.05708 23.059C5.76364 23.1248 5.60936 23.3128 5.60634 23.5916C5.60634 23.8799 5.76364 24.0773 6.06918 24.1399C6.17506 24.1619 6.28396 24.1619 6.39287 24.1619C7.44864 24.1619 8.5044 24.1619 9.56017 24.1619V24.1587ZM9.54807 13.105C9.98066 13.105 10.4133 13.105 10.8458 13.105C11.5779 13.105 12.31 13.105 13.0391 13.105C13.3053 13.105 13.4928 12.9514 13.5594 12.707C13.629 12.4564 13.5231 12.2715 13.3506 12.1149C13.2266 12.0052 13.0723 12.0146 12.9241 12.0146C10.7037 12.0146 8.48625 12.0146 6.26581 12.0146C6.19019 12.0146 6.11456 12.0146 6.04196 12.024C5.77574 12.071 5.62146 12.2433 5.60634 12.5065C5.58516 12.8856 5.77877 13.1018 6.15993 13.1018C7.29133 13.105 8.4197 13.1018 9.55109 13.1018L9.54807 13.105ZM9.56622 14.2329C9.1185 14.2329 8.66776 14.2329 8.22004 14.2329C7.52124 14.2329 6.82244 14.2298 6.12363 14.2329C5.78482 14.236 5.59726 14.4428 5.60331 14.7843C5.60936 15.1321 5.82415 15.3201 6.22951 15.3201C8.45903 15.3201 10.6885 15.3201 12.9181 15.3201C13.036 15.3201 13.154 15.3201 13.2599 15.2668C13.4777 15.1603 13.5927 14.9723 13.5745 14.7279C13.5564 14.4835 13.4142 14.3144 13.1812 14.2486C13.0875 14.2235 12.9846 14.2298 12.8848 14.2298C11.7776 14.2298 10.6734 14.2298 9.56622 14.2298V14.2329ZM9.57529 19.7191C10.3406 19.7191 11.103 19.7191 11.8683 19.7191C12.2677 19.7191 12.667 19.7285 13.0633 19.7128C13.4656 19.6971 13.6925 19.2741 13.4958 18.9138C13.3718 18.682 13.1601 18.6287 12.9211 18.6287C10.6855 18.6287 8.44995 18.6287 6.21439 18.6287C6.16599 18.6287 6.11456 18.6287 6.06616 18.635C5.76969 18.6757 5.59121 18.8919 5.60029 19.199C5.60936 19.5279 5.79995 19.7128 6.15691 19.7159C7.29435 19.7191 8.43482 19.7159 9.57227 19.7159L9.57529 19.7191ZM9.57832 20.8501C9.42101 20.8501 9.26371 20.8501 9.10338 20.8501C8.12324 20.8501 7.14007 20.8501 6.15993 20.8501C5.79692 20.8501 5.59424 21.0538 5.60331 21.3922C5.61239 21.718 5.84532 21.9342 6.20531 21.9373C7.41233 21.9373 8.61633 21.9373 9.82335 21.9373C10.8549 21.9373 11.8865 21.9373 12.915 21.9373C13.1419 21.9373 13.3506 21.8935 13.4807 21.6804C13.5836 21.5112 13.6138 21.3326 13.5079 21.1446C13.393 20.9347 13.2236 20.847 12.9937 20.8501C11.8532 20.8501 10.7158 20.8501 9.57529 20.8501H9.57832ZM9.57227 26.3332C10.7037 26.3332 11.832 26.3332 12.9634 26.3332C13.3325 26.3332 13.5654 26.1232 13.5715 25.8005C13.5775 25.4841 13.3355 25.2522 12.9725 25.2522C10.7127 25.2522 8.45298 25.2522 6.19321 25.2522C6.07523 25.2522 5.9633 25.2679 5.86045 25.3368C5.65474 25.4778 5.56096 25.7222 5.62449 25.9666C5.68197 26.1922 5.8665 26.3332 6.13271 26.3332C7.27923 26.3363 8.42575 26.3332 9.57227 26.3332ZM12.7819 5.39739C12.7002 5.39426 12.6155 5.39112 12.5339 5.39426C12.2132 5.40366 12.0045 5.58851 11.9682 5.88929C11.9379 6.14308 12.1103 6.40627 12.3826 6.48773C12.667 6.57232 12.9574 6.56606 13.2387 6.46893C13.4716 6.3906 13.6138 6.14935 13.5896 5.90809C13.5624 5.63864 13.3627 5.42559 13.1086 5.40052C13.0028 5.39112 12.8939 5.40052 12.7849 5.40052L12.7819 5.39739ZM12.7577 8.706C12.8666 8.706 12.9755 8.71227 13.0814 8.706C13.3143 8.69034 13.4656 8.55875 13.5473 8.33943C13.629 8.12324 13.5745 7.93838 13.4202 7.77546C13.1449 7.49034 12.3947 7.47781 12.1285 7.76919C11.9742 7.93525 11.9137 8.13577 12.0045 8.36136C12.0922 8.58068 12.2465 8.706 12.4824 8.70914C12.5732 8.70914 12.6639 8.70914 12.7577 8.70914V8.706ZM12.788 9.79634C12.6881 9.79634 12.5883 9.78694 12.4885 9.79634C12.1769 9.83394 11.9863 10.0564 11.9893 10.3634C11.9893 10.6674 12.186 10.8898 12.5006 10.918C12.6912 10.9368 12.8817 10.9337 13.0723 10.918C13.3416 10.8929 13.5412 10.6893 13.5806 10.4292C13.6138 10.2005 13.4747 9.953 13.2538 9.84647C13.1026 9.77441 12.9453 9.79321 12.788 9.79634Z",
    fill: "#6AA0D5"
  }), jsx("path", {
    d: "M21.5729 22.7502C21.5668 23.0008 21.3884 23.2264 21.1464 23.2922C20.9346 23.3486 20.6775 23.2515 20.5716 23.0353C20.4748 22.8473 20.4052 22.6405 20.3356 22.44C20.2842 22.2865 20.1965 22.2238 20.0392 22.2238C19.6308 22.2301 19.2254 22.2301 18.817 22.2238C18.6718 22.2238 18.5841 22.2802 18.5357 22.4212C18.4752 22.5998 18.4117 22.7784 18.336 22.9507C18.1969 23.2578 17.9155 23.38 17.6372 23.2703C17.3498 23.1575 17.2107 22.8567 17.3256 22.5277C17.7038 21.4593 18.091 20.3972 18.4752 19.3319C18.6083 18.9622 18.7414 18.5894 18.8775 18.2196C18.9864 17.922 19.171 17.7747 19.4251 17.7716C19.6822 17.7716 19.8698 17.9157 19.9756 18.2134C20.4778 19.6014 20.98 20.9862 21.4821 22.3742C21.5245 22.4933 21.5729 22.6155 21.5729 22.7471V22.7502ZM19.4583 20.0525C19.4372 20.0525 19.416 20.0525 19.3948 20.0525C19.2889 20.3471 19.1831 20.6384 19.0772 20.933C19.059 20.9831 19.059 21.052 19.1195 21.0614C19.3252 21.0928 19.534 21.0928 19.7367 21.0614C19.7972 21.052 19.7941 20.9831 19.776 20.933C19.6701 20.6384 19.5642 20.3471 19.4553 20.0525H19.4583Z",
    fill: "#FFC112"
  }), jsx("path", {
    d: "M22.335 25.4823C20.8557 25.4823 19.3765 25.4823 17.8972 25.4823C17.513 25.4823 17.3254 25.2943 17.3315 24.9277C17.3345 24.6426 17.4797 24.464 17.758 24.4139C17.8457 24.3982 17.9395 24.4014 18.0303 24.4014C20.889 24.4014 23.7478 24.4014 26.6065 24.4014C26.7638 24.4014 26.9211 24.4014 27.0724 24.464C27.2781 24.5549 27.4202 24.7805 27.396 24.9935C27.3718 25.2348 27.1782 25.4447 26.9423 25.4729C26.8515 25.4855 26.7608 25.4792 26.667 25.4792C25.221 25.4792 23.775 25.4792 22.329 25.4792L22.335 25.4823Z",
    fill: "#FFC112"
  }), jsx("path", {
    d: "M25.0276 20.0054C25.6175 20.0054 26.2074 20.0054 26.7973 20.0054C27.1542 20.0054 27.4053 20.2341 27.4023 20.5443C27.4023 20.8451 27.1542 21.0832 26.8124 21.0832C25.6175 21.0895 24.4195 21.0895 23.2246 21.0832C22.8828 21.0832 22.6347 20.8482 22.6317 20.5475C22.6256 20.2373 22.8797 20.0086 23.2337 20.0054C23.8326 20.0023 24.4286 20.0054 25.0276 20.0054Z",
    fill: "#FFC112"
  }), jsx("path", {
    d: "M25.0184 18.865C24.4194 18.865 23.8235 18.865 23.2245 18.865C22.8827 18.865 22.6376 18.6394 22.6346 18.3386C22.6286 18.0378 22.8736 17.7903 23.2124 17.7872C24.4073 17.7809 25.6053 17.7809 26.8002 17.7872C27.1209 17.7872 27.3205 17.9438 27.3871 18.2101C27.4476 18.4483 27.3447 18.6269 27.1693 18.771C27.0573 18.8618 26.9242 18.865 26.7881 18.865C26.1982 18.865 25.6083 18.865 25.0184 18.865Z",
    fill: "#FFC112"
  }), jsx("path", {
    d: "M25.0457 22.2268C25.6356 22.2268 26.2255 22.2268 26.8124 22.2268C27.1482 22.2268 27.4023 22.4555 27.3992 22.75C27.3962 23.0352 27.1482 23.2607 26.8245 23.2607C25.6114 23.2607 24.4013 23.2607 23.1883 23.2607C22.7587 23.2607 22.5197 22.8691 22.7012 22.4837C22.795 22.2863 22.9523 22.2268 23.152 22.2268C23.7842 22.2268 24.4134 22.2268 25.0457 22.2268Z",
    fill: "#FFC112"
  })),
  shapes: jsx("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M22.2733 15.4388C19.4381 15.4642 16.9645 13.3137 16.6034 10.5094C16.214 7.48531 18.1513 4.74771 21.1293 4.11357C21.3077 4.07552 21.4994 4.09901 21.6647 4.00037H22.2738C22.3541 4.09055 22.3489 4.20235 22.3489 4.31086C22.3503 7.91652 22.3503 11.5222 22.3489 15.1274C22.3489 15.2363 22.3517 15.3477 22.2733 15.4383V15.4388Z",
    fill: "#FDD92D"
  }), jsx("path", {
    d: "M22.2733 15.4388C22.2733 11.626 22.2733 7.81318 22.2738 4.00037H22.5551C22.649 4.03888 22.7425 4.03888 22.8364 4.00037H22.8833C23.0956 4.09854 23.3319 4.08163 23.5535 4.14129C25.8801 4.7665 27.3726 6.24803 27.8737 8.59481C28.5181 11.6119 26.6339 14.5186 23.6362 15.2885C23.1905 15.4031 22.7359 15.4623 22.2738 15.4388H22.2733Z",
    fill: "#FBBF14"
  }), jsx("path", {
    d: "M4.00043 22.7937C4.41841 22.0821 4.8392 21.3728 5.25343 20.6588C5.79727 19.7217 6.33783 18.7827 6.87556 17.8418C6.95258 17.7065 7.03994 17.6455 7.20619 17.646C9.04718 17.6502 10.8877 17.6445 12.7287 17.6436C12.8024 17.6436 12.886 17.6121 12.9489 17.6826C12.8466 17.7822 12.716 17.7587 12.5939 17.7592C11.8608 17.762 11.1272 17.7601 10.3941 17.761C10.0353 17.761 10.0273 17.7686 10.0273 18.127C10.0268 21.2718 10.0273 24.4167 10.0254 27.561C10.0254 27.7057 10.0607 27.8603 9.95218 27.988C9.00914 27.9904 8.0661 27.9899 7.12353 27.9993C6.9817 28.0007 6.93896 27.9185 6.88355 27.8227C5.97292 26.2439 5.06087 24.6661 4.14789 23.0887C4.10657 23.0169 4.09013 22.9248 4.0009 22.8872C4.0009 22.8557 4.0009 22.8247 4.0009 22.7933L4.00043 22.7937Z",
    fill: "#48C3D1"
  }), jsx("path", {
    d: "M10.1853 4.00047C10.2064 4.12683 10.29 4.22265 10.3501 4.32881C12.2855 7.74094 14.2223 11.1517 16.1591 14.5629C16.1896 14.6169 16.2174 14.6728 16.2507 14.7254C16.308 14.816 16.2789 14.8532 16.1784 14.8517C16.1474 14.8517 16.1159 14.8517 16.0849 14.8517C14.1646 14.8517 12.2447 14.8517 10.3243 14.8508C10.2633 14.8508 10.2022 14.8362 10.1407 14.8283C10.0608 14.7385 10.0637 14.6272 10.0637 14.5182C10.0623 11.1474 10.0627 7.77711 10.0637 4.40632C10.0637 4.29781 10.0651 4.18789 10.0895 4.08032C10.1012 4.0512 10.1177 4.02443 10.1383 4H10.1853V4.00047Z",
    fill: "#D22045"
  }), jsx("path", {
    d: "M4.15075 14.5492C4.71197 13.5693 5.27601 12.5909 5.83441 11.6092C7.233 9.14917 8.62924 6.68778 10.0269 4.22732C10.0612 4.1672 10.1039 4.11224 10.1424 4.05493C10.1415 7.64603 10.141 11.2371 10.1401 14.8287C8.09338 14.8278 6.04669 14.8273 4 14.8264V14.7794C4.05824 14.7075 4.05025 14.5929 4.15028 14.5487L4.15075 14.5492Z",
    fill: "#ED1B5C"
  }), jsx("path", {
    d: "M4.15074 14.5494C4.11692 14.6373 4.09202 14.7303 4.00043 14.7801V14.5457C4.05069 14.5471 4.10095 14.548 4.15074 14.5494Z",
    fill: "white"
  }), jsx("path", {
    d: "M22.6487 17.4104C23.9909 17.4071 25.3331 17.4038 26.6754 17.4014C27.0421 17.4005 27.4094 17.4113 27.7757 17.3967C27.9528 17.3897 27.9946 17.4423 27.9941 17.6166C27.988 19.8257 27.9899 22.0353 27.9899 24.2445C27.9899 25.431 27.9899 26.618 27.9899 27.8046C27.9899 27.906 28.0115 28 27.8462 27.999C26.1137 27.9915 24.3812 27.9906 22.6487 27.9882C22.5627 27.8999 22.5735 27.7863 22.5735 27.6787C22.5716 24.3591 22.5716 21.04 22.5735 17.7204C22.5735 17.6123 22.5637 17.4991 22.6487 17.4104Z",
    fill: "#46B973"
  }), jsx("path", {
    d: "M22.6493 17.4103C22.6493 20.9361 22.6493 24.4624 22.6493 27.9882C20.9478 27.9905 19.2463 27.9924 17.5453 27.998C17.4345 27.998 17.3856 27.9656 17.3992 27.8524C17.4039 27.8139 17.3997 27.7745 17.3997 27.7355C17.3997 24.3783 17.402 21.0211 17.3945 17.6639C17.3945 17.4493 17.4495 17.3962 17.6618 17.3976C19.3243 17.4094 20.9863 17.4079 22.6489 17.4103H22.6493Z",
    fill: "#74C163"
  }), jsx("path", {
    d: "M9.95165 27.9886C9.95165 24.639 9.95306 21.2893 9.94601 17.9396C9.94601 17.7306 10.0033 17.6775 10.2085 17.6799C11.1215 17.6907 12.035 17.6841 12.9484 17.6836C13.4199 18.4902 13.8933 19.2953 14.3625 20.1032C14.8594 20.9591 15.3502 21.8187 15.8503 22.6731C15.9189 22.7901 15.9156 22.8765 15.8494 22.9902C14.9148 24.6014 13.9835 26.2144 13.0536 27.8284C12.9963 27.928 12.9442 28.0008 12.8075 27.9999C11.8556 27.9914 10.9041 27.9919 9.95212 27.9891L9.95165 27.9886Z",
    fill: "#07A9DF"
  })),
  rightPanel: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.46959 15.1278C2.21288 15.1278 2 14.915 2 14.6582V5.26635C2 5.00964 2.21288 4.79675 2.46959 4.79675C2.72631 4.79675 2.93919 5.00964 2.93919 5.26635V14.6582C2.93919 14.915 2.72631 15.1278 2.46959 15.1278Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M5.20546 15.1278C4.94875 15.1278 4.73587 14.915 4.73587 14.6582V5.26635C4.73587 5.00964 4.94875 4.79675 5.20546 4.79675C5.46218 4.79675 5.67506 5.00964 5.67506 5.26635V14.6582C5.67506 14.915 5.46218 15.1278 5.20546 15.1278Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M17.9389 5.72377C17.6875 3.4483 16.3358 3 14.0943 3H11.3774C9.13586 3 7.78416 3.4483 7.53963 5.70339C7.49209 6.02264 7.47171 6.39622 7.47171 6.90565V13.0188C7.47171 13.5283 7.49209 13.8951 7.53284 14.2007C7.78416 16.4762 9.13586 16.9245 11.3774 16.9245H14.0943C16.3358 16.9245 17.6875 16.4762 17.9321 14.2211C17.9796 13.9019 18 13.5283 18 13.0188V6.90565C18 6.39622 17.9796 6.02943 17.9389 5.72377ZM16.9811 13.0188C16.9811 13.4807 16.9675 13.8068 16.9268 14.0921C16.7706 15.4505 16.3426 15.9056 14.0943 15.9056H11.3774C9.12907 15.9056 8.69435 15.4505 8.54492 14.0717C8.51095 13.8068 8.49058 13.4807 8.49058 13.0188V6.90565C8.49058 6.44377 8.51095 6.11773 8.54492 5.83245C8.70114 4.47396 9.12907 4.01887 11.3774 4.01887H14.0943C16.3426 4.01887 16.7774 4.47396 16.9268 5.85282C16.9607 6.11773 16.9811 6.44377 16.9811 6.90565V13.0188Z",
    fill: "#F9FBFC"
  })),
  leftPanel: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M12.467 5.72373C12.2157 3.44829 10.864 3 8.62253 3H5.9056C3.66412 3 2.31245 3.44829 2.06792 5.70335C2.02038 6.02259 2 6.39617 2 6.9056V13.0187C2 13.5281 2.02038 13.8949 2.06113 14.2006C2.31245 16.476 3.66412 16.9243 5.9056 16.9243H8.62253C10.864 16.9243 12.2157 16.476 12.4602 14.2209C12.5078 13.9017 12.5281 13.5281 12.5281 13.0187V6.9056C12.5281 6.39617 12.5078 6.02938 12.467 5.72373ZM11.5093 13.0187C11.5093 13.4806 11.4957 13.8066 11.4549 14.0919C11.2987 15.4504 10.8708 15.9054 8.62253 15.9054H5.9056C3.65733 15.9054 3.22262 15.4504 3.07319 14.0715C3.03923 13.8066 3.01885 13.4806 3.01885 13.0187V6.9056C3.01885 6.44372 3.03923 6.11768 3.07319 5.83241C3.22941 4.47394 3.65733 4.01885 5.9056 4.01885H8.62253C10.8708 4.01885 11.3055 4.47394 11.4549 5.85278C11.4889 6.11768 11.5093 6.44372 11.5093 6.9056V13.0187Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M14.7947 15.1277C14.538 15.1277 14.3251 14.9148 14.3251 14.6581V5.26634C14.3251 5.00963 14.538 4.79675 14.7947 4.79675C15.0514 4.79675 15.2643 5.00963 15.2643 5.26634V14.6581C15.2643 14.9148 15.0514 15.1277 14.7947 15.1277Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M17.5306 15.1277C17.2739 15.1277 17.061 14.9148 17.061 14.6581V5.26634C17.061 5.00963 17.2739 4.79675 17.5306 4.79675C17.7873 4.79675 18.0001 5.00963 18.0001 5.26634V14.6581C18.0001 14.9148 17.7873 15.1277 17.5306 15.1277Z",
    fill: "#F9FBFC"
  })),
  middlePanel: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.46959 15.1276C2.21288 15.1276 2 14.9147 2 14.658V5.26622C2 5.00951 2.21288 4.79663 2.46959 4.79663C2.7263 4.79663 2.93918 5.00951 2.93918 5.26622V14.658C2.93918 14.9147 2.7263 15.1276 2.46959 15.1276Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M15.2028 5.72373C14.9515 3.44829 13.5998 3 11.3583 3H8.64141C6.39993 3 5.04826 3.44829 4.80373 5.70335C4.75619 6.02259 4.73581 6.39617 4.73581 6.9056V13.0187C4.73581 13.5281 4.75619 13.8949 4.79694 14.2006C5.04826 16.476 6.39993 16.9243 8.64141 16.9243H11.3583C13.5998 16.9243 14.9515 16.476 15.196 14.2209C15.2436 13.9017 15.2639 13.5281 15.2639 13.0187V6.9056C15.2639 6.39617 15.2436 6.02938 15.2028 5.72373ZM14.2451 13.0187C14.2451 13.4806 14.2315 13.8066 14.1907 14.0919C14.0345 15.4504 13.6066 15.9054 11.3583 15.9054H8.64141C6.39314 15.9054 5.95843 15.4504 5.809 14.0715C5.77504 13.8066 5.75466 13.4806 5.75466 13.0187V6.9056C5.75466 6.44372 5.77504 6.11768 5.809 5.83241C5.96522 4.47394 6.39314 4.01885 8.64141 4.01885H11.3583C13.6066 4.01885 14.0413 4.47394 14.1907 5.85278C14.2247 6.11768 14.2451 6.44372 14.2451 6.9056V13.0187Z",
    fill: "#F9FBFC"
  }), jsx("path", {
    d: "M17.5304 15.1276C17.2737 15.1276 17.0608 14.9147 17.0608 14.658V5.26622C17.0608 5.00951 17.2737 4.79663 17.5304 4.79663C17.7871 4.79663 18 5.00951 18 5.26622V14.658C18 14.9147 17.7871 15.1276 17.5304 15.1276Z",
    fill: "#F9FBFC"
  })),
  chevron: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7722 13.7657C16.4685 14.0781 15.976 14.0781 15.6723 13.7657L10 7.93137L4.32775 13.7657C4.02401 14.0781 3.53155 14.0781 3.22781 13.7657C2.92406 13.4533 2.92406 12.9467 3.22781 12.6343L9.45003 6.23431C9.75377 5.9219 10.2462 5.9219 10.55 6.23431L16.7722 12.6343C17.0759 12.9467 17.0759 13.4533 16.7722 13.7657Z",
    fill: "white"
  })),
  redo: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29697 17L9.29913 17L15.3933 17C15.7284 17 16 16.717 16 16.3679C16 16.0188 15.7284 15.7358 15.3933 15.7358H9.30023C7.80842 15.7301 6.80351 15.2468 6.17102 14.5924C5.53329 13.9327 5.22235 13.0461 5.21366 12.1388C5.19596 10.2904 6.39567 8.57236 8.35217 8.57237L13.9285 8.57235L11.103 11.5158C10.866 11.7627 10.866 12.1629 11.103 12.4097C11.3399 12.6566 11.7241 12.6566 11.961 12.4097L15.8223 8.38721C16.0592 8.14037 16.0592 7.74016 15.8223 7.49333L11.961 3.47084C11.724 3.224 11.3399 3.224 11.1029 3.47085C10.866 3.71769 10.866 4.11789 11.1029 4.36473L13.9285 7.3082L8.35218 7.30822C5.5501 7.3082 3.97764 9.79189 4.00024 12.1514C4.0117 13.348 4.42403 14.5667 5.31595 15.4894C6.21294 16.4174 7.54372 16.9935 9.29697 17Z",
    fill: "white"
  })),
  undo: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.703 17L10.7009 17L4.60674 17C4.27165 17 4 16.717 4 16.3679C4 16.0188 4.27165 15.7358 4.60674 15.7358H10.6998C12.1916 15.7301 13.1965 15.2468 13.829 14.5924C14.4667 13.9327 14.7776 13.0461 14.7863 12.1388C14.804 10.2904 13.6043 8.57236 11.6478 8.57237L6.07154 8.57235L8.89704 11.5158C9.13399 11.7627 9.13399 12.1629 8.89704 12.4097C8.66009 12.6566 8.27593 12.6566 8.03898 12.4097L4.17771 8.38721C3.94076 8.14037 3.94076 7.74016 4.17771 7.49333L8.03901 3.47084C8.27595 3.224 8.66012 3.224 8.89707 3.47085C9.13401 3.71769 9.13401 4.11789 8.89707 4.36473L6.07155 7.3082L11.6478 7.30822C14.4499 7.3082 16.0224 9.79189 15.9998 12.1514C15.9883 13.348 15.576 14.5667 14.6841 15.4894C13.7871 16.4174 12.4563 16.9935 10.703 17Z",
    fill: "white"
  })),
  back: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20971 15.7614L4.22922 10.5761C3.92359 10.2579 3.92359 9.74206 4.22922 9.42386L9.20971 4.23864C9.51534 3.92045 10.0109 3.92045 10.3165 4.23864C10.6221 4.55684 10.6221 5.07272 10.3165 5.39091L6.67199 9.18522H15.2174C15.6496 9.18522 16 9.55001 16 10C16 10.45 15.6496 10.8148 15.2174 10.8148H6.67199L10.3165 14.6091C10.6221 14.9273 10.6221 15.4432 10.3165 15.7614C10.0109 16.0795 9.51534 16.0795 9.20971 15.7614Z",
    fill: "white"
  })),
  replace: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M13.8772 18.0001C13.4694 17.8269 13.3143 17.5463 13.4419 17.2145C13.482 17.1072 13.5595 17.0266 13.6396 16.9486C14.0723 16.5265 14.5051 16.1044 14.9454 15.675C14.8704 15.6287 14.7978 15.6457 14.7328 15.6457C11.8109 15.6457 8.88644 15.6238 5.96453 15.6531C4.50358 15.6677 3.19522 14.6381 3.0176 13.2108C3.0176 13.1938 3.00509 13.1791 3.00009 13.162C3.00009 12.1886 3.00009 11.2127 3.00009 10.2392C3.09515 10.0099 3.24525 9.83908 3.51293 9.81225C3.90318 9.77565 4.18086 10.0367 4.18337 10.449C4.18837 11.2493 4.18337 12.0495 4.18587 12.8498C4.19087 13.6402 4.71371 14.2746 5.50423 14.4527C5.66183 14.4893 5.82194 14.4844 5.98204 14.4868C8.89395 14.4868 11.8059 14.4868 14.7178 14.4868C14.7753 14.4868 14.8353 14.499 14.8954 14.4673C14.9004 14.3917 14.8303 14.3624 14.7878 14.3209C14.39 13.9306 13.9898 13.5402 13.592 13.1523C13.4219 12.9864 13.3644 12.7888 13.4319 12.5619C13.4995 12.3301 13.6696 12.2057 13.8997 12.1593C14.0873 12.1203 14.2575 12.1764 14.39 12.3057C15.1981 13.084 16.0036 13.8623 16.8041 14.6479C17.0768 14.9162 17.0593 15.2432 16.7866 15.5091C16.0211 16.2557 15.2556 16.9998 14.4926 17.7488C14.3775 17.8635 14.2525 17.9538 14.0924 17.9977H13.8772V18.0001Z",
    fill: "white"
  }), jsx("path", {
    d: "M3.00009 4.77891C3.04012 4.67644 3.09515 4.58129 3.17771 4.50078C3.96823 3.72981 4.75624 2.95885 5.54926 2.19032C5.89449 1.85607 6.43234 1.9805 6.55492 2.41966C6.61996 2.64656 6.54992 2.84174 6.3798 3.0052C5.95953 3.41508 5.53925 3.82496 5.11898 4.23485C5.09396 4.25924 5.07145 4.28364 5.03893 4.32024C5.11147 4.36659 5.18152 4.34708 5.24656 4.34708C7.06525 4.34708 8.88394 4.34708 10.7026 4.34708C11.1054 4.34708 11.3581 4.60813 11.323 4.98385C11.3005 5.23515 11.1054 5.44497 10.8527 5.48157C10.7352 5.49865 10.6151 5.50353 10.4975 5.50353C8.76136 5.50353 7.02773 5.50353 5.29159 5.50353C5.22405 5.50353 5.1515 5.49133 5.08396 5.5206C5.09396 5.60112 5.15901 5.63039 5.20153 5.67431C5.59929 6.06467 5.99956 6.4526 6.39732 6.8454C6.56493 7.0113 6.61996 7.21136 6.54992 7.43582C6.47737 7.6676 6.30726 7.78959 6.0746 7.83106C5.85696 7.87254 5.68435 7.77983 5.53425 7.631C4.78376 6.89663 4.03077 6.16226 3.27777 5.43033C3.1627 5.3181 3.05012 5.21075 3.00259 5.05461V4.77647L3.00009 4.77891Z",
    fill: "white"
  }), jsx("path", {
    d: "M16.9916 8.19947C16.9916 8.72158 16.9916 9.13878 16.9916 9.55598C16.9916 9.92927 16.749 10.1806 16.4012 10.1806C16.0535 10.1806 15.8034 9.9317 15.8009 9.56086C15.7959 8.74842 15.8009 7.93841 15.7959 7.12597C15.7909 6.33793 15.233 5.68163 14.4475 5.53036C14.3024 5.50353 14.1523 5.50353 14.0047 5.48157C13.727 5.43765 13.5044 5.1644 13.5194 4.89602C13.5369 4.59593 13.7795 4.35927 14.0822 4.34707C15.4957 4.29584 16.789 5.38398 16.9591 6.75757C17.0217 7.27236 16.9666 7.78715 16.9916 8.19703V8.19947Z",
    fill: "white"
  })),
  cardView: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M10 16.1284C9.80465 16.1284 9.6093 16.0829 9.44651 15.9917C8.22884 15.3275 6.08651 14.6243 4.74512 14.4484L4.55628 14.4224C3.70326 14.3182 3 13.5173 3 12.6512V4.7852C3 4.27078 3.20186 3.80194 3.57302 3.46334C3.94419 3.12473 4.42605 2.96194 4.93395 3.00752C6.36651 3.11822 8.52837 3.8345 9.75256 4.60287L9.90884 4.69403C9.95442 4.72008 10.0521 4.72008 10.0912 4.70054L10.1953 4.63543C11.4195 3.86706 13.5814 3.13775 15.0205 3.01403C15.0335 3.01403 15.0856 3.01403 15.0986 3.01403C15.574 2.96845 16.0623 3.13775 16.427 3.47636C16.7981 3.81496 17 4.2838 17 4.79822V12.6577C17 13.5303 16.2967 14.3247 15.4372 14.4289L15.2223 14.455C13.8809 14.6308 11.7321 15.3405 10.5405 15.9982C10.3842 16.0894 10.1953 16.1284 10 16.1284ZM4.77767 3.97775C4.5693 3.97775 4.38047 4.04938 4.2307 4.18613C4.06791 4.33589 3.97674 4.55078 3.97674 4.7852V12.6512C3.97674 13.0354 4.30884 13.4066 4.68 13.4587L4.87535 13.4847C6.34047 13.6801 8.58698 14.4159 9.8893 15.1257C9.94791 15.1517 10.0326 15.1582 10.0651 15.1452C11.3674 14.4224 13.627 13.6801 15.0986 13.4847L15.32 13.4587C15.6912 13.4131 16.0233 13.0354 16.0233 12.6512V4.79171C16.0233 4.55078 15.9321 4.3424 15.7693 4.18613C15.6 4.03636 15.3851 3.96473 15.1442 3.97775C15.1312 3.97775 15.0791 3.97775 15.066 3.97775C13.8223 4.08845 11.8167 4.75915 10.7228 5.44287L10.6186 5.5145C10.2605 5.73589 9.75256 5.73589 9.40744 5.52101L9.25116 5.42985C8.13767 4.74613 6.13209 4.08194 4.85581 3.97775C4.82977 3.97775 4.80372 3.97775 4.77767 3.97775Z",
    fill: "white"
  }), jsx("path", {
    d: "M10.0003 15.5814C9.73328 15.5814 9.51189 15.36 9.51189 15.093V5.32553C9.51189 5.05855 9.73328 4.83716 10.0003 4.83716C10.2672 4.83716 10.4886 5.05855 10.4886 5.32553V15.093C10.4886 15.3665 10.2672 15.5814 10.0003 15.5814ZM7.23282 7.76739H5.7677C5.50072 7.76739 5.27933 7.546 5.27933 7.27902C5.27933 7.01204 5.50072 6.79065 5.7677 6.79065H7.23282C7.49979 6.79065 7.72119 7.01204 7.72119 7.27902C7.72119 7.546 7.49979 7.76739 7.23282 7.76739ZM7.72119 9.72089H5.7677C5.50072 9.72089 5.27933 9.49949 5.27933 9.23251C5.27933 8.96554 5.50072 8.74414 5.7677 8.74414H7.72119C7.98816 8.74414 8.20956 8.96554 8.20956 9.23251C8.20956 9.49949 7.98816 9.72089 7.72119 9.72089Z",
    fill: "white"
  })),
  alertDefault: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M11.503 2.19993C13.9595 2.86913 15.5842 4.92636 15.6011 7.38318C15.6063 8.13308 15.585 8.88334 15.6105 9.63253C15.6596 11.0788 16.2646 12.29 17.387 13.2621C17.935 13.737 18.1232 14.2562 17.9208 14.8154C17.7262 15.3532 17.2033 15.7114 16.5889 15.7135C15.4395 15.7174 14.2898 15.7174 13.1405 15.7114C12.9905 15.7107 12.9347 15.7485 12.8886 15.8906C12.5137 17.0558 11.6942 17.7529 10.4302 17.9686C10.3942 17.9746 10.3601 17.9893 10.3252 18H9.65045C9.51887 17.97 9.38541 17.9446 9.25533 17.9089C8.14048 17.6018 7.41848 16.9191 7.09722 15.8549C7.08373 15.8103 7.06761 15.7664 7.05036 15.7149C6.38385 15.7149 5.72221 15.7149 5.06056 15.7149C4.52338 15.7149 3.98619 15.7164 3.44901 15.7146C2.82448 15.7121 2.31616 15.3907 2.10061 14.8654C1.88394 14.3383 2.01851 13.7713 2.49197 13.3742C3.38603 12.6243 4.00456 11.7155 4.25685 10.6031C4.34457 10.2167 4.38318 9.81536 4.3963 9.41934C4.41842 8.74157 4.40117 8.06273 4.40267 7.38461C4.40755 4.82637 6.19004 2.6963 8.80437 2.12673C9.38841 2.03781 10.0632 1.85926 11.503 2.20029V2.19993ZM9.99345 14.5715C12.1298 14.5715 14.2662 14.5722 16.4022 14.5701C16.5383 14.5701 16.7058 14.6204 16.7771 14.4487C16.8487 14.2755 16.689 14.2069 16.5877 14.1191C15.3582 13.0485 14.6054 11.7312 14.4551 10.1496C14.3708 9.26365 14.4195 8.36662 14.3996 7.4746C14.3933 7.19571 14.3768 6.91503 14.334 6.63971C13.9899 4.42143 11.6421 2.80878 9.32544 3.1923C7.11409 3.55833 5.6045 5.26846 5.60225 7.40889C5.6015 8.15272 5.61799 8.89691 5.59513 9.64003C5.55277 11.0202 5.08418 12.2622 4.174 13.3399C3.90935 13.6534 3.58658 13.922 3.29981 14.2191C3.24883 14.2719 3.20047 14.3808 3.22484 14.4326C3.25408 14.4958 3.35792 14.534 3.43664 14.568C3.47825 14.5858 3.53523 14.5712 3.58509 14.5712C5.72146 14.5712 7.85783 14.5712 9.99382 14.5712L9.99345 14.5715ZM11.6669 15.7253H8.32904C8.50335 16.3738 9.27745 16.8751 10.0594 16.8552C10.7889 16.8366 11.5432 16.3088 11.6669 15.7253Z",
    fill: "white"
  })),
  alertBadge: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M9.39026 18.9994C9.17652 18.9466 8.95661 18.9097 8.75047 18.8384C7.79803 18.5083 7.1865 17.8894 6.91805 16.988C6.90863 16.9561 6.89668 16.9246 6.87965 16.8748C6.81951 16.8748 6.75575 16.8748 6.69162 16.8748C5.57435 16.8748 4.45707 16.8798 3.34015 16.8725C2.56125 16.8675 1.95841 16.2735 2.00225 15.5633C2.02398 15.2094 2.19208 14.9179 2.48408 14.6844C3.69555 13.7156 4.30201 12.4911 4.31614 11.0203C4.3223 10.3951 4.3165 9.76987 4.31723 9.14434C4.32049 6.60205 6.25834 4.54053 9.00298 4.17265C9.31781 4.13048 9.64132 4.12816 9.96013 4.13281C10.3021 4.13779 10.5325 4.3131 10.5829 4.56709C10.6535 4.92302 10.3594 5.21387 9.94745 5.19395C9.18267 5.15743 8.45195 5.28824 7.78173 5.62524C6.3105 6.36432 5.53268 7.5098 5.48052 9.04971C5.45842 9.70213 5.48124 10.3556 5.47581 11.0083C5.46059 12.7816 4.7353 14.2638 3.29414 15.4498C3.21227 15.5172 3.1188 15.5796 3.17459 15.6994C3.22748 15.8123 3.33689 15.8133 3.44993 15.8133C7.63501 15.8127 11.8201 15.8133 16.0048 15.808C16.0965 15.808 16.2204 15.7602 16.2729 15.6961C16.3559 15.5942 16.245 15.5178 16.1631 15.4508C14.8944 14.4148 14.1666 13.1223 14.0108 11.5721C13.9666 11.1328 13.984 10.6876 13.9898 10.2453C13.9931 9.98834 14.2198 9.7878 14.4948 9.76389C14.7944 9.73799 15.0556 9.89869 15.1172 10.161C15.1422 10.2676 15.1422 10.3805 15.1419 10.4907C15.1397 11.0717 15.1335 11.6518 15.2965 12.2212C15.5744 13.191 16.1186 14.0088 16.946 14.6645C17.4079 15.0307 17.5749 15.5507 17.3775 16.0537C17.1815 16.5531 16.6819 16.8728 16.0794 16.8741C14.9683 16.8768 13.8572 16.8765 12.7461 16.8728C12.6193 16.8725 12.5668 16.8994 12.5262 17.0225C12.1664 18.1136 11.3738 18.7683 10.1442 18.9705C10.1094 18.9762 10.0764 18.9898 10.0427 18.9997H9.39062L9.39026 18.9994ZM8.11503 16.8824C8.26103 17.4927 9.07363 17.9811 9.85253 17.9333C10.5362 17.8914 11.2901 17.3552 11.3303 16.8824H8.11503Z",
    fill: "white"
  }), jsx("path", {
    d: "M15.5148 2C15.7376 2.04383 15.963 2.07803 16.1821 2.13347C17.9671 2.58569 19.1174 4.11166 18.9909 5.85278C18.875 7.4488 17.4534 8.81806 15.6768 9.04549C13.5875 9.31277 11.6685 8.01224 11.3196 6.09249C10.9794 4.22056 12.3865 2.40241 14.4392 2.06109C14.545 2.04349 14.6493 2.02059 14.754 2C15.0076 2 15.2612 2 15.5148 2Z",
    fill: "#E5838B"
  })),
  layerUp: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M17.9997 16.7613C17.8316 17.0979 17.555 17.2229 17.1737 17.2224C12.397 17.2168 7.61985 17.2184 2.84316 17.2196C2.64541 17.2196 2.45432 17.207 2.28869 17.0881C2.04462 16.9127 1.95825 16.6693 2.01875 16.3897C2.07591 16.1243 2.25322 15.9534 2.53067 15.8862C2.6404 15.8598 2.75013 15.8577 2.86069 15.8577C7.62361 15.8577 12.3865 15.8594 17.1499 15.8545C17.5333 15.8545 17.8262 15.9676 18.0002 16.3144V16.7613H17.9997Z",
    fill: "white"
  }), jsx("path", {
    d: "M10.6898 5.37183C10.6898 5.4516 10.6898 5.53179 10.6898 5.61156C10.6898 8.2038 10.6898 10.7956 10.6894 13.3879C10.6894 13.834 10.4061 14.1079 9.96765 14.0932C9.61718 14.0814 9.34057 13.8136 9.33181 13.4681C9.32555 13.2177 9.33014 12.9674 9.33014 12.7167C9.33014 10.3479 9.33014 7.97913 9.33014 5.61034V5.36613C9.22333 5.3698 9.18787 5.44509 9.13781 5.49393C8.28794 6.32016 7.43974 7.14802 6.59238 7.97669C6.44719 8.11873 6.29157 8.23392 6.07378 8.2445C5.77422 8.25915 5.53891 8.1517 5.40666 7.88715C5.27356 7.62137 5.30778 7.36129 5.50387 7.12889C5.5435 7.08208 5.58856 7.03975 5.63279 6.99661C6.91614 5.7418 8.19991 4.48699 9.48326 3.23259C9.792 2.93059 10.2109 2.91838 10.5221 3.22119C11.8384 4.50124 13.1514 5.78454 14.4615 7.07069C14.7581 7.3617 14.7639 7.78946 14.4953 8.05443C14.2207 8.32509 13.7802 8.31451 13.4727 8.01617C12.6165 7.18628 11.765 6.35232 10.9139 5.51754C10.8559 5.46097 10.82 5.38282 10.7741 5.31485C10.7462 5.33357 10.7182 5.3527 10.6903 5.37142L10.6898 5.37183Z",
    fill: "white"
  })),
  layerDown: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.00042 3.23882C2.16856 2.90222 2.44517 2.77727 2.8265 2.77767C7.60319 2.78337 12.3803 2.78174 17.157 2.78052C17.3547 2.78052 17.5458 2.79314 17.7115 2.91199C17.9555 3.08741 18.0419 3.3308 17.9814 3.61041C17.9242 3.87578 17.7469 4.04673 17.4695 4.11388C17.3598 4.14034 17.25 4.14237 17.1395 4.14237C12.3765 4.14237 7.61362 4.14075 2.85028 4.14563C2.46686 4.14563 2.17398 4.03248 2 3.68571L2 3.23882L2.00042 3.23882Z",
    fill: "white"
  }), jsx("path", {
    d: "M9.31031 14.6282C9.31031 14.5484 9.31031 14.4682 9.31031 14.3884C9.31031 11.7962 9.31031 9.20437 9.31073 6.61213C9.31073 6.16604 9.59401 5.89213 10.0325 5.90678C10.383 5.91858 10.6596 6.1864 10.6683 6.53195C10.6746 6.78226 10.67 7.03257 10.67 7.28328C10.67 9.65208 10.67 12.0209 10.67 14.3897L10.67 14.6339C10.7768 14.6302 10.8123 14.5549 10.8623 14.5061C11.7122 13.6798 12.5604 12.852 13.4078 12.0233C13.553 11.8813 13.7086 11.7661 13.9264 11.7555C14.2259 11.7408 14.4612 11.8483 14.5935 12.1129C14.7266 12.3786 14.6924 12.6387 14.4963 12.8711C14.4567 12.9179 14.4116 12.9602 14.3674 13.0034C13.084 14.2582 11.8002 15.513 10.5169 16.7674C10.2082 17.0694 9.78927 17.0816 9.47803 16.7788C8.16172 15.4988 6.84874 14.2155 5.53869 12.9293C5.24205 12.6383 5.23621 12.2105 5.50489 11.9456C5.77942 11.6749 6.22 11.6855 6.52749 11.9838C7.38361 12.8137 8.23515 13.6477 9.08626 14.4825C9.14426 14.539 9.18014 14.6172 9.22603 14.6852C9.25398 14.6664 9.28194 14.6473 9.30989 14.6286L9.31031 14.6282Z",
    fill: "white"
  })),
  duplicate: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M14.5748 17.9999H8.48513C8.39393 17.9899 8.30239 17.9819 8.21154 17.9697C6.67716 17.7661 5.46943 16.6568 5.1414 15.1325C5.1043 14.9597 5.03044 14.9001 4.87059 14.865C3.1937 14.4965 2.02063 13.0694 2.00954 11.3581C1.99705 9.43695 1.99601 7.51576 2.01127 5.59457C2.01925 4.58661 2.3927 3.71571 3.124 3.01274C3.84108 2.3233 4.70969 2.00443 5.69655 2.00235C7.4206 1.99819 9.1443 2.00061 10.8684 2.00166C11.1159 2.00166 11.3632 2.00617 11.6111 2.02213C13.1805 2.12379 14.5519 3.30524 14.8574 4.84476C14.8952 5.03525 14.9777 5.10152 15.1584 5.14524C16.528 5.47521 17.4206 6.32356 17.8499 7.66427C17.949 7.97446 17.9681 8.2968 18 8.61706V14.4337C17.991 14.5479 17.984 14.6624 17.9726 14.7765C17.8311 16.2231 16.7475 17.493 15.3373 17.8702C15.0866 17.9371 14.83 17.9635 14.5744 17.9996L14.5748 17.9999ZM3.16838 8.46959C3.16838 9.43314 3.16665 10.3963 3.16873 11.3599C3.17185 12.6954 4.26932 13.7953 5.60466 13.7974C7.51873 13.8001 9.4328 13.8001 11.3465 13.7967C11.8615 13.7956 12.3368 13.6489 12.7554 13.3446C13.4478 12.8411 13.7936 12.1496 13.7977 11.2999C13.8064 9.47131 13.8005 7.64241 13.8005 5.81386C13.8005 5.65806 13.7929 5.50366 13.7748 5.34822C13.6288 4.09148 12.5938 3.16055 11.3299 3.15985C9.43315 3.15847 7.53642 3.15881 5.63968 3.15985C4.25822 3.16055 3.17046 4.249 3.16838 5.63169C3.167 6.57789 3.16838 7.52374 3.16838 8.46994V8.46959ZM11.5202 16.8448C12.4658 16.8448 13.4111 16.8455 14.3567 16.8448C15.7291 16.8435 16.8342 15.7678 16.8422 14.3987C16.8529 12.4834 16.8505 10.5681 16.8429 8.65279C16.8387 7.62783 16.2063 6.73611 15.2516 6.36971C14.9631 6.25902 14.9538 6.26596 14.9517 6.56956C14.9413 8.20208 14.9805 9.83459 14.9323 11.4668C14.8952 12.7183 14.3203 13.6791 13.2925 14.3727C12.6763 14.7887 11.9818 14.9549 11.2449 14.9559C9.67102 14.958 8.09711 14.9566 6.52321 14.957C6.28221 14.957 6.27389 14.9698 6.3526 15.2019C6.67716 16.1599 7.61894 16.841 8.63215 16.8445C9.59508 16.8476 10.5577 16.8452 11.5206 16.8452L11.5202 16.8448Z",
    fill: "white"
  }), jsx("path", {
    d: "M10.0195 9.04545C9.7601 9.04545 9.50038 9.051 9.24136 9.04337C9.09884 9.0392 9.04752 9.09194 9.04926 9.2349C9.0548 9.73107 9.05238 10.2269 9.05099 10.7231C9.04995 11.0784 8.83843 11.3212 8.51318 11.3462C8.20249 11.3702 7.92751 11.1384 7.91052 10.7886C7.88694 10.3053 7.89908 9.81989 7.89665 9.33552C7.89573 9.14214 7.80095 9.04533 7.61232 9.0451C7.14524 9.0451 6.67851 9.04614 6.21144 9.04441C5.8692 9.04302 5.61572 8.80604 5.60913 8.48509C5.60254 8.16101 5.86191 7.91258 6.21283 7.91119C6.63378 7.90946 7.05439 7.91258 7.47535 7.91015C7.93653 7.90738 7.89457 7.97261 7.89596 7.48025C7.897 7.09962 7.89631 6.71864 7.89596 6.33801C7.89596 6.22212 7.9022 6.10623 7.93861 5.99624C8.02252 5.74122 8.28675 5.57849 8.54751 5.61561C8.83739 5.65656 9.04544 5.87584 9.04856 6.16453C9.05446 6.67215 9.0503 7.17977 9.05134 7.68739C9.05168 7.90599 9.05584 7.91015 9.27638 7.91015C9.76634 7.91084 10.2563 7.90911 10.7463 7.91084C11.1055 7.91189 11.3416 8.14332 11.3385 8.48647C11.3354 8.81818 11.0982 9.04198 10.7456 9.04441C10.5035 9.0458 10.2615 9.04441 10.0191 9.04475L10.0195 9.04545Z",
    fill: "white"
  })),
  crop: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6 2.8C6 2.35818 5.64182 2 5.2 2C4.75818 2 4.4 2.35818 4.4 2.8H6ZM12.4 15.6C12.8418 15.6 13.2 15.2418 13.2 14.8C13.2 14.3582 12.8418 14 12.4 14V15.6ZM17.2 15.6C17.6418 15.6 18 15.2418 18 14.8C18 14.3582 17.6418 14 17.2 14V15.6ZM14.8 14C14.3582 14 14 14.3582 14 14.8C14 15.2418 14.3582 15.6 14.8 15.6V14ZM14 17.2C14 17.6418 14.3582 18 14.8 18C15.2418 18 15.6 17.6418 15.6 17.2H14ZM7.6 4.4C7.15818 4.4 6.8 4.75818 6.8 5.2C6.8 5.64182 7.15818 6 7.6 6V4.4ZM2.8 4.4C2.35818 4.4 2 4.75818 2 5.2C2 5.64182 2.35818 6 2.8 6V4.4ZM5.2 6C5.64182 6 6 5.64182 6 5.2C6 4.75818 5.64182 4.4 5.2 4.4V6ZM6 12.24V2.8H4.4V12.24H6ZM12.4 14H7.76V15.6H12.4V14ZM17.2 14H14.8V15.6H17.2V14ZM4.4 12.24C4.4 12.6749 4.39938 13.0491 4.42446 13.356C4.4503 13.6723 4.50735 13.9869 4.66158 14.2896L6.08719 13.5632C6.06704 13.5236 6.0369 13.443 6.01914 13.2258C6.00062 12.999 6 12.7013 6 12.24H4.4ZM7.76 14C7.29876 14 7.00094 13.9994 6.77427 13.9809C6.55694 13.9631 6.47636 13.933 6.43681 13.9128L5.71042 15.3384C6.01313 15.4926 6.3277 15.5497 6.64398 15.5755C6.95091 15.6006 7.32516 15.6 7.76 15.6V14ZM4.66158 14.2896C4.89168 14.7412 5.25883 15.1083 5.71042 15.3384L6.43681 13.9128C6.28628 13.8361 6.1639 13.7138 6.08719 13.5632L4.66158 14.2896ZM14 7.76V17.2H15.6V7.76H14ZM7.6 6H12.24V4.4H7.6V6ZM2.8 6H5.2V4.4H2.8V6ZM15.6 7.76C15.6 7.32516 15.6006 6.95091 15.5755 6.64398C15.5497 6.3277 15.4926 6.01313 15.3384 5.71042L13.9128 6.43681C13.933 6.47636 13.9631 6.55694 13.9809 6.77427C13.9994 7.00094 14 7.29876 14 7.76H15.6ZM12.24 6C12.7013 6 12.999 6.00062 13.2258 6.01914C13.443 6.0369 13.5236 6.06704 13.5632 6.08719L14.2896 4.66158C13.9869 4.50735 13.6723 4.4503 13.356 4.42446C13.0491 4.39938 12.6749 4.4 12.24 4.4V6ZM15.3384 5.71042C15.1083 5.25883 14.7412 4.89168 14.2896 4.66158L13.5632 6.08719C13.7138 6.1639 13.8361 6.28628 13.9128 6.43681L15.3384 5.71042Z",
    fill: "white"
  })),
  previewBasic: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07189 3.7463C5.07353 3.78519 5.07465 3.83708 5.07589 3.89484C5.07596 3.89837 5.07604 3.90193 5.07612 3.9055C5.08065 4.11627 5.08734 4.39774 5.12677 4.41633C5.14985 4.41636 5.17293 4.41639 5.19601 4.4164C5.59118 4.41655 5.98627 4.41275 6.38129 4.40616C7.32811 4.39038 8.27458 4.35859 9.22105 4.32679C10.5855 4.28096 11.9499 4.23513 13.3153 4.23726C13.442 4.23726 13.4631 4.17757 13.4631 4.03687C13.4607 3.79628 13.4597 3.384 13.4599 2.99188C13.4599 2.99179 13.4599 2.99198 13.4599 2.99188C13.46 2.97353 13.46 2.95494 13.46 2.9367C13.46 2.91828 13.46 2.89994 13.4601 2.88168C13.4604 2.61277 13.4614 2.36236 13.4631 2.19502C13.4673 2.03727 13.442 1.97758 13.3027 2.00742C13.0606 2.06257 12.8178 2.11454 12.5746 2.16471C12.2536 2.23091 11.9318 2.29397 11.6101 2.35703L5.07612 3.64889H5.07189L5.06345 3.67447C5.06332 3.67439 5.06359 3.6745 5.06345 3.67447C5.06731 3.67693 5.07011 3.70403 5.07189 3.7463Z",
    fill: "white"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6663 3.82798C15.6705 3.67875 15.641 3.64038 15.5017 3.64038C12.0574 3.64464 8.61311 3.64464 5.16884 3.64038C5.03377 3.64038 5 3.67875 5 3.82798V17.8167C5 17.9659 5.03377 18 5.16884 18C8.61311 17.9958 12.0574 17.9958 15.5017 18C15.641 18 15.6663 17.9616 15.6663 17.8124C15.6621 16.0132 15.6621 5.62293 15.6663 3.82798ZM14.7762 16.9992C14.7736 14.3073 14.7736 7.33168 14.7762 4.64122C11.8138 4.64437 8.85133 4.64437 5.88889 4.64121V16.9992C8.85133 16.996 11.8138 16.996 14.7762 16.9992ZM14.7774 17.8107C14.7774 17.8122 14.7774 17.8136 14.7774 17.8151L15.5017 17.8129M15.5017 17.8129L14.7774 17.8124L15.5017 17.8129Z",
    fill: "white"
  }), jsx("path", {
    d: "M13.0368 11.1017C12.9186 10.6327 12.6822 10.2533 12.3403 9.96337C11.5384 9.28547 10.6309 9.14051 9.63894 9.52849C8.92983 9.80562 8.46131 10.3258 8.25026 11.0719C8.23338 11.1358 8.22916 11.187 8.24604 11.2424C8.34734 11.6347 8.5415 11.9758 8.82009 12.2572C9.30127 12.7432 9.91331 12.9948 10.6393 13.0033C10.6562 13.0033 10.6731 13.0033 10.69 13.0033C10.977 13.0033 11.2556 12.9521 11.5215 12.8541C12.3024 12.5641 12.8089 12.0269 13.0326 11.2595C13.0452 11.2126 13.0579 11.1614 13.041 11.1017H13.0368ZM12.602 11.2382C12.3868 11.8564 11.9605 12.2657 11.302 12.4831C11.0867 12.5556 10.863 12.5897 10.6351 12.5812C10.0442 12.5727 9.54186 12.3765 9.1451 11.9928C8.92139 11.7796 8.76099 11.5153 8.66813 11.2169C8.65547 11.1785 8.65969 11.1401 8.67657 11.0889C8.87074 10.5262 9.2464 10.1296 9.79512 9.91647C10.0948 9.80136 10.386 9.74167 10.6689 9.74167C11.1374 9.74167 11.5806 9.89942 11.9942 10.2192C12.277 10.4366 12.4796 10.7308 12.602 11.0932C12.6189 11.1444 12.6189 11.1913 12.602 11.2424V11.2382Z",
    fill: "white"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.535 11.4085C12.4688 11.5585 12.3883 11.6945 12.2931 11.817C12.075 12.0975 11.7797 12.3065 11.403 12.4476C11.4028 12.4477 11.4033 12.4475 11.403 12.4476C11.3702 12.4598 11.3361 12.4719 11.302 12.4831C11.104 12.5498 10.8989 12.584 10.69 12.5824C10.6744 12.5823 10.6588 12.582 10.6432 12.5815C10.6419 12.5814 10.6406 12.5814 10.6393 12.5813C10.6379 12.5813 10.6365 12.5812 10.6351 12.5812C10.0442 12.5727 9.54186 12.3765 9.1451 11.9928C9.12338 11.9721 9.10226 11.951 9.08174 11.9293C8.89212 11.7293 8.75377 11.4895 8.66976 11.2221C8.66922 11.2203 8.66867 11.2186 8.66813 11.2169C8.66748 11.2149 8.66687 11.2129 8.6663 11.2109C8.65697 11.1781 8.65979 11.1449 8.67212 11.1032C8.67349 11.0985 8.67497 11.0938 8.67657 11.0889C8.67824 11.0841 8.67992 11.0793 8.68161 11.0745C8.87328 10.5305 9.23624 10.1435 9.76273 9.92935C9.7627 9.92936 9.76276 9.92934 9.76273 9.92935C9.77343 9.925 9.78429 9.92068 9.79512 9.91647C10.0948 9.80136 10.386 9.74167 10.6689 9.74167C11.1374 9.74167 11.5806 9.89942 11.9942 10.2192C12.033 10.249 12.0703 10.2803 12.1061 10.313C12.1059 10.3128 12.1062 10.3131 12.1061 10.313C12.3194 10.5081 12.4795 10.7542 12.5854 11.0458C12.5911 11.0614 12.5966 11.0773 12.602 11.0932C12.603 11.096 12.6038 11.0988 12.6047 11.1016C12.6059 11.1059 12.6071 11.1102 12.6081 11.1144C12.6183 11.1562 12.6167 11.1958 12.6034 11.2382C12.6034 11.2383 12.6035 11.238 12.6034 11.2382C12.6033 11.2387 12.6029 11.2397 12.6028 11.2402C12.6025 11.2409 12.6023 11.2417 12.602 11.2424V11.2382C12.6017 11.239 12.6015 11.2398 12.6012 11.2407C12.601 11.2411 12.6009 11.2415 12.6007 11.2419C12.6007 11.2421 12.6008 11.2417 12.6007 11.2419C12.5985 11.2484 12.596 11.2554 12.5936 11.2619C12.5755 11.3122 12.556 11.3611 12.535 11.4085ZM12.9851 11.407C12.9748 11.436 12.9641 11.4647 12.953 11.493C12.8641 11.719 12.7473 11.9221 12.603 12.1017C12.3362 12.4337 11.9751 12.6856 11.5215 12.8541C11.4848 12.8676 11.4479 12.8802 11.4107 12.8919C11.4101 12.8921 11.4095 12.8923 11.4088 12.8926C11.1772 12.9655 10.9367 13.0033 10.69 13.0033H10.6393C10.6363 13.0032 10.6333 13.0032 10.6303 13.0032C10.6277 13.0031 10.6252 13.0031 10.6226 13.003C9.93992 12.9915 9.3586 12.7641 8.89281 12.3279C8.89208 12.3272 8.89135 12.3265 8.89062 12.3258C8.8668 12.3035 8.84329 12.2806 8.82008 12.2572C8.57382 12.0084 8.39352 11.713 8.28503 11.3769C8.28416 11.3742 8.28329 11.3715 8.28242 11.3687C8.2692 11.3273 8.25707 11.2851 8.24604 11.2424C8.22916 11.187 8.23338 11.1358 8.25026 11.0719C8.26396 11.0234 8.27875 10.976 8.29462 10.9294C8.29534 10.9273 8.29606 10.9252 8.29678 10.9231C8.52601 10.2563 8.97795 9.78681 9.63894 9.52849C9.65001 9.52416 9.66106 9.5199 9.6721 9.51571C9.67251 9.51555 9.67293 9.51539 9.67334 9.51524C10.0156 9.38537 10.3477 9.3192 10.6689 9.31672C11.2168 9.3125 11.7327 9.4937 12.2122 9.86031C12.2125 9.86051 12.2128 9.86072 12.213 9.86092C12.2558 9.8936 12.2982 9.92775 12.3403 9.96337C12.6392 10.2168 12.8574 10.5386 12.9866 10.9288C12.9869 10.9299 12.9873 10.9311 12.9876 10.9322C13.0058 10.9873 13.0222 11.0438 13.0368 11.1017H13.041C13.0452 11.1164 13.0475 11.1305 13.0485 11.1442C13.0507 11.1733 13.0468 11.2004 13.041 11.2261C13.0401 11.2302 13.0391 11.2342 13.0381 11.2382C13.0378 11.2396 13.0374 11.241 13.0371 11.2424C13.037 11.2428 13.0369 11.2432 13.0368 11.2435C13.0354 11.2489 13.034 11.2542 13.0326 11.2595C13.0184 11.3083 13.003 11.3561 12.9865 11.403C12.986 11.4043 12.9856 11.4057 12.9851 11.407Z",
    fill: "white"
  }), jsx("path", {
    d: "M10.6473 10.2104H10.6389C10.3941 10.2104 10.1619 10.3085 9.9804 10.4918C9.80312 10.6709 9.6976 10.9097 9.6976 11.1527C9.6976 11.3957 9.79468 11.643 9.97618 11.8263C10.1535 12.0097 10.3983 12.112 10.6389 12.1163C10.8879 12.1163 11.1369 12.0097 11.3184 11.8178C11.4915 11.6345 11.5844 11.4042 11.5759 11.1655C11.5844 10.931 11.4957 10.6965 11.3227 10.5174C11.1412 10.3256 10.8963 10.2147 10.6515 10.2147L10.6473 10.2104ZM11.158 11.1655C11.158 11.4597 10.9259 11.6899 10.6346 11.6899C10.3434 11.6899 10.1155 11.4554 10.1155 11.1612C10.1155 10.867 10.3476 10.6368 10.6389 10.6368C10.9301 10.6368 11.158 10.8713 11.158 11.1655Z",
    fill: "white"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3227 10.5174C11.1412 10.3256 10.8963 10.2147 10.6515 10.2147L10.6473 10.2104H10.6389C10.3941 10.2104 10.1619 10.3085 9.9804 10.4918C9.80312 10.6709 9.6976 10.9097 9.6976 11.1527C9.6976 11.1555 9.69761 11.1584 9.69764 11.1612C9.69988 11.4015 9.79681 11.6451 9.97618 11.8263C10.1524 12.0086 10.3954 12.1108 10.6346 12.1162C10.6361 12.1162 10.6375 12.1162 10.6389 12.1163C10.8879 12.1163 11.1369 12.0097 11.3184 11.8178C11.4915 11.6345 11.5844 11.4042 11.5759 11.1655C11.5844 10.931 11.4957 10.6965 11.3227 10.5174ZM11.0461 11.4924C11.0462 11.4923 11.0463 11.4922 11.0464 11.4921C11.1129 11.4076 11.1538 11.3013 11.1577 11.1842C11.1579 11.178 11.158 11.1718 11.158 11.1655C11.158 11.1591 11.1579 11.1528 11.1577 11.1464C11.1539 11.0332 11.1162 10.9295 11.0543 10.8456C11.0534 10.8444 11.0525 10.8432 11.0516 10.842C10.9598 10.7199 10.8163 10.6408 10.6515 10.637C10.6501 10.6369 10.6487 10.6369 10.6473 10.6369C10.6445 10.6368 10.6417 10.6368 10.6389 10.6368C10.4787 10.6368 10.3364 10.7064 10.2408 10.8181C10.1888 10.8787 10.1506 10.9517 10.1308 11.0327C10.1214 11.071 10.1162 11.1112 10.1155 11.1527C10.1155 11.1555 10.1155 11.1584 10.1155 11.1612C10.1155 11.2915 10.1602 11.41 10.2353 11.5017C10.2363 11.503 10.2373 11.5042 10.2384 11.5055C10.3328 11.6187 10.4741 11.6899 10.6346 11.6899C10.6361 11.6899 10.6375 11.6899 10.6389 11.6899C10.6409 11.6899 10.6429 11.6898 10.6448 11.6898C10.8084 11.6868 10.9526 11.611 11.0461 11.4924Z",
    fill: "white"
  })),
  picture: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M3.59246 4C7.85988 4 12.1273 4 16.3947 4C16.4201 4.00581 16.4448 4.01436 16.4704 4.01742C17.3492 4.11828 17.9984 4.82369 17.9987 5.68406C17.9997 8.7114 17.9987 11.7384 18 14.7658C18 14.9091 17.9828 15.0488 17.9446 15.1869C17.7313 15.9575 17.0423 16.4434 16.1485 16.4437C12.0441 16.445 7.93997 16.4446 3.83555 16.4425C3.68069 16.4425 3.52175 16.4318 3.37127 16.3982C2.62009 16.2304 2.1777 15.7594 2 15.0375V5.40257C2.10293 4.95603 2.32694 4.5856 2.71207 4.31542C2.97581 4.1302 3.27459 4.04034 3.59246 4ZM17.271 12.1969C17.3023 12.1593 17.2879 12.1174 17.2879 12.0789C17.2889 9.9905 17.2895 7.90238 17.2867 5.81396C17.2867 5.69323 17.2704 5.56975 17.2416 5.45239C17.1306 4.99791 16.7226 4.71214 16.1917 4.71214C12.0754 4.71183 7.95937 4.71183 3.84306 4.71214C3.11848 4.71214 2.70018 5.11833 2.69956 5.82955C2.69799 8.2126 2.69893 10.5957 2.69956 12.9787C2.69956 13.0273 2.67359 13.0924 2.72302 13.1211C2.77558 13.1517 2.81625 13.0918 2.85693 13.0655C3.5593 12.6107 4.2601 12.1535 4.96216 11.6978C5.68237 11.2305 6.36472 11.2317 7.08555 11.7015C7.61366 12.0453 8.14114 12.3901 8.66862 12.7351C8.87699 12.8714 9.10068 12.953 9.3566 12.9368C9.69887 12.9154 9.9526 12.7501 10.1506 12.486C10.9096 11.4731 11.6649 10.4581 12.4311 9.45074C12.8813 8.85903 13.4942 8.63836 14.2313 8.78078C14.6974 8.87095 15.0463 9.14327 15.3172 9.52043C15.9298 10.3732 16.5461 11.2228 17.1618 12.0734C17.1934 12.1171 17.2144 12.1718 17.271 12.1972V12.1969ZM9.98514 15.7276C10.9788 15.7276 11.9727 15.7276 12.9664 15.7276C14.0539 15.7276 15.1414 15.7298 16.2286 15.7264C16.7917 15.7246 17.1922 15.3841 17.2635 14.8452C17.3211 14.4106 17.2776 13.973 17.2867 13.5365C17.2879 13.4708 17.246 13.4225 17.2103 13.3733C16.3794 12.2238 15.5512 11.0721 14.7159 9.9257C14.2469 9.28203 13.457 9.28172 12.9789 9.91775C12.2371 10.9047 11.4966 11.8925 10.7567 12.8809C10.1325 13.7147 9.13697 13.8904 8.25752 13.3189C7.71189 12.9644 7.16814 12.6068 6.62251 12.2522C6.23707 12.0019 5.8413 11.9857 5.45242 12.2354C4.56577 12.8048 3.68413 13.3819 2.80092 13.9561C2.75306 13.9873 2.70175 14.0197 2.70206 14.0842C2.70362 14.3981 2.66639 14.7153 2.75681 15.0231C2.8854 15.4608 3.27585 15.727 3.78831 15.7273C5.85382 15.7282 7.91963 15.7276 9.98514 15.7279V15.7276Z",
    fill: "white"
  }), jsx("path", {
    d: "M8.40658 10.4449C7.10383 10.444 6.07702 9.43292 6.07858 8.15322C6.08015 6.89521 7.12385 5.87958 8.41503 5.87988C9.71809 5.87988 10.7568 6.90377 10.7537 8.185C10.7508 9.43934 9.70526 10.4461 8.40658 10.4449ZM10.0209 8.16575C10.0209 7.29101 9.31669 6.59966 8.42222 6.59691C7.52588 6.59416 6.79848 7.29835 6.80098 8.16636C6.80348 9.02489 7.52494 9.74803 8.40689 9.74528C9.3389 9.74253 10.0444 8.98761 10.0209 8.16575Z",
    fill: "white"
  })),
  picturePlus: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M3.59246 4C7.85988 4 12.1273 4 16.3947 4C16.4201 4.00581 16.4448 4.01436 16.4704 4.01742C17.3492 4.11828 17.9984 4.82369 17.9987 5.68406C17.9997 8.7114 17.9987 11.7384 18 14.7658C18 14.9091 17.9828 15.0488 17.9446 15.1869C17.7313 15.9575 17.0423 16.4434 16.1485 16.4437C12.0441 16.445 7.93997 16.4446 3.83555 16.4425C3.68069 16.4425 3.52175 16.4318 3.37127 16.3982C2.62009 16.2304 2.1777 15.7594 2 15.0375V5.40257C2.10293 4.95603 2.32694 4.5856 2.71207 4.31542C2.97581 4.1302 3.27459 4.04034 3.59246 4ZM17.271 12.1969C17.3023 12.1593 17.2879 12.1174 17.2879 12.0789C17.2889 9.9905 17.2895 7.90238 17.2867 5.81396C17.2867 5.69323 17.2704 5.56975 17.2416 5.45239C17.1306 4.99791 16.7226 4.71214 16.1917 4.71214C12.0754 4.71183 7.95937 4.71183 3.84306 4.71214C3.11848 4.71214 2.70018 5.11833 2.69956 5.82955C2.69799 8.2126 2.69893 10.5957 2.69956 12.9787C2.69956 13.0273 2.67359 13.0924 2.72302 13.1211C2.77558 13.1517 2.81625 13.0918 2.85693 13.0655C3.5593 12.6107 4.2601 12.1535 4.96216 11.6978C5.68237 11.2305 6.36472 11.2317 7.08555 11.7015C7.61366 12.0453 8.14114 12.3901 8.66862 12.7351C8.87699 12.8714 9.10068 12.953 9.3566 12.9368C9.69887 12.9154 9.9526 12.7501 10.1506 12.486C10.9096 11.4731 11.6649 10.4581 12.4311 9.45074C12.8813 8.85903 13.4942 8.63836 14.2313 8.78078C14.6974 8.87095 15.0463 9.14327 15.3172 9.52043C15.9298 10.3732 16.5461 11.2228 17.1618 12.0734C17.1934 12.1171 17.2144 12.1718 17.271 12.1972V12.1969ZM9.98514 15.7276C10.9788 15.7276 11.9727 15.7276 12.9664 15.7276C14.0539 15.7276 15.1414 15.7298 16.2286 15.7264C16.7917 15.7246 17.1922 15.3841 17.2635 14.8452C17.3211 14.4106 17.2776 13.973 17.2867 13.5365C17.2879 13.4708 17.246 13.4225 17.2103 13.3733C16.3794 12.2238 15.5512 11.0721 14.7159 9.9257C14.2469 9.28203 13.457 9.28172 12.9789 9.91775C12.2371 10.9047 11.4966 11.8925 10.7567 12.8809C10.1325 13.7147 9.13697 13.8904 8.25752 13.3189C7.71189 12.9644 7.16814 12.6068 6.62251 12.2522C6.23707 12.0019 5.8413 11.9857 5.45242 12.2354C4.56577 12.8048 3.68413 13.3819 2.80092 13.9561C2.75306 13.9873 2.70175 14.0197 2.70206 14.0842C2.70362 14.3981 2.66639 14.7153 2.75681 15.0231C2.8854 15.4608 3.27585 15.727 3.78831 15.7273C5.85382 15.7282 7.91963 15.7276 9.98514 15.7279V15.7276Z",
    fill: "white"
  }), jsx("path", {
    d: "M8.40658 10.4449C7.10383 10.444 6.07702 9.43292 6.07858 8.15322C6.08015 6.89521 7.12385 5.87958 8.41503 5.87988C9.71809 5.87988 10.7568 6.90377 10.7537 8.185C10.7508 9.43934 9.70526 10.4461 8.40658 10.4449ZM10.0209 8.16575C10.0209 7.29101 9.31669 6.59966 8.42222 6.59691C7.52588 6.59416 6.79848 7.29835 6.80098 8.16636C6.80348 9.02489 7.52494 9.74803 8.40689 9.74528C9.3389 9.74253 10.0444 8.98761 10.0209 8.16575Z",
    fill: "white"
  })),
  dots: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M5.69231 11.3846C4.75692 11.3846 4 10.6277 4 9.69231C4 8.75692 4.75692 8 5.69231 8C6.62769 8 7.38462 8.75692 7.38462 9.69231C7.38462 10.6277 6.62769 11.3846 5.69231 11.3846ZM5.69231 8.92308C5.26769 8.92308 4.92308 9.26769 4.92308 9.69231C4.92308 10.1169 5.26769 10.4615 5.69231 10.4615C6.11692 10.4615 6.46154 10.1169 6.46154 9.69231C6.46154 9.26769 6.11692 8.92308 5.69231 8.92308ZM14.3077 11.3846C13.3723 11.3846 12.6154 10.6277 12.6154 9.69231C12.6154 8.75692 13.3723 8 14.3077 8C15.2431 8 16 8.75692 16 9.69231C16 10.6277 15.2431 11.3846 14.3077 11.3846ZM14.3077 8.92308C13.8831 8.92308 13.5385 9.26769 13.5385 9.69231C13.5385 10.1169 13.8831 10.4615 14.3077 10.4615C14.7323 10.4615 15.0769 10.1169 15.0769 9.69231C15.0769 9.26769 14.7323 8.92308 14.3077 8.92308ZM10 11.3846C9.06462 11.3846 8.30769 10.6277 8.30769 9.69231C8.30769 8.75692 9.06462 8 10 8C10.9354 8 11.6923 8.75692 11.6923 9.69231C11.6923 10.6277 10.9354 11.3846 10 11.3846ZM10 8.92308C9.57538 8.92308 9.23077 9.26769 9.23077 9.69231C9.23077 10.1169 9.57538 10.4615 10 10.4615C10.4246 10.4615 10.7692 10.1169 10.7692 9.69231C10.7692 9.26769 10.4246 8.92308 10 8.92308Z",
    fill: "white"
  })),
  magnify: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4409 15.5184C13.1275 16.5932 11.4485 17.238 9.61902 17.238C5.41115 17.238 2 13.8269 2 9.61902C2 5.41115 5.41115 2 9.61902 2C13.8269 2 17.238 5.41115 17.238 9.61902C17.238 11.4486 16.5932 13.1275 15.5184 14.4409L17.7768 16.6994C18.0743 16.9969 18.0743 17.4793 17.7768 17.7768C17.4793 18.0744 16.9968 18.0744 16.6993 17.7768L14.4409 15.5184ZM15.7142 9.61902C15.7142 12.9853 12.9853 15.7142 9.61902 15.7142C6.25273 15.7142 3.5238 12.9853 3.5238 9.61902C3.5238 6.25273 6.25273 3.5238 9.61902 3.5238C12.9853 3.5238 15.7142 6.25273 15.7142 9.61902Z",
    fill: "white"
  })),
  keyboard: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M17.4352 16H2.58784C2.5625 15.9912 2.53757 15.9804 2.51183 15.9741C1.54863 15.7378 0.992831 14.8271 1.00007 13.936C1.02138 11.2815 1.0065 8.62627 1.00852 5.97183C1.00972 4.88993 1.86795 4.00135 2.91319 4.00094C7.64593 3.99927 12.3783 4.0001 17.111 4.00135C17.2172 4.00135 17.3262 4.00386 17.4295 4.02682C18.2829 4.21681 18.7881 4.7751 19 5.63861V14.3769C18.7925 15.2434 18.2725 15.7862 17.4352 16ZM10.0316 5.36344C7.72436 5.36344 5.4171 5.36261 3.10985 5.36386C2.56974 5.36386 2.32321 5.61982 2.32281 6.17936C2.3216 8.7315 2.3216 11.2836 2.32281 13.8358C2.32281 14.3953 2.57014 14.6521 3.10945 14.6521C7.71068 14.6529 12.3119 14.6529 16.9131 14.6521C17.4516 14.6521 17.699 14.3945 17.7002 13.8362C17.7018 13.0942 17.7006 12.3522 17.7006 11.6102C17.7006 9.80004 17.6998 7.98991 17.701 6.17977C17.701 5.87829 17.6346 5.61231 17.3604 5.45447C17.2099 5.36803 17.0414 5.36261 16.8729 5.36261C14.5922 5.36344 12.3119 5.36344 10.0312 5.36344H10.0316Z",
    fill: "white"
  }), jsx("path", {
    d: "M10.0218 11.9898C10.8844 11.9898 11.7471 11.9873 12.6094 11.9915C12.9271 11.9932 13.1949 12.2446 13.2331 12.5561C13.277 12.9135 13.0996 13.2229 12.7863 13.3219C12.7115 13.3457 12.6287 13.3507 12.5494 13.3507C10.8579 13.3524 9.16597 13.3528 7.47445 13.3511C7.05619 13.3511 6.78392 13.0734 6.78714 12.6596C6.79035 12.2588 7.06182 11.9903 7.47404 11.9894C8.32303 11.9873 9.17241 11.989 10.0218 11.9894V11.9898Z",
    fill: "white"
  }), jsx("path", {
    d: "M5.18317 8.02594C5.07619 8.02594 4.96921 8.02802 4.86223 8.02594C4.48701 8.01717 4.22077 7.7374 4.21876 7.35199C4.21675 6.9528 4.48098 6.67095 4.86827 6.66468C5.09549 6.66093 5.32272 6.65967 5.54994 6.66552C5.90908 6.67471 6.1721 6.96157 6.17411 7.33779C6.17612 7.72696 5.91391 8.01425 5.54391 8.02552C5.42366 8.02928 5.30341 8.02594 5.18317 8.02635V8.02594Z",
    fill: "white"
  }), jsx("path", {
    d: "M8.41041 6.66429C8.53066 6.66429 8.65131 6.66053 8.77116 6.66512C9.12587 6.6789 9.38527 6.97036 9.38407 7.34909C9.38286 7.72657 9.12185 8.01469 8.76312 8.02471C8.52262 8.03097 8.28172 8.03181 8.04122 8.02471C7.68812 8.01385 7.42751 7.71822 7.42872 7.34116C7.42992 6.96243 7.68972 6.67807 8.04926 6.66554C8.16951 6.66137 8.28976 6.66471 8.41001 6.66512L8.41041 6.66429Z",
    fill: "white"
  }), jsx("path", {
    d: "M11.6133 8.02464C11.4862 8.02464 11.3591 8.03049 11.2325 8.02339C10.8926 8.00418 10.6384 7.70855 10.6397 7.34068C10.6409 6.97197 10.8958 6.67926 11.2397 6.66632C11.4866 6.65713 11.7344 6.65838 11.9817 6.66548C12.3368 6.67592 12.5962 6.96947 12.595 7.34819C12.5938 7.72567 12.3328 8.01212 11.9745 8.02464C11.8542 8.02882 11.734 8.02548 11.6137 8.02548V8.02464H11.6133Z",
    fill: "white"
  }), jsx("path", {
    d: "M14.8128 8.02543C14.699 8.02543 14.5855 8.02877 14.4717 8.0246C14.1078 8.01207 13.8451 7.71769 13.8492 7.32936C13.8532 6.95313 14.1162 6.67295 14.4798 6.6646C14.7134 6.65959 14.9479 6.65875 15.1816 6.6646C15.5403 6.67379 15.8029 6.96149 15.8045 7.33813C15.8061 7.72729 15.5439 8.01374 15.1735 8.0246C15.0533 8.02794 14.933 8.02502 14.8128 8.02502V8.02543Z",
    fill: "white"
  }), jsx("path", {
    d: "M5.19844 10.6879C5.07135 10.6879 4.94427 10.6933 4.81758 10.687C4.47654 10.6699 4.21915 10.3764 4.21875 10.0101C4.21835 9.64019 4.47091 9.34372 4.81276 9.33036C5.06653 9.32034 5.3211 9.32075 5.57447 9.33036C5.91631 9.34289 6.1733 9.63894 6.1737 10.006C6.1745 10.3738 5.91913 10.6691 5.57929 10.6874C5.45261 10.6941 5.32552 10.6887 5.19844 10.6887V10.6879Z",
    fill: "white"
  }), jsx("path", {
    d: "M8.40889 10.6883C8.2818 10.6883 8.15471 10.6937 8.02803 10.6874C7.68699 10.6703 7.4296 10.3768 7.4292 10.0106C7.4288 9.64061 7.68136 9.34414 8.02321 9.33036C8.27697 9.32034 8.53155 9.32075 8.78492 9.33036C9.12676 9.34289 9.38375 9.63894 9.38455 10.006C9.38535 10.3738 9.13038 10.6686 8.79014 10.6874C8.66346 10.6945 8.53637 10.6887 8.40929 10.6887L8.40889 10.6883Z",
    fill: "white"
  }), jsx("path", {
    d: "M11.6032 10.6884C11.4962 10.6884 11.3892 10.6905 11.2822 10.6884C10.9074 10.6796 10.6412 10.3995 10.6392 10.0136C10.6376 9.61444 10.9018 9.33301 11.2895 9.32716C11.5167 9.3234 11.7439 9.32215 11.9712 9.328C12.3299 9.33718 12.5929 9.62446 12.5945 10.0011C12.5965 10.3903 12.3339 10.6771 11.9639 10.688C11.8437 10.6913 11.7234 10.6884 11.6032 10.6888V10.6884Z",
    fill: "white"
  }), jsx("path", {
    d: "M14.8189 10.6877C14.6918 10.6877 14.5647 10.6944 14.438 10.6865C14.0998 10.666 13.8472 10.3683 13.8496 9.99915C13.8516 9.64047 14.1022 9.34567 14.434 9.33063C14.6942 9.31894 14.9556 9.31936 15.2158 9.33063C15.5472 9.34441 15.8014 9.64005 15.8046 9.99581C15.8078 10.3658 15.5572 10.6652 15.2194 10.6865C15.0863 10.6948 14.952 10.6877 14.8185 10.6877H14.8189Z",
    fill: "white"
  })),
  paint: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M9.64274 2H10.2311C10.6415 2.03782 11.0533 2.06163 11.4582 2.14989C14.4447 2.79705 16.4842 4.53964 17.5432 7.41407C17.6721 7.76427 17.7379 8.12988 17.7141 8.50249C17.6623 9.32195 17.3387 10.0153 16.7182 10.5603C16.6145 10.6513 16.6075 10.6961 16.7125 10.7928C17.2392 11.2803 17.7659 11.7691 18.2786 12.2734C18.8362 12.8211 18.8964 13.684 18.4383 14.3018C17.8458 15.1002 16.7336 15.1661 16.0318 14.4321C15.0876 13.4445 14.1519 12.4499 13.2204 11.4512C13.0943 11.3167 12.9878 11.3097 12.8365 11.3895C12.4149 11.6123 12.2062 12.0675 12.307 12.5662C12.3967 13.0145 12.7679 13.3492 13.2232 13.3913C13.3857 13.4067 13.5496 13.4095 13.7092 13.4403C14.4531 13.586 14.9756 14.1141 15.1282 14.8621C15.2739 15.5751 14.9882 16.2713 14.3606 16.6859C13.0004 17.5838 11.4974 18.0083 9.87247 17.9999C9.07541 17.9957 8.28957 17.8766 7.53174 17.6189C4.95287 16.7406 3.2271 15.0064 2.3544 12.4261C2.16389 11.863 2.07284 11.2775 2 10.6891C2 10.2325 2 9.77441 2 9.31775C2.007 9.28553 2.01541 9.25472 2.01961 9.2225C2.08965 8.46467 2.25494 7.72785 2.55471 7.02885C3.67815 4.40657 5.62666 2.77044 8.41704 2.15129C8.82047 2.06163 9.2337 2.03642 9.64414 2H9.64274ZM3.01558 10.1512C3.01558 10.3151 3.02118 10.6191 3.0632 10.9217C3.28453 12.4807 3.92469 13.8437 5.05793 14.9405C6.86356 16.6873 9.02359 17.2925 11.4834 16.8036C12.307 16.6397 13.0691 16.3063 13.7737 15.8455C14.0566 15.6606 14.1883 15.3566 14.1225 15.061C14.044 14.708 13.8283 14.5077 13.4711 14.4433C13.2988 14.4124 13.1251 14.425 12.9528 14.3914C11.9723 14.1967 11.2326 13.3282 11.2466 12.3407C11.2565 11.6095 11.5646 11.0169 12.1768 10.5995C12.2832 10.5266 12.3084 10.4804 12.209 10.3796C11.9036 10.0686 11.6067 9.7506 11.3083 9.43262C11.2354 9.35417 11.1612 9.32055 11.0491 9.33596C10.2941 9.43682 9.62873 9.23651 9.0558 8.73222C8.67619 8.39883 8.49548 7.94777 8.33719 7.48971C7.9996 6.51336 7.83431 5.49919 7.71244 4.47801C7.67462 4.16563 7.91135 3.91629 8.22933 3.91769C8.50809 3.91769 8.77985 3.97372 9.0544 4.01574C9.90468 4.14742 10.7466 4.31551 11.5506 4.63209C11.8756 4.75957 12.1936 4.90525 12.4443 5.15879C13.0215 5.74432 13.2456 6.45033 13.1405 7.26139C13.1265 7.36925 13.1573 7.43228 13.2302 7.50092C14.0594 8.27976 14.8873 9.05861 15.7124 9.84305C15.8076 9.9341 15.8721 9.9327 15.9729 9.85286C16.6075 9.35417 16.8428 8.53331 16.5725 7.73906C15.4406 4.41637 12.1011 2.57573 8.81066 3.12904C5.47537 3.69076 2.99737 6.64223 3.01558 10.1512ZM10.5561 8.32879C11.5912 8.32879 12.258 7.54995 12.1179 6.67866C12.0325 6.14915 11.7369 5.79335 11.2354 5.60144C10.5617 5.3437 9.86126 5.19521 9.15386 5.07334C8.82327 5.01731 8.81487 5.01871 8.8737 5.3465C9.00257 6.07491 9.14825 6.79912 9.42841 7.48691C9.66095 8.05844 10.1078 8.30638 10.5561 8.32739V8.32879ZM17.7071 13.352C17.7169 13.1994 17.6329 13.0663 17.5082 12.9486C15.9883 11.5142 14.4699 10.0798 12.9486 8.64677C12.8632 8.56553 12.7875 8.42545 12.6783 8.42685C12.5676 8.42685 12.5088 8.57813 12.4233 8.66078C12.1964 8.8765 12.1978 8.8807 12.4177 9.11184C13.5271 10.2871 14.6352 11.4624 15.7446 12.6376C16.0878 13.0018 16.4296 13.3675 16.777 13.7289C16.9507 13.9096 17.179 13.9558 17.3891 13.8675C17.5866 13.7835 17.7057 13.6 17.7057 13.352H17.7071Z",
    fill: "white"
  }), jsx("ellipse", {
    opacity: 0.4,
    cx: 8.22234,
    cy: 13.5533,
    rx: 1.77745,
    ry: 1.77745,
    fill: "white"
  }), jsx("ellipse", {
    opacity: 0.4,
    cx: 5.55608,
    cy: 9.99864,
    rx: 1.77745,
    ry: 1.77745,
    fill: "white"
  })),
  signature: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    opacity: 0.4,
    d: "M17.0659 7.63893C17.0659 7.6695 17.0566 7.69935 17.0392 7.72447C16.9691 7.8254 16.887 7.91094 16.7849 7.95424C16.674 8.00128 16.562 7.98935 16.4585 7.93837C16.4584 7.93835 16.4584 7.93833 16.4584 7.93831L16.5247 7.80377L17.0659 7.63893ZM17.0659 7.63893V7.63842V4.20333C17.0659 4.18091 17.0609 4.15878 17.0512 4.13856C17.0003 4.03214 16.9266 3.95458 16.8302 3.90698C16.7377 3.8613 16.6364 3.84918 16.5387 3.85004L16.5386 3.85004C16.0289 3.85482 15.5196 3.85408 15.0093 3.85334C14.8224 3.85307 14.6353 3.8528 14.448 3.8528C14.3527 3.8528 14.2572 3.85274 14.1616 3.85269C13.9065 3.85254 13.6508 3.85239 13.3954 3.8533L13.3952 3.8533M17.0659 7.63893L13.3952 3.8533M13.3952 3.8533C13.2969 3.85378 13.2025 3.87482 13.1232 3.9266C13.0417 3.97977 12.9879 4.05778 12.961 4.14949L13.3952 3.8533ZM13.0302 4.54558C12.9391 4.43576 12.9194 4.29129 12.961 4.14954L13.0302 4.54558ZM13.0302 4.54558C13.1194 4.65318 13.2574 4.70396 13.4065 4.70412L13.0302 4.54558Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), jsx("path", {
    opacity: 0.4,
    d: "M3.09618 17.1237C3.12062 17.1397 3.14921 17.1483 3.17844 17.1483L2.85341 14.4475C2.8538 15.1571 2.85419 15.866 2.85003 16.5752L2.85003 16.5752C2.84895 16.762 2.8753 16.9789 3.09618 17.1237ZM3.70411 13.472L3.70411 13.4717L6.81105 16.8236L6.9533 16.8712C6.95331 16.8712 6.95331 16.8712 6.95332 16.8712C7.00132 16.7276 6.98401 16.5794 6.89496 16.4656C6.80719 16.3535 6.66752 16.2974 6.51419 16.2972L6.39067 16.2971C5.49487 16.2961 4.59858 16.2951 3.70223 16.2991C3.70571 15.7864 3.7053 15.2737 3.70489 14.7616C3.70475 14.5951 3.70462 14.4286 3.70462 14.2623C3.70462 14.1853 3.70473 14.1082 3.70484 14.031C3.7051 13.845 3.70536 13.6583 3.70411 13.472ZM3.00703 13.1162C2.90127 13.2069 2.85332 13.3454 2.85329 13.494L3.36063 13.1862L3.40064 13.0417C3.4006 13.0417 3.40056 13.0417 3.40051 13.0416C3.25907 13.0025 3.11553 13.0232 3.00703 13.1162Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), jsx("path", {
    opacity: 0.4,
    d: "M14.5961 16.2978C14.4491 16.2979 14.3021 16.2981 14.1551 16.2981H14.1551C14.0807 16.2981 14.006 16.2979 13.9311 16.2977C13.7469 16.2973 13.5613 16.2968 13.3763 16.2991L13.3762 16.2991C13.2595 16.3007 13.1505 16.3387 13.0689 16.4149C12.9865 16.4918 12.9426 16.5978 12.9402 16.7134L12.9402 16.7135C12.9359 16.9314 13.0733 17.0564 13.2079 17.1311C13.2301 17.1434 13.2552 17.1499 13.2807 17.1499H16.7158C16.8012 17.1499 16.8932 17.1317 16.9649 17.069C17.0404 17.0029 17.0663 16.9117 17.0663 16.8245V13.3894C17.0663 13.3657 17.0607 13.3423 17.0499 13.3212C17.0469 13.3154 17.0437 13.3088 17.0402 13.3016C17.0078 13.235 16.9484 13.1126 16.8103 13.0573C16.8038 13.054 16.797 13.0512 16.79 13.0489C16.6465 13.0011 16.4982 13.0183 16.3844 13.1073C16.2721 13.195 16.2159 13.3346 16.2157 13.488L16.2156 13.6115C16.2146 14.5075 16.2137 15.4037 16.2176 16.3003C15.677 16.2968 15.1363 16.2973 14.5961 16.2978Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), jsx("path", {
    opacity: 0.4,
    d: "M3.69969 4.698C3.69966 4.70129 3.69965 4.70477 3.69967 4.70847L3.54967 4.70911L3.69967 4.70834C3.70426 5.60816 3.70304 6.50793 3.70182 7.40713L3.70168 7.51514C3.70168 7.51515 3.70168 7.51517 3.70168 7.51518C3.7015 7.67503 3.63373 7.8173 3.51734 7.90246C3.39875 7.98924 3.242 8.00668 3.09621 7.9359L3.69969 4.698ZM3.69969 4.698C3.69975 4.698 3.69982 4.698 3.69989 4.698L3.69969 4.698ZM2.85086 4.33253L2.85086 4.33234C2.85115 4.19946 2.88201 4.071 2.97423 3.97706C3.06704 3.88252 3.19484 3.85049 3.32746 3.85048L2.85086 4.33253ZM2.85086 4.33253C2.85052 4.68341 2.85063 5.03426 2.85075 5.38504C2.8508 5.55746 2.85085 5.72987 2.85086 5.90226M2.85086 4.33253L2.85086 5.90226M2.85086 5.90226C2.85069 5.90515 2.85061 5.90807 2.85061 5.91101C2.85061 6.0597 2.8507 6.20829 2.8508 6.35683C2.85105 6.74273 2.8513 7.12823 2.84985 7.51389L2.85086 5.90226ZM2.90391 7.7551C2.86313 7.67857 2.84954 7.59486 2.84985 7.51391L2.90391 7.7551ZM2.90391 7.7551C2.94582 7.83376 3.01104 7.89457 3.09615 7.93587L2.90391 7.7551ZM3.6999 4.698C4.07138 4.70497 4.44383 4.70381 4.81435 4.70266C4.95348 4.70223 5.09235 4.7018 5.23078 4.7018C5.34796 4.7018 5.4652 4.70186 5.58248 4.70191C5.89542 4.70206 6.20862 4.70221 6.52158 4.7013L6.52162 4.7013C6.62018 4.70098 6.71469 4.67969 6.79402 4.62754C6.87534 4.57408 6.92893 4.49581 6.95562 4.4041C6.95564 4.40405 6.95565 4.404 6.95566 4.40395L6.81163 4.36208C6.87168 4.15627 6.74328 4.00048 6.50933 4.00048L6.50944 3.85048L3.6999 4.698Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M16.3787 9.02118C16.3798 9.02114 16.3809 9.0211 16.3819 9.02107C16.4969 9.0178 16.6242 9.03293 16.7448 9.09452C16.8701 9.15853 16.9625 9.25958 17.0255 9.38388C17.0468 9.42591 17.0579 9.47235 17.0579 9.51946V9.69486C17.0579 9.75079 17.0422 9.8056 17.0127 9.85311C16.9619 9.93504 16.8924 10.02 16.7936 10.084C16.6915 10.1502 16.5747 10.1831 16.4486 10.1836C15.5321 10.1875 14.7314 10.5424 13.9646 11.0882C13.8155 11.1943 13.6718 11.3056 13.5226 11.4213C13.4791 11.455 13.435 11.4891 13.3903 11.5236C13.1955 11.6735 12.9905 11.8267 12.7703 11.9645C12.5069 12.1294 12.1706 12.2851 11.767 12.2117C11.5245 12.1676 11.3139 12.0573 11.1582 11.8761C11.1157 11.8268 11.0788 11.7738 11.0469 11.7177C10.9638 11.8103 10.8785 11.9015 10.7903 11.9872M16.3787 9.02118L10.5812 11.772M16.3787 9.02118C15.4861 9.04774 14.6659 9.30551 13.9057 9.74763L13.9057 9.74766C13.4855 9.99213 13.0987 10.2875 12.7295 10.5695C12.6454 10.6337 12.5622 10.6973 12.4797 10.7594L12.4796 10.7594C12.4715 10.7655 12.4635 10.7716 12.4555 10.7776C12.3005 10.8945 12.1795 10.9857 12.0436 11.0459C12.0428 10.9074 12.0724 10.7643 12.1183 10.5982L12.1183 10.5981C12.1702 10.4101 12.1406 10.2101 12.0155 10.0568C11.8909 9.90407 11.702 9.83492 11.5093 9.84536L16.3787 9.02118ZM10.7903 11.9872L10.5812 11.772M10.7903 11.9872C10.7903 11.9872 10.7903 11.9871 10.7903 11.9871L10.5812 11.772M10.7903 11.9872C10.5402 12.2303 10.234 12.4949 9.8119 12.6014M10.5812 11.772C10.3372 12.0092 10.0792 12.2246 9.73841 12.3105M9.8119 12.6014L9.73841 12.3105M9.8119 12.6014C9.81186 12.6014 9.81182 12.6014 9.81178 12.6014L9.73841 12.3105M9.8119 12.6014L9.73841 12.3105M8.70638 11.578L8.45764 11.7457C8.45076 11.7355 8.4445 11.7253 8.4388 11.715C8.43422 11.7228 8.42963 11.7307 8.42505 11.7386C8.44956 11.8721 8.49429 11.9963 8.55732 12.1075C8.61598 12.0072 8.67419 11.9071 8.73216 11.8073C8.73629 11.8002 8.74041 11.7931 8.74453 11.7861C8.72501 11.7212 8.71203 11.6517 8.70638 11.578ZM8.70638 11.578C8.6805 11.5396 8.68252 11.4965 8.68454 11.4533C8.68654 11.4104 8.68854 11.3676 8.66341 11.3295C8.612 11.4173 8.56081 11.5052 8.50966 11.5931L8.70638 11.578ZM8.93476 9.33443C8.72102 9.56941 8.55906 9.83611 8.41434 10.0744L8.40678 10.0869C8.2152 10.4021 8.03326 10.7141 7.85292 11.0234C7.56831 11.5115 7.28768 11.9927 6.97943 12.4692L6.97935 12.4693C6.78808 12.7653 6.6085 13.0418 6.39935 13.2871C6.39183 13.0502 6.42894 12.8047 6.47806 12.5361L6.47808 12.5359C6.74012 11.0986 7.18012 9.7141 7.78101 8.38022L7.50748 8.257L7.78101 8.38022C7.92317 8.06464 8.05616 7.79625 8.261 7.58469L9.69921 9.40061L9.89076 9.16972C9.79635 9.0914 9.67548 9.02593 9.52901 9.01888C9.3813 9.01176 9.25302 9.06619 9.1488 9.14037L9.14851 9.14059C9.06482 9.20032 8.99361 9.26971 8.93476 9.33443ZM8.93476 9.33443L9.15668 9.5363L8.9347 9.3345C8.93472 9.33448 8.93474 9.33446 8.93476 9.33443ZM9.55653 11.4728C9.55432 11.4735 9.55211 11.4741 9.54989 11.4748L9.54969 11.4748C9.5318 11.4801 9.51818 11.4829 9.50844 11.4842C9.5068 11.4845 9.50531 11.4847 9.50395 11.4848C9.50341 11.4849 9.5029 11.4849 9.5024 11.485C9.49788 11.4854 9.49519 11.4854 9.49416 11.4854C9.49391 11.4854 9.49375 11.4854 9.4937 11.4854C9.49366 11.4854 9.49376 11.4854 9.49399 11.4854C9.49513 11.4855 9.49947 11.4861 9.50611 11.4882C9.51437 11.4908 9.52442 11.4954 9.53466 11.5026C9.5449 11.5098 9.55271 11.5178 9.55812 11.5249C9.56336 11.5317 9.56528 11.5362 9.56532 11.5363C9.56534 11.5364 9.56492 11.5354 9.56425 11.5331C9.56358 11.5309 9.5627 11.5276 9.56177 11.523C9.5609 11.5187 9.56003 11.5135 9.55925 11.5074C9.5592 11.507 9.55915 11.5067 9.55911 11.5063C9.55825 11.4994 9.55751 11.4913 9.557 11.482L9.557 11.4819C9.55683 11.4789 9.55667 11.4758 9.55653 11.4728ZM6.1239 13.5524L6.1239 13.5524L6.1239 13.5524ZM10.9257 11.4019C10.9531 11.3705 10.9805 11.3389 11.0081 11.3072C11.0382 11.2725 11.0684 11.2376 11.0991 11.2026C11.0991 11.2026 11.0991 11.2025 11.0992 11.2025C11.1282 11.1693 11.1575 11.136 11.1873 11.1026C11.1886 11.1192 11.1895 11.1329 11.1903 11.1448C11.1916 11.1636 11.1926 11.178 11.1941 11.1923C11.2054 11.296 11.2279 11.3898 11.2614 11.4731L10.9257 11.4019ZM10.5678 10.5049L10.7948 10.701L10.568 10.5047C10.5679 10.5048 10.5679 10.5048 10.5678 10.5049ZM11.056 10.0287C11.056 10.0288 11.056 10.0288 11.0559 10.0288L11.2318 10.2718L11.056 10.0287Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })),
  casing: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M9.29158 13.0974C10.1564 11.353 11.0211 9.60796 11.8859 7.86352C12.0758 7.48112 12.2643 7.09871 12.4597 6.71811C12.7603 6.1324 13.3341 5.88916 14.0383 6.04708C14.4495 6.13966 14.6913 6.39621 14.8553 6.72417C15.2009 7.41456 15.5466 8.10434 15.8915 8.79474C16.5548 10.1217 17.2146 11.4498 17.8827 12.7749C18.0507 13.1077 18.0555 13.4187 17.7843 13.7067C17.3806 14.1364 16.5876 14.0892 16.2877 13.5966C16.0479 13.2021 15.8574 12.7822 15.662 12.3677C15.5964 12.2292 15.5192 12.1795 15.3464 12.1807C14.2016 12.1886 13.0567 12.1886 11.9119 12.1807C11.7363 12.1795 11.6598 12.2316 11.5977 12.3707C11.4283 12.7489 11.252 13.1253 11.056 13.4932C10.7991 13.9754 10.1789 14.1382 9.69801 13.8689C9.47942 13.7467 9.38106 13.5543 9.29089 13.3546C9.29089 13.2687 9.29089 13.1828 9.29089 13.0968L9.29158 13.0974ZM14.8457 10.6553C14.4379 9.79493 14.0424 8.96053 13.6312 8.09285C13.2186 8.96295 12.8217 9.80158 12.4174 10.6553H14.8464H14.8457Z",
    fill: "white"
  }), jsx("path", {
    opacity: 0.5,
    d: "M5.19164 9.11192C5.51991 9.13114 5.76937 9.2455 5.92392 9.4C6.01077 9.48682 6.07188 9.59002 6.10159 9.7067C5.33521 9.52032 4.55654 9.49452 3.77594 9.62631L3.77586 9.62632C3.22398 9.71968 2.77113 9.90398 2.4308 10.1986C2.08711 10.4961 1.87686 10.8899 1.78513 11.3661L1.78511 11.3661C1.62862 12.1798 2.00247 13.0273 2.77871 13.4218L2.77884 13.4219C3.82203 13.9513 4.8982 13.9319 5.93793 13.4103L5.93823 13.4101C6.05122 13.3532 6.1518 13.2847 6.24147 13.2195C6.2442 13.2175 6.2469 13.2156 6.24959 13.2136L8.21182 10.0235C8.20977 9.78811 8.19132 9.55092 8.14897 9.31857L8.39493 9.27379C8.39493 9.27377 8.39492 9.27376 8.39492 9.27374C8.30217 8.76439 8.09494 8.32324 7.75486 7.97786C7.41505 7.63277 6.95762 7.39853 6.3895 7.27758L6.38945 7.27757C5.23493 7.032 4.09756 7.12983 2.99467 7.47276L2.99459 7.47279C2.66563 7.57519 2.39795 7.80254 2.3174 8.16277L2.31739 8.16282C2.23674 8.52376 2.37347 8.85464 2.62565 9.06455C2.87528 9.27234 3.23078 9.35821 3.5962 9.26993C4.12549 9.14207 4.65241 9.08034 5.19164 9.11192ZM5.19164 9.11192L5.20626 8.86234M5.19164 9.11192L5.20626 8.86234M5.20626 8.86234C4.63794 8.82907 4.08601 8.89441 3.53749 9.02693C2.95141 9.16851 2.44388 8.74314 2.56137 8.21733L6.21581 9.73569M5.20626 8.86234C5.85905 8.90058 6.3153 9.27116 6.36719 9.77666C6.34255 9.77029 6.32186 9.76455 6.29957 9.75836C6.27573 9.75175 6.25007 9.74462 6.21581 9.73569M6.21581 9.73569C6.21596 9.73574 6.21611 9.73578 6.21627 9.73582L6.15233 9.9775L6.21535 9.73558C6.21551 9.73562 6.21566 9.73566 6.21581 9.73569ZM5.26295 12.3458C5.93989 12.2496 6.45083 11.8962 6.39824 11.1471M5.26295 12.3458L5.22798 12.0982M5.26295 12.3458L5.22778 12.0983C5.22784 12.0982 5.22791 12.0982 5.22798 12.0982M5.26295 12.3458C5.04027 12.3772 4.80324 12.3724 4.57919 12.3446C4.17276 12.2937 3.90157 12.0457 3.86674 11.7346L5.01272 11.0584M6.39824 11.1471L6.14874 11.1631L6.14885 11.1646M6.39824 11.1471C6.39482 11.0939 6.34017 11.0176 6.28689 10.9971L6.39824 11.1471ZM5.22798 12.0982C5.53766 12.0542 5.77817 11.955 5.93267 11.8094C6.07024 11.6797 6.16044 11.494 6.15135 11.2132M5.22798 12.0982C5.03181 12.1259 4.81747 12.1222 4.61001 12.0965C4.28553 12.0558 4.1338 11.873 4.11518 11.7068L4.11514 11.7064C4.10009 11.574 4.12892 11.4653 4.18721 11.3802C4.24613 11.2943 4.34695 11.2154 4.50364 11.1658L4.50391 11.1657C4.63623 11.1237 4.76416 11.1019 4.88419 11.0813C4.92815 11.0738 4.97105 11.0665 5.01272 11.0584M6.15135 11.2132C6.16638 11.2186 6.18134 11.2242 6.19624 11.23C6.17655 11.2223 6.166 11.2136 6.16348 11.2114C6.16161 11.2098 6.16058 11.2087 6.1602 11.2083L6.15979 11.2078L6.15968 11.2077L6.15958 11.2075L6.15925 11.207C6.15897 11.2065 6.15824 11.2052 6.15725 11.2029C6.15605 11.2001 6.15049 11.1869 6.14885 11.1646M6.15135 11.2132C5.8295 11.0968 5.47598 11.0622 5.01272 11.0584M6.15135 11.2132C6.15084 11.1973 6.15001 11.1811 6.14885 11.1646M6.14885 11.1646L5.01272 11.0584",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })),
  fontSize: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.0007 13.0974C2.89136 11.353 3.78202 9.60796 4.67268 7.86352C4.86826 7.48112 5.06243 7.09871 5.26364 6.71811C5.57319 6.1324 6.16414 5.88916 6.88947 6.04708C7.31299 6.13966 7.56204 6.39621 7.73089 6.72417C8.08687 7.41456 8.44285 8.10434 8.79813 8.79474C9.48125 10.1217 10.1609 11.4498 10.8489 12.7749C11.022 13.1077 11.0269 13.4187 10.7476 13.7067C10.3318 14.1364 9.51502 14.0892 9.20617 13.5966C8.95924 13.2021 8.76295 12.7822 8.56175 12.3677C8.49421 12.2292 8.41471 12.1795 8.23672 12.1807C7.05762 12.1886 5.87851 12.1886 4.69941 12.1807C4.51861 12.1795 4.43981 12.2316 4.37579 12.3707C4.20132 12.7489 4.01981 13.1253 3.8179 13.4932C3.55338 13.9754 2.91458 14.1382 2.4193 13.8689C2.19417 13.7467 2.09286 13.5543 2 13.3546C2 13.2687 2 13.1828 2 13.0968L2.0007 13.0974ZM7.72104 10.6553C7.30104 9.79493 6.8937 8.96053 6.47018 8.09285C6.04525 8.96295 5.6365 9.80158 5.22002 10.6553H7.72174H7.72104Z",
    fill: "white"
  }), jsx("path", {
    opacity: 0.5,
    d: "M16.0895 10.4077C16.1831 9.78086 15.6765 9.29317 14.8999 9.249C14.3145 9.21572 13.7461 9.28107 13.1812 9.41358C12.5775 9.55517 12.0548 9.1298 12.1758 8.60399C12.2342 8.35046 12.4263 8.18044 12.6985 8.09815C13.7988 7.76596 14.9252 7.67338 16.0649 7.90876C17.1568 8.13445 17.7547 8.76736 17.9306 9.70523C17.9742 9.93758 17.9932 10.1748 17.9954 10.4101C18.0031 11.2687 18.0003 12.1274 17.9975 12.986C17.9961 13.4162 17.778 13.709 17.3756 13.8355C16.7923 14.0188 16.233 13.7526 16.0804 13.2153C15.8996 13.3363 15.7335 13.4779 15.538 13.5735C14.5368 14.0612 13.5146 14.0775 12.5163 13.5856C11.8248 13.2443 11.4885 12.5104 11.6292 11.8C11.7994 10.942 12.3939 10.4362 13.4696 10.2595C14.2779 10.127 15.0828 10.1609 15.8742 10.3642C15.934 10.3793 15.9931 10.3962 16.0529 10.4107C16.0642 10.4132 16.0776 10.4089 16.0895 10.4077ZM14.679 11.1943C14.5432 11.2216 14.3124 11.2482 14.0985 11.3141C13.6849 11.4412 13.4766 11.7486 13.5203 12.1213C13.5561 12.4323 13.8354 12.6804 14.254 12.7312C14.4848 12.7591 14.7289 12.7639 14.9583 12.7324C15.6554 12.6362 16.1817 12.2829 16.1275 11.5338C16.124 11.4805 16.0677 11.4043 16.0128 11.3837C15.6189 11.2349 15.1989 11.198 14.6797 11.1949L14.679 11.1943Z",
    fill: "white"
  })),
  fontFamily: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M5.00078 13.8718C5.99373 11.6912 6.98668 9.50995 7.97963 7.32941C8.19768 6.85139 8.41415 6.37338 8.63846 5.89764C8.98356 5.1655 9.64239 4.86145 10.451 5.05886C10.9232 5.17458 11.2008 5.49527 11.3891 5.90521C11.7859 6.7682 12.1828 7.63043 12.5789 8.49342C13.3405 10.1521 14.0981 11.8123 14.8652 13.4687C15.0581 13.8847 15.0636 14.2734 14.7522 14.6334C14.2887 15.1704 13.3781 15.1114 13.0338 14.4958C12.7585 14.0026 12.5397 13.4777 12.3154 12.9596C12.2401 12.7864 12.1514 12.7244 11.953 12.7259C10.6385 12.7358 9.32396 12.7358 8.00944 12.7259C7.80787 12.7244 7.72002 12.7895 7.64865 12.9634C7.45414 13.4361 7.25178 13.9066 7.02668 14.3664C6.73178 14.9693 6.01962 15.1727 5.46746 14.8361C5.21647 14.6834 5.10353 14.4428 5 14.1932C5 14.0858 5 13.9784 5 13.871L5.00078 13.8718ZM11.3781 10.8192C10.9099 9.74366 10.4557 8.70066 9.98357 7.61606C9.50984 8.70368 9.05415 9.75198 8.58984 10.8192H11.3789H11.3781Z",
    fill: "#6B7280"
  })),
  align: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M2.97214 9.3386C2.84169 9.3386 2.70673 9.33823 2.58154 9.30704C2.21349 9.21536 1.97213 8.85728 2.00258 8.47215C2.03304 8.08438 2.32138 7.78604 2.70861 7.74471C2.79507 7.73569 2.88304 7.73419 2.97026 7.73419C7.6564 7.73419 12.3422 7.73419 17.0279 7.73532C17.1584 7.73532 17.2933 7.73532 17.4185 7.76651C17.7869 7.85781 18.0275 8.21552 17.9975 8.6014C17.9674 8.98916 17.679 9.28788 17.2914 9.32883C17.1986 9.3386 17.1042 9.33935 17.011 9.33935C14.6741 9.33973 5.31502 9.34011 2.97214 9.3386Z",
    fill: "white"
  }), jsx("path", {
    d: "M2.95154 16.8068C2.82146 16.8068 2.68612 16.8027 2.56244 16.7677C2.191 16.6629 1.96619 16.3104 2.00416 15.9204C2.041 15.5432 2.3286 15.2531 2.70943 15.2129C2.79627 15.2039 2.88387 15.2028 2.97146 15.2028C7.65722 15.2024 12.3434 15.202 17.0291 15.2039C17.1656 15.2039 17.3073 15.2065 17.437 15.2426C17.8084 15.3463 18.0329 15.6991 17.9953 16.0899C17.9588 16.4671 17.6712 16.7576 17.2896 16.7974C17.1968 16.8072 17.1024 16.8079 17.0092 16.8079C14.6663 16.8083 5.29441 16.809 2.95154 16.8068Z",
    fill: "white"
  }), jsx("path", {
    d: "M5.3498 13.0719C5.21409 13.0719 5.07198 13.0647 4.94378 13.0253C4.57235 12.9107 4.3622 12.5605 4.40769 12.1656C4.44979 11.8 4.73777 11.517 5.11221 11.4783C5.19905 11.4693 5.28664 11.4686 5.37424 11.4686C8.45998 11.4682 11.5457 11.4678 14.6315 11.4697C14.7676 11.4697 14.9097 11.4727 15.039 11.5091C15.4104 11.614 15.6334 11.9664 15.595 12.3576C15.5582 12.7344 15.2698 13.0238 14.8882 13.0636C14.8014 13.0726 14.7138 13.0737 14.6266 13.0737C13.0773 13.0745 6.89343 13.0752 5.35056 13.0722L5.3498 13.0719Z",
    fill: "white"
  }), jsx("path", {
    d: "M5.3498 5.60359C5.21409 5.60359 5.07198 5.59645 4.94378 5.557C4.57235 5.4424 4.3622 5.09221 4.40769 4.6973C4.44979 4.33171 4.73777 4.04878 5.11221 4.01008C5.19905 4.00106 5.28664 4.00031 5.37424 4.00031C8.45998 3.99993 11.5457 3.99956 14.6315 4.00143C14.7676 4.00143 14.9097 4.00444 15.039 4.04089C15.4104 4.14572 15.6334 4.49816 15.595 4.88931C15.5582 5.26618 15.2698 5.5555 14.8882 5.59532C14.8014 5.60434 14.7138 5.60547 14.6266 5.60547C13.0773 5.60622 6.89343 5.60697 5.35056 5.60397L5.3498 5.60359Z",
    fill: "white"
  })),
  delete: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M15.9998 6.48663C15.9865 6.48663 15.9665 6.48663 15.9465 6.48663C12.4198 6.1333 8.89981 5.99996 5.41312 6.3533L4.05312 6.48663C3.77312 6.5133 3.52646 6.3133 3.49979 6.0333C3.47312 5.7533 3.67312 5.5133 3.94646 5.48663L5.30646 5.3533C8.85314 4.9933 12.4465 5.1333 16.0465 5.48663C16.3198 5.5133 16.5198 5.75996 16.4931 6.0333C16.4731 6.2933 16.2531 6.48663 15.9998 6.48663Z",
    fill: "#DC2626"
  }), jsx("path", {
    d: "M7.66715 5.81331C7.64048 5.81331 7.61381 5.81331 7.58048 5.80665C7.31381 5.75998 7.12715 5.49998 7.17381 5.23331L7.32048 4.35998C7.42715 3.71998 7.57381 2.83331 9.12712 2.83331H10.8738C12.4338 2.83331 12.5805 3.75331 12.6805 4.36665L12.8271 5.23331C12.8738 5.50665 12.6871 5.76665 12.4205 5.80665C12.1471 5.85331 11.8871 5.66665 11.8471 5.39998L11.7005 4.53331C11.6071 3.95331 11.5871 3.83998 10.8805 3.83998H9.13379C8.42715 3.83998 8.41381 3.93331 8.31381 4.52665L8.16048 5.39331C8.12048 5.63998 7.90715 5.81331 7.66715 5.81331ZM12.1403 17.1667H7.86025C5.53358 17.1667 5.44025 15.88 5.36691 14.84L4.93358 8.12669C4.91358 7.85336 5.12691 7.61337 5.40025 7.59337C5.68025 7.58003 5.91358 7.7867 5.93358 8.06003L6.36691 14.7734C6.44025 15.7867 6.46691 16.1667 7.86025 16.1667H12.1403C13.5403 16.1667 13.5669 15.7867 13.6336 14.7734L14.0669 8.06003C14.0869 7.7867 14.3269 7.58003 14.6003 7.59337C14.8736 7.61337 15.0869 7.84669 15.0669 8.12669L14.6336 14.84C14.5603 15.88 14.4669 17.1667 12.1403 17.1667Z",
    fill: "#DC2626"
  }), jsx("path", {
    d: "M11.1067 13.5H8.88674C8.6134 13.5 8.38673 13.2733 8.38673 13C8.38673 12.7266 8.6134 12.5 8.88674 12.5H11.1067C11.3801 12.5 11.6067 12.7266 11.6067 13C11.6067 13.2733 11.3801 13.5 11.1067 13.5ZM11.6667 10.8333H8.33334C8.06001 10.8333 7.83334 10.6066 7.83334 10.3333C7.83334 10.06 8.06001 9.83331 8.33334 9.83331H11.6667C11.94 9.83331 12.1667 10.06 12.1667 10.3333C12.1667 10.6066 11.94 10.8333 11.6667 10.8333Z",
    fill: "#DC2626"
  })),
  plus: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M10.625 3.88388C10.625 3.5387 10.3452 3.25888 10 3.25888C9.65483 3.25888 9.37501 3.5387 9.37501 3.88388L9.37501 9.44607L3.81281 9.44607C3.46763 9.44607 3.18781 9.72589 3.18781 10.0711C3.18781 10.4162 3.46763 10.6961 3.81281 10.6961H9.37501V16.2581C9.37501 16.6033 9.65483 16.8831 10 16.8831C10.3452 16.8831 10.625 16.6033 10.625 16.2581V10.6961H16.1871C16.5322 10.6961 16.8121 10.4162 16.8121 10.0711C16.8121 9.72589 16.5322 9.44607 16.1871 9.44607L10.625 9.44607L10.625 3.88388Z",
    fill: "#585D62"
  })),
  close: jsx("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M6.06693 5.2541C5.82286 5.01003 5.42713 5.01003 5.18306 5.2541C4.93898 5.49818 4.93898 5.8939 5.18306 6.13798L9.11613 10.071L5.18306 14.0041C4.93898 14.2482 4.93898 14.6439 5.18306 14.888C5.42713 15.1321 5.82286 15.1321 6.06693 14.888L10 10.9549L13.933 14.8879C14.177 15.132 14.5728 15.132 14.8168 14.8879C15.0609 14.6438 15.0609 14.2481 14.8168 14.004L10.8839 10.071L14.8168 6.13807C15.0609 5.894 15.0609 5.49827 14.8168 5.2542C14.5728 5.01012 14.177 5.01012 13.933 5.2542L10 9.18717L6.06693 5.2541Z",
    fill: "#585D62"
  })),
  verticalImage: jsx("svg", {
    width: 140,
    height: 188,
    viewBox: "0 0 140 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("g", {
    filter: "url(#filter0_d_567_3628)"
  }, jsx("rect", {
    x: 16,
    y: 16,
    width: 108,
    height: 156,
    rx: 6,
    fill: "white"
  }), jsx("g", {
    clipPath: "url(#clip0_567_3628)"
  }, jsx("path", {
    d: "M47.4926 72C62.2116 72 76.9306 72 91.6496 72C91.737 72.0205 91.8222 72.0508 91.9107 72.0616C94.9419 72.4182 97.181 74.9124 97.1821 77.9544C97.1854 88.6583 97.1821 99.3611 97.1864 110.065C97.1864 110.572 97.1271 111.066 96.9954 111.554C96.2595 114.279 93.8833 115.997 90.8003 115.998C76.6435 116.002 62.4879 116.001 48.3311 115.994C47.7969 115.994 47.2488 115.956 46.7297 115.837C44.1388 115.244 42.6129 113.578 42 111.026V76.9591C42.355 75.3803 43.1277 74.0705 44.456 73.1152C45.3657 72.4604 46.3963 72.1426 47.4926 72ZM94.6721 100.982C94.78 100.849 94.7304 100.701 94.7304 100.565C94.7336 93.1809 94.7358 85.7978 94.7261 78.4137C94.7261 77.9868 94.67 77.5503 94.5707 77.1353C94.1876 75.5283 92.7805 74.5179 90.9492 74.5179C76.7515 74.5168 62.5548 74.5168 48.357 74.5179C45.8578 74.5179 44.415 75.9541 44.4129 78.4688C44.4075 86.8947 44.4107 95.3206 44.4129 103.746C44.4129 103.918 44.3233 104.148 44.4938 104.25C44.6751 104.358 44.8154 104.146 44.9557 104.053C47.3783 102.445 49.7954 100.829 52.217 99.2174C54.701 97.5651 57.0546 97.5694 59.5408 99.2304C61.3624 100.446 63.1817 101.665 65.0011 102.885C65.7198 103.367 66.4913 103.656 67.374 103.598C68.5546 103.523 69.4297 102.938 70.1128 102.004C72.7307 98.4231 75.3357 94.8343 77.9784 91.2724C79.5312 89.1803 81.6452 88.4 84.1876 88.9036C85.7954 89.2224 86.9986 90.1853 87.9331 91.5188C90.046 94.5338 92.1718 97.5381 94.2955 100.546C94.4045 100.7 94.4768 100.894 94.6721 100.983V100.982ZM69.542 113.466C72.9692 113.466 76.3975 113.466 79.8247 113.466C83.5757 113.466 87.3267 113.473 91.0766 113.462C93.0189 113.455 94.4002 112.251 94.6462 110.346C94.8448 108.809 94.6948 107.262 94.7261 105.719C94.7304 105.486 94.5858 105.316 94.4628 105.142C91.5967 101.077 88.7403 97.0053 85.8591 92.9518C84.2415 90.6759 81.5168 90.6748 79.8679 92.9237C77.3094 96.4131 74.7551 99.9058 72.203 103.401C70.0502 106.349 66.6165 106.97 63.5832 104.949C61.7012 103.696 59.8257 102.431 57.9438 101.178C56.6143 100.293 55.2492 100.235 53.9079 101.118C50.8497 103.132 47.8088 105.172 44.7625 107.202C44.5974 107.313 44.4204 107.427 44.4215 107.655C44.4269 108.765 44.2985 109.887 44.6104 110.975C45.0539 112.522 46.4006 113.464 48.1682 113.465C55.2924 113.468 62.4177 113.466 69.542 113.467V113.466Z",
    fill: "#D1D5DB"
  }), jsx("path", {
    d: "M64.098 94.7878C59.6046 94.7845 56.063 91.2097 56.0684 86.685C56.0738 82.237 59.6737 78.646 64.1271 78.6471C68.6216 78.6471 72.2042 82.2673 72.1934 86.7974C72.1837 91.2324 68.5773 94.7921 64.098 94.7878ZM69.6662 86.7293C69.6662 83.6365 67.2371 81.192 64.1519 81.1823C61.0603 81.1726 58.5514 83.6624 58.56 86.7315C58.5687 89.767 61.0571 92.3239 64.0991 92.3142C67.3137 92.3044 69.7471 89.6352 69.6662 86.7293Z",
    fill: "#D1D5DB"
  }))), jsx("defs", null, jsx("filter", {
    id: "filter0_d_567_3628",
    x: 0,
    y: 0,
    width: 140,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, jsx("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), jsx("feOffset", null), jsx("feGaussianBlur", {
    stdDeviation: 8
  }), jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_567_3628"
  }), jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_567_3628",
    result: "shape"
  })), jsx("clipPath", {
    id: "clip0_567_3628"
  }, jsx("rect", {
    width: 55.1864,
    height: 44,
    fill: "white",
    transform: "translate(42 72)"
  })))),
  horizontalImage: jsx("svg", {
    width: 188,
    height: 140,
    viewBox: "0 0 188 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("g", {
    filter: "url(#filter0_d_567_3634)"
  }, jsx("rect", {
    x: 16,
    y: 124,
    width: 108,
    height: 156,
    rx: 6,
    transform: "rotate(-90 16 124)",
    fill: "white"
  }), jsx("g", {
    clipPath: "url(#clip0_567_3634)"
  }, jsx("path", {
    d: "M71.4926 48C86.2116 48 100.931 48 115.65 48C115.737 48.0205 115.822 48.0508 115.911 48.0616C118.942 48.4182 121.181 50.9124 121.182 53.9544C121.185 64.6583 121.182 75.3611 121.186 86.065C121.186 86.5719 121.127 87.0657 120.995 87.5542C120.259 90.2785 117.883 91.9968 114.8 91.9978C100.644 92.0022 86.4879 92.0011 72.3311 91.9935C71.7969 91.9935 71.2488 91.9557 70.7297 91.8368C68.1388 91.2435 66.6129 89.5783 66 87.0257V52.9591C66.355 51.3803 67.1277 50.0705 68.456 49.1152C69.3657 48.4604 70.3963 48.1426 71.4926 48ZM118.672 76.9821C118.78 76.8492 118.73 76.7011 118.73 76.565C118.734 69.1809 118.736 61.7978 118.726 54.4137C118.726 53.9868 118.67 53.5503 118.571 53.1353C118.188 51.5283 116.78 50.5179 114.949 50.5179C100.751 50.5168 86.5548 50.5168 72.357 50.5179C69.8578 50.5179 68.415 51.9541 68.4129 54.4688C68.4075 62.8947 68.4107 71.3206 68.4129 79.7464C68.4129 79.9183 68.3233 80.1484 68.4938 80.25C68.6751 80.3581 68.8154 80.1463 68.9557 80.0533C71.3783 78.4453 73.7954 76.8287 76.217 75.2174C78.701 73.5651 81.0546 73.5694 83.5408 75.2304C85.3624 76.4461 87.1817 77.6651 89.0011 78.8852C89.7198 79.3671 90.4913 79.6557 91.374 79.5984C92.5546 79.5227 93.4297 78.9381 94.1128 78.0044C96.7307 74.4231 99.3357 70.8343 101.978 67.2724C103.531 65.1803 105.645 64.4 108.188 64.9036C109.795 65.2224 110.999 66.1853 111.933 67.5188C114.046 70.5338 116.172 73.5381 118.296 76.5455C118.405 76.7001 118.477 76.8935 118.672 76.9832V76.9821ZM93.542 89.4659C96.9692 89.4659 100.398 89.4659 103.825 89.4659C107.576 89.4659 111.327 89.4734 115.077 89.4615C117.019 89.4551 118.4 88.2512 118.646 86.346C118.845 84.8093 118.695 83.2618 118.726 81.7186C118.73 81.4863 118.586 81.3156 118.463 81.1416C115.597 77.0772 112.74 73.0053 109.859 68.9518C108.242 66.6759 105.517 66.6748 103.868 68.9237C101.309 72.4131 98.7551 75.9058 96.203 79.4006C94.0502 82.3487 90.6165 82.97 87.5832 80.9492C85.7012 79.6956 83.8257 78.4313 81.9438 77.1777C80.6143 76.2927 79.2492 76.2354 77.9079 77.1183C74.8497 79.1315 71.8088 81.1718 68.7625 83.2024C68.5974 83.3126 68.4204 83.4272 68.4215 83.6552C68.4269 84.765 68.2985 85.8867 68.6104 86.9749C69.0539 88.5224 70.4006 89.4637 72.1682 89.4648C79.2924 89.468 86.4177 89.4659 93.542 89.4669V89.4659Z",
    fill: "#D1D5DB"
  }), jsx("path", {
    d: "M88.098 70.7878C83.6046 70.7845 80.063 67.2097 80.0684 62.685C80.0738 58.237 83.6737 54.646 88.1271 54.6471C92.6216 54.6471 96.2042 58.2673 96.1934 62.7974C96.1837 67.2324 92.5773 70.7921 88.098 70.7878ZM93.6662 62.7293C93.6662 59.6365 91.2371 57.192 88.1519 57.1823C85.0603 57.1726 82.5514 59.6624 82.56 62.7315C82.5687 65.767 85.0571 68.3239 88.0991 68.3142C91.3137 68.3044 93.7471 65.6352 93.6662 62.7293Z",
    fill: "#D1D5DB"
  }))), jsx("defs", null, jsx("filter", {
    id: "filter0_d_567_3634",
    x: 0,
    y: 0,
    width: 188,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, jsx("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), jsx("feOffset", null), jsx("feGaussianBlur", {
    stdDeviation: 8
  }), jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_567_3634"
  }), jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_567_3634",
    result: "shape"
  })), jsx("clipPath", {
    id: "clip0_567_3634"
  }, jsx("rect", {
    width: 55.1864,
    height: 44,
    fill: "white",
    transform: "translate(66 48)"
  })))),
  replaceImage: jsx("svg", {
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M10.6081 16.0001C10.2104 15.8269 10.0592 15.5463 10.1836 15.2145C10.2226 15.1072 10.2983 15.0266 10.3763 14.9486C10.7984 14.5265 11.2205 14.1044 11.6499 13.675C11.5767 13.6287 11.5059 13.6457 11.4425 13.6457C8.59286 13.6457 5.74077 13.6238 2.89113 13.6531C1.4663 13.6677 0.190302 12.6381 0.0170784 11.2108C0.0170784 11.1938 0.00487954 11.1791 0 11.162C0 10.1886 0 9.21267 0 8.23921C0.0927112 8.00987 0.239097 7.83908 0.500152 7.81225C0.880756 7.77565 1.15157 8.03671 1.15401 8.44903C1.15889 9.24927 1.15401 10.0495 1.15645 10.8498C1.16133 11.6402 1.67124 12.2746 2.44221 12.4527C2.59591 12.4893 2.75206 12.4844 2.9082 12.4868C5.74809 12.4868 8.58798 12.4868 11.4279 12.4868C11.484 12.4868 11.5425 12.499 11.6011 12.4673C11.606 12.3917 11.5377 12.3624 11.4962 12.3209C11.1083 11.9306 10.7179 11.5402 10.33 11.1523C10.1641 10.9864 10.108 10.7888 10.1738 10.5619C10.2397 10.3301 10.4056 10.2057 10.6301 10.1593C10.8131 10.1203 10.979 10.1764 11.1083 10.3057C11.8963 11.084 12.6819 11.8623 13.4626 12.6479C13.7286 12.9162 13.7115 13.2432 13.4456 13.5091C12.699 14.2557 11.9524 14.9998 11.2083 15.7488C11.0961 15.8635 10.9741 15.9538 10.8179 15.9977H10.6081V16.0001Z",
    fill: "#4B4E53"
  }), jsx("path", {
    d: "M0 2.77891C0.0390363 2.67644 0.0927112 2.58129 0.173224 2.50078C0.94419 1.72981 1.71272 0.958847 2.48612 0.19032C2.82281 -0.143928 3.34736 -0.0195 3.46691 0.419658C3.53034 0.646557 3.46203 0.841738 3.29613 1.0052C2.88625 1.41508 2.47636 1.82496 2.06648 2.23485C2.04209 2.25924 2.02013 2.28364 1.98841 2.32024C2.05916 2.36659 2.12748 2.34707 2.19091 2.34707C3.96462 2.34707 5.73834 2.34707 7.51205 2.34707C7.90485 2.34707 8.15127 2.60813 8.11711 2.98385C8.09515 3.23515 7.90485 3.44497 7.65843 3.48157C7.54376 3.49865 7.42665 3.50353 7.31199 3.50353C5.61879 3.50353 3.92803 3.50353 2.23483 3.50353C2.16895 3.50353 2.0982 3.49133 2.03233 3.5206C2.04209 3.60112 2.10552 3.63039 2.147 3.67431C2.53492 4.06467 2.92528 4.4526 3.31321 4.8454C3.47667 5.0113 3.53034 5.21136 3.46203 5.43582C3.39128 5.6676 3.22537 5.78959 2.99848 5.83106C2.78622 5.87254 2.61787 5.77983 2.47149 5.631C1.73955 4.89663 1.00518 4.16226 0.270814 3.43033C0.158585 3.3181 0.0487954 3.21075 0.00243977 3.05461V2.77647L0 2.77891Z",
    fill: "#4B4E53"
  }), jsx("path", {
    d: "M13.6456 6.19935C13.6456 6.72146 13.6456 7.13866 13.6456 7.55586C13.6456 7.92914 13.409 8.18044 13.0698 8.18044C12.7307 8.18044 12.4867 7.93158 12.4843 7.56074C12.4794 6.74829 12.4843 5.93829 12.4794 5.12585C12.4745 4.3378 11.9305 3.68151 11.1644 3.53024C11.0229 3.5034 10.8765 3.5034 10.7325 3.48144C10.4617 3.43753 10.2446 3.16427 10.2592 2.8959C10.2763 2.59581 10.513 2.35915 10.8082 2.34695C12.1866 2.29572 13.448 3.38385 13.6139 4.75744C13.6749 5.27223 13.6212 5.78703 13.6456 6.19691V6.19935Z",
    fill: "#4B4E53"
  })),
  cropImage: jsx("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M4.66667 1.99992C4.66667 1.63173 4.36819 1.33325 4 1.33325C3.63182 1.33325 3.33334 1.63173 3.33334 1.99992H4.66667ZM10 12.6666C10.3682 12.6666 10.6667 12.3681 10.6667 11.9999C10.6667 11.6317 10.3682 11.3333 10 11.3333V12.6666ZM14 12.6666C14.3682 12.6666 14.6667 12.3681 14.6667 11.9999C14.6667 11.6317 14.3682 11.3333 14 11.3333V12.6666ZM12 11.3333C11.6318 11.3333 11.3333 11.6317 11.3333 11.9999C11.3333 12.3681 11.6318 12.6666 12 12.6666V11.3333ZM11.3333 13.9999C11.3333 14.3681 11.6318 14.6666 12 14.6666C12.3682 14.6666 12.6667 14.3681 12.6667 13.9999H11.3333ZM6 3.33325C5.63182 3.33325 5.33334 3.63173 5.33334 3.99992C5.33334 4.36811 5.63182 4.66659 6 4.66659V3.33325ZM2 3.33325C1.63182 3.33325 1.33334 3.63173 1.33334 3.99992C1.33334 4.36811 1.63182 4.66659 2 4.66659V3.33325ZM4 4.66659C4.36819 4.66659 4.66667 4.36811 4.66667 3.99992C4.66667 3.63173 4.36819 3.33325 4 3.33325V4.66659ZM4.66667 9.86659V1.99992H3.33334V9.86659H4.66667ZM10 11.3333H6.13334V12.6666H10V11.3333ZM14 11.3333H12V12.6666H14V11.3333ZM3.33334 9.86659C3.33334 10.229 3.33282 10.5409 3.35372 10.7966C3.37525 11.0602 3.4228 11.3223 3.55132 11.5746L4.73933 10.9693C4.72254 10.9363 4.69742 10.8691 4.68262 10.6881C4.66719 10.4991 4.66667 10.251 4.66667 9.86659H3.33334ZM6.13334 11.3333C5.74897 11.3333 5.50078 11.3327 5.3119 11.3173C5.13078 11.3025 5.06364 11.2774 5.03068 11.2606L4.42536 12.4486C4.67761 12.5771 4.93976 12.6247 5.20332 12.6462C5.4591 12.6671 5.77097 12.6666 6.13334 12.6666V11.3333ZM3.55132 11.5746C3.74307 11.9509 4.04903 12.2569 4.42536 12.4486L5.03068 11.2606C4.90524 11.1967 4.80325 11.0947 4.73933 10.9693L3.55132 11.5746ZM11.3333 6.13325V13.9999H12.6667V6.13325H11.3333ZM6 4.66659H9.86667V3.33325H6V4.66659ZM2 4.66659H4V3.33325H2V4.66659ZM12.6667 6.13325C12.6667 5.77089 12.6672 5.45901 12.6463 5.20323C12.6247 4.93967 12.5772 4.67753 12.4487 4.42527L11.2607 5.03059C11.2775 5.06355 11.3026 5.1307 11.3174 5.31181C11.3328 5.5007 11.3333 5.74889 11.3333 6.13325H12.6667ZM9.86667 4.66659C10.2511 4.66659 10.4992 4.66711 10.6881 4.68254C10.8692 4.69733 10.9363 4.72245 10.9693 4.73925L11.5747 3.55124C11.3224 3.42271 11.0603 3.37517 10.7967 3.35363C10.5409 3.33273 10.2291 3.33325 9.86667 3.33325V4.66659ZM12.4487 4.42527C12.2569 4.04895 11.951 3.74299 11.5747 3.55124L10.9693 4.73925C11.0948 4.80317 11.1967 4.90515 11.2607 5.03059L12.4487 4.42527Z",
    fill: "#4B4E53"
  })),
  duplicateImage: jsx("svg", {
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("path", {
    d: "M11.0031 14.5H5.67458C5.59478 14.4912 5.51468 14.4842 5.43519 14.4736C4.09258 14.2954 3.0358 13.3247 2.74877 11.991C2.7163 11.8398 2.65168 11.7876 2.5118 11.7569C1.0445 11.4345 0.0180545 10.1858 0.00834527 8.68842C-0.00257758 7.00737 -0.00348782 5.32632 0.00986234 3.64526C0.0168408 2.76329 0.343616 2.00125 0.983514 1.38615C1.61097 0.782889 2.37102 0.503877 3.23453 0.502055C4.7431 0.498412 6.25137 0.500537 7.75993 0.501448C7.97657 0.501448 8.1929 0.505395 8.40984 0.519361C9.78309 0.608317 10.9831 1.64209 11.2504 2.98918C11.2835 3.15585 11.3557 3.21384 11.5138 3.2521C12.7122 3.54082 13.4932 4.28313 13.8688 5.45626C13.9556 5.72768 13.9723 6.00973 14.0002 6.28995V11.3796C13.9923 11.4794 13.9863 11.5796 13.9763 11.6795C13.8525 12.9452 12.9043 14.0564 11.6703 14.3865C11.4509 14.445 11.2264 14.4681 11.0028 14.4997L11.0031 14.5ZM1.02235 6.16092C1.02235 7.00403 1.02083 7.84683 1.02265 8.68994C1.02538 9.85851 1.98569 10.8209 3.15413 10.8228C4.82897 10.8252 6.5038 10.8252 8.17834 10.8221C8.62891 10.8212 9.04489 10.6928 9.41111 10.4266C10.017 9.98602 10.3195 9.38094 10.3232 8.63742C10.3307 7.03743 10.3256 5.43713 10.3256 3.83714C10.3256 3.70082 10.3189 3.56572 10.3031 3.4297C10.1754 2.33005 9.26971 1.51548 8.16378 1.51488C6.50411 1.51366 4.84444 1.51397 3.18477 1.51488C1.97598 1.51548 1.02417 2.46789 1.02235 3.67775C1.02114 4.50568 1.02235 5.3333 1.02235 6.16122V6.16092ZM8.33035 13.4893C9.15775 13.4893 9.98486 13.4899 10.8123 13.4893C12.0132 13.4881 12.9801 12.5469 12.9871 11.3489C12.9965 9.67301 12.9944 7.99712 12.9877 6.32122C12.9841 5.42438 12.4307 4.64412 11.5954 4.32351C11.3429 4.22666 11.3347 4.23274 11.3329 4.49839C11.3238 5.92684 11.3581 7.3553 11.3159 8.78345C11.2835 9.87855 10.7804 10.7192 9.88109 11.3261C9.34193 11.6901 8.73419 11.8356 8.08944 11.8365C6.71225 11.8383 5.33506 11.8371 3.95787 11.8374C3.747 11.8374 3.73971 11.8486 3.80859 12.0517C4.09258 12.89 4.91665 13.486 5.80322 13.489C6.6458 13.4917 7.48808 13.4896 8.33065 13.4896L8.33035 13.4893Z",
    fill: "#4B4E53"
  }), jsx("path", {
    d: "M7.01724 6.6649C6.79029 6.6649 6.56303 6.66976 6.33638 6.66308C6.21168 6.65944 6.16677 6.70559 6.16829 6.83067C6.17315 7.26483 6.17102 7.69868 6.16981 8.13283C6.1689 8.44372 5.98382 8.65624 5.69922 8.6781C5.42736 8.69905 5.18675 8.49624 5.17189 8.19021C5.15125 7.76729 5.16187 7.34255 5.15975 6.91872C5.15894 6.74951 5.07601 6.6648 4.91095 6.6646C4.50225 6.6646 4.09386 6.66551 3.68516 6.66399C3.38569 6.66278 3.1639 6.45542 3.15814 6.17459C3.15237 5.89102 3.37932 5.67364 3.68638 5.67242C4.05472 5.67091 4.42276 5.67364 4.7911 5.67151C5.19464 5.66909 5.15793 5.72616 5.15914 5.29535C5.16005 4.9623 5.15945 4.62894 5.15914 4.29589C5.15914 4.19448 5.1646 4.09308 5.19646 3.99684C5.26989 3.77369 5.50109 3.6313 5.72925 3.66378C5.98291 3.69961 6.16495 3.89149 6.16769 4.14408C6.17284 4.58826 6.1692 5.03243 6.17011 5.4766C6.17042 5.66787 6.17406 5.67151 6.36703 5.67151C6.79575 5.67212 7.22447 5.6706 7.65319 5.67212C7.96753 5.67303 8.17415 5.87554 8.17142 6.1758C8.16869 6.46604 7.96116 6.66187 7.65259 6.66399C7.44081 6.66521 7.22902 6.66399 7.01694 6.6643L7.01724 6.6649Z",
    fill: "#4B4E53"
  }))
};

var useSvg = function (props) {
  var width = props.width,
      height = props.height,
      fill = props.fill,
      stroke = props.stroke,
      svg = props.svg,
      rest = __rest(props, ["width", "height", "fill", "stroke", "svg"]);

  var svgElement = SVGs[svg];
  var cursor = rest.onClick ? 'pointer' : 'inherit';
  var style = {
    width: width,
    height: height,
    fill: fill,
    stroke: stroke,
    cursor: cursor
  };
  return __assign(__assign({}, svgElement), {
    props: __assign(__assign(__assign({}, svgElement.props), rest), {
      style: style
    })
  });
};

var Icon = function (props) {
  var svg = useSvg(props);
  return svg;
};

var PanelElement = function (props) {
  var isPreviewMode = props.isPreviewMode,
      panelOptions = props.panelOptions;

  var _a = __read(useState(-1), 2),
      sidebarHoverIndex = _a[0],
      setSidebarHoverIndex = _a[1];

  var tooltipVariants = {
    hoverOn: {
      opacity: 1
    },
    hoverOff: {
      opacity: 0
    }
  };
  return jsx(Div, null, jsx(AnimatePresence, null, !isPreviewMode && jsx(Flex, {
    flexDirection: "row",
    alignItems: "center",
    columnGap: "x2"
  }, panelOptions.map(function (option, index) {
    return jsx(Div, {
      exit: {
        opacity: 0,
        x: -70
      },
      initial: {
        opacity: 0,
        x: -70
      },
      animate: {
        opacity: 1,
        x: 0
      },
      transition: {
        duration: 0.3
      },
      "data-feature": option.dataFeature
    }, jsx(Flex, {
      key: index,
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      onHoverStart: function () {
        setSidebarHoverIndex(index + 1);
      },
      onHoverEnd: function () {
        return setSidebarHoverIndex(-1);
      }
    }, jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      onClick: option.onClick,
      cursor: "pointer"
    }, jsx(Icon, {
      svg: option.icon,
      width: "56px",
      height: "38px"
    }), jsx(Text, {
      type: "body",
      content: option.title,
      style: {
        fontSize: '14px',
        color: option.isActive ? 'pink' : 'black'
      }
    })), sidebarHoverIndex === index + 1 && jsx(Flex, {
      position: "absolute",
      left: "75px",
      variants: tooltipVariants,
      animate: sidebarHoverIndex ? 'hoverOn' : 'hoverOff',
      initial: 'hoverOff',
      transition: {
        ease: 'easeIn',
        duration: 0.2
      }
    }, jsx(Tooltip, {
      direction: "left",
      title: "Add " + option.title,
      background: "dark"
    }))), jsx(Spacer, {
      space: 'x4'
    }));
  }))));
};

var MobileNavigation = function (props) {
  var isPreviewMode = props.isPreviewMode;

  var _a = useReduxState('editorChrome'),
      isElementInsertOpen = _a.isElementInsertOpen,
      elementInsertDrawerType = _a.elementInsertDrawerType;

  var actions = useReduxActions();
  var panelOptions = [{
    title: 'Image',
    icon: 'images',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'images' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('images');
      actions.toggleMobileNavigation(false);
      actions.toggleDrawerState('expanded');
    },
    isActive: elementInsertDrawerType === 'images' && isElementInsertOpen
  }, {
    title: 'Text',
    icon: 'text',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(false);
      actions.addTextElement();
      actions.openElementSettingsDrawer('text');
      actions.toggleMobileNavigation(false);
    }
  }, {
    title: 'Stickers',
    icon: 'stickers',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'stickers' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('stickers');
      actions.toggleMobileNavigation(false);
      actions.toggleDrawerState('expanded');
    },
    isActive: elementInsertDrawerType === 'stickers' && isElementInsertOpen,
    dataFeature: 'stickers'
  }, {
    title: 'Template',
    icon: 'layout',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'layouts' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('layouts');
      actions.toggleMobileNavigation(false);
      actions.toggleDrawerState('minified');
    },
    isActive: elementInsertDrawerType === 'layouts' && isElementInsertOpen
  }];
  return jsx(PanelElement, {
    panelOptions: panelOptions,
    isPreviewMode: isPreviewMode
  });
};

var MobileSettings = function (props) {
  var _a;

  var sections = props.sections,
      startingActiveKey = props.startingActiveKey;
  var initialActiveKey = (_a = sections.find(function (section) {
    return section.key === startingActiveKey;
  })) === null || _a === void 0 ? void 0 : _a.key;

  var _b = __read(useState(initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : 'NONE'), 2),
      activeKey = _b[0],
      setActiveKey = _b[1];

  var activeImageSetting = useReduxState('editorChrome').activeImageSetting;
  useEffect(function () {
    var _a;

    setActiveKey((_a = initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : activeImageSetting) !== null && _a !== void 0 ? _a : 'NONE');
  }, [activeImageSetting, initialActiveKey]);

  var onSettingSectionChange = function (section) {
    if (section.onClick) section.onClick();
    setActiveKey(activeKey === section.key ? 'NONE' : section.key);
  };

  return jsx(Flex, {
    flexDirection: "column"
  }, jsx(Flex, {
    flexDirection: "row"
  }, sections.map(function (section) {
    return jsx(React.Fragment, null, section.title && jsx(Div, {
      key: section.key,
      width: "100%"
    }, jsx(Div, {
      onClick: function () {
        return onSettingSectionChange(section);
      },
      style: {
        cursor: 'pointer',
        background: section.key === activeKey ? '#f0f0f0' : 'transparent',
        padding: '10px',
        borderRadius: '5px',
        marginBottom: '5px'
      }
    }, jsx(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }, section.icon && jsx(Icon$1, {
      name: section.icon,
      size: "medium",
      primaryColor: section.key === activeKey ? 'primaryBrand' : 'default'
    }), jsx(Text, {
      type: "footnote",
      weight: section.key === activeKey ? 'semiBold' : 'regular',
      whiteSpace: "nowrap"
    }, section.title)))));
  })), sections.map(function (section) {
    return section.key === activeKey && jsx(Div, {
      key: section.key + "-settings",
      width: "100%"
    }, section.settings);
  }));
};

var MinifiedColorPicker = function (props) {
  var _a;

  var colors = props.colors,
      setColor = props.setColor,
      onColorChange = props.onColorChange,
      onOpen = props.onOpen;

  var _b = __read(useState(null), 2),
      selectedColor = _b[0],
      setSelectedColor = _b[1];

  return jsx(Flex, null, jsx(Flex, {
    alignItems: "center"
  }, jsx(Div, {
    whileHover: {
      scale: 1.2
    },
    cursor: "pointer",
    boxShadow: "mediumDark",
    borderRadius: "circle",
    width: "24px",
    height: "24px",
    onClick: onOpen,
    outset: {
      horizontal: 'x_5'
    },
    style: {
      backgroundImage: 'conic-gradient(red, orange, yellow, green, blue, indigo, violet, red)'
    }
  }), jsx(Text, {
    type: "body",
    content: "|",
    style: {
      fontSize: '1.75rem',
      color: '#B6B4B4'
    }
  }), (_a = colors === null || colors === void 0 ? void 0 : colors.palette) === null || _a === void 0 ? void 0 : _a.map(function (color, index) {
    var cardColor = Color(color).hex();
    var isSelected = cardColor === selectedColor;
    return jsx(Div, {
      whileHover: {
        scale: 1.2
      },
      inset: 'x_5',
      borderRadius: "circle",
      backgroundColor: "trasparent",
      outset: {
        horizontal: 'x_5'
      },
      style: {
        border: isSelected ? '1.5px solid black' : '1px solid #DEDEDE'
      }
    }, jsx(Div, {
      key: index,
      cursor: "pointer",
      boxShadow: "mediumDark",
      borderRadius: "circle",
      backgroundColor: cardColor,
      width: "24px",
      height: "24px",
      onClick: function () {
        setColor(cardColor);
        onColorChange(color);
        setSelectedColor(cardColor);
      }
    }));
  })));
};

var MobileColorPicker = function (props) {
  var _a;

  var defaultColor = props.defaultColor,
      onColorChange = props.onColorChange,
      isChangingBackground = props.isChangingBackground;

  var _b = __read(useState(false), 2),
      showColorPicker = _b[0],
      setShowColorPicker = _b[1];

  var strDefaultColor = defaultColor ? Color(defaultColor).hex() : '';
  var colorPalettes = useContext(EditorChromeContext).colorPalettes;

  var rgbToHex = function (r, g, b) {
    return '#' + [r, g, b].map(function (x) {
      return x.toString(16).padStart(2, '0');
    }).join('');
  };

  var convertedDefaultColor = defaultColor ? rgbToHex(defaultColor.r, defaultColor.g, defaultColor.b) : '#fff';

  var _c = __read(useState(convertedDefaultColor), 2),
      color = _c[0],
      setColor = _c[1];

  var colorPickerRef = useRef(null);
  useOutsideClick(colorPickerRef, !showColorPicker || !isChangingBackground, function () {
    return setShowColorPicker(false);
  });
  useEffect(function () {
    try {
      if (convertedDefaultColor !== Color(color).hex().toLowerCase()) {
        setColor(strDefaultColor);
      }
    } catch (_a) {}
  }, [convertedDefaultColor]); //eslint-disable-line

  return jsx(Div, {
    ref: colorPickerRef,
    width: "100%"
  }, showColorPicker && jsx(QuantumColorPicker, {
    color: color,
    onChange: function (color) {
      return setColor(color);
    },
    convertedColorType: "rgb",
    convertedColorCallback: function (color) {
      return onColorChange(color);
    },
    palette: {
      title: 'Card Colors',
      isLoading: colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.isLoading,
      colors: (_a = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.palette) === null || _a === void 0 ? void 0 : _a.map(function (palette) {
        return Color(palette).hex();
      })
    }
  }), !showColorPicker && jsx(MinifiedColorPicker, {
    onOpen: function () {
      return setShowColorPicker(!showColorPicker);
    },
    colors: colorPalettes,
    setColor: function (color) {
      return setColor(color);
    },
    onColorChange: function (color) {
      return onColorChange(color);
    }
  }));
};

var MobileTextSettings = function () {
  var actions = useReduxActions();
  var editor = useReduxState('editor');
  var activeTextSetting = useReduxState('editorChrome').activeTextSetting; // const activeElement = editor.activeElement

  var selectedElement$1 = selectedElement(editor);
  var textState$1 = textState(editor);
  var color = selectedColor(textState$1);
  var fontSize = selectedFontSize(textState$1);
  var text = selectedText(textState$1);

  var setActiveTextSetting = function (setting) {
    if (activeTextSetting !== setting) {
      actions.setActiveTextSetting(setting);
      actions.toggleDrawerState('expanded');
    }
  };

  return selectedElement$1 ? jsx(Flex, null, jsx(MobileSettings, {
    sections: [{
      title: 'Font Family',
      onClick: function () {
        setActiveTextSetting('family');
      },
      icon: 'aText',
      settings: jsx(FontFamilySettings, null),
      key: 'family'
    }, {
      title: 'Settings',
      onClick: function () {
        setActiveTextSetting('alignment');
      },
      icon: 'fontSize',
      key: 'font_size',
      settings: jsx(VStack, {
        gap: "x2"
      }, jsx(Div, null, jsx(ElementIncrementSetting, {
        initial: fontSize ? fontSize / 100 : DEFAULT_FONT_SIZE / 100,
        title: "Size:",
        min: 8,
        max: 80,
        callback: function (value) {
          actions.selectFontSize(value * 100);
        },
        resetDependency: fontSize
      })), jsx(AlignmentSettings, null), jsx(CasingSettings, {
        originalText: text !== null && text !== void 0 ? text : '',
        onTextCasingUpdate: actions.updateTextCasing
      }))
    }, {
      title: 'Color',
      onClick: function () {
        setActiveTextSetting('casing');
      },
      icon: 'colorPalette',
      key: 'color',
      settings: jsx(Div, {
        outset: {
          vertical: 'x3'
        }
      }, jsx(MobileColorPicker, {
        defaultColor: color || {
          r: 51,
          b: 51,
          g: 51
        },
        onColorChange: function (color) {
          return actions.selectColor(color);
        }
      }))
    }, {
      title: 'Insert',
      onClick: function () {
        setActiveTextSetting('casing');
      },
      icon: 'signature',
      key: 'insert',
      settings: jsx(InsertSettings, {
        onInsertPlaceholder: actions.insertPlaceholder,
        onInsertSignature: actions.insertSignature
      })
    }]
  })) : jsx("div", null, "There is no current text element selected");
};

var MobilePanelSettings = function (props) {
  var _a;

  var images = props.images,
      onUploadImages = props.onUploadImages;
  var editor = useReduxState('editor');
  var isPanelBackgroundImage = editor.activeElement.type === 'image' && editor.editing === 'element';
  var selectedPanel$1 = selectedPanel(editor);
  var actions = useReduxActions();
  return jsx(Flex, null, jsx(MobileSettings, {
    startingActiveKey: "background_settings",
    sections: [{
      key: 'background_settings',
      settings: jsx(Div, null, jsx(MobileColorPicker, {
        defaultColor: (_a = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor) !== null && _a !== void 0 ? _a : undefined,
        onColorChange: function (color) {
          return actions.setPanelBackground(color);
        },
        isChangingBackground: true
      }), jsx(Spacer, {
        space: "x4"
      }), jsx(BackgroundImageUploader, {
        images: images,
        onUploadImages: onUploadImages
      }))
    }]
  }), isPanelBackgroundImage && jsx(React.Fragment, null));
};

var styles$5 = {
  layoutList: function (isMinified) {
    return /*#__PURE__*/css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    display: flex;\n    justify-content: ", ";\n    overflow-y: ", ";\n    overflow-x: ", ";\n    max-height: ", ";\n    /* Custom scrollbar styles */\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n    }\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 10px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #afafaf;\n      border-radius: 10px;\n      border: 2px solid transparent;\n      background-clip: padding-box;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: #555;\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n    display: flex;\n    justify-content: ", ";\n    overflow-y: ", ";\n    overflow-x: ", ";\n    max-height: ", ";\n    /* Custom scrollbar styles */\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n    }\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 10px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #afafaf;\n      border-radius: 10px;\n      border: 2px solid transparent;\n      background-clip: padding-box;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: #555;\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), isMinified ? 'flex-start' : 'center', isMinified ? 'hidden' : 'auto', isMinified ? 'auto' : 'hidden', isMinified ? 'none' : '600px');
  }
};
var templateObject_1$6;

var MobileLayouts = function (props) {
  var layouts = props.layouts,
      title = props.title,
      canDelete = props.canDelete,
      onDelete = props.onDelete,
      isOnBackPanel = props.isOnBackPanel,
      onSetDefaultBackPanel = props.onSetDefaultBackPanel,
      defaultBackPanelId = props.defaultBackPanelId,
      onSelectBackLayout = props.onSelectBackLayout;
  var card = useReduxState('editor').card;
  var drawerState = useReduxState('mobileChrome').drawerState;
  var isMinified = drawerState === 'minified';
  var actions = useReduxActions();

  var _a = __read(useState(), 2),
      isHoveringId = _a[0],
      setIsHoveringId = _a[1];

  var orientation = card === null || card === void 0 ? void 0 : card.orientation;
  var isHorizontal = orientation === 'LANDSCAPE';

  var handleLayout = function (layout) {
    if (isOnBackPanel) {
      onSelectBackLayout === null || onSelectBackLayout === void 0 ? void 0 : onSelectBackLayout(layout.id.toString());
      actions.selectBackPanel(layout);
    } else {
      actions.selectLayout(layout);
    }
  }; // AspectRatio is defined by layout image sizes stored in our servers


  var getAspectRatio = function () {
    if ((card === null || card === void 0 ? void 0 : card.type) === 'POSTCARD') {
      return '735/850';
    } else if (orientation === 'LANDSCAPE') {
      return '14/10';
    } else {
      return '10/14';
    }
  };

  return jsx(Flex, {
    position: "relative",
    inset: 'x1',
    flexDirection: 'column',
    height: "100%",
    width: "100%"
  }, jsx(Flex, {
    justifyContent: "space-between"
  }, jsx(Flex, {
    flexDirection: "row",
    columnGap: "x_5",
    justifyContent: "flex-start",
    alignItems: "center"
  }, jsx(Icon, {
    svg: "layout",
    width: "18px",
    height: "18px"
  }), jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title)), jsx(Div, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    inset: {
      horizontal: 'x1_5'
    },
    onClick: function () {
      return actions.toggleDrawerState(isMinified ? 'expanded' : 'minified');
    },
    style: {
      borderRadius: '8px',
      backgroundColor: '#fff',
      color: '#000',
      fontSize: '12px',
      boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
      cursor: 'pointer'
    }
  }, isMinified ? 'Expand' : 'Close')), jsx(Flex, {
    css: styles$5.layoutList(isMinified)
  }, jsx(Div, {
    display: isMinified ? 'flex' : 'grid',
    height: "100%",
    width: "100%",
    style: isMinified ? {
      minWidth: (isHorizontal ? layouts.length * 170 : layouts.length * 110) + "px",
      columnGap: '16px',
      padding: '16px 16px'
    } : {
      gridTemplateColumns: "repeat(" + (orientation === 'LANDSCAPE' ? 2 : 3) + ", minmax(100px, 1fr))",
      gridAutoRows: '1fr',
      columnGap: '16px',
      rowGap: '16px',
      padding: '16px 16px'
    }
  }, layouts.map(function (layout) {
    var id = typeof layout.id === 'number' ? layout.id.toString() : layout.id;
    var isHorizontal = orientation === 'LANDSCAPE';
    var isDefaultBackPanel = id === defaultBackPanelId;
    var isDefaultSocBackPanel = layout.id.toString() === DEFAULT_BACK_PANEL_ID;
    return jsx(Div, {
      key: id,
      inset: "x1",
      display: "grid",
      width: '100%',
      height: '100%',
      style: {
        aspectRatio: getAspectRatio(),
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        borderRadius: isHorizontal ? '10px' : '16px'
      }
    }, jsx(Div, _extends({}, isDefaultBackPanel ? defaultBackPanelBorderStyles : {}, {
      position: "relative",
      width: "100%",
      height: "100%",
      onHoverStart: function () {
        return setIsHoveringId(id);
      },
      onHoverEnd: function () {
        return setIsHoveringId(undefined);
      }
    }), canDelete && !isDefaultSocBackPanel && jsx(Div, {
      width: "100%",
      height: "100%",
      alignItems: "center",
      position: "absolute",
      zIndex: 1,
      backgroundColor: "#343434b8",
      display: "flex",
      justifyContent: "center",
      borderRadius: "small"
    }, jsx(Span, {
      cursor: "pointer"
    }, jsx(Icon$1, {
      size: "medium",
      name: "delete",
      primaryColor: "danger",
      onClick: function () {
        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(id);
      }
    }))), isDefaultBackPanel && jsx(Div, {
      display: "flex",
      justifyContent: "center",
      onClick: function () {
        handleLayout(layout);
      }
    }, jsx(Div, isDefaultBackPanel ? defaultBackPanelLabelStyles : {}, jsx(Text, {
      alignment: "center",
      type: "caption",
      color: "inverseBody"
    }, "Default"))), jsx(Image$1, {
      image: layout.thumbnail,
      onClick: function () {
        if (canDelete) {
          return;
        }

        handleLayout(layout);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    }), id === isHoveringId && isOnBackPanel && onSetDefaultBackPanel && id !== defaultBackPanelId && !canDelete && jsx(Div, {
      bottom: "30px",
      zIndex: 2,
      position: "relative",
      display: "flex",
      justifyContent: "center"
    }, jsx(Button, {
      size: "xSmall",
      title: "set as default",
      onClick: function () {
        return onSetDefaultBackPanel(layout.id.toString());
      }
    }))));
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1yb0euq",
  styles: "z-index:8"
} : {
  name: "teyxs0-MobileChrome",
  styles: "z-index:8;label:MobileChrome;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var MobileChrome = function (props) {
  var children = props.children,
      layouts = props.layouts,
      images = props.images,
      stickers = props.stickers,
      onUploadImages = props.onUploadImages,
      //  helpIcon,
  contextZones = props.contextZones,
      handleNextPanel = props.handleNextPanel,
      handlePreviousPanel = props.handlePreviousPanel,
      handleChangeView = props.handleChangeView,
      customBackPanels = props.customBackPanels,
      //   onSaveBackPanel,
  //  onCreateBackPanel,
  defaultBackPanels = props.defaultBackPanels,
      onDeleteBackPanel = props.onDeleteBackPanel,
      onSelectBackLayout = props.onSelectBackLayout,
      onDeleteImage = props.onDeleteImage,
      onSetDefaultBackPanel = props.onSetDefaultBackPanel,
      defaultBackPanelId = props.defaultBackPanelId;

  var _a = __read(useState(1000), 2),
      setIsMinified = _a[1];

  var _b = useReduxState('editor'),
      // editing,
  card = _b.card,
      fullBleedLocation = _b.fullBleedLocation;

  var _c = useReduxState('mobileChrome'),
      shouldShowMobileNavigation = _c.shouldShowMobileNavigation,
      drawerState = _c.drawerState;

  var _d = useReduxState('editorChrome'),
      // isElementInsertOpen,
  // isElementSettingsOpen,
  elementInsertDrawerType = _d.elementInsertDrawerType,
      elementSettingsDrawerType = _d.elementSettingsDrawerType,
      interactionMode = _d.interactionMode;

  var isPreviewMode = interactionMode === 'preview'; // const editor = useReduxState('editor')
  // const selectedPanel = getSelectedPanel(editor)
  // const actions = useReduxActions()
  // const renderSettingsDrawerContent = (settingType: SettingsDrawer) => {
  //   switch (settingType) {
  //     case 'image':
  //       return <ImageElementSettings />
  //     case 'text':
  //       return <TextSettings />
  //     case 'panel':
  //       return <PanelSettings images={images} onUploadImages={onUploadImages} />
  //     case 'fullbleed':
  //       return <FullBleedSettings />
  //     default:
  //       return <></>
  //   }
  // }
  // Adjust for Duvet offset?

  var bottomBarHeight = 0;
  var isOnBackPanel = (card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation].name.toLowerCase()) === 'back';

  var _e = __read(layouts, 1),
      layout = _e[0];

  var renderElementInsertDrawerContent = function (insertType) {
    switch (insertType) {
      case 'images':
        return jsx(Images, {
          images: images,
          onUploadImages: onUploadImages,
          loaderComponent: jsx(LoadingSpinner, {
            size: "medium"
          }),
          onDelete: onDeleteImage
        });

      case 'layouts':
        return isOnBackPanel ? jsx(BackPanels, {
          onSetDefaultBackPanel: onSetDefaultBackPanel,
          defaultBackPanelId: defaultBackPanelId,
          defaultBackPanels: defaultBackPanels,
          customBackPanels: customBackPanels,
          onDelete: onDeleteBackPanel,
          onSelectBackLayout: onSelectBackLayout
        }) : jsx(MobileLayouts, {
          title: "Layouts",
          layouts: [layout, layout, layout, layout, layout, layout, layout, layout, layout]
        });

      case 'clientNav':
        return (contextZones === null || contextZones === void 0 ? void 0 : contextZones.clientNavigation) && jsx(ClientNavigation, {
          clientNav: contextZones.clientNavigation
        });

      case 'stickers':
        return jsx(Stickers, {
          stickers: stickers
        });

      default:
        return jsx(React.Fragment, null);
    }
  };

  var renderSettingsDrawerContent = function (settingType) {
    switch (settingType) {
      case 'image':
        return jsx(ImageElementSettings, null);

      case 'text':
        return jsx(MobileTextSettings, null);

      case 'panel':
        return jsx(MobilePanelSettings, {
          images: images,
          onUploadImages: onUploadImages
        });

      case 'fullbleed':
        return jsx(FullBleedSettings, null);

      default:
        return jsx(React.Fragment, null);
    }
  };

  var getDrawerStatuse = function (status) {
    switch (status) {
      case 'minified':
        return 320;

      case 'expanded':
        return window.innerHeight - 130;

      default:
        return 0;
    }
  };

  return jsx("div", null, jsx(MobileChromeContent, {
    onNextPanel: handleNextPanel,
    onPreviousPanel: handlePreviousPanel,
    onChangeView: handleChangeView,
    height: "calc(100vh - " + bottomBarHeight + "px)"
  }, children), jsx(Duvet, {
    onClose: function () {
      return setIsMinified(300);
    },
    openValue: getDrawerStatuse(drawerState),
    isOpen: true,
    css: _ref
  }, jsx(Flex, {
    inset: '36px 16px 16px 16px',
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    alignItems: "center"
  }, shouldShowMobileNavigation && jsx(MobileNavigation, {
    isPreviewMode: isPreviewMode
  }), renderSettingsDrawerContent(elementSettingsDrawerType), renderElementInsertDrawerContent(elementInsertDrawerType))));
};

var EditorChrome = function (props) {
  var size = useWindowSize();
  return jsx(QuantumThemeWrapper, {
    theme: props.theme
  }, jsx(EditorChromeProvider, {
    value: {
      layouts: props.layouts,
      images: props.images,
      fonts: props.fonts,
      signatures: props.signatures,
      placeholders: props.placeholders,
      defaultBackPanels: props.defaultBackPanels,
      customBackPanels: props.customBackPanels,
      colorPalettes: props.colorPalettes,
      stickers: props.stickers
    }
  }, size.width <= 960 ? jsx(MobileChrome, props) : jsx(DesktopChrome, props)));
};

var EditorContext = /*#__PURE__*/createContext({
  panelView: 'fullbleed',
  currentIndex: 0,
  editorId: 0
});
var EditorProvider = EditorContext.Provider;
EditorContext.Consumer;

var imageIsCached = function (src) {
  var mutableImage = new Image();
  mutableImage.src = src;
  return mutableImage.complete;
};

var IndicatorModeControl = function (_a) {
  var onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementReplace = _a.onActiveElementReplace,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage;

  var _b = __read(useState(-1), 2),
      activeIndicatorTooltip = _b[0],
      setActiveIndicatorTooltip = _b[1];

  var actions = useReduxActions();

  var _c = useReduxState('editorChrome'),
      activeImageSetting = _c.activeImageSetting,
      isTextCursorActive = _c.isTextCursorActive;

  useEffect(function () {
    setActiveIndicatorTooltip(-1);
  }, [shouldReplaceSelectedImage]);
  return jsx(Flex, {
    width: '100%',
    position: 'absolute',
    bottom: '-32px',
    zIndex: 10,
    justifyContent: "center"
  }, jsx(Flex, {
    width: "fit-content",
    position: "absolute",
    borderRadius: "circle",
    backgroundColor: "foreground",
    inset: "x1",
    boxShadow: "mediumLight"
  }, jsx(HStack, {
    gap: 'x3',
    justify: 'center',
    shouldWrap: false
  }, jsx(Span, {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(1);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'delete',
    size: 'xSmall',
    isActive: false,
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementDelete();
    }
  })), elementType === 'text' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'textBox',
    size: 'xSmall',
    isActive: isTextCursorActive,
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setIsTextCursorActive(true);
    }
  })), elementType === 'image' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'replaceImage',
    size: 'xSmall',
    isActive: shouldReplaceSelectedImage,
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementReplace(true);
      actions.setActiveImageSetting(null);
    }
  })), elementType === 'image' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(3);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'crop',
    size: 'xSmall',
    isActive: activeImageSetting === 'crop',
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setActiveImageSetting('crop');
      actions.setShouldReplaceSelectedImage(false);
    }
  })), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(elementType === 'text' ? 3 : 4);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'drag',
    size: 'xSmall',
    hasBackgroundColor: false,
    isActive: activeImageSetting === null && !isTextCursorActive && !shouldReplaceSelectedImage,
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setIsTextCursorActive(false);
      onActiveElementDrag();
      actions.setShouldReplaceSelectedImage(false);
    }
  }))), activeIndicatorTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    bottom: "-44px",
    left: activeIndicatorTooltip === 1 ? '-8px' : activeIndicatorTooltip === 2 ? '28px' : undefined,
    right: activeIndicatorTooltip === 4 ? '-4px' : activeIndicatorTooltip === 3 ? '36px' : undefined,
    animate: activeIndicatorTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "top",
    title: activeIndicatorTooltip === 1 ? 'Delete' : activeIndicatorTooltip === 2 ? elementType === 'text' ? 'Edit Text' : 'Replace' : activeIndicatorTooltip === 3 ? elementType === 'text' ? 'Move' : 'Crop' : activeIndicatorTooltip === 4 && elementType === 'image' ? 'Move' : ''
  }))));
};

var MoveableWrapper = function (_a) {
  var parentHeight = _a.parentHeight,
      parentWidth = _a.parentWidth,
      parentId = _a.parentId,
      children = _a.children,
      position = _a.position,
      rotation = _a.rotation,
      size = _a.size,
      isSelected = _a.isSelected,
      isEditable = _a.isEditable,
      isPhotoDropTemplate = _a.isPhotoDropTemplate,
      isFullPanelElement = _a.isFullPanelElement,
      onUpdatePosition = _a.onUpdatePosition,
      onUpdateRotation = _a.onUpdateRotation,
      onUpdateSize = _a.onUpdateSize,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementReplace = _a.onActiveElementReplace,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage,
      elementLocation = _a.elementLocation,
      isPreviewMode = _a.isPreviewMode,
      isDraggable = _a.isDraggable;

  var getParent = function () {
    return parentWidth && parentHeight ? {
      width: parentWidth,
      height: parentHeight
    } : {
      width: 0,
      height: 0
    };
  };

  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;

  var xToPixels = function (x) {
    return getParent().width * x;
  };

  var yToPixels = function (y) {
    return getParent().height * y;
  };

  var widthToPixels = function (widthPct) {
    return getParent().width * widthPct;
  };

  var heightToPixels = function (heighPct) {
    return getParent().height * heighPct;
  };

  var widthToPercent = function (width) {
    return width / getParent().width;
  };

  var heightToPercent = function (height) {
    return height / getParent().height;
  };

  var xToPercentage = function (x) {
    var fixedX = parseInt(x.toFixed(8));
    var fixedParentWidth = parseInt(getParent().width.toFixed(8));
    var xWithoutNegatives = fixedX < 0 ? 0 : fixedX;
    var xPercentage = xWithoutNegatives / fixedParentWidth;
    return xPercentage;
  };

  var yToPercentage = function (y) {
    var fixedY = parseInt(y.toFixed(8));
    var fixedParentHeight = parseInt(getParent().height.toFixed(8));
    var yWithoutNegatives = fixedY < 0 ? 0 : fixedY;
    var yPercentage = yWithoutNegatives / fixedParentHeight;
    return yPercentage;
  };

  var _b = __read(useState(null), 2),
      target = _b[0],
      setTarget = _b[1];

  var moveableRef = React.useRef(null); // TODO Update rect when window resizes

  var _c = __read(React.useState({
    translate: [0, 0],
    rotate: rotation
  }), 2),
      frame = _c[0],
      setFrame = _c[1];

  useEffect(function () {
    setTarget(document.querySelector(".target-" + parentId + " "));
  }, [parentId]);
  var height = heightToPixels(size.height);
  var width = widthToPixels(size.width);
  var x = xToPixels(position.x) - frame.translate[0];
  var y = yToPixels(position.y) - frame.translate[1];
  useEffect(function () {
    var _a, _b; // Updates the moveable instance when a position change happens
    // Bugs still occuring with the sliders, state gets out of sync


    (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
    (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
  }, [position.x, position.y]);
  useEffect(function () {
    var _a, _b;

    if (target && elementType === 'text') {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        moveableTarget.style.height = height + "px";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [height]); //eslint-disable-line

  useEffect(function () {
    var _a, _b;

    if (target) {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        moveableTarget.style.height = height + "px";
        moveableTarget.style.width = width + "px";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [height, width]); //eslint-disable-line

  useEffect(function () {
    var _a, _b;

    if (target) {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        setFrame(__assign(__assign({}, frame), {
          rotate: rotation
        }));
        moveableTarget.style.transform = "translate(" + frame.translate[0] + "px, " + frame.translate[1] + "px) rotate(" + rotation + "deg)";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [rotation]); //eslint-disable-line

  return jsx(React.Fragment, null, target && isSelected && isEditable && !isPreviewMode && jsx(Moveable, {
    ref: moveableRef,
    snappable: true,
    draggable: (!isTextCursorActive || !isFullPanelElement) && !shouldReplaceSelectedImage,
    resizable: !isFullPanelElement && !shouldReplaceSelectedImage,
    rotatable: size.width > 0.98 || size.height > 0.98 || shouldReplaceSelectedImage ? false : true ,
    origin: false,
    keepRatio: false // Keep ratio for images?
    ,
    throttleResize: 1,
    edge: false,
    bounds: {
      left: 0,
      top: 0,
      right: parentWidth,
      bottom: parentHeight
    },
    target: target,
    zoom: 1,
    onDragStart: function (_a) {
      var set = _a.set;
      set(frame.translate);
    },
    onDrag: function (_a) {
      var beforeTranslate = _a.beforeTranslate,
          target = _a.target;
      frame.translate = beforeTranslate;
      target.style.transform = "translate(" + beforeTranslate[0] + "px, " + beforeTranslate[1] + "px) rotate(" + frame.rotate + "deg)";
    },
    onDragEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
    },
    onResizeStart: function (_a) {
      var setOrigin = _a.setOrigin,
          dragStart = _a.dragStart;
      setOrigin(['%', '%']);
      dragStart && dragStart.set(frame.translate);
    },
    onResize: function (_a) {
      var target = _a.target,
          drag = _a.drag,
          width = _a.width,
          height = _a.height;
      frame.translate = drag.beforeTranslate;
      target.style.width = width + "px";
      target.style.height = height + "px";
      target.style.transform = "translate(" + drag.beforeTranslate[0] + "px, " + drag.beforeTranslate[1] + "px) rotate(" + frame.rotate + "deg)";
    },
    onResizeEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      var width = currentTarget.state.width;
      var height = currentTarget.state.height;
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
      onUpdateSize(widthToPercent(width), heightToPercent(height));
    },
    throttleRotate: 0,
    rotationPosition: 'right-top',
    onRotateStart: function (_a) {
      var set = _a.set;
      set(frame.rotate);
    },
    onRotate: function (_a) {
      var beforeRotate = _a.beforeRotate,
          target = _a.target;
      frame.rotate = beforeRotate;
      target.style.transform = "translate(" + frame.translate[0] + "px, " + frame.translate[1] + "px) rotate(" + beforeRotate + "deg)";
    },
    onRotateEnd: function () {
      onUpdateRotation(elementLocation, frame.rotate);
    }
  }), jsx(Div, {
    position: "absolute",
    top: y + "px",
    left: x + "px",
    width: width + "px",
    height: height + "px",
    className: "target-" + parentId,
    id: "moveable-wrapper",
    zIndex: position.z,
    transformOrigin: "top left",
    css: /*#__PURE__*/css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n          transform: ", ";\n          pointer-events: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:MoveableWrapper;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n          transform: ", ";\n          pointer-events: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:MoveableWrapper;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), "rotate(" + frame.rotate + "deg)", isPhotoDropTemplate ? 'none' : 'auto')
  }, children, isSelected && isDraggable && !isPreviewMode && !isFullPanelElement && jsx(IndicatorModeControl, {
    onActiveElementDelete: onActiveElementDelete,
    onActiveElementReplace: onActiveElementReplace,
    onActiveElementDrag: onActiveElementDrag,
    elementType: elementType,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  })));
};
var templateObject_1$5;

var styles$4 = {
  elementContainer: function (props, activeColor, inactiveColor) {
    return /*#__PURE__*/css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiZcclxuICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgcHJvcHMuZWxlbWVudC5pc1NlbGVjdGVkXHJcbiAgICAgICAgPyBcIjFweCBkYXNoZWQgXCIgKyBhY3RpdmVDb2xvclxyXG4gICAgICAgIDogcHJvcHMucGFuZWxMb2NhdGlvbiAhPT0gbnVsbCAmJlxyXG4gICAgICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgICAgICFwcm9wcy5lbGVtZW50LmRyYWdnYWJsZVxyXG4gICAgICAgICAgICA/IFwiMXB4IGRhc2hlZCBcIiArIGluYWN0aXZlQ29sb3JcclxuICAgICAgICAgICAgOiAnbm9uZScpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiZcclxuICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgcHJvcHMuZWxlbWVudC5pc1NlbGVjdGVkXHJcbiAgICAgICAgPyBcIjFweCBkYXNoZWQgXCIgKyBhY3RpdmVDb2xvclxyXG4gICAgICAgIDogcHJvcHMucGFuZWxMb2NhdGlvbiAhPT0gbnVsbCAmJlxyXG4gICAgICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgICAgICFwcm9wcy5lbGVtZW50LmRyYWdnYWJsZVxyXG4gICAgICAgICAgICA/IFwiMXB4IGRhc2hlZCBcIiArIGluYWN0aXZlQ29sb3JcclxuICAgICAgICAgICAgOiAnbm9uZScpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])), props.panelLocation !== null && props.showBorder && props.element.isSelected ? "1px dashed " + activeColor : props.panelLocation !== null && props.showBorder && !props.element.draggable ? "1px dashed " + inactiveColor : 'none');
  }
};
var templateObject_1$4;

var noSettingsEnabled = function (activeSetting) {
  return activeSetting === null;
};

var Element = function (props) {
  var _a;

  var elementId = props.elementId,
      originalHeight = props.height,
      originalWidth = props.width,
      originalX = props.x,
      originalY = props.y,
      originalZ = props.z,
      panelSize = props.panelSize,
      children = props.children,
      element = props.element,
      _b = props.isFullBleedBackground,
      isFullBleedBackground = _b === void 0 ? false : _b,
      isFullPanelElement = props.isFullPanelElement,
      panelLocation = props.panelLocation,
      onEdit = props.onEdit,
      originalRotation = props.rotation,
      isPreviewMode = props.isPreviewMode;

  var _c = useReduxState('editor'),
      canSelectElements = _c.canSelectElements,
      editing = _c.editing;

  var _d = useReduxState('editorChrome'),
      activeImageSetting = _d.activeImageSetting,
      activeTextSetting = _d.activeTextSetting,
      elementSettingsDrawerType = _d.elementSettingsDrawerType,
      shouldReplaceSelectedImage = _d.shouldReplaceSelectedImage;

  var actions = useReduxActions();
  var width = originalWidth <= 1 ? originalWidth : 1;
  var height = originalHeight <= 1 ? originalHeight : 1;
  var x = originalX >= 0 ? originalX : 0;
  var y = originalY >= 0 ? originalY : 0;
  var z = originalZ && originalZ >= 0 ? originalZ : 0; // TODO remove optional type and make z required

  var rotation = originalRotation || 0;
  var activeSetting = elementSettingsDrawerType === 'image' || isFullBleedBackground ? activeImageSetting : activeTextSetting;

  var _e = useColorSwatch(),
      success = _e.success,
      grayScale = _e.grayScale;

  var isElementLocked = function (isFullBleedBackground) {
    if (activeElement.type === 'text') {
      return element.movingProhibited || !element.draggable || !element.isSelected;
    }

    if (isFullBleedBackground) {
      return element.locked || editing !== 'fullbleed' || !noSettingsEnabled(activeSetting);
    }

    return element.movingProhibited || !element.draggable || !element.isSelected || !noSettingsEnabled(activeSetting) || element.isSelected && shouldReplaceSelectedImage;
  };

  var canElementBeSelected = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return canSelectElements && !element.isSelected && panelLocation !== null && !element.locked;
  };

  var canElementBeEdited = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return element.isSelected && canSelectElements && panelLocation !== null && !element.editingProhibited;
  };

  var activeElement = {
    location: element.location,
    type: !!element.image ? 'image' : !!element.text ? 'text' : null
  };

  var handleUpdatePosition = function (x, y) {
    if (isFullBleedBackground) {
      actions.enableSelectingElements();
      actions.updateFullBleedBackgroundElementPosition(x, y);
    } else {
      actions.enableSelectingElements();
      actions.updateElementPosition(element.location, x, y);
    }
  };

  var handleUpdateSize = function (width, height) {
    if (isFullBleedBackground) {
      actions.enableSelectingElements();
      actions.updateFullBleedBackgroundElementSize(width, height);
    } else {
      actions.enableSelectingElements();
      actions.updateElementSize(element.location, width, height);
    }
  };

  var handleElementOnClick = function (event, isFullBleedBackground) {
    event.stopPropagation();

    if (isFullBleedBackground) {
      onEdit();
      return;
    }

    if (canElementBeEdited(isFullBleedBackground)) {
      onEdit();
    }
  };

  var handleSelectElement = function (activeElement, panelLocation) {
    if (!element.draggable) {
      actions.setShouldReplaceSelectedImage(true);
      actions.setActiveImageSetting(null);
      actions.selectElement(element.editingProhibited && activeElement.location ? {
        location: activeElement.location - 1,
        type: 'image'
      } : activeElement, panelLocation);
    } else {
      actions.setShouldReplaceSelectedImage(false);
      actions.setActiveImageSetting(null);
      actions.selectElement(activeElement, panelLocation);
    }
  };

  return jsx(React.Fragment, null, jsx(MoveableWrapper, {
    isFullPanelElement: isFullPanelElement,
    isEditable: !isElementLocked(isFullBleedBackground),
    isPreviewMode: isPreviewMode,
    isPhotoDropTemplate: element.locked,
    isSelected: editing === 'fullbleed' ? true : element.isSelected,
    size: {
      width: width,
      height: height
    },
    position: {
      x: x,
      y: y,
      z: z
    },
    parentWidth: panelSize.width,
    parentHeight: panelSize.height,
    parentId: "" + activeElement.location + panelLocation,
    elementLocation: (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0,
    onUpdatePosition: handleUpdatePosition,
    onUpdateRotation: actions.updateElementRotation,
    onUpdateSize: handleUpdateSize,
    rotation: rotation,
    onActiveElementDelete: function () {
      actions.removeElement();
      actions.closeElementSettingsDrawer();
    },
    onActiveElementReplace: function (shouldReplaceSelectedImage) {
      actions.openElementInsertDrawer('images');
      actions.setShouldReplaceSelectedImage(shouldReplaceSelectedImage);
    },
    onActiveElementDrag: function () {
      activeElement.type === 'image' ? actions.setActiveImageSetting(null) : actions.setActiveTextSetting(null);
    },
    onActiveElementCrop: function () {
      return actions.setActiveImageSetting('crop');
    },
    elementType: activeElement.type,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage,
    isDraggable: (_a = element.draggable) !== null && _a !== void 0 ? _a : false
  }, jsx("div", {
    onClick: function (event) {
      if (isPreviewMode) {
        return;
      }

      handleElementOnClick(event, isFullBleedBackground);
    },
    id: elementId,
    className: 'elementContainer',
    css: styles$4.elementContainer(props, success.base, grayScale.base),
    onMouseDown: function () {
      if (isPreviewMode) {
        return;
      }

      if (canElementBeSelected(isFullBleedBackground)) {
        if (isFullBleedBackground) {
          return;
        }

        handleSelectElement(activeElement, panelLocation);
      }
    }
  }, children)));
};

var connect = connect$1;

var EmptyImage = function (_a) {
  var title = _a.title,
      type = _a.type;
  return jsx(VStack, {
    gap: "x1_5"
  }, jsx(IconLink, {
    onClick: function () {},
    size: type === 'element' ? 'xSmall' : 'medium',
    activeColor: "primaryHeadingText",
    icon: "image",
    isStacked: true,
    isActive: true,
    hasBackgroundColor: true
  }), jsx(Text, {
    type: type === 'element' ? 'footnote' : 'body',
    alignment: "center"
  }, title));
};

var ImageElement =
/** @class */
function (_super) {
  __extends(ImageElement, _super);

  function ImageElement(props) {
    var _this = _super.call(this, props) || this;

    _this.isUserImage = function (photoUrl) {
      return photoUrl && photoUrl.indexOf('user_images') > -1;
    };

    _this.photoUrl = function (element) {
      var image = element.image && element.image.image;

      if (!image || !image.url) {
        return '';
      }

      return image.url;
    };

    var image = props.element.image;
    _this.state = {
      isLoaded: !!(image && image.image && imageIsCached(image.image.url))
    };
    return _this;
  }

  ImageElement.prototype.componentDidUpdate = function (prevProps) {
    var element = prevProps.element;
    var image = element.image;
    var next = this.props.element.image;

    if (image && image.image && next && next.image && !imageIsCached(next.image.url) && image.image.url !== next.image.url // image.filter !== next.filter
    ) {
        this.setState({
          isLoaded: false
        });
      }
  };

  ImageElement.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        element = _a.element,
        panelLocation = _a.panelLocation,
        elementId = _a.elementId,
        _b = _a.isFullBleedBackground,
        isFullBleedBackground = _b === void 0 ? false : _b,
        panelSize = _a.panelSize,
        selectImagePosition = _a.selectImagePosition,
        isPanelLocked = _a.isPanelLocked,
        activeImageSetting = _a.activeImageSetting,
        elementSettingsDrawerType = _a.elementSettingsDrawerType,
        openElementSettingsDrawer = _a.openElementSettingsDrawer,
        openElementInsertDrawer = _a.openElementInsertDrawer,
        setActiveImageSetting = _a.setActiveImageSetting,
        updateFullBleedBackgroundImagePosition = _a.updateFullBleedBackgroundImagePosition,
        isFullPanelElement = _a.isFullPanelElement,
        isPreviewMode = _a.isPreviewMode;
    var isLoaded = this.state.isLoaded;
    var x = element.x,
        y = element.y,
        z = element.z,
        rotation = element.rotation,
        height = element.height,
        width = element.width,
        isSelected = element.isSelected;
    var image = element.image;
    var url = this.photoUrl(element);
    var showLoadingSpinner = !this.state.isLoaded && image && image.image;
    return jsx(Element, {
      x: x,
      y: y,
      z: z,
      rotation: rotation,
      height: height,
      width: width,
      elementId: elementId,
      element: element,
      panelLocation: panelLocation,
      panelIsLocked: isPanelLocked,
      isFullPanelElement: isFullPanelElement,
      showBorder: !!(image && !image.image && !isPreviewMode) || !!image && image.scale < 1 || isSelected,
      panelSize: panelSize,
      nonDraggableSelector: '.nonDraggable',
      isPreviewMode: isPreviewMode,
      onEdit: function () {
        var _a;

        if (isPreviewMode) {
          return;
        }

        if (!(activeImageSetting === 'crop')) openElementSettingsDrawer(isFullBleedBackground ? 'fullbleed' : isFullPanelElement ? 'panel' : 'image');

        if (!element.draggable) {
          openElementInsertDrawer('images');
          ((_a = element.image) === null || _a === void 0 ? void 0 : _a.image) && setActiveImageSetting('crop');
        }
      },
      isFullBleedBackground: isFullBleedBackground
    }, image && image.image ? jsx(AvatarEditor, {
      image: url,
      width: element.points.width,
      height: element.points.height,
      border: 0,
      scale: image.scale || 1,
      position: image.position,
      onPositionChange: activeImageSetting === 'crop' ? isFullBleedBackground ? function (position) {
        return updateFullBleedBackgroundImagePosition(position.x, position.y);
      } : function (position) {
        return selectImagePosition(position.x, position.y);
      } : function () {
        return null;
      },
      onImageReady: function () {
        return _this.setState({
          isLoaded: true
        });
      },
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: isLoaded || !image.image ? 1 : 0,
        transition: 'opacity 500ms',
        zIndex: elementSettingsDrawerType === 'panel' ? 102 : 1
      }
    }) : !isFullBleedBackground && !isPreviewMode && jsx(EmptyImage, {
      title: "Add an Image",
      type: "element"
    }), showLoadingSpinner && jsx("div", {
      className: "center"
    }, jsx(LoadingSpinner, {
      size: "medium"
    })));
  };

  return ImageElement;
}(React.Component);

var ImageElement$1 = connect(function (state) {
  return {
    activeImageSetting: state.editorChrome.activeImageSetting,
    elementSettingsDrawerType: state.editorChrome.elementSettingsDrawerType
  };
}, {
  selectImagePosition: selectImagePosition,
  updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
  openElementSettingsDrawer: openElementSettingsDrawer,
  openElementInsertDrawer: openElementInsertDrawer,
  setActiveImageSetting: setActiveImageSetting
})(ImageElement);

var selectionIndex = function (node, offset, isStart, selectionUpperBound) {
  if (node.nodeName === '#text') {
    var spanIndex = parseInt(node.parentElement && node.parentElement.dataset.index || '1', 10);

    if (offset === 0) {
      return spanIndex;
    } else if (offset === (node.textContent && node.textContent.length)) {
      return spanIndex + 1;
    } else {
      return isStart ? spanIndex : spanIndex + 1;
    }
  } else if (node.nodeName === 'P' && node instanceof HTMLElement) {
    return parseInt(node.dataset.index || '1', 10) + offset + 1;
  } else {
    return isStart ? 1 : selectionUpperBound;
  }
};
var setCaretPositionOrHighlightText = function (selectionUpperBound, selection, selectText) {
  var windowSelection = window.getSelection();

  if (windowSelection) {
    var range = windowSelection.getRangeAt(0);
    var start = selectionIndex(range.startContainer, range.startOffset, true, selectionUpperBound);
    var end = selectionIndex(range.endContainer, range.endOffset, false, selectionUpperBound);

    if (!selection || selection.start.index !== start || selection.end.index !== end) {
      selectText(start, end);
    }
  }
};

var DEFAULT_OPTIONS = {
  config: {
    childList: true,
    characterData: true
  }
};

var useMutationObservable = function (targetEl, cb, options) {
  if (options === void 0) {
    options = DEFAULT_OPTIONS;
  }

  var _a = __read(useState(null), 2),
      observer = _a[0],
      setObserver = _a[1];

  useEffect(function () {
    var obs = new MutationObserver(cb);
    setObserver(obs);
  }, [cb, options, setObserver]);
  useEffect(function () {
    if (!observer) return;
    var config = options.config;
    if (targetEl) observer.observe(targetEl, config);
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, options]);
};

var styles$3 = {
  paragraph: function (paragraph, scale, isUsingOldFlattener) {
    return /*#__PURE__*/css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n    margin: 0px;\n    min-height: ", "px;\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n    margin: 0px;\n    min-height: ", "px;\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), paragraph.fontFamily, paragraph.fontSize, rgbString(paragraph.color), paragraph.textAlign.toLowerCase(), paragraph.fontSize * scale || 12, isUsingOldFlattener ? 1.4 : 1);
  },
  span: function (fragment, scale, isTextCursorActive, isPreviewMode) {
    var _a;

    return /*#__PURE__*/css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: ", ";\n    cursor: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: ", ";\n    cursor: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), (_a = fragment.signatureFontFamily) !== null && _a !== void 0 ? _a : fragment.fontFamily, fragment.fontSize * scale, rgbString(fragment.color), fragment.text && fragment.text.length > 1 ? 'underline' : 'none', isTextCursorActive && !isPreviewMode ? 'text' : 'inherit');
  }
};
var templateObject_1$3, templateObject_2$1;

var TextEditorParagraph = function (props) {
  var paragraph = props.paragraph,
      scale = props.scale,
      externalChangesDetected = props.externalChangesDetected,
      isTextCursorActive = props.isTextCursorActive,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;

  var _a = __read(useState(false), 2),
      isChangeExternal = _a[0],
      setIsChangeExternal = _a[1];

  var mutableRef = useRef();
  var ref = mutableRef.current;

  var _b = __read(useState(false), 2),
      hasDomChanges = _b[0],
      setHasDomChanges = _b[1];

  var onListMutation = useCallback(function () {
    setHasDomChanges(true);
  }, []);
  useMutationObservable(ref, onListMutation);
  useEffect(function () {
    // Checks if there were changes made to the DOM by an external plugin / source
    if ((ref === null || ref === void 0 ? void 0 : ref.innerText) !== paragraph.fragments.map(function (elem) {
      return elem.text;
    }).join('')) {
      setIsChangeExternal(true);
    } else {
      setHasDomChanges(false);
    }
  }, [hasDomChanges, externalChangesDetected]);

  if (isChangeExternal) {
    // This conditional render is to clear the current paragraph dom elements that were messed up by the external changes and react can no longer rely on them
    // by triggering and another component we force the cleanup of the messed up content and the recreate it as they should be on the next render.
    externalChangesDetected(false);
    setTimeout(function () {
      setHasDomChanges(false);
      setIsChangeExternal(false);
      externalChangesDetected(true);
    }, 1);
    return jsx("div", null);
  }

  return jsx("p", {
    key: paragraph.index,
    "data-index": paragraph.index,
    css: styles$3.paragraph(paragraph, scale, isUsingOldFlattener),
    ref: function (ref) {
      return mutableRef.current = ref !== null && ref !== void 0 ? ref : undefined;
    }
  }, paragraph.fragments.map(function (fragment) {
    return jsx("span", {
      key: fragment.index,
      "data-index": fragment.index,
      css: styles$3.span(fragment, scale, isTextCursorActive, isPreviewMode)
    }, fragment.text ? fragment.text : signatureCharacter);
  }));
};

var TextBlock = function (_a) {
  var paragraphs = _a.paragraphs,
      scale = _a.scale,
      isPreviewMode = _a.isPreviewMode,
      externalChangesDetected = _a.externalChangesDetected,
      isUsingOldFlattener = _a.isUsingOldFlattener;
  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var renderParagraphs = React.useCallback(function () {
    return paragraphs.map(function (paragraph) {
      return jsx(TextEditorParagraph, {
        paragraph: paragraph,
        scale: scale,
        externalChangesDetected: externalChangesDetected,
        isTextCursorActive: isTextCursorActive,
        isPreviewMode: isPreviewMode,
        isUsingOldFlattener: isUsingOldFlattener
      });
    });
  }, [paragraphs, scale, isTextCursorActive, isPreviewMode, externalChangesDetected]);
  return jsx(React.Fragment, null, renderParagraphs());
};

var fragmentsFormat = 'application/vnd.sendoutcards.textfragments+json';
var textManagementKeys = new Set(['Backspace', 'Delete', 'Enter']);

var TextEditor = function (props) {
  // Hooks
  var _a = useResizeObserver(),
      ref = _a.ref,
      height = _a.height;

  var textEditorRef = useRef(null);
  var previousHeight = usePrevious(height); // State

  var _b = useReduxState('editor'),
      activeElement = _b.activeElement,
      textSelection = _b.textSelection;

  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var actions = useReduxActions(); // Props

  var _c = props.elementText,
      paragraphs = _c.paragraphs,
      selectionUpperBound = _c.selectionUpperBound,
      selection = _c.selection,
      selectText = props.selectText,
      scale = props.scale,
      panelSize = props.panelSize,
      elementProperties = props.elementProperties,
      openElementSettingsDrawer = props.openElementSettingsDrawer,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;

  var _d = __read(useState(true), 2),
      shouldEditContent = _d[0],
      setShouldEditContent = _d[1];
  /******************************** Helpers  ******************************************/


  var getHeightPercentage = function (height) {
    return height / panelSize.height;
  };

  var hasHeightReachedElementBounds = function (height) {
    return getHeightPercentage(height) >= elementProperties.height;
  };

  var hasHeightReachedPanelBounds = function () {
    return elementProperties.height + elementProperties.y >= 1;
  };

  var handleUpdateElementSize = function (height) {
    actions.updateElementSize((activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0, elementProperties.width, height);
  };

  useEffect(function () {
    if (hasHeightReachedPanelBounds()) {
      return;
    }

    if (previousHeight && height && height !== previousHeight) {
      if (hasHeightReachedElementBounds(height)) {
        var delta = getHeightPercentage(height) - getHeightPercentage(previousHeight);
        var newHeight = delta + elementProperties.height + elementProperties.y >= 1 ? 1 - elementProperties.y : getHeightPercentage(height);
        handleUpdateElementSize(newHeight);
      }
    }
  }, [height]); //eslint-disable-line

  useEffect(function () {
    var selection = props.elementText.selection;

    if (!selection || !ref) {
      return;
    }

    if (textEditorRef.current) {
      var startNode = textEditorRef.current.childNodes[selection.start.paragraph];
      var endNode = textEditorRef.current.childNodes[selection.end.paragraph];

      if (!startNode || !endNode) {
        return;
      }

      var range = document.createRange();
      range.setStart(startNode, Math.max(0, Math.min(selection.start.offset, startNode.childNodes.length)));
      range.setEnd(endNode, Math.max(0, Math.min(selection.end.offset, endNode.childNodes.length)));
      var windowSelection = window.getSelection();

      if (windowSelection) {
        windowSelection.removeAllRanges();
        windowSelection.addRange(range);
      }
    }
  });
  React.useEffect(function () {
    actions.setIsTextCursorActive(true);
  }, []); //eslint-disable-line

  var externalChangesDetected = useCallback(function (preventTextEdition) {
    setShouldEditContent(preventTextEdition);
  }, []);
  /******************************** Events  ******************************************/

  var handleOnCopy = function (event) {
    if (!selection) {
      return;
    }

    event.preventDefault();
    event.clipboardData.setData('text', selection.text);
    event.clipboardData.setData(fragmentsFormat, JSON.stringify(selection.fragments));
  };

  var handleOnClick = function (event) {
    event.stopPropagation();
    openElementSettingsDrawer();
  };

  var handleOnCut = function (event) {
    handleOnCopy(event);
    actions.deleteFragments();
  };

  var handleOnPaste = function (event) {
    event.preventDefault();
    var fragments = event.clipboardData.getData(fragmentsFormat);
    var text = event.clipboardData.getData('text');

    if (fragments) {
      actions.insertFragments(JSON.parse(fragments));
    } else if (text) {
      actions.insertText(text);
    }
  };

  var handleOnKeyDown = function (event) {
    if (textManagementKeys.has(event.key)) setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);

    if (event.key === 'Backspace') {
      event.preventDefault();
      actions.deleteFragments();
    } else if (event.key === 'Delete') {
      event.preventDefault();
      actions.deleteForwardFragments();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      actions.insertNewLine();
    }
  };

  var handleOnKeyPress = function (event) {
    setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);

    if (event.nativeEvent.metaKey || event.nativeEvent.ctrlKey) {
      return;
    }

    event.preventDefault();
    actions.insertCharacter(event.nativeEvent.key);
  };

  var handleMouseUpListener = function () {
    handleOnMouseUp(true);
  };

  var handleOnMouseUp = function (shouldDeleteEvent) {
    if (shouldDeleteEvent) {
      window.removeEventListener('mouseup', handleMouseUpListener);
    }

    setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);
  };

  return jsx("div", {
    onMouseDown: function () {
      if ((textSelection === null || textSelection === void 0 ? void 0 : textSelection.start) === (textSelection === null || textSelection === void 0 ? void 0 : textSelection.end)) {
        window.addEventListener('mouseup', handleMouseUpListener);
      }
    },
    id: 'text_editor',
    ref: useMergeRefs([textEditorRef, ref]),
    autoCapitalize: "off",
    autoCorrect: "off",
    style: {
      whiteSpace: 'pre-wrap',
      outline: '0px',
      width: '100%'
    },
    onClick: handleOnClick,
    onCut: handleOnCut,
    onCopy: handleOnCopy,
    onPaste: handleOnPaste,
    onKeyDown: handleOnKeyDown,
    onKeyPress: handleOnKeyPress,
    onMouseUp: function () {
      return handleOnMouseUp();
    },
    contentEditable: isTextCursorActive && !isPreviewMode && shouldEditContent,
    suppressContentEditableWarning: true
  }, jsx(TextBlock, {
    scale: scale,
    paragraphs: paragraphs,
    isPreviewMode: isPreviewMode,
    externalChangesDetected: externalChangesDetected,
    isUsingOldFlattener: isUsingOldFlattener
  }));
};

var TextEditor$1 = /*#__PURE__*/React.memo(TextEditor);

var styles$2 = {
  contents: function (isTextCursorActive, isActive, isPreviewMode) {
    return /*#__PURE__*/css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    cursor: ", ";\n    background-color: ", ";\n    backdrop-filter: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBjb250ZW50czogZnVuY3Rpb24gKGlzVGV4dEN1cnNvckFjdGl2ZSwgaXNBY3RpdmUsIGlzUHJldmlld01vZGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgIGhlaWdodDogMTAwJTtcXG4gICAgd2lkdGg6IDEwMCU7XFxuICAgIG92ZXJmbG93OiBhdXRvO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgY3Vyc29yOiBcIiwgXCI7XFxuICAgIGJhY2tncm91bmQtY29sb3I6IFwiLCBcIjtcXG4gICAgYmFja2Ryb3AtZmlsdGVyOiBcIiwgXCI7XFxuICBcIl0sIFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgZGlzcGxheTogZmxleDtcXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcXG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XFxuICAgIGN1cnNvcjogXCIsIFwiO1xcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBcIiwgXCI7XFxuICAgIGJhY2tkcm9wLWZpbHRlcjogXCIsIFwiO1xcbiAgXCJdKSksIGlzVGV4dEN1cnNvckFjdGl2ZSAmJiAhaXNQcmV2aWV3TW9kZSA/ICd0ZXh0JyA6ICdpbmhlcml0JywgaXNBY3RpdmUgPyAncmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE1KScgOiAndHJhbnNwYXJlbnQnLCBpc0FjdGl2ZSAmJiAnYmx1cig1cHgpJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")], ["\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    cursor: ", ";\n    background-color: ", ";\n    backdrop-filter: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBjb250ZW50czogZnVuY3Rpb24gKGlzVGV4dEN1cnNvckFjdGl2ZSwgaXNBY3RpdmUsIGlzUHJldmlld01vZGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgIGhlaWdodDogMTAwJTtcXG4gICAgd2lkdGg6IDEwMCU7XFxuICAgIG92ZXJmbG93OiBhdXRvO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgY3Vyc29yOiBcIiwgXCI7XFxuICAgIGJhY2tncm91bmQtY29sb3I6IFwiLCBcIjtcXG4gICAgYmFja2Ryb3AtZmlsdGVyOiBcIiwgXCI7XFxuICBcIl0sIFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgZGlzcGxheTogZmxleDtcXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcXG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XFxuICAgIGN1cnNvcjogXCIsIFwiO1xcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBcIiwgXCI7XFxuICAgIGJhY2tkcm9wLWZpbHRlcjogXCIsIFwiO1xcbiAgXCJdKSksIGlzVGV4dEN1cnNvckFjdGl2ZSAmJiAhaXNQcmV2aWV3TW9kZSA/ICd0ZXh0JyA6ICdpbmhlcml0JywgaXNBY3RpdmUgPyAncmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE1KScgOiAndHJhbnNwYXJlbnQnLCBpc0FjdGl2ZSAmJiAnYmx1cig1cHgpJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")])), isTextCursorActive && !isPreviewMode ? 'text' : 'inherit', isActive ? 'rgba(255, 255, 255, 0.15)' : 'transparent', isActive && 'blur(5px)');
  }
};
var templateObject_1$2;

var TextElement = function (props) {
  var element = props.element,
      elementId = props.elementId,
      panelLocation = props.panelLocation,
      panelSize = props.panelSize,
      scaledPanelWidth = props.scaledPanelWidth,
      isPanelLocked = props.isPanelLocked,
      isFullPanelElement = props.isFullPanelElement,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;
  var actions = useReduxActions();
  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var activeElement = useReduxState('editor').activeElement;
  var isActive = activeElement.location === element.location;
  var x = element.x,
      y = element.y,
      z = element.z,
      rotation = element.rotation,
      height = element.height,
      width = element.width;

  var selectText = function (start, end) {
    actions.selectElement({
      location: element.location,
      type: 'text'
    }, panelLocation, start, end);
  };

  var selectTextElement = function () {
    if (element.text) {
      selectText(element.text.selectionUpperBound);
    }
  };

  var hasNoTextInElement = !!(element.text && element.text.paragraphs.length === 1 && element.text.paragraphs[0].fragments.length === 0);
  var flattenerScaleRatio = isUsingOldFlattener ? 1.395 : 1;
  var textScale = panelSize.width / scaledPanelWidth * flattenerScaleRatio;
  return jsx(Element, {
    x: x,
    y: y,
    z: z,
    rotation: rotation,
    height: height,
    width: width,
    elementId: elementId,
    showBorder: element.isSelected || hasNoTextInElement,
    panelSize: panelSize,
    panelIsLocked: isPanelLocked,
    element: element,
    panelLocation: panelLocation,
    onEdit: function () {
      selectTextElement();
      actions.openElementSettingsDrawer(panelLocation === null ? 'panel' : 'text');
      actions.closeElementInsertDrawer();
    },
    isFullPanelElement: isFullPanelElement,
    isPreviewMode: isPreviewMode
  }, jsx("div", {
    css: styles$2.contents(isTextCursorActive, isActive, isPreviewMode)
  }, jsx(React.Fragment, null, element.text && jsx(TextEditor$1, {
    elementProperties: {
      width: width,
      height: height,
      x: x,
      y: y,
      z: z
    },
    elementText: element.text,
    selectText: selectText,
    scale: textScale,
    panelSize: panelSize,
    isPreviewMode: isPreviewMode,
    openElementSettingsDrawer: function () {
      return actions.openElementSettingsDrawer(panelLocation === null ? 'panel' : 'text');
    },
    isUsingOldFlattener: isUsingOldFlattener
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$1 = {
  fullbleedPanel: process.env.NODE_ENV === "production" ? {
    name: "1cjuka5",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4"
  } : {
    name: "16bxou2-fullbleedPanel",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4;label:fullbleedPanel;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
  },
  panelContainer: function (props, panelView, isPreview) {
    return /*#__PURE__*/css(__assign(__assign({}, styles$1.fullbleedPanel), {
      display: 'flex',
      justifyContent: 'center',
      width: panelView === 'fullbleed' ? props.panel.width * 100 + "%" : '100%',
      height: panelView === 'fullbleed' ? props.panel.height * 100 + "%" : '100%',
      position: 'relative',
      zIndex: props.isActivePanel && !isPreview ? 100 : 3,
      '&::after': props.isActivePanel && !isPreview ? {
        content: '""',
        position: 'absolute',
        top: -3,
        left: -3,
        width: 'calc(100% + 6px)',
        height: 'calc(100% + 6px)',
        background: 'blue'
      } : {}
    }), process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  },
  panelContents: function (isEditingFullBleed, isPreviewMode) {
    return /*#__PURE__*/css({
      cursor: isEditingFullBleed || isPreviewMode ? 'grab' : 'pointer',
      position: 'relative',
      height: '100%',
      width: '100%',
      // backgroundColor: '#ffffff',
      // border: `2px solid ${isSelected ? activeColor : 'transparent'}`, TODO Active Panel Border causing issues
      zIndex: 3
    }, process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QmUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgdmFyIHN0eWxlcyA9IHtcclxuICAgIGZ1bGxibGVlZFBhbmVsOiBjc3Moe1xyXG4gICAgICAgIGJhY2tncm91bmQ6ICd0cmFuc3BhcmVudCcsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMCA4cHggMjJweCAwIHJnYmEoMCwgMCwgMCwgMC4xNzUpJyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIGN1cnNvcjogJ2RlZmF1bHQnLFxyXG4gICAgICAgIHpJbmRleDogNCxcclxuICAgIH0pLFxyXG4gICAgcGFuZWxDb250YWluZXI6IGZ1bmN0aW9uIChwcm9wcywgcGFuZWxWaWV3LCBpc1ByZXZpZXcpIHtcclxuICAgICAgICByZXR1cm4gY3NzKF9fYXNzaWduKF9fYXNzaWduKHt9LCBzdHlsZXMuZnVsbGJsZWVkUGFuZWwpLCB7IGRpc3BsYXk6ICdmbGV4JywganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLCB3aWR0aDogcGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJyA/IHByb3BzLnBhbmVsLndpZHRoICogMTAwICsgXCIlXCIgOiAnMTAwJScsIGhlaWdodDogcGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJyA/IHByb3BzLnBhbmVsLmhlaWdodCAqIDEwMCArIFwiJVwiIDogJzEwMCUnLCBwb3NpdGlvbjogJ3JlbGF0aXZlJywgekluZGV4OiBwcm9wcy5pc0FjdGl2ZVBhbmVsICYmICFpc1ByZXZpZXcgPyAxMDAgOiAzLCAnJjo6YWZ0ZXInOiBwcm9wcy5pc0FjdGl2ZVBhbmVsICYmICFpc1ByZXZpZXdcclxuICAgICAgICAgICAgICAgID8ge1xyXG4gICAgICAgICAgICAgICAgICAgIGNvbnRlbnQ6ICdcIlwiJyxcclxuICAgICAgICAgICAgICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcclxuICAgICAgICAgICAgICAgICAgICB0b3A6IC0zLFxyXG4gICAgICAgICAgICAgICAgICAgIGxlZnQ6IC0zLFxyXG4gICAgICAgICAgICAgICAgICAgIHdpZHRoOiAnY2FsYygxMDAlICsgNnB4KScsXHJcbiAgICAgICAgICAgICAgICAgICAgaGVpZ2h0OiAnY2FsYygxMDAlICsgNnB4KScsXHJcbiAgICAgICAgICAgICAgICAgICAgYmFja2dyb3VuZDogJ2JsdWUnLFxyXG4gICAgICAgICAgICAgICAgfVxyXG4gICAgICAgICAgICAgICAgOiB7fSB9KSk7XHJcbiAgICB9LFxyXG4gICAgcGFuZWxDb250ZW50czogZnVuY3Rpb24gKGlzRWRpdGluZ0Z1bGxCbGVlZCwgaXNQcmV2aWV3TW9kZSkge1xyXG4gICAgICAgIHJldHVybiBjc3Moe1xyXG4gICAgICAgICAgICBjdXJzb3I6IGlzRWRpdGluZ0Z1bGxCbGVlZCB8fCBpc1ByZXZpZXdNb2RlID8gJ2dyYWInIDogJ3BvaW50ZXInLFxyXG4gICAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcclxuICAgICAgICAgICAgaGVpZ2h0OiAnMTAwJScsXHJcbiAgICAgICAgICAgIHdpZHRoOiAnMTAwJScsXHJcbiAgICAgICAgICAgIC8vIGJhY2tncm91bmRDb2xvcjogJyNmZmZmZmYnLFxyXG4gICAgICAgICAgICAvLyBib3JkZXI6IGAycHggc29saWQgJHtpc1NlbGVjdGVkID8gYWN0aXZlQ29sb3IgOiAndHJhbnNwYXJlbnQnfWAsIFRPRE8gQWN0aXZlIFBhbmVsIEJvcmRlciBjYXVzaW5nIGlzc3Vlc1xyXG4gICAgICAgICAgICB6SW5kZXg6IDMsXHJcbiAgICAgICAgfSk7XHJcbiAgICB9LFxyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */");
  }
};

var StickerElement = function (_a) {
  var _b;

  var element = _a.element,
      id = _a.id,
      panelLocation = _a.panelLocation,
      isPreviewMode = _a.isPreviewMode,
      isPanelLocked = _a.isPanelLocked,
      panelSize = _a.panelSize;
  var x = element.x,
      y = element.y,
      z = element.z,
      rotation = element.rotation,
      height = element.height,
      width = element.width;

  var _c = __read(useState(false), 2),
      isLoaded = _c[0],
      setIsLoaded = _c[1];

  var sticker = element.image;
  var actions = useReduxActions();
  var elementSettingsDrawerType = useReduxState('editorChrome').elementSettingsDrawerType;
  var showLoadingSpinner = !isLoaded && !!(sticker === null || sticker === void 0 ? void 0 : sticker.image);
  return jsx(Element, {
    x: x,
    y: y,
    z: z,
    rotation: rotation,
    height: height,
    width: width,
    elementId: id,
    element: element,
    panelLocation: panelLocation,
    panelIsLocked: isPanelLocked,
    isFullPanelElement: false,
    showBorder: false,
    panelSize: panelSize,
    nonDraggableSelector: '.nonDraggable',
    isPreviewMode: isPreviewMode,
    onEdit: function () {
      if (isPreviewMode) {
        return;
      }

      actions.closeElementSettingsDrawer();
      actions.setShouldReplaceSelectedImage(false);
    },
    isFullBleedBackground: false
  }, sticker && ((_b = sticker.image) === null || _b === void 0 ? void 0 : _b.url) && jsx(AvatarEditor, {
    image: sticker.image.url,
    width: element.points.width,
    height: element.points.height,
    border: 0,
    scale: sticker.scale || 1,
    position: sticker.position,
    onImageReady: function () {
      return setIsLoaded(true);
    },
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: isLoaded || !sticker.image ? 1 : 0,
      transition: 'opacity 500ms',
      zIndex: elementSettingsDrawerType === 'panel' ? 102 : 1
    }
  }), showLoadingSpinner && jsx(LoadingSpinner, {
    size: "medium"
  }));
};

var getElementId = function (editorId, panelIndex, elementIndex) {
  return "editor_" + editorId + "_panel_" + panelIndex + "_element_" + elementIndex;
};

var Panel = function (props) {
  var panel = props.panel,
      panelIndex = props.panelIndex,
      scaledPanelWidth = props.scaledPanelWidth,
      onSelectPanel = props.onSelectPanel,
      // isPanelLabelHidden,
  isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;

  var _a = useReduxState('editor'),
      editing = _a.editing,
      fullBleedLocation = _a.fullBleedLocation;

  var actions = useReduxActions();
  var isEditingFullBleed = editing === 'fullbleed';

  var handleSelectPanel = function (event, location) {
    var target = event.target;

    if (target.id !== 'panel-content') {
      return;
    }

    if (isEditingFullBleed) {
      return;
    }

    onSelectPanel(location, fullBleedLocation); // Editor Chrome Actions

    if (fullBleedLocation !== 0 || !panel.isLocked) actions.openElementSettingsDrawer('panel');else {
      actions.closeElementSettingsDrawer();
      actions.closeElementInsertDrawer();
    }
  };

  var _b = useContext(EditorContext),
      panelView = _b.panelView,
      editorId = _b.editorId;

  return jsx("div", {
    id: "editor_" + editorId + "_panel_" + panelIndex,
    css: styles$1.panelContainer(props, panelView, isPreviewMode),
    onMouseDown: function (event) {
      if (isPreviewMode) {
        return;
      }

      handleSelectPanel(event, panel.location);
    }
  }, jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true,
    render: function (_a) {
      var width = _a.width,
          height = _a.height;
      return jsx("div", {
        id: "panel-content",
        css: [styles$1.panelContents(isEditingFullBleed, isPreviewMode), {
          backgroundColor: panel.backgroundColor ? rgbString(panel.backgroundColor) : undefined
        }, process.env.NODE_ENV === "production" ? "" : ";label:Panel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
      }, panel.elements.length > 0 ? panel.elements.map(function (element, index) {
        var _a, _b, _c, _d;

        return jsx(React.Fragment, {
          key: index
        }, element.text ? jsx(TextElement, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          panelSize: {
            width: width,
            height: height
          },
          scaledPanelWidth: scaledPanelWidth,
          isPreviewMode: isPreviewMode,
          isFullPanelElement: (_a = element.isFullPanel) !== null && _a !== void 0 ? _a : false,
          isPanelLocked: panel.isLocked,
          isUsingOldFlattener: isUsingOldFlattener
        }) : ((_c = (_b = element.image) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.isSticker) ? jsx(StickerElement, {
          id: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          isPanelLocked: panel.isLocked,
          panelSize: {
            width: width,
            height: height
          },
          isPreviewMode: isPreviewMode
        }) : element.image && jsx(ImageElement$1, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          isPanelLocked: panel.isLocked,
          panelSize: {
            width: width,
            height: height
          },
          isPreviewMode: isPreviewMode,
          isFullPanelElement: (_d = element.isFullPanel) !== null && _d !== void 0 ? _d : false
        }));
      }) : jsx(React.Fragment, null));
    }
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles = {
  fullbleedContainer: process.env.NODE_ENV === "production" ? {
    name: "1nxtnvz",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF"
  } : {
    name: "urvcuy-fullbleedContainer",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF;label:fullbleedContainer;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0IiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  fullbleedPanels: process.env.NODE_ENV === "production" ? {
    name: "36um8q",
    styles: "position:relative;display:flex;width:100%;height:100%;overflow:hidden"
  } : {
    name: "11qz17z-fullbleedPanels",
    styles: "position:relative;display:flex;width:100%;height:100%;overflow:hidden;label:fullbleedPanels;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRcUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  backgroundElement: function (width, height, translate) {
    return /*#__PURE__*/css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    #backgroundImage {\n      width: ", ";\n      height: ", ";\n      transform: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlb0UiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    #backgroundImage {\n      width: ", ";\n      height: ", ";\n      transform: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlb0UiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])), width, height, translate);
  }
};
var templateObject_1$1;

var FullBleed = function (_a) {
  var activePanel = _a.activePanel,
      isHorizontal = _a.isHorizontal,
      onSelectPanel = _a.onSelectPanel,
      fullBleed = _a.fullBleed,
      hidePanelLabel = _a.hidePanelLabel,
      isPreviewMode = _a.isPreviewMode,
      panelsTotal = _a.panelsTotal,
      isUsingOldFlattener = _a.isUsingOldFlattener;
  var fbHeight = fullBleed.height,
      fbWidth = fullBleed.width,
      panels = fullBleed.panels,
      backgroundElement = fullBleed.backgroundElement;
  var editing = useReduxState('editor').editing;
  var actions = useReduxActions();
  var panelView = useContext(EditorContext).panelView;
  var width = panelView === 'fullbleed' ? fbWidth : panels[0].width * fbWidth;
  var height = panelView === 'fullbleed' ? fbHeight : panels[0].height * fbHeight;
  return jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true
  }, function (_a) {
    var _b;

    var parentWidth = _a.width,
        parentHeight = _a.height;
    var heightMax = {
      height: parentHeight || 0,
      width: parentHeight / height * width || 0
    };
    var widthMax = {
      width: parentWidth || 0,
      height: parentWidth / width * height || 0
    };
    var isHeightWithinBounds = heightMax.height <= parentHeight && heightMax.width <= parentWidth;
    var isWidthWithinBounds = widthMax.height <= parentHeight && widthMax.width <= parentWidth;
    var heightArea = heightMax.height * heightMax.width;
    var widthArea = widthMax.height * widthMax.width;
    var hasReachedLimitHeight = isHeightWithinBounds && isWidthWithinBounds ? heightArea > widthArea : isHeightWithinBounds;

    var getPercentageFromPanelCount = function () {
      return panelsTotal === 3 ? '300%' : panelsTotal === 2 ? '200%' : '100%';
    };

    var calcElementWidth = function () {
      return isHorizontal || panelView === 'fullbleed' ? '100%' : getPercentageFromPanelCount();
    };

    var calcElementHeight = function () {
      return !isHorizontal || panelView === 'fullbleed' ? '100%' : getPercentageFromPanelCount();
    };

    var getBackgroundDisplayTransform = function () {
      if (panelView === 'fullbleed') return 'translateX(0)';

      if (panelsTotal === 3 && activePanel === 2) {
        return isHorizontal ? "translateY(-" + 100 * (2 / 3) + "%)" : "translateX(-" + 100 * (2 / 3) + "%)";
      } else if (panelsTotal === 3 && activePanel === 1) {
        return isHorizontal ? "translateY(-" + 100 * (1 / 3) + "%)" : "translateX(-" + 100 * (1 / 3) + "%)";
      } else if (panelsTotal === 2 && activePanel === 1) {
        return isHorizontal ? "translateY(-50%)" : "translateX(-50%)";
      }

      return isHorizontal ? "translateY(0)" : "translateX(0)";
    };

    return jsx("div", {
      id: 'fullbleed',
      css: [styles.fullbleedContainer, __assign({}, hasReachedLimitHeight ? heightMax : widthMax), process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, jsx("div", {
      css: [styles.fullbleedPanels, {
        flexDirection: isHorizontal ? 'row' : 'column'
      }, process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, editing === 'fullbleed' && !((_b = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _b === void 0 ? void 0 : _b.image) && !isPreviewMode && jsx(Flex, {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      onClick: function () {
        return actions.openElementInsertDrawer('images');
      },
      cursor: "pointer"
    }, jsx(EmptyImage, {
      type: "fullbleed",
      title: "Add full background image"
    })), (backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) && jsx(Div, {
      css: styles.backgroundElement(calcElementWidth(), calcElementHeight(), getBackgroundDisplayTransform())
    }, jsx(ImageElement$1, {
      isFullPanelElement: false,
      elementId: 'backgroundImage',
      element: backgroundElement,
      panelLocation: null,
      isFullBleedBackground: true,
      panelSize: hasReachedLimitHeight ? heightMax : widthMax,
      isPreviewMode: isPreviewMode,
      isPanelLocked: false
    })), editing !== 'fullbleed' && panels.map(function (panel) {
      return jsx(Panel, {
        isPanelLabelHidden: hidePanelLabel,
        key: panel.location,
        panel: panel,
        panelIndex: panel.location,
        scaledPanelWidth: fullBleed.width * panel.width,
        onSelectPanel: onSelectPanel,
        isActivePanel: activePanel === panel.location,
        isPreviewMode: isPreviewMode,
        isUsingOldFlattener: isUsingOldFlattener
      });
    })));
  });
};

var useDebouncedEffect = function (effect, deps, delay) {
  if (delay === void 0) {
    delay = 250;
  }

  useEffect(function () {
    var handler = setTimeout(function () {
      return effect();
    }, delay);
    return function () {
      return clearTimeout(handler);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, __spread(deps || [], [delay]));
};

var Editor = function (_a) {
  var card = _a.card,
      onSave = _a.onSave,
      panelView = _a.panelView,
      currentIndex = _a.currentIndex,
      isUsingOldFlattener = _a.isUsingOldFlattener;
  var editor = useReduxState('editor');
  var interactionMode = useReduxState('editorChrome').interactionMode;
  var isPreviewMode = interactionMode === 'preview';
  var activeFullBleedLocation = editor.fullBleedLocation,
      activePanelLocation = editor.panelLocation,
      reduxCard = editor.card;
  var isHorizontal = !!editor.card && editor.card.orientation === 'LANDSCAPE';
  var fullBleeds = computedFullBleeds(editor);
  var panels = editor.card && computedSingleFullBleeds(editor);
  var panelLocations = editor.card ? getPanelLocations(editor) : [];
  var actions = useReduxActions();
  var id = Date.now();

  var _b = __read(useState(reduxCard), 2),
      savedCard = _b[0],
      setSavedCard = _b[1];

  var selectedFullBleed = panelView === 'fullbleed' && fullBleeds ? fullBleeds[activeFullBleedLocation] : panels ? panels[currentIndex] : null;
  var context = {
    currentIndex: currentIndex,
    panelView: panelView,
    editorId: id
  };
  var hasHorizontalAspectRatio = selectedFullBleed ? isHorizontalFullBleed(panelView, activeFullBleedLocation, card.fullBleeds.length, selectedFullBleed.panels.length, isHorizontal) : false;

  var handleSelectPanel = function () {
    if (panelView === 'fullbleed') {
      actions.selectFullBleed(currentIndex);
    } else {
      if (panelLocations && !!panelLocations.length) {
        var _a = panelLocations[currentIndex],
            fullbleed = _a.fullbleed,
            panel = _a.panel;
        actions.selectSinglePanel(fullbleed, panel);
      }
    } // EditorChrome Actions


    if (activeFullBleedLocation !== 0 && !card.fullBleeds[0].panels[0].isLocked) actions.openElementSettingsDrawer('panel');
  };

  useDebouncedEffect(function () {
    if (reduxCard) {
      if (!equal(savedCard, reduxCard)) {
        setSavedCard(reduxCard);
        onSave(reduxCard);
      }
    }
  }, [reduxCard, isPreviewMode]); //eslint-disable-line

  useDebouncedEffect(function () {
    if (card) {
      actions.loadedCard(card);
      if (!isPreviewMode) handleSelectPanel();
    }

    return function () {
      actions.resetState();
    };
  }, [card, isPreviewMode]); //eslint-disable-line

  return reduxCard && selectedFullBleed ? jsx(EditorProvider, {
    value: context
  }, jsx(FullBleed, {
    activePanel: activePanelLocation,
    fullBleed: selectedFullBleed,
    isHorizontal: hasHorizontalAspectRatio,
    onSelectPanel: actions.selectPanel,
    isPreviewMode: isPreviewMode,
    panelsTotal: card.fullBleeds[activeFullBleedLocation].panels.length,
    isUsingOldFlattener: isUsingOldFlattener
  })) : jsx(React.Fragment, null);
};

var useUserSnapEffect = function () {
  var _a;

  var usersnapButton = document.getElementsByName('us-entrypoint-button')[0];

  if (usersnapButton) {
    return;
  }

  var mutableScript = document.createElement('script');
  mutableScript.type = 'text/javascript';
  mutableScript.async = true;
  mutableScript.src = '//api.usersnap.com/load/e00dd5b1-8ec8-4ab5-b5c6-ca140a3a1268.js';
  var x = document.getElementsByTagName('script')[0];
  (_a = x.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(mutableScript, x);
};

var App = function (props) {
  var _a, _b, _c;

  var layouts = props.layouts,
      images = props.images,
      fonts = props.fonts,
      signatures = props.signatures,
      placeholders = props.placeholders,
      onUploadImages = props.onUploadImages,
      onSave = props.onSave,
      card = props.card,
      onSelectLayout = props.onSelectLayout,
      contextZones = props.contextZones,
      theme = props.theme,
      customBackPanels = props.customBackPanels,
      defaultBackPanels = props.defaultBackPanels,
      onDeleteBackPanel = props.onDeleteBackPanel,
      onDeleteImage = props.onDeleteImage,
      onCreateBackPanel = props.onCreateBackPanel,
      onSaveBackPanel = props.onSaveBackPanel,
      onSelectBackLayout = props.onSelectBackLayout,
      userInfo = props.userInfo,
      defaultBackPanel = props.defaultBackPanel,
      isUsingOldFlattener = props.isUsingOldFlattener,
      colorPalettes = props.colorPalettes,
      stickers = props.stickers;
  LogRocket.init('0xqcnb/editor-20');
  LogRocket.identify((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _a !== void 0 ? _a : 'none', {
    name: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) !== null && _b !== void 0 ? _b : '',
    email: (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _c !== void 0 ? _c : ''
  });

  var _d = __read(React.useState('fullbleed'), 2),
      panelView = _d[0],
      setPanelView = _d[1];

  var _e = __read(React.useState(0), 2),
      currentIndex = _e[0],
      setCurrentIndex = _e[1];

  var _f = __read(React.useState(0), 2),
      currentPanelIndex = _f[0],
      setCurrentPanelIndex = _f[1];

  var lastFullBleed = card.fullBleeds.length - 1;
  var actions = useReduxActions();
  var isFrontPanelLocked = card.fullBleeds[0].panels[0].isLocked;
  useUserSnapEffect();
  var editor = useReduxState('editor');
  var panelLocations = editor.card ? getPanelLocations(editor) : [];
  var lastPanel = panelLocations.length - 1;

  var handleSettingsDrawer = function (currentIndex) {
    if (!isFrontPanelLocked) return;
    if (currentIndex === 0) actions.openElementSettingsDrawer('panel');else actions.closeElementSettingsDrawer();
  };

  var getCurrentPanelIndex = function () {
    var _a;

    var currentPanelLocation = (_a = editor.panelLocation) !== null && _a !== void 0 ? _a : 0;
    return card.fullBleeds.slice(0, editor.fullBleedLocation).reduce(function (sum, fullBleed) {
      return sum + fullBleed.panels.length;
    }, 0) + currentPanelLocation;
  };

  var handlePreviousPanel = function () {
    var prevFullBleed = currentIndex - 1;
    var prevPanel = currentPanelIndex - 1;
    handleSettingsDrawer(currentIndex);

    if (panelView === 'fullbleed') {
      setCurrentIndex(prevFullBleed >= 0 ? prevFullBleed : lastFullBleed);
      actions.selectFullBleed(prevFullBleed >= 0 ? prevFullBleed : lastFullBleed);
    } else {
      var selectedPanelIndex = prevPanel >= 0 ? prevPanel : lastPanel;
      var _a = panelLocations[selectedPanelIndex],
          fullbleed = _a.fullbleed,
          panel = _a.panel;
      actions.selectSinglePanel(fullbleed, panel);
      setCurrentPanelIndex(selectedPanelIndex);
    }

    actions.setIsTextCursorActive(false);
  };

  var handleNextPanel = function () {
    var next = currentIndex + 1;
    var nextPanel = currentPanelIndex + 1;
    handleSettingsDrawer(currentIndex);

    if (panelView === 'fullbleed') {
      setCurrentIndex(next > lastFullBleed ? 0 : next);
      actions.selectFullBleed(next > lastFullBleed ? 0 : next);
    } else {
      var selectedPanelIndex = nextPanel > lastPanel ? 0 : nextPanel;
      var _a = panelLocations[selectedPanelIndex],
          fullbleed = _a.fullbleed,
          panel = _a.panel;
      actions.selectSinglePanel(fullbleed, panel);
      setCurrentPanelIndex(selectedPanelIndex);
    }

    actions.setIsTextCursorActive(false);
  };

  var handleChangeView = function (viewMode) {
    setPanelView(viewMode);
    viewMode === 'panel' ? setCurrentPanelIndex(getCurrentPanelIndex()) : setCurrentIndex(editor.fullBleedLocation);
  };

  var _g = __read(defaultBackPanel, 2),
      backPanelId = _g[0],
      setBackPanelId = _g[1];

  return jsx(React.Fragment, null, jsx(Global, {
    styles: [fonts.map(function (font) {
      return /*#__PURE__*/css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0ZtQiIsImZpbGUiOiJBcHAudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QsIF9fcmVhZCB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBHbG9iYWwsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IEVkaXRvckNocm9tZSBmcm9tIFwiLi4vY29udGFpbmVycy9FZGl0b3JDaHJvbWUvRWRpdG9yQ2hyb21lXCI7XHJcbmltcG9ydCB7IERpdiwgSWNvbiB9IGZyb20gJ0BzZW5kb3V0Y2FyZHMvcXVhbnR1bS1kZXNpZ24tdWknO1xyXG5pbXBvcnQgRWRpdG9yIGZyb20gXCIuLi9jb250YWluZXJzL0VkaXRvci9FZGl0b3JcIjtcclxuaW1wb3J0IHVzZVJlZHV4QWN0aW9ucyBmcm9tIFwiLi4vaG9va3MvdXNlUmVkdXhBY3Rpb25zXCI7XHJcbmltcG9ydCB1c2VVc2VyU25hcEVmZmVjdCBmcm9tIFwiLi4vaG9va3MvdXNlVXNlclNuYXBFZmZlY3RcIjtcclxuaW1wb3J0IExvZ1JvY2tldCBmcm9tICdsb2dyb2NrZXQnO1xyXG5pbXBvcnQgdXNlUmVkdXhTdGF0ZSBmcm9tIFwiLi4vaG9va3MvdXNlUmVkdXhTdGF0ZVwiO1xyXG5pbXBvcnQgeyBnZXRQYW5lbExvY2F0aW9ucyB9IGZyb20gXCIuLi9zZWxlY3RvcnMvZWRpdG9yU2VsZWN0b3JzXCI7XHJcbnZhciBBcHAgPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHZhciBfYSwgX2IsIF9jO1xyXG4gICAgdmFyIGxheW91dHMgPSBwcm9wcy5sYXlvdXRzLCBpbWFnZXMgPSBwcm9wcy5pbWFnZXMsIGZvbnRzID0gcHJvcHMuZm9udHMsIHNpZ25hdHVyZXMgPSBwcm9wcy5zaWduYXR1cmVzLCBwbGFjZWhvbGRlcnMgPSBwcm9wcy5wbGFjZWhvbGRlcnMsIG9uVXBsb2FkSW1hZ2VzID0gcHJvcHMub25VcGxvYWRJbWFnZXMsIG9uU2F2ZSA9IHByb3BzLm9uU2F2ZSwgY2FyZCA9IHByb3BzLmNhcmQsIG9uU2VsZWN0TGF5b3V0ID0gcHJvcHMub25TZWxlY3RMYXlvdXQsIGNvbnRleHRab25lcyA9IHByb3BzLmNvbnRleHRab25lcywgdGhlbWUgPSBwcm9wcy50aGVtZSwgY3VzdG9tQmFja1BhbmVscyA9IHByb3BzLmN1c3RvbUJhY2tQYW5lbHMsIGRlZmF1bHRCYWNrUGFuZWxzID0gcHJvcHMuZGVmYXVsdEJhY2tQYW5lbHMsIG9uRGVsZXRlQmFja1BhbmVsID0gcHJvcHMub25EZWxldGVCYWNrUGFuZWwsIG9uRGVsZXRlSW1hZ2UgPSBwcm9wcy5vbkRlbGV0ZUltYWdlLCBvbkNyZWF0ZUJhY2tQYW5lbCA9IHByb3BzLm9uQ3JlYXRlQmFja1BhbmVsLCBvblNhdmVCYWNrUGFuZWwgPSBwcm9wcy5vblNhdmVCYWNrUGFuZWwsIG9uU2VsZWN0QmFja0xheW91dCA9IHByb3BzLm9uU2VsZWN0QmFja0xheW91dCwgdXNlckluZm8gPSBwcm9wcy51c2VySW5mbywgZGVmYXVsdEJhY2tQYW5lbCA9IHByb3BzLmRlZmF1bHRCYWNrUGFuZWwsIGlzVXNpbmdPbGRGbGF0dGVuZXIgPSBwcm9wcy5pc1VzaW5nT2xkRmxhdHRlbmVyLCBjb2xvclBhbGV0dGVzID0gcHJvcHMuY29sb3JQYWxldHRlcywgc3RpY2tlcnMgPSBwcm9wcy5zdGlja2VycztcclxuICAgIExvZ1JvY2tldC5pbml0KCcweHFjbmIvZWRpdG9yLTIwJyk7XHJcbiAgICBMb2dSb2NrZXQuaWRlbnRpZnkoKF9hID0gdXNlckluZm8gPT09IG51bGwgfHwgdXNlckluZm8gPT09IHZvaWQgMCA/IHZvaWQgMCA6IHVzZXJJbmZvLmlkKSAhPT0gbnVsbCAmJiBfYSAhPT0gdm9pZCAwID8gX2EgOiAnbm9uZScsIHtcclxuICAgICAgICBuYW1lOiAoX2IgPSB1c2VySW5mbyA9PT0gbnVsbCB8fCB1c2VySW5mbyA9PT0gdm9pZCAwID8gdm9pZCAwIDogdXNlckluZm8ubmFtZSkgIT09IG51bGwgJiYgX2IgIT09IHZvaWQgMCA/IF9iIDogJycsXHJcbiAgICAgICAgZW1haWw6IChfYyA9IHVzZXJJbmZvID09PSBudWxsIHx8IHVzZXJJbmZvID09PSB2b2lkIDAgPyB2b2lkIDAgOiB1c2VySW5mby5lbWFpbCkgIT09IG51bGwgJiYgX2MgIT09IHZvaWQgMCA/IF9jIDogJycsXHJcbiAgICB9KTtcclxuICAgIHZhciBfZCA9IF9fcmVhZChSZWFjdC51c2VTdGF0ZSgnZnVsbGJsZWVkJyksIDIpLCBwYW5lbFZpZXcgPSBfZFswXSwgc2V0UGFuZWxWaWV3ID0gX2RbMV07XHJcbiAgICB2YXIgX2UgPSBfX3JlYWQoUmVhY3QudXNlU3RhdGUoMCksIDIpLCBjdXJyZW50SW5kZXggPSBfZVswXSwgc2V0Q3VycmVudEluZGV4ID0gX2VbMV07XHJcbiAgICB2YXIgX2YgPSBfX3JlYWQoUmVhY3QudXNlU3RhdGUoMCksIDIpLCBjdXJyZW50UGFuZWxJbmRleCA9IF9mWzBdLCBzZXRDdXJyZW50UGFuZWxJbmRleCA9IF9mWzFdO1xyXG4gICAgdmFyIGxhc3RGdWxsQmxlZWQgPSBjYXJkLmZ1bGxCbGVlZHMubGVuZ3RoIC0gMTtcclxuICAgIHZhciBhY3Rpb25zID0gdXNlUmVkdXhBY3Rpb25zKCk7XHJcbiAgICB2YXIgaXNGcm9udFBhbmVsTG9ja2VkID0gY2FyZC5mdWxsQmxlZWRzWzBdLnBhbmVsc1swXS5pc0xvY2tlZDtcclxuICAgIHVzZVVzZXJTbmFwRWZmZWN0KCk7XHJcbiAgICB2YXIgZWRpdG9yID0gdXNlUmVkdXhTdGF0ZSgnZWRpdG9yJyk7XHJcbiAgICB2YXIgcGFuZWxMb2NhdGlvbnMgPSBlZGl0b3IuY2FyZCA/IGdldFBhbmVsTG9jYXRpb25zKGVkaXRvcikgOiBbXTtcclxuICAgIHZhciBsYXN0UGFuZWwgPSBwYW5lbExvY2F0aW9ucy5sZW5ndGggLSAxO1xyXG4gICAgdmFyIGhhbmRsZVNldHRpbmdzRHJhd2VyID0gZnVuY3Rpb24gKGN1cnJlbnRJbmRleCkge1xyXG4gICAgICAgIGlmICghaXNGcm9udFBhbmVsTG9ja2VkKVxyXG4gICAgICAgICAgICByZXR1cm47XHJcbiAgICAgICAgaWYgKGN1cnJlbnRJbmRleCA9PT0gMClcclxuICAgICAgICAgICAgYWN0aW9ucy5vcGVuRWxlbWVudFNldHRpbmdzRHJhd2VyKCdwYW5lbCcpO1xyXG4gICAgICAgIGVsc2VcclxuICAgICAgICAgICAgYWN0aW9ucy5jbG9zZUVsZW1lbnRTZXR0aW5nc0RyYXdlcigpO1xyXG4gICAgfTtcclxuICAgIHZhciBnZXRDdXJyZW50UGFuZWxJbmRleCA9IGZ1bmN0aW9uICgpIHtcclxuICAgICAgICB2YXIgX2E7XHJcbiAgICAgICAgdmFyIGN1cnJlbnRQYW5lbExvY2F0aW9uID0gKF9hID0gZWRpdG9yLnBhbmVsTG9jYXRpb24pICE9PSBudWxsICYmIF9hICE9PSB2b2lkIDAgPyBfYSA6IDA7XHJcbiAgICAgICAgcmV0dXJuIChjYXJkLmZ1bGxCbGVlZHNcclxuICAgICAgICAgICAgLnNsaWNlKDAsIGVkaXRvci5mdWxsQmxlZWRMb2NhdGlvbilcclxuICAgICAgICAgICAgLnJlZHVjZShmdW5jdGlvbiAoc3VtLCBmdWxsQmxlZWQpIHtcclxuICAgICAgICAgICAgcmV0dXJuIHN1bSArIGZ1bGxCbGVlZC5wYW5lbHMubGVuZ3RoO1xyXG4gICAgICAgIH0sIDApICsgY3VycmVudFBhbmVsTG9jYXRpb24pO1xyXG4gICAgfTtcclxuICAgIHZhciBoYW5kbGVQcmV2aW91c1BhbmVsID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHZhciBwcmV2RnVsbEJsZWVkID0gY3VycmVudEluZGV4IC0gMTtcclxuICAgICAgICB2YXIgcHJldlBhbmVsID0gY3VycmVudFBhbmVsSW5kZXggLSAxO1xyXG4gICAgICAgIGhhbmRsZVNldHRpbmdzRHJhd2VyKGN1cnJlbnRJbmRleCk7XHJcbiAgICAgICAgaWYgKHBhbmVsVmlldyA9PT0gJ2Z1bGxibGVlZCcpIHtcclxuICAgICAgICAgICAgc2V0Q3VycmVudEluZGV4KHByZXZGdWxsQmxlZWQgPj0gMCA/IHByZXZGdWxsQmxlZWQgOiBsYXN0RnVsbEJsZWVkKTtcclxuICAgICAgICAgICAgYWN0aW9ucy5zZWxlY3RGdWxsQmxlZWQocHJldkZ1bGxCbGVlZCA+PSAwID8gcHJldkZ1bGxCbGVlZCA6IGxhc3RGdWxsQmxlZWQpO1xyXG4gICAgICAgIH1cclxuICAgICAgICBlbHNlIHtcclxuICAgICAgICAgICAgdmFyIHNlbGVjdGVkUGFuZWxJbmRleCA9IHByZXZQYW5lbCA+PSAwID8gcHJldlBhbmVsIDogbGFzdFBhbmVsO1xyXG4gICAgICAgICAgICB2YXIgX2EgPSBwYW5lbExvY2F0aW9uc1tzZWxlY3RlZFBhbmVsSW5kZXhdLCBmdWxsYmxlZWQgPSBfYS5mdWxsYmxlZWQsIHBhbmVsID0gX2EucGFuZWw7XHJcbiAgICAgICAgICAgIGFjdGlvbnMuc2VsZWN0U2luZ2xlUGFuZWwoZnVsbGJsZWVkLCBwYW5lbCk7XHJcbiAgICAgICAgICAgIHNldEN1cnJlbnRQYW5lbEluZGV4KHNlbGVjdGVkUGFuZWxJbmRleCk7XHJcbiAgICAgICAgfVxyXG4gICAgICAgIGFjdGlvbnMuc2V0SXNUZXh0Q3Vyc29yQWN0aXZlKGZhbHNlKTtcclxuICAgIH07XHJcbiAgICB2YXIgaGFuZGxlTmV4dFBhbmVsID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHZhciBuZXh0ID0gY3VycmVudEluZGV4ICsgMTtcclxuICAgICAgICB2YXIgbmV4dFBhbmVsID0gY3VycmVudFBhbmVsSW5kZXggKyAxO1xyXG4gICAgICAgIGhhbmRsZVNldHRpbmdzRHJhd2VyKGN1cnJlbnRJbmRleCk7XHJcbiAgICAgICAgaWYgKHBhbmVsVmlldyA9PT0gJ2Z1bGxibGVlZCcpIHtcclxuICAgICAgICAgICAgc2V0Q3VycmVudEluZGV4KG5leHQgPiBsYXN0RnVsbEJsZWVkID8gMCA6IG5leHQpO1xyXG4gICAgICAgICAgICBhY3Rpb25zLnNlbGVjdEZ1bGxCbGVlZChuZXh0ID4gbGFzdEZ1bGxCbGVlZCA/IDAgOiBuZXh0KTtcclxuICAgICAgICB9XHJcbiAgICAgICAgZWxzZSB7XHJcbiAgICAgICAgICAgIHZhciBzZWxlY3RlZFBhbmVsSW5kZXggPSBuZXh0UGFuZWwgPiBsYXN0UGFuZWwgPyAwIDogbmV4dFBhbmVsO1xyXG4gICAgICAgICAgICB2YXIgX2EgPSBwYW5lbExvY2F0aW9uc1tzZWxlY3RlZFBhbmVsSW5kZXhdLCBmdWxsYmxlZWQgPSBfYS5mdWxsYmxlZWQsIHBhbmVsID0gX2EucGFuZWw7XHJcbiAgICAgICAgICAgIGFjdGlvbnMuc2VsZWN0U2luZ2xlUGFuZWwoZnVsbGJsZWVkLCBwYW5lbCk7XHJcbiAgICAgICAgICAgIHNldEN1cnJlbnRQYW5lbEluZGV4KHNlbGVjdGVkUGFuZWxJbmRleCk7XHJcbiAgICAgICAgfVxyXG4gICAgICAgIGFjdGlvbnMuc2V0SXNUZXh0Q3Vyc29yQWN0aXZlKGZhbHNlKTtcclxuICAgIH07XHJcbiAgICB2YXIgaGFuZGxlQ2hhbmdlVmlldyA9IGZ1bmN0aW9uICh2aWV3TW9kZSkge1xyXG4gICAgICAgIHNldFBhbmVsVmlldyh2aWV3TW9kZSk7XHJcbiAgICAgICAgdmlld01vZGUgPT09ICdwYW5lbCdcclxuICAgICAgICAgICAgPyBzZXRDdXJyZW50UGFuZWxJbmRleChnZXRDdXJyZW50UGFuZWxJbmRleCgpKVxyXG4gICAgICAgICAgICA6IHNldEN1cnJlbnRJbmRleChlZGl0b3IuZnVsbEJsZWVkTG9jYXRpb24pO1xyXG4gICAgfTtcclxuICAgIHZhciBfZyA9IF9fcmVhZChkZWZhdWx0QmFja1BhbmVsLCAyKSwgYmFja1BhbmVsSWQgPSBfZ1swXSwgc2V0QmFja1BhbmVsSWQgPSBfZ1sxXTtcclxuICAgIHJldHVybiAoPD5cbiAgICAgIDxHbG9iYWwgc3R5bGVzPXtbXHJcbiAgICAgICAgZm9udHMubWFwKGZ1bmN0aW9uIChmb250KSB7XHJcbiAgICAgICAgICAgIHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICAgICAgICAgICAgQGZvbnQtZmFjZSB7XFxuICAgICAgICAgICAgICAgIGZvbnQtZmFtaWx5OiAnXCIsIFwiJztcXG4gICAgICAgICAgICAgICAgc3JjOiB1cmwoJ1wiLCBcIicpIGZvcm1hdCgndHJ1ZXR5cGUnKTtcXG4gICAgICAgICAgICAgIH1cXG4gICAgICAgICAgICBcIl0sIFtcIlxcbiAgICAgICAgICAgICAgQGZvbnQtZmFjZSB7XFxuICAgICAgICAgICAgICAgIGZvbnQtZmFtaWx5OiAnXCIsIFwiJztcXG4gICAgICAgICAgICAgICAgc3JjOiB1cmwoJ1wiLCBcIicpIGZvcm1hdCgndHJ1ZXR5cGUnKTtcXG4gICAgICAgICAgICAgIH1cXG4gICAgICAgICAgICBcIl0pKSwgZm9udC5mb250TmFtZSwgZm9udC50dGZGaWxlKTtcclxuICAgICAgICB9KSxcclxuICAgICAgICBzaWduYXR1cmVzID09PSBudWxsIHx8IHNpZ25hdHVyZXMgPT09IHZvaWQgMCA/IHZvaWQgMCA6IHNpZ25hdHVyZXMubWFwKGZ1bmN0aW9uIChzaWduYXR1cmUpIHtcclxuICAgICAgICAgICAgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8yIHx8ICh0ZW1wbGF0ZU9iamVjdF8yID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICAgICAgICAgICBAZm9udC1mYWNlIHtcXG4gICAgICAgICAgICAgICAgZm9udC1mYW1pbHk6ICdcIiwgXCInO1xcbiAgICAgICAgICAgICAgICBzcmM6IHVybCgnXCIsIFwiJykgZm9ybWF0KCd0cnVldHlwZScpO1xcbiAgICAgICAgICAgICAgfVxcbiAgICAgICAgICAgIFwiXSwgW1wiXFxuICAgICAgICAgICAgICBAZm9udC1mYWNlIHtcXG4gICAgICAgICAgICAgICAgZm9udC1mYW1pbHk6ICdcIiwgXCInO1xcbiAgICAgICAgICAgICAgICBzcmM6IHVybCgnXCIsIFwiJykgZm9ybWF0KCd0cnVldHlwZScpO1xcbiAgICAgICAgICAgICAgfVxcbiAgICAgICAgICAgIFwiXSkpLCBzaWduYXR1cmUuZm9udE5hbWUsIHNpZ25hdHVyZS50dGZGaWxlKTtcclxuICAgICAgICB9KSxcclxuICAgIF19Lz5cbiAgICAgIDxFZGl0b3JDaHJvbWUgdGhlbWU9e3RoZW1lfSBjb250ZXh0Wm9uZXM9e2NvbnRleHRab25lc30gZGVmYXVsdEJhY2tQYW5lbHM9e2RlZmF1bHRCYWNrUGFuZWxzfSBjdXN0b21CYWNrUGFuZWxzPXtjdXN0b21CYWNrUGFuZWxzfSBsYXlvdXRzPXtsYXlvdXRzfSBpbWFnZXM9e2ltYWdlc30gZm9udHM9e2ZvbnRzfSBzaWduYXR1cmVzPXtzaWduYXR1cmVzfSBwbGFjZWhvbGRlcnM9e3BsYWNlaG9sZGVyc30gaGFuZGxlQ2hhbmdlVmlldz17aGFuZGxlQ2hhbmdlVmlld30gb25VcGxvYWRJbWFnZXM9e29uVXBsb2FkSW1hZ2VzfSBoYW5kbGVOZXh0UGFuZWw9e2hhbmRsZU5leHRQYW5lbH0gaGFuZGxlUHJldmlvdXNQYW5lbD17aGFuZGxlUHJldmlvdXNQYW5lbH0gb25EZWxldGVCYWNrUGFuZWw9e29uRGVsZXRlQmFja1BhbmVsfSBvblNhdmVCYWNrUGFuZWw9e29uU2F2ZUJhY2tQYW5lbH0gb25DcmVhdGVCYWNrUGFuZWw9e29uQ3JlYXRlQmFja1BhbmVsfSBvblNlbGVjdEJhY2tMYXlvdXQ9e29uU2VsZWN0QmFja0xheW91dH0gb25EZWxldGVJbWFnZT17b25EZWxldGVJbWFnZX0gb25TZXREZWZhdWx0QmFja1BhbmVsPXtkZWZhdWx0QmFja1BhbmVsID8gc2V0QmFja1BhbmVsSWQgOiB1bmRlZmluZWR9IGRlZmF1bHRCYWNrUGFuZWxJZD17ZGVmYXVsdEJhY2tQYW5lbCA/IGJhY2tQYW5lbElkIDogdW5kZWZpbmVkfSBjb2xvclBhbGV0dGVzPXtjb2xvclBhbGV0dGVzfSBzdGlja2Vycz17c3RpY2tlcnN9IFxyXG4gICAgLy8gaGFuZGxlUHJldmlldz17aGFuZGxlUHJldmlld31cclxuICAgIHNjYWxlPXsxMDB9IGhlbHBJY29uPXs8RGl2IGRpc3BsYXk9XCJmbGV4XCIganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIiBhbGlnbkl0ZW1zPVwiY2VudGVyXCIgaW5zZXQ9e3sgYm90dG9tOiAneDInIH19IGN1cnNvcj1cInBvaW50ZXJcIj5cbiAgICAgICAgICAgIDxJY29uIG5hbWU9XCJpbmZvcm1hdGlvblwiIHByaW1hcnlDb2xvcj1cInByaW1hcnlCcmFuZFwiIHNpemU9XCJtZWRpdW1cIi8+XG4gICAgICAgICAgPC9EaXY+fT5cbiAgICAgICAgPEVkaXRvciB7Li4ucHJvcHN9IG9uU2F2ZT17b25TYXZlfSBvblNlbGVjdExheW91dD17b25TZWxlY3RMYXlvdXR9IG9uVXBsb2FkSW1hZ2VzPXtvblVwbG9hZEltYWdlc30gY2FyZD17Y2FyZH0gcGFuZWxWaWV3PXtwYW5lbFZpZXd9IGN1cnJlbnRJbmRleD17cGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJyA/IGN1cnJlbnRJbmRleCA6IGN1cnJlbnRQYW5lbEluZGV4fSBpc1VzaW5nT2xkRmxhdHRlbmVyPXtpc1VzaW5nT2xkRmxhdHRlbmVyfS8+XG4gICAgICA8L0VkaXRvckNocm9tZT5cbiAgICA8Lz4pO1xyXG59O1xyXG5leHBvcnQgZGVmYXVsdCBBcHA7XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xLCB0ZW1wbGF0ZU9iamVjdF8yO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1BcHAuanN4Lm1hcCJdfQ== */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), font.fontName, font.ttfFile);
    }), signatures === null || signatures === void 0 ? void 0 : signatures.map(function (signature) {
      return /*#__PURE__*/css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName, signature.ttfFile);
    }), process.env.NODE_ENV === "production" ? "" : ";label:App;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
  }), jsx(EditorChrome, {
    theme: theme,
    contextZones: contextZones,
    defaultBackPanels: defaultBackPanels,
    customBackPanels: customBackPanels,
    layouts: layouts,
    images: images,
    fonts: fonts,
    signatures: signatures,
    placeholders: placeholders,
    handleChangeView: handleChangeView,
    onUploadImages: onUploadImages,
    handleNextPanel: handleNextPanel,
    handlePreviousPanel: handlePreviousPanel,
    onDeleteBackPanel: onDeleteBackPanel,
    onSaveBackPanel: onSaveBackPanel,
    onCreateBackPanel: onCreateBackPanel,
    onSelectBackLayout: onSelectBackLayout,
    onDeleteImage: onDeleteImage,
    onSetDefaultBackPanel: defaultBackPanel ? setBackPanelId : undefined,
    defaultBackPanelId: defaultBackPanel ? backPanelId : undefined,
    colorPalettes: colorPalettes,
    stickers: stickers // handlePreview={handlePreview}
    ,
    scale: 100,
    helpIcon: jsx(Div, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      inset: {
        bottom: 'x2'
      },
      cursor: "pointer"
    }, jsx(Icon$1, {
      name: "information",
      primaryColor: "primaryBrand",
      size: "medium"
    }))
  }, jsx(Editor, _extends({}, props, {
    onSave: onSave,
    onSelectLayout: onSelectLayout,
    onUploadImages: onUploadImages,
    card: card,
    panelView: panelView,
    currentIndex: panelView === 'fullbleed' ? currentIndex : currentPanelIndex,
    isUsingOldFlattener: isUsingOldFlattener
  }))));
};
var templateObject_1, templateObject_2;

var GlobalEditor = function (props) {
  return jsx(App, props);
};

var updateCard = function (state, transform) {
  return __assign(__assign({}, state), {
    card: state.card ? transform(state.card) : null
  });
};
var updateFullBleed = function (state, transform) {
  return updateCard(state, function (card) {
    return __assign(__assign({}, card), {
      fullBleeds: card.fullBleeds.map(function (fullBleed, location) {
        return location === state.fullBleedLocation ? transform(fullBleed) : fullBleed;
      })
    });
  });
};
var updatePanel = function (state, transform) {
  return updateFullBleed(state, function (fullBleed) {
    return __assign(__assign({}, fullBleed), {
      panels: fullBleed.panels.map(function (panel, location) {
        return location === state.panelLocation ? transform(panel) : panel;
      })
    });
  });
};
var updateElement = function (state, transform) {
  return updatePanel(state, function (panel) {
    return __assign(__assign({}, panel), {
      elements: panel.elements.map(function (element, location) {
        return location === state.activeElement.location ? transform(element, panel) : element;
      })
    });
  });
};
var updateElementImage = function (state, transform) {
  return updateElement(state, function (element) {
    return __assign(__assign({}, element), {
      movingProhibited: element.movingProhibited,
      image: element.image ? transform(element.image) : null
    });
  });
};
var textElement = {
  image: null,
  text: {
    fragments: [defaultFragment]
  }
};
var imageElement = {
  text: null,
  image: {
    image: null,
    filter: null,
    position: {
      x: 0.5,
      y: 0.5
    },
    scale: 1
  }
};
var fullBleedBackgroundImage = {
  image: {
    id: null,
    height: null,
    width: null,
    url: null
  },
  filter: null,
  position: {
    x: 0.5,
    y: 0.5
  },
  scale: 1
};
var isFragmentType = function (valueToCheck) {
  if (typeof valueToCheck === 'undefined') {
    return false;
  }

  return valueToCheck.fragments !== undefined;
};
var isImageType = function (valueToCheck) {
  if (typeof valueToCheck === 'undefined') {
    return false;
  }

  var image = valueToCheck;
  return image.id !== undefined && image.height !== undefined && image.url !== undefined && image.width !== undefined;
};
var addElement = function (panel, type, isFullPanel, isPanelLandscape, defaultElementState) {
  var image = isImageType(defaultElementState) ? __assign(__assign({}, imageElement), {
    image: __assign(__assign({}, imageElement.image), {
      image: defaultElementState
    })
  }) : imageElement;
  var text = isFragmentType(defaultElementState) ? __assign(__assign({}, textElement), {
    text: __assign({}, defaultElementState)
  }) : textElement;
  var element = type === 'image' ? image : text;
  var size = isFullPanel && type === 'image' ? {
    x: 0,
    y: 0,
    width: 1,
    height: 1
  } : isFullPanel ? {
    x: 0.05,
    y: 0.05,
    width: 0.9,
    height: 0.9
  } : isPanelLandscape ? {
    x: 0.1,
    y: 0.1,
    width: 0.35,
    height: 0.42
  } : {
    x: 0.1,
    y: 0.1,
    width: 0.5,
    height: 0.3
  };
  return __assign(__assign(__assign({}, size), {
    z: isFullPanel && type === 'image' ? 0 : hasFullPanelElement(panel) ? panel.elements.length : panel.elements.length + 1,
    rotation: 0,
    draggable: true,
    locked: false,
    isFullPanel: isFullPanel
  }), element);
};
var isElementType = function (valueToCheck) {
  var element = valueToCheck;

  if ((element.height || element.width || element.x || element.y || element.z) !== undefined) {
    return true;
  }

  return false;
};
var getCopyLocation = function (activeElement) {
  var startingPoints = {
    x: activeElement.x,
    y: activeElement.y
  };
  var endingPoints = {
    x: activeElement.x + activeElement.width,
    y: activeElement.y + activeElement.height
  };
  return {
    x: startingPoints.x + getCopyDirection(endingPoints.x),
    y: startingPoints.y + getCopyDirection(endingPoints.y)
  };
};
var getCopyDirection = function (endPoint) {
  if (endPoint <= 0.99) {
    return 0.01;
  }

  return -0.01;
};
var isInsideRightPanel = function (cardType, fullBleedLocation, panelLocation) {
  switch (cardType) {
    case 'POSTCARD':
    case 'FLATCARD':
      return fullBleedLocation === 1 && panelLocation === 0;

    case 'THREE_PANEL':
      return fullBleedLocation === 2 && panelLocation === 0;

    case 'TWO_PANEL':
    case 'TWO_PANEL_BIG':
    default:
      return fullBleedLocation === 1 && panelLocation === 1;
  }
};
var getElementLocation = function (state) {
  return state.card && typeof state.panelLocation === 'number' ? state.card.fullBleeds[state.fullBleedLocation].panels[state.panelLocation].elements.length : 0;
};
var hasFullPanelElement = function (panel) {
  return panel.elements.some(function (element) {
    return element.isFullPanel;
  });
};

var _insertFragments = function (state, fragments) {
  var start = state.start + fragments.length;
  return {
    fragments: __spread(state.fragments.slice(0, state.start), fragments, state.fragments.slice(state.end)),
    start: start,
    end: start,
    overrideProperties: {}
  };
};

var _insertCharacter = function (state, character) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    text: character
  })]);
};

var _insertPlaceholder = function (state, placeholder) {
  return _insertCharacter(state, placeholder);
};

var _insertText = function (state, text) {
  return _insertFragments(state, __spread(text).map(function (character) {
    return __assign(__assign({}, insertionProperties(state)), {
      text: character
    });
  }));
};

var _insertSignature = function (state, signatureFontFamily) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    signatureFontFamily: signatureFontFamily
  })]);
};

var _insertNewLine = function (state) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    textAlign: insertionTextAlign(state)
  })]);
};

var _deleteFragments = function (state) {
  return _insertFragments(state.start === state.end && state.start > 1 ? __assign(__assign({}, state), {
    start: state.start - 1,
    overrideProperties: {}
  }) : state, []);
};

var _deleteForwardFragments = function (state) {
  if (state.start === state.end) {
    return {
      fragments: __spread(state.fragments.slice(0, state.start), state.fragments.slice(state.start + 1)),
      start: state.start,
      end: state.start,
      overrideProperties: {}
    };
  }

  return _insertFragments(state, []);
};

var _updateProperties = function (state, properties) {
  // If no text is highlighted
  if (state.start === state.end) {
    // If the only fragment that exists is the default fragment
    if (state.fragments[state.start - 1].textAlign) {
      return __assign(__assign({}, state), {
        fragments: __spread(state.fragments.slice(0, state.start - 1), [__assign(__assign({}, state.fragments[state.start - 1]), properties)], state.fragments.slice(state.end))
      });
    } else {
      // The cursor is somewhere in between the starting character and the ending character but no text is selected
      // We set the overrideProperties state to the properties being passed in, this sets up the future fragments to be
      // inserted with the new properties.
      // E.G I type at 16px font, I bump it up to 24px. The next letter I type will be 24px font (Same for color)
      return __assign(__assign({}, state), {
        overrideProperties: __assign(__assign({}, state.overrideProperties), properties)
      });
    }
  } else {
    // There is some chunk of text highlighted, we only alter that chunk of fragments with the new properties
    return __assign(__assign({}, state), {
      fragments: state.fragments.map(function (fragment, index) {
        return state.start <= index && index < state.end || index === state.start - 1 && fragment.textAlign ? __assign(__assign({}, fragment), properties) : fragment;
      })
    });
  }
};

var _updateTextAlign = function (state, textAlign) {
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, paragraphStart(state)), state.fragments.slice(paragraphStart(state), state.end).map(function (fragment) {
      return fragment.textAlign ? __assign(__assign({}, fragment), {
        textAlign: textAlign
      }) : fragment;
    }), state.fragments.slice(state.end))
  });
};

var _updateTextCasing = function (state, casing) {
  var isTextSelected = state.start !== state.end;
  var selectedFragments = isTextSelected ? state.fragments.slice(state.start, state.end) : state.fragments.slice(1);
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, isTextSelected ? state.start : 1), selectedFragments.map(function (fragment, index) {
      switch (casing) {
        case 'uppercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toUpperCase()
          }) : fragment;

        case 'lowercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toLowerCase()
          }) : fragment;

        case 'capitalize':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: index === 0 ? fragment.text.toUpperCase() : selectedFragments[index - 1].text === ' ' ? fragment.text.toUpperCase() : fragment.text.toLowerCase()
          }) : fragment;

        default:
          return fragment;
      }
    }), state.fragments.slice(isTextSelected ? state.end : state.fragments.length))
  });
};

var textReducer = (function (state, action) {
  switch (action.type) {
    case insertCharacter.type:
      return _insertCharacter(state, action.character);

    case insertText.type:
      return _insertText(state, action.text);

    case insertFragments.type:
      return _insertFragments(state, action.fragments);

    case insertSignature.type:
      return _insertSignature(state, action.signature);

    case insertPlaceholder.type:
      return _insertPlaceholder(state, action.placeholder);

    case insertNewLine.type:
      return _insertNewLine(state);

    case deleteFragments.type:
      return _deleteFragments(state);

    case deleteForwardFragments.type:
      return _deleteForwardFragments(state);

    case selectFontFamily.type:
      return _updateProperties(state, {
        fontFamily: action.fontFamily
      });

    case selectFontSize.type:
      return _updateProperties(state, {
        fontSize: action.fontSize
      });

    case selectColor.type:
      return _updateProperties(state, {
        color: action.color
      });

    case selectTextAlign.type:
      return _updateTextAlign(state, action.textAlign);

    case updateTextCasing.type:
      return _updateTextCasing(state, action.casing);

    case clearText.type:
      return __assign(__assign({}, state), {
        start: 1,
        end: 1,
        overrideProperties: {},
        fragments: [defaultFragment]
      });

    default:
      return state;
  }
});

var Historian =
/** @class */
function () {
  function Historian(config) {
    var _this = this;

    this.addChange = function (changedObj) {
      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];

      if (_this.mutableHistory.length > _this.numEntries) {
        _this.mutableHistory = _this.mutableHistory.slice(1, _this.mutableHistory.length);
      }
    };

    this.replaceCurrentState = function (changedObj) {
      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];
    };

    this.undo = function () {
      if (_this.mutableHistory.length === 0) {
        return undefined;
      }

      var obj = _this.mutableHistory.pop();

      if (_this.mutableCurrentState) {
        _this.mutableFuture.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.redo = function () {
      if (_this.mutableFuture.length === 0) {
        return undefined;
      }

      var obj = _this.mutableFuture.pop();

      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.reset = function () {
      _this.mutableCurrentState = undefined;
      _this.mutableHistory = [];
      _this.mutableFuture = [];
    };

    this.mutableHistory = [];
    this.mutableFuture = [];
    this.numEntries = config.numEntries;
    this.mutableCurrentState = config.startState;
  }

  return Historian;
}();

var CardHistorian = new Historian({
  numEntries: 100
});
var mutableActions = {
  prev: 'Bob',
  current: 'Blah',
  hasAddedBeforeReplacing: false
};
var actionsToIgnoreIfSame = ['SELECT_IMAGE_POSITION', 'SELECT_IMAGE_SCALE'];
var actionsIgnoreAltogether = ['SELECT_ELEMENT', 'SELECT_PANEL', 'ENABLE_SELECTING_ELEMENTS', 'DISABLE_SELECTING_ELEMENTS', 'REDO_EDITOR_CHANGE', 'UNDO_EDITOR_CHANGE', 'OPEN_IMAGE_DRAWER', 'OPEN_LAYOUT_DRAWER', 'OPEN_ELEMENT_INSERT_DRAWER', 'CLOSE_ELEMENT_INSERT_DRAWER', 'OPEN_ELEMENT_SETTINGS_DRAWER', 'CLOSE_ELEMENT_SETTINGS_DRAWER', 'SET_ACTIVE_IMAGE_SETTING', 'SET_ACTIVE_TEXT_SETTING', 'SET_SHOULD_REPLACE_SELECTED_IMAGE', 'SELECT_IMAGE', 'UPDATE_ELEMENT_SIZE'];

var shouldUseReplace = function (isSame, type) {
  return actionsToIgnoreIfSame.some(function (action) {
    return action === type;
  }) && isSame;
};

var ignoreAltogether = function (type) {
  return actionsIgnoreAltogether.some(function (action) {
    return action === type;
  });
};

var keepCardHistory = function (state, action) {
  var card = state.card;
  mutableActions.current = action.type;

  if (action.type === 'LOADED_CARD') {
    CardHistorian.addChange(action.card);
    return;
  }

  if (action.type === 'RESET_STATE') {
    CardHistorian.reset();
    return;
  }

  if (card && shouldUseReplace(mutableActions.current === mutableActions.prev, action.type) && !ignoreAltogether(action.type)) {
    if (!mutableActions.hasAddedBeforeReplacing) {
      CardHistorian.addChange(card);
      mutableActions.hasAddedBeforeReplacing = true;
    }

    CardHistorian.replaceCurrentState(card);
  } else if (card && !ignoreAltogether(action.type)) {
    CardHistorian.addChange(card);
    mutableActions.hasAddedBeforeReplacing = false;
  }

  mutableActions.prev = mutableActions.current;
  return;
};

var initialState$3 = {
  fullBleedLocation: 0,
  panelLocation: 0,
  loadError: null,
  layoutToLoad: null,
  activeToolbarAction: null,
  card: null,
  canSelectElements: true,
  activeElement: {
    location: null,
    type: null
  },
  editing: 'panel'
};
var editor = (function (state, action) {
  if (state === void 0) {
    state = initialState$3;
  }

  var newState = editorReducer(state, action);
  keepCardHistory(newState, action);
  return newState;
});

var editorReducer = function (state, action) {
  var _a, _b, _c;

  if (state === void 0) {
    state = initialState$3;
  }

  switch (action.type) {
    case addImageElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'element',
        activeElement: {
          location: getElementLocation(state),
          type: 'image'
        }
      }), function (panel) {
        var _a, _b;

        return __assign(__assign({}, panel), {
          elements: panel.elements.concat(addElement(panel, 'image', !!action.isFullPanel, ((_a = state.card) === null || _a === void 0 ? void 0 : _a.orientation) === 'LANDSCAPE' && ((_b = state.card) === null || _b === void 0 ? void 0 : _b.fullBleeds[state.fullBleedLocation].name.toLowerCase()) !== 'back', action.image))
        });
      });

    case addTextElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'element',
        activeElement: {
          location: getElementLocation(state),
          type: 'text'
        },
        textSelection: {
          start: 1,
          end: 1,
          overrideProperties: {}
        }
      }), function (panel) {
        var _a, _b;

        return __assign(__assign({}, panel), {
          elements: panel.elements.concat(addElement(panel, 'text', !!action.isFullPanel, ((_a = state.card) === null || _a === void 0 ? void 0 : _a.orientation) === 'LANDSCAPE' && ((_b = state.card) === null || _b === void 0 ? void 0 : _b.fullBleeds[state.fullBleedLocation].name.toLowerCase()) !== 'back'))
        });
      });

    case disableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: false
      });

    case enableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: true
      });

    case setToolbarAction.type:
      return __assign(__assign({}, state), {
        activeToolbarAction: action.toolbarAction
      });

    case loadedCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case setPanelBackground.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          backgroundColor: action.color
        });
      });

    case removeElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      }), function (panel) {
        // set variable to distinguish when gap in z-indices is found
        var isFound = false;
        var filteredSortedPanel = panel.elements // add a location prop on each element, so that we can return the panel in the same order at the end
        .map(function (e, i) {
          e.location = i;
          return e;
        }) // // filter out element being deleted and sort elemnts by z index
        .sort(function (a, b) {
          if (a.location === b.location) {
            return 0;
          }

          if (a.location === state.activeElement.location) {
            return 1;
          }

          if (b.location === state.activeElement.location) {
            return -1;
          }

          return a.z - b.z;
        }); // Remove the last item O(1) - Optimization over O(N) filter to remove.

        filteredSortedPanel.pop();
        var newPanel = filteredSortedPanel // Locate the gap in z-indeces and decrement all z-indeces after the gap
        .map(function (element, index) {
          // this is the edge case where element with z-index of 1 gets deleted
          if (index === 0 && element.z === 2) {
            isFound = true;
          } //all other z-index gap scenarios


          if (!isFound && filteredSortedPanel[index - 1] && element.z - filteredSortedPanel[index - 1].z > 1) {
            isFound = true;
          }

          if (isFound) {
            element.z = element.z - 1;
          }

          return element;
        }) // reorder the elements according to the original index
        .sort(function (a, b) {
          if (typeof a.location === 'number' && typeof b.location === 'number') {
            return a.location - b.location;
          } else return 1;
        });
        return __assign(__assign({}, panel), {
          elements: newPanel
        });
      });

    case clearPanel.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      }), function (panel) {
        var newElements = panel.elements.filter(function (element) {
          var isElementLocked = element.locked;
          var shouldClearContent = panel.isLocked && !element.draggable && (element.image || element.text);
          return isElementLocked || shouldClearContent;
        }).map(function (element) {
          return element.locked ? element : element.image ? __assign(__assign({}, element), {
            image: {
              image: null,
              position: {
                x: 0.5,
                y: 0.5
              },
              scale: 1,
              filter: null
            }
          }) : __assign(__assign({}, element), {
            text: {
              fragments: [defaultFragment]
            }
          });
        });
        return __assign(__assign({}, panel), {
          elements: newElements,
          backgroundColor: null
        });
      });

    case selectFullBleed.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: 0,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined,
        editing: 'panel'
      });

    case selectPanel.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        activeToolbarAction: null,
        textSelection: undefined,
        editing: action.fullBleedLocation !== 0 ? 'panel' : state.editing
      });

    case selectSinglePanel.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case selectElement.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: action.activeElement,
        textSelection: action.textStart ? {
          start: action.textStart,
          end: action.textEnd ? action.textEnd : action.textStart,
          overrideProperties: state.textSelection ? state.textSelection.overrideProperties : {}
        } : undefined,
        editing: 'element'
      });

    case deselectElement.type:
      return __assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      });

    case selectImage.type:
      var image_1 = action.photo;
      return updateElementImage(__assign({}, state), function () {
        return {
          image: {
            id: image_1.id,
            url: decodeURI(image_1.url),
            width: image_1.width,
            height: image_1.height,
            thumbnailUrl: decodeURI(image_1.thumbnailUrl)
          },
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case toggleElementDraggable.type:
      return __assign({}, updateElement(state, function (element) {
        return __assign(__assign({}, element), {
          draggable: !element.draggable
        });
      }));

    case selectImagePosition.type:
      var isInRange_1 = function (val) {
        return val <= 1 && val >= 0;
      };

      return updateElementImage(state, function (image) {
        return __assign(__assign({}, image), {
          position: {
            x: isInRange_1(action.x) ? action.x : image.position.x,
            y: isInRange_1(action.y) ? action.y : image.position.y
          }
        });
      });

    case selectImageScale.type:
      return updateElementImage(state, function (image) {
        // when the scale changes to 1 from anything less than 1
        // it looks like it is fine on the editor, but it
        // is actually positioned wrong, this fix below forces it to center
        // if the user likes this position, it will be fine when
        // flattened, if they want to manually move it, it will still
        // be updated as usual
        return __assign(__assign({}, image), {
          scale: action.scale
        });
      });

    case selectFilter.type:
      return updateElementImage(state, function (image) {
        return __assign(__assign({}, image), {
          filterUrl: action.url,
          filter: {
            name: action.filterName
          }
        });
      });

    case removeImage.type:
      return updateElementImage(state, function () {
        return {
          image: null,
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case selectLayout.type:
      return __assign({}, updatePanel(__assign(__assign({}, state), {
        layoutToLoad: null
      }), function (panel) {
        var elementImages = panel.elements.filter(function (element) {
          return element.image;
        }).map(function (element) {
          return element.image;
        });
        var elementTexts = panel.elements.filter(function (element) {
          return element.text;
        }).map(function (element) {
          return element.text;
        });
        return __assign(__assign({}, panel), {
          elements: action.layout.panel.elements.map(function (element) {
            if (element.image) {
              return element.image.image ? element : __assign(__assign({}, element), {
                image: elementImages.length > 0 ? elementImages.shift() || null : element.image
              });
            } else {
              return element.text && element.text.fragments.length > 1 ? element : __assign(__assign({}, element), {
                text: elementTexts.length > 0 ? elementTexts.shift() || null : element.text
              });
            }
          })
        });
      }));

    case selectBackPanel.type:
      var id = action.layout.id;
      var layoutToLoad = typeof id === 'number' ? id.toString() : id;
      return updatePanel(__assign(__assign({}, state), {
        layoutToLoad: layoutToLoad
      }), function (panel) {
        return __assign(__assign({}, panel), {
          elements: action.layout.panel.elements
        });
      });

    case selectLayoutToLoad.type:
      return __assign(__assign({}, state), {
        layoutToLoad: action.layoutId
      });

    case setCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case updateElementPosition.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : element.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : element.y
            }) : element;
          })
        });
      });

    case updateElementSize.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : element.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : element.height
            }) : element;
          })
        });
      });

    case updateElementRotation.type:
      {
        return updatePanel(state, function (panel) {
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element, location) {
              return location === action.elementLocation ? __assign(__assign({}, element), {
                rotation: action.rotation
              }) : element;
            })
          });
        });
      }

    case closeEditorDrawer.type:
      return __assign(__assign({}, state), {
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case resetState.type:
      return __assign({}, initialState$3);

    case editorUndo.type:
      {
        var newCardState = CardHistorian.undo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case editorRedo.type:
      {
        var newCardState = CardHistorian.redo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case duplicateElement.type:
      {
        if (typeof state.fullBleedLocation === 'number' && typeof state.panelLocation === 'number' && typeof state.activeElement.location === 'number') {
          var activePanel = (_a = state.card) === null || _a === void 0 ? void 0 : _a.fullBleeds[state.fullBleedLocation].panels[state.panelLocation];
          var activeElement = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements[state.activeElement.location];

          if (isElementType(activeElement)) {
            var copy_1 = __assign(__assign(__assign({}, activeElement), getCopyLocation(activeElement)), {
              z: activeElement.z + 1
            });

            return updatePanel(__assign(__assign({}, state), {
              activeElement: {
                location: (_c = (_b = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : null,
                type: activeElement.text ? 'text' : activeElement.image ? 'image' : null
              }
            }), function (panel) {
              return __assign(__assign({}, panel), {
                elements: panel.elements.concat(copy_1)
              });
            });
          }
        }

        return state;
      }

    case layerUp.type:
      {
        var tempZ_1 = 0;
        return updatePanel(state, function (panel) {
          panel.elements.forEach(function (element, index) {
            if (index === action.elementLocation) tempZ_1 = element.z;
          });
          var length = panel.elements.some(function (element) {
            return element.isFullPanel;
          }) ? panel.elements.length - 1 : panel.elements.length;
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element) {
              return element.isFullPanel ? __assign({}, element) : tempZ_1 === element.z ? __assign(__assign({}, element), {
                z: element.z === length ? element.z : element.z + 1
              }) : tempZ_1 === element.z - 1 ? __assign(__assign({}, element), {
                z: hasFullPanelElement(panel) && element.z === 1 ? element.z : element.z - 1
              }) : element;
            })
          });
        });
      }

    case layerDown.type:
      {
        var tempZ_2 = 0;
        return __assign({}, updatePanel(state, function (panel) {
          panel.elements.forEach(function (element, index) {
            if (index === action.elementLocation) tempZ_2 = element.z;
          });
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element) {
              return element.isFullPanel ? __assign({}, element) : tempZ_2 === element.z ? __assign(__assign({}, element), {
                z: element.z === 1 ? element.z : element.z - 1
              }) : tempZ_2 === element.z + 1 ? __assign(__assign({}, element), {
                z: element.z + 1
              }) : element;
            })
          });
        }));
      }

    case setEditing.type:
      {
        var isEditingElement = action.editing === 'element';
        return __assign(__assign({}, state), {
          editing: action.editing,
          activeElement: {
            location: isEditingElement ? state.activeElement.location : null,
            type: isEditingElement ? state.activeElement.type : null
          }
        });
      }

    case setFullBleedBackgroundImage.type:
      {
        var image_2 = __assign(__assign({}, fullBleedBackgroundImage), {
          image: {
            url: action.image.url,
            thumbnailUrl: action.image.thumbnailUrl,
            height: action.image.height,
            width: action.image.width,
            id: action.image.id
          }
        });

        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                image: action.image
              }) : image_2
            }) : null
          });
        });
      }

    case deleteFullBleedBackgroundImage.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: 0,
              y: 0,
              z: 0,
              width: 1,
              height: 1,
              rotation: 0,
              image: null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImagePosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                position: {
                  x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.image.position.x,
                  y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.image.position.y
                }
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImageScale.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                scale: action.scale
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementPosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.y
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementSize.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.height
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementRotation.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              rotation: action.rotation
            }) : null
          });
        });
      }

    case selectVariation.type:
      {
        return updateCard(state, function (card) {
          var _a, _b;

          var variations = (_b = (_a = card.variationState) === null || _a === void 0 ? void 0 : _a.variations) !== null && _b !== void 0 ? _b : [];
          var variation = variations.find(function (v) {
            return v.id === action.variationID;
          });
          if (!variation) return card;

          var elementImage = function (image) {
            return {
              image: {
                id: image.id,
                width: image.width,
                height: image.height,
                url: image.url,
                thumbnailUrl: image.thumbnailUrl
              },
              position: {
                x: 0.5,
                y: 0.5
              },
              scale: 1,
              filter: null
            };
          };

          return __assign(__assign({}, card), {
            variationState: {
              selectedVariationID: action.variationID,
              variations: variations
            },
            fullBleeds: card.fullBleeds.map(function (fullBleed, fullBleedLocation) {
              return __assign(__assign({}, fullBleed), {
                panels: fullBleed.panels.map(function (panel, panelLocation) {
                  return __assign(__assign({}, panel), {
                    elements: panel.elements.map(function (element) {
                      return __assign(__assign({}, element), {
                        image: element.image ? fullBleedLocation === 0 && panelLocation === 0 && element.locked ? elementImage(variation.frontImage) : variation.insideRightImage && isInsideRightPanel(card.type, fullBleedLocation, panelLocation) && element.locked ? elementImage(variation.insideRightImage) : element.image : element.image
                      });
                    })
                  });
                })
              });
            })
          });
        });
      }

    case enablePreviewMode.type:
      {
        var newState = __assign({}, state);

        return __assign(__assign({}, initialState$3), {
          card: newState.card,
          fullBleedLocation: newState.fullBleedLocation
        });
      }

    case updateClientAsset.type:
      {
        return updateElementImage(state, function (image) {
          var _a, _b, _c, _d;

          return __assign(__assign({}, image), {
            image: __assign(__assign({}, image.image), {
              id: (_a = action.image.id) !== null && _a !== void 0 ? _a : '',
              height: action.image.height,
              width: action.image.width,
              url: (_b = action.image.url) !== null && _b !== void 0 ? _b : '',
              thumbnailUrl: (_d = (_c = action.image) === null || _c === void 0 ? void 0 : _c.thumbnailUrl) !== null && _d !== void 0 ? _d : ''
            })
          });
        });
      }

    default:
      if (state.textSelection) {
        var _d = textReducer(textState(state), action),
            fragments_1 = _d.fragments,
            textSelection = __rest(_d, ["fragments"]);

        return __assign(__assign({}, updateElement(state, function (element) {
          return __assign(__assign({}, element), {
            text: element.text ? {
              fragments: fragments_1
            } : null
          });
        })), {
          textSelection: textSelection
        });
      } else {
        return state;
      }

  }
};

var initialState$2 = {
  loading: false,
  images: [],
  hasMore: true
};
var images = (function (state, action) {
  if (state === void 0) {
    state = initialState$2;
  }

  switch (action.type) {
    case showImages.type:
      return __assign(__assign({}, state), {
        loading: true
      });

    default:
      return state;
  }
});

var initialState$1 = {
  isElementInsertOpen: false,
  elementInsertDrawerType: null,
  isElementSettingsOpen: false,
  elementSettingsDrawerType: null,
  activeImageSetting: null,
  activeTextSetting: null,
  isTextCursorActive: false,
  shouldReplaceSelectedImage: false,
  showBetaBanner: true,
  interactionMode: 'edit',
  isImageUploaderWidgetActive: false,
  hasUploadedImage: false
}; // Can we put a flag on release and persist it to control if the release has been seen or not?

var editorChrome = (function (state, action) {
  if (state === void 0) {
    state = initialState$1;
  }

  switch (action.type) {
    case openElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: true,
        elementInsertDrawerType: action.insertType
      });

    case closeElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: false,
        elementInsertDrawerType: null
      });

    case openElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: true,
        elementSettingsDrawerType: action.settingType,
        activeImageSetting: null,
        activeTextSetting: null,
        isImageUploaderWidgetActive: state.isImageUploaderWidgetActive && action.settingType === 'panel'
      });

    case closeElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: false,
        activeImageSetting: null,
        activeTextSetting: null,
        isImageUploaderWidgetActive: false,
        elementSettingsDrawerType: null
      });

    case setActiveImageSetting.type:
      return __assign(__assign({}, state), {
        activeImageSetting: action.activeSetting
      });

    case setActiveTextSetting.type:
      return __assign(__assign({}, state), {
        activeTextSetting: action.activeSetting
      });

    case setShouldReplaceSelectedImage.type:
      return __assign(__assign({}, state), {
        shouldReplaceSelectedImage: action.shouldReplaceSelectedImage
      });

    case setIsTextCursorActive.type:
      return __assign(__assign({}, state), {
        isTextCursorActive: action.isTextCursorActive
      });

    case closeBetaBanner.type:
      return __assign(__assign({}, state), {
        showBetaBanner: false
      });

    case toggleInteractionMode.type:
      var isPreviewMode = state.interactionMode === 'preview';
      return __assign(__assign({}, state), {
        interactionMode: isPreviewMode ? 'edit' : 'preview',
        isElementInsertOpen: false,
        elementInsertDrawerType: null,
        elementSettingsDrawerType: isPreviewMode ? null : state.elementSettingsDrawerType,
        isElementSettingsOpen: isPreviewMode ? false : state.isElementInsertOpen,
        isTextCursorActive: false,
        shouldReplaceSelectedImage: false
      });

    case toggleImageUploaderWidget.type:
      return __assign(__assign({}, state), {
        isImageUploaderWidgetActive: !state.isImageUploaderWidgetActive
      });

    case setHasUploadedImage.type:
      return __assign(__assign({}, state), {
        hasUploadedImage: action.hasUploadedImage
      });

    default:
      return state;
  }
});

var initialState = {
  shouldShowMobileNavigation: true,
  drawerState: 'minified'
};
var mobileChrome = (function (state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case toggleMobileNavigation.type:
      return __assign(__assign({}, state), {
        shouldShowMobileNavigation: action.isVisible
      });

    case toggleDrawerState.type:
      return __assign(__assign({}, state), {
        drawerState: action.drawerState
      });

    default:
      return state;
  }
});

var rootReducer = combineReducers({
  images: images,
  editor: editor,
  editorChrome: editorChrome,
  mobileChrome: mobileChrome
});

var appReducer = function (state, action) {
  if (action.type === 'SAVED_AND_SENT') {
    // Passing undefined into rootReducer seems odd here but it comes straight from Dan Abramov via:
    // https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
    return rootReducer(undefined, action);
  }

  return rootReducer(state, action);
}; // const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['editorChrome'],
// }
// const persistedReducer = persistReducer(persistConfig, appReducer)
// export const store = createStore(persistedReducer, {}, composeWithDevTools())
// export const persistor = persistStore(store)


var store = createStore(appReducer, {}, composeWithDevTools());

var GlobalEditorProvider = function (_a) {
  var children = _a.children;
  return jsx(Provider, {
    store: store
  }, children);
};

export { GlobalEditor, GlobalEditorProvider };
